import { TranslationInterface } from '../schema';

export const en: TranslationInterface = {
  wss: {
    toggleOfferRequestValidators: 'Add requests for offers up to 365 days in the past',
  },
  workflows: {
    workflowNames: {
      PAYMENTS: 'Payments',
      PAYMENT_DONE: 'Payment done',
      LOGO: 'Logo',
      CUSTOM_ETRANSPORT_UPLOAD: 'Custom ETransport Upload',
      INVOICE_RECEIVED: 'Received Invoice',
    },
    workflowDescriptions: {
      PAYMENTS: 'Payments',
      PAYMENT_DONE: 'Configure if emails are sent automatically for a payment',
      LOGO: 'Configure if platform logo should be displayed in menubar',
      CUSTOM_ETRANSPORT_UPLOAD: 'Configure if custom eTransport excel upload is enabled',
      INVOICE_RECEIVED: 'Configure if invoices are auto-ACCEPTED or await user input',
    },
    selectableItems: {
      SHOW_CUSTOM_ETRANSPORT_UPLOAD: 'Activate custom eTransport excel upload for eTransport',
      PAYMENTS_TEST_WORKFLOW_STEP_001: 'Test workflow step 001 :) ',
      PAYMENTS_PAYMENTS_1: 'Test UI',
      PAYMENTS_EMAIL: 'Email ----',
      PAYMENT_DONE_FINAL_DUE_DATE: 'Configure payment due date',
      PAYMENT_DONE_EMAIL: 'Send emails',
      LOGO_LOGO_1: 'Display logo',
      INVOICE_RECEIVED_INVOICE_WORKFLOW_NEVER_ACCEPT: 'Never auto accept',
    },
    details: {
      workflowName: 'Workflow name',
      workflowDefaultDescription: 'Description',
      title: 'Workflow details',
      systemName: 'System',
      stepsUiTitle: 'Workflow Ui steps',
      stepsTitle: 'Workflow steps',
      stepName: 'Step name',
      notiTitle: 'Notifications',
      notificationType: 'Notification type',
      label: 'Label',
      generalTitle: 'General info',
      errors: {
        requiredLabel: "The 'Tag' field is required",
      },
    },
    configuration: {
      title: 'Workflows configuration',
      list: {
        validTo: 'Valid to',
        validFrom: 'Valid from',
        systemName: 'System name',
        name: 'Workflow name',
        configuredForOwner: 'Configuration',
        configurationType: {
          default: 'Default',
          custom: 'Custom',
        },
      },
    },
  },
  'wip-message': {
    title: 'Working area',
    description: 'Some functionalities might not be available',
  },
  warehouses: {
    warehouseName: 'Warehouse name',
    warehouseDetails: 'Warehouse details',
    terminals: {
      unloading: 'Unloading',
      terminalTypeErrorMessage: 'It is necessary to select at least one type of terminal',
      terminalType: 'Terminal type',
      reservations: {
        vendorVo: 'Vendor',
        vehicleType: 'Vehicle type',
        UNLOADING: 'Unloading',
        types: {
          UNLOADING: 'Unloading',
          MAINTENANCE: 'Administrative',
          LOADING: 'Loading',
          CLEANING: 'Cleaning',
        },
        to: 'To',
        terminalReservationNumber: 'Reference number',
        driverPhoneNumber: 'Driver phone number',
        tag: 'Tag',
        statuses: {
          upcoming: 'Planned',
          partially_completed: 'Partially completed',
          expired: 'Expired',
          completed: 'Completed',
          cancelled: 'Cancelled',
          archived: 'Archived',
          arrived_at_gate: 'Arrived at gate',
          check_in: 'Check-in',
          loading_in_progress: 'Loading in progress',
          loading_completed: 'Loading completed',
          exited_gate: 'Exited gate',
          not_present_at_loading: 'Absent',
          unloading_in_progress: 'Unloading in progress',
          unloading_completed: 'Unloading completed',
          not_present_at_unloading: 'Absent',
        },
        hasUitCode: 'UIT code present',
        retrievedProtectionMaterials: 'Retrieved protection materials',
        receivedProtectionMaterials: 'Received protection materials',
        nextStatus: 'Next status',
        notPresentAtLoading: 'Absent at loading',
        notPresentAtUnloading: 'Absent at unloading',
        statusAlertMessage: 'Booking period exceeded, update status!',
        status: 'Status',
        shipments: 'Shipments',
        reservationType: 'Reservation type',
        reservationStatus: 'Reservation status',
        orders: 'Orders',
        order: 'Order',
        MAINTENANCE: 'Administrative',
        LOADING: 'Loading',
        licencePlate: 'Licence plate',
        from: 'From',
        driver: 'Driver',
        deleteMessage: 'Are you sure you want to cancel your reservation?',
        contactPhoneNumber: 'Responsible phone number',
        contactName: 'Responsible name',
        confirmHeader: 'Confirm removal',
        comments: 'Comments',
        CLEANING: 'Cleaning',
        cancel: 'Cancel reservation',
        list: {
          title: 'Warehouse Reservations',
          columns: {
            terminalName: 'Terminal name',
            terminalReservationNumber: 'Reservation number',
            orderNumbers: 'Order numbers',
            serviceProviderName: 'Service provider name',
            timeRange: 'Time range',
            licencePlate: 'License plate',
            reservationType: 'Reservation type',
            reservationStatus: 'Reservation status',
            terminalStatus: 'Terminal status',
          },
        },
      },
      name: 'Name',
      loadingAndUnloading: 'Loading and unloading',
      loading: 'Loading',
      hour: 'Current hour',
      errors: {
        requiredTerminalReservationNumber: 'The field is required',
        requiredReservationType: 'The field is required',
        requiredName: 'The field is required',
        requiredDescription: 'The field is required',
        requiredContactPhoneNumber: 'The field is required',
        requiredDriverPhoneNumber: 'The field is required',
        requiredContactName: 'The field is required',
        requiredSpOrCourier: 'The field is required',
        requiredVehicleType: 'The field is required',
        requiredDriver: 'The field is required',
        requiredLicencePlate: 'The field is required',
      },
      emptyAttachments: 'No document uploaded',
      editTerminal: 'Edit terminal',
      description: 'Description',
      vendor: 'Vendor',
      externalSP: 'Courier',
      'delete-confirmation-message': (param) =>
        `Are you sure you want to delete the terminal <strong>${param.terminalName}</strong> ? This action will cancel all the future reservations of this terminal`,
      delete: 'Delete terminal',
      deleted: 'Deleted',
      active: 'Active',
      contactPhoneNumber: 'Phone number responsible',
      contactName: 'Responsible name',
      attachmentsTooltip: 'See documents',
      attachments: 'Documents',
      addTerminal: 'Add new terminal',
    },
    orderReservationButton: 'Schedule order in warehouse',
    moreDetails: 'More details',
    location: 'Location',
    lessDetails: 'Less details',
    futureSchedule: 'Future schedule',
    editWarehouse: 'Edit warehouse',
    editFutureSchedule: 'Edit future schedule',
    deleteFutureScheduleMessage: 'Are you sure you want to delete the future schedule?',
    deleteFutureScheduleHeader: 'Confirm deletion',
    deleteFutureSchedule: 'Delete future schedule',
    currentScheduled: 'Current schedule',
    create: {
      warehouseName: 'Warehouse name',
      title: 'Create warehouse',
      timeSlot: 'Minimum minute range',
      openingTime: 'Start time activity',
      noExistingDeposit: 'There is no warehouse created',
      error: {
        timeOrderError: 'End time must be after start time',
        requiredWarehouseName: "The  'warehouse name' field is required",
        requiredTimeSlot: "The  'minimum minute interval' field is required",
        requiredOpeningTime: "The  'activity start time' field is required",
        requiredClosingTime: "The  'activity completion time' field is required",
        requiredAddress: "The  'address' fields are required",
        '0AddressDTO': "The  'address' fields are required",
      },
      createWarehouseForm: 'Fill in the fields below to create a warehouse',
      closingTime: 'Activity end time',
    },
    addFutureSchedule: 'Add future schedule',
    tooltipFromOrderSchedulingMode: 'Click on a slot to schedule the order',
    clearOrderContext: 'Cancel active order',
  },
  'vendor-templates': {
    title: 'Templates',
    'empty-list': "The list is empty. Add a template using the 'Add' button above.",
    'add-template': 'Add template',
  },
  utils: {
    yes: 'Yes',
    visibilityTypeDescription: {
      SERVICE_PROVIDER: 'This visibility is aimed at customer contacts receiving requests from suppliers',
      PUBLIC: 'All contacts so marked can be seen by all companies',
      NONE: 'This visibility is aimed at internal management; contacts marked in this way cannot be seen by partner companies.',
      CUSTOMER: 'This visibility is aimed at service providers contacts who receive requests from customers.',
      BOTH: 'This visibility is aimed at supplier and customer contacts.',
    },
    update: 'Update',
    partialSave: 'Partial save',
    status: 'Status',
    validateAndSave: 'Validate and save',
    saveAndUpload: 'Save and upload',
    confirmation: 'Confirmation',
    deliverByDate: 'Deliver by date',
    plannedDelivery: 'Planned delivery',
    deliveryDate: 'Delivery date',
    timeLimit: 'payment deadline',
    sync: 'Sync',
    'show-more': 'Show more',
    'show-less': 'Show less',
    search: 'Search',
    save: 'Save',
    requiredLegend: 'Fields marked with * are required!',
    successSave: 'Successfully saved',
    verifyData: 'Verify data',
    defaultInfoSummary: 'Info',
    defaultInfoDetails: 'Info details',
    noDataFound: 'No data found',
    no: 'No ',
    languages: {
      ro: 'Romanian',
      en: 'English',
    },
    emptyMessage: 'No results were found',
    edit: 'Edit',
    download: 'Download',
    deleteConfirmationMessage: 'Delete confirmation',
    delete: 'Delete',
    close: 'Close',
    closeDetails: 'Close details',
    back: 'Back',
    all: 'All',
    add: 'Add',
    loadingSuccess: 'Loading successful!',
    downloadPdf: 'Download PDF',
    send: 'Send',
    seeDetails: 'See details',
    seeMore: 'See more',
    details: 'Details',
    saveForLater: 'Save for later',
    resetData: 'Reset data',
    addContactInfoMessage: 'Add a contact using the next button',
    existentCompany: 'Already existent company!',
    existentCompanyDetails: 'The selected company was already added.',
    publicContact: 'Public contact',
    partnerContact: 'Private contact',
    daysOfWeek: {
      MONDAY: 'Monday',
      TUESDAY: 'Tuesday',
      WEDNESDAY: 'Wednesday',
      THURSDAY: 'Thursday',
      FRIDAY: 'Friday',
      SATURDAY: 'Saturday',
      SUNDAY: 'Sunday',
    },
    shortDaysOfWeek: {
      MONDAY: 'Mon',
      TUESDAY: 'Tue',
      WEDNESDAY: 'Wed',
      THURSDAY: 'Thu',
      FRIDAY: 'Fri',
      SATURDAY: 'Sat',
      SUNDAY: 'Sun',
    },
    inactive: 'Inactive',
    packages: 'Packages',
    itemsSelected: 'items selected',
    upload: 'Upload',
  },
  user: {
    phoneNumberNotValidated: 'Phone number not valid',
  },
  'user-preferences': {
    filters: {
      saveSearch: 'Save search',
      savedFilters: 'Saved searches',
      resetSearch: 'Reset filters',
      filterName: 'Search name',
      deleteSearchTooltip: 'Delete search',
      confirmDeletionMessage: 'Are you sure you want to delete this search?',
      confirmDeletionHeader: 'Confirm deletion',
      applyFilterTooltip: 'Click to apply filter',
      addFilterName: 'Add name for search',
      markAsDefaultTooltip: 'Mark as default filter',
    },
    defaultOption: 'Default filter',
    noDataMessage: 'No saved search',
    saveSuccessMessage: 'Search successfully saved',
    deleteSuccessMessage: 'Search successfully deleted',
  },
  'user-action-tracking': {
    userActionType: {
      scroll: 'Scroll',
      page_open: 'Page open',
      page_exit: 'Closed page ',
      button_press: 'Pressed button',
    },
    userAction: {
      sp_invoices_open: 'Issued invoices page open',
      sp_invoice_payments_open: 'Receipts page open',
      outbox_open: 'Outbox page open',
      order_page_open: 'Order page open',
      offer_request_page_open: 'Offer request page open',
      offer_page_open: 'Page offer open ',
      invoice_page_open: 'Invoice page open',
      inbox_open: 'Inbox page open',
      homepage_open: 'Start page open',
      customer_invoices_open: 'Received invoices page open',
      customer_invoice_payments_open: 'Payment page open ',
    },
    menu: {
      userActions: 'User Actions',
    },
    list: {
      userName: 'User name',
      userActionType: 'User Action Type',
      userAction: 'User Action',
      trackedEntity: 'Tracked Entity',
      search: 'Search',
      all: 'All',
      actionUrl: 'Action URL',
      actionedAt: 'Date of Action',
    },
  },
  type: 'Global account type',
  'transport-project': {
    list: {
      validTo: 'Valid to',
      validFrom: 'Valid from',
      title: 'Transport Projects',
      label: 'Label',
      description: 'Description',
    },
    form: {
      validTo: 'Valid to',
      validFrom: 'Valid from',
      label: 'Label',
      error: {
        requiredValidFrom: "The field 'Valid from' is mandatory!",
        requiredLabel: "The field 'Label' is mandatory!",
      },
      description: 'Description',
    },
    edit: 'Edit the Transport Project',
    add: 'Add a Transport Project',
    shipment: {
      title: 'Shipment',
    },
  },
  timeUnit: {
    WEEK: 'Weeks',
    SECOND: 'Seconds',
    MINUTE: 'Minutes',
    HOUR: 'Hours',
    DAY: 'Days',
  },
  timeAvailability: {
    error: {
      requiredUnit: "The  'time unit' is required!",
      requiredDuration: 'Duration is required!',
      minValueExceededDuration: 'The minimum validity value has been exceeded!',
    },
  },
  'terms-and-conditions': {
    statuses: {
      rejected: 'rejected',
      accepted: 'accepted',
    },
    'preview-title': 'View Terms & Conditions',
    'not-found': 'No Terms & Conditions!',
    currentStatus: 'Terms and Conditions have been',
    comments: 'Refusal reason ',
  },
  task: {
    wizard: {
      secondStep: {
        title: 'Tasks',
        task: 'Task',
        timeWarningMessage: 'Time intervals are different from order',
        dimensions: 'Length - Width - Height',
      },
      firstStep: {
        title: 'Route',
        selectRoute: 'Select a route',
        errors: {
          requiredVehicle: 'Vehicle is required',
          requiredMainDriver: 'Main driver is required',
        },
        changeRoute: 'Change route',
      },
    },
    list: {
      updatedAt: 'Updated at',
      title: 'Dispatcher Shipments',
      deleteMessage: 'Are you sure you want to delete?',
      deleteTaskOnly: 'Delete task only',
      deleteSolution: 'Delete solution',
      solutionNotDeletable: 'The solution contains other active segments',
      solutionDeletableWarning:
        'Deleting the solution implies deleting all segments and hub shipments originating from this solution',
      deletedSuccessfully: 'Task deleted successfully',
      deleteQuestionTask: 'Would you like to modify the details of this task?',
      deleteQuestionSegment: 'Would you like to reallocate shipments to another route segment?',
      deleteSegment: 'Delete segment / Deallocate shipments',
      deleteQuestionSolution: 'Would you like to discard the current routing solution?',
      deleteEntireSolution: 'Delete entire solution',
      closeMessage: 'Are you sure you want to close the task?',
      closeBody: 'This action will not change the statuses of packages, shipments, or orders.',
      closeTask: 'Close task',
      closedSuccessfully: 'Task closed successfully',
      fullHandoverMessage: 'Full completion',
      fullHandoverBody:
        'This action will complete all checkpoints and update the statuses of packages, shipments, and orders.',
      fullHandover: 'Full completion',
      fullHandoverSuccessfully: 'Full completion done successfully',
      legend: {
        task: 'Task',
        shipment: 'Shipment',
      },
      filter: 'Filter',
      filterInputs: {
        packageId: 'Package ID',
        orderNumber: 'Order number',
        series: 'Shipment series',
        serviceProviderName: 'Service provider',
        pickupDate: 'Pickup Date',
        deliveredBy: 'Delivery Date',
        mainDriverName: 'Driver Name',
        licensePlate: 'Vehicle license plate',
        pickupAddress: 'Pickup address',
        deliveryAddress: 'Delivery address',
        pickupLocation: 'Pickup location',
        deliveryLocation: 'Delivery location',
        taskStatus: 'Task status',
        shipmentStatus: 'Shipment status',
        lastModifiedAt: 'Last modified date',
        unknownDestination: 'Unknown destination',
      },
    },
    statusEnum: {
      created: 'Created',
      accepted: 'Accepted',
      rejected: 'Rejected',
      in_transit: 'In transit',
      in_transit_returning: 'Returning in transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
      closed: 'Closed',
      partially_closed: 'Partially closed',
    },
  },
  tariff: {
    tags: 'Tags',
    pickupCity: 'Pickup city',
    packageWeight: 'Packages weight',
    packageType: 'Packages type',
    emptyTariffsMessage: 'No tariff found for the current search.',
    deliveryCity: 'Delivery city',
    currencyCode: 'Currency',
  },
  'system-administration': {
    utils: {
      save: 'Save',
      cancel: 'Close',
    },
    menu: {
      reportTemplates: 'Report Templates',
      reports: 'Reports',
      pdfTemplates: 'PDF Templates',
      jobSystem: 'Job System',
      jobLogs: 'Logs',
      jobExecution: 'Executions',
      jobDefinition: 'Definitions',
      integrationExecutions: 'Executions',
      integrationDefinitions: 'Definitions',
      integration: 'Data Import',
      exceptions: 'Exceptions',
      dashboardDefinitions: 'Definitions',
      dashboard: 'Dashboard',
    },
    error: {
      defaultError:
        'An error occurred on the server! Please contact support team for this issue at well.suport@irian.ro',
    },
  },

  'suggestion-message': {
    title: 'Suggestion ',
    'button-tooltip': 'Get me there',
  },
  'standard-package-dimension': {
    utils: {
      save: 'Save',
      delete: 'Delete',
      close: 'Close',
    },
    'update-package': 'Update standard dimension',
    standardPackage: 'Standard package',
    'page-title': 'Standard packages',
    package: 'Package',
    list: {
      width: 'Width',
      type: 'Type',
      tags: 'Tags',
      name: 'Name',
      length: 'Length',
      height: 'Height',
      weight: 'Weight',
    },
    form: {
      width: 'Width',
      type: 'Type',
      tags: 'Tags',
      name: 'Name',
      length: 'Length',
      height: 'Height',
      weight: 'Weight',
      errors: {
        requiredDescription: "The field 'Name' is mandatory!",
        requiredlength: "The field 'Length' is mandatory!",
        requiredwidth: "The field 'Width' is mandatory!",
        requiredheight: "The field 'Height' is mandatory!",
      },
    },
    emptyStandardPackagesMessage: 'You have no standard package added',
    'delete-package': 'Delete standard dimension',
    'delete-confirmation-message': (param) =>
      `Are you sure you want to delete the standard dimension <strong>${param.name}</strong> ?`,
  },
  sswl: {
    value: 'Value',
    type: 'Type',
    system: 'System',
    name_filter: 'Filter by name...',
    name: 'Name',
    msg: {
      delete: 'Do you want to delete this record?',
    },
    list_title: 'System settings',
    delete_confirmation: 'Delete confirmation',
    add_new_setting: 'Add new setting',
  },
  signup: {
    vatSplitStatus: 'VAT breakdown payment',
    vatRegistration: 'VAT payer',
    vatInactiveStatus: 'Inactive (VAT)',
    vatInactivationDate: 'Inactive (VAT) from',
    vat: 'VAT value',
    editData: 'Edit data',
    utils: {
      select: 'Select',
      save: 'Save',
      requiredLabel: 'All fields marked with * are required',
      next: 'Next page',
      edit: 'Edit',
      close: 'Close',
      choose: 'Choose',
      cancel: 'Close',
      all: 'All',
    },
    uniqueIdNumber: 'Unique identification number',
    title: 'Sign-up',
    'terms-and-conditions': 'Terms and Conditions & Data Processing Policy',
    successfulIfValid: 'If the data is valid, an account activation email has been sent to you!',
    subscriptionTypeTabTitle: 'Subscription type',
    subscriptionTypeTabHeader: 'Choose Subscription type',
    'subscription-type': {
      subscription: {
        list: {
          title: 'Subscriptions',
        },
        legalEntity: 'Company',
        detail: 'Details',
      },
      private: 'Private',
      'new-actions': 'Define actions',
      'list-title': 'Subscription type',
      inputs: {
        typeName: 'Subscription name',
        subscriptionPrice: 'Price',
        subscriptionCurrency: 'Currency ',
        private: 'Private',
        legalEntity: 'Company ',
        creditStart: 'Initial credit',
      },
      errors: {
        requiredtypeName: 'The Name field is required',
        requiredsubscriptionPrice: 'The Price field is required',
        requiredsubscriptionCurrency: 'The Currency field is required',
      },
      companies: 'Companies',
      'add-title': 'Define Subscription Types',
      add: 'Add',
      actions: {
        SEND_ORDER: 'Send order',
        RECEIVE_ORDER: 'Receive order',
        'offer-request': 'Offer request',
        monthlyIncludedAmount: 'Actions include',
        info: 'Access to all application features',
        creditStart: 'Initial credit',
        CREATE_OFFER: 'Request offers',
        actionCost: 'An additional share costs',
      },
    },
    'subscription-plan': {
      title: 'Select a subscription plan',
      'card-info': 'Card information',
    },
    subscription: 'Subscription',
    startingBalance: 'Starting balance',
    selectIndustryType: 'Select industry type',
    save: 'Save',
    registrationCode: 'Commercial Register serial number',
    preferredLanguage: 'Language',
    payment: {
      termsAccept: 'I accept the terms and conditions',
      terms: 'Terms and conditions',
      paymentOrder: 'Payment Order',
      paymentMethod: 'Payment method',
      go: 'Go to',
      error: 'This field is required',
      card: 'Card',
    },
    'payment-info': 'Payment Info',
    password: 'Password',
    mainPhone: 'Main phone number',
    mainEmailAddress: 'Main e-mail',
    mainAddress: 'Main address',
    legalEntityNotFound: 'No company selected',
    invoiceSeriesPrefix: 'Prefix Invoice Series',
    industryTypeValue: 'Industry type',
    indication: 'Select a company or create a new one',
    firstUser: 'First user',
    firstEmployee: 'Fisrt employee',
    firstContact: {
      visibilityTypes: {
        SERVICE_PROVIDER: 'Service provider',
        PUBLIC: 'Public',
        NONE: 'Private',
        CUSTOMER: 'Customer',
        BOTH: 'Both',
      },
      inputs: {
        visibilityType: 'Visibility',
        validTo: 'Valid to',
        validFrom: 'Valid from',
        receivesRequestsRequiredTooltip: 'To select a contact method you must receive requests',
        receivesRequests: 'I agree to be contacted by the selected method',
        phoneNumber: 'Phone number',
        newDepartment: 'New department',
        email: 'E-mail',
        departmentName: 'Department name',
        contactMethod: 'Contract method\n',
      },
      error: {
        uniqueIdNumberrequired: 'The Unique registration number field is required',
        requiredVisibility: 'The Visibility field is required',
        requiredValidFrom: 'The Valid from field is required',
        requiredPhoneNumber: 'The Phone number field is required',
        requiredPerson: 'The Person field is required',
        requiredInvoiceSeriesPrefix: "The 'Invoice Series Prefix' field is required",
        requiredEmail: 'The E-mail field is required',
        requiredContactMethod: 'The Contact method field is required',
        DuplicateUniqueID: 'There is another customer with this unique registration number!',
        DuplicateCompanyName: 'There is already a customer with this name!',
        countryrequired: 'The Country field is required',
        companyNamerequired: 'The Company name field is required',
        cityrequired: 'The City field is required',
      },
      contactMethods: {
        VISIT: 'Visit',
        TEL: 'Phone number',
        EMAIL: 'E-mail',
      },
    },
    existingCompanyError: 'The company you want to add is already registered in the platform',
    error: {
      requiredUniqueIdNumber: "The 'Unique identification number' is required",
      requiredPreferredLanguage: "The 'Language' field is required",
      requiredInvoiceSeriesPrefix: "The 'Invoice Series Prefix' field is required",
      requiredCountry: "The 'Country' field is required",
      requiredCompanyName: "The 'Company name' field is required",
      companyTypeMismatch: 'Registered company type is different from the one selected',
      patternUniqueIdNumber: 'This field must contain at least 2 digits and should not have any spaces',
    },
    employee: {
      error: {
        requiredValidTo: 'The Valid to field is required',
        requiredValidFrom: 'The Valid from field is required',
        requireduserName: 'The Username field is required',
        requiredPerson: 'The Person field is required',
        requiredpassword: 'The Password field is required',
        requiredname: 'The Name field is required',
        requiredcounty: 'The Country field is required',
      },
      common: {
        newDepartment: 'New department',
        departmentName: 'Department name',
      },
    },
    emailImportSettings: 'E-mail import settings',
    discount: 'On the date of payment you will benefit from the following discount',
    description: 'Enter the details for the company administrator user.',
    creditCard: {
      expirationDateFormat: 'MM/YY',
      expirationDate: 'Expiration date',
      error: {
        requiredName: 'The Name field is required',
        requiredExpirationDate: 'The Expiration date field is required',
        requiredCardNumber: 'The Number card field is required',
        invalidExpirationDate: 'Invalid expiration date',
        invalidCardNumber: 'Invalid card number',
      },
      cardOwner: 'Name',
      cardNumber: 'Card number',
      card: 'Card',
    },
    createServiceProvider: 'Service provider',
    country: 'Country',
    contact: 'Contact',
    confirm: 'Confirm',
    companyTabTitle: 'Company ',
    companyTabHeader: 'Company details',
    companyRegistration: 'Company registration',
    companyName: 'Company name',
    companyInfo: {
      title: 'Company information',
      confirmPassword: {
        error: {
          'Bad credentials': 'Incorrect password!',
        },
      },
      confirmLegalEntitySignup: 'Confirm company registration',
    },
    companyFormSubTitle: 'These are the official data from the Ministry of Finance',
    'company-info': 'Company information',
    close: 'Close',
    city: 'City',
    cardTabTitle: 'Card',
    cardTabHeader: 'Add card',
    bankAccountTabTitle: 'Bank accounts',
    bankAccountTabHeader: 'Add bank account',
    autocompletePlaceholder: 'Search registered company',
    address: {
      errors: {
        alreadyExistingAddressOfType: 'There is already an address of this type for this company',
      },
    },
    addCompany: 'Add new company',
    actions: {
      list: {
        validTo: 'Valid to',
        validFrom: 'Valid from',
        title: 'Actions list',
        subscriptionTypeName: 'Subscription name',
        subscriptionTypeModule: 'Subscription mode',
        search: 'Search',
        name: 'Name',
        monthlyIncludedAmount: 'Included monthly ',
        cost: 'Cost',
        adminTitle: 'Action administration ',
      },
      inputs: {
        validTo: 'Valid to ',
        validFrom: 'Valid from',
        monthlyIncludedAmount: 'Included monthly ',
        actionName: 'Action name',
        actionCost: 'Action cost ',
      },
      errors: {
        requiredcost: 'The Action cost field is required',
        requiredactionName: 'The Action name field is required',
      },
      detailTitle: 'Action details',
      addTitle: 'Add action',
    },
    'account-type': {
      'vendor-description': 'Receive shipment orders.',
      vendor: 'Vendor',
      title: 'Account type',
      'expedition-house-description': 'Intermediate transport orders.',
      'expedition-house': 'Forwarder',
      'client-with-fleet-description': 'Send shipment orders with own fleet',
      'client-with-fleet': 'Customer with fleet',
      'client-description': 'Send shipment orders.',
      client: 'Customer',
    },
  },
  'shipment-timeline': {
    utils: {
      workInProgressSolution: 'View work in progress',
      shipments: (param) => `${param.shipments} ` + (param.shipments === '1' ? 'shipment' : 'shipments'),
      orderStatus: 'Order status',
      inactiveTooltip: "You haven't reached this stage yet",
      date: 'On the date of',
      consolidation: 'Consolidation',
      availableDocuments: 'Available documents',
      attachments: 'Attachments',
      addSolution: 'Add a solution ',
    },
    solutionTab: {
      solution: 'Solution',
      signup: 'Sign up',
      routingOptions: (solutionTab) =>
        `${solutionTab.routingOptions} ` + (solutionTab.routingOptions === 1 ? 'routing option' : 'routing options'),
      requestOffer: 'Request offer',
      requestPreOffer: 'Request pre-offer',
      receivedOffers: (solutionTab) =>
        solutionTab.receivedOffers !== null
          ? `${solutionTab.receivedOffers} ` + (solutionTab.receivedOffers === 1 ? 'offer received' : 'offers received')
          : '0 offers received',
      preferredCompleteSolution: 'Preferred complete solution',
      order: 'Order',
      orderDisabled: 'This action is not available for offer requests stage',
      preOrder: 'Pre-order',
      preOrderDisabled: "This action is not available for offer requests stage'",
      task: 'Task',
      taskDisabled: 'This action is not available for this offer request or order',
      taskTooltip: 'Create a task that will be solved with your fleet',
      requestOfferTooltip: 'Request an offer from partner vendors',
      orderTooltip: 'Send an order to a partner vendor',
      notAllow: 'This action is reserved for customers registered on the platform',
      completeSolutions: (solutionTab) =>
        `${solutionTab.completeSolutions} ` +
        (solutionTab.completeSolutions === 1 ? 'complete solution' : 'complete solutions'),
      completeSolution: 'Complete solution',
    },
    'shipment-management': 'Shipment Management',
    orderTrackingTab: {
      transport: 'Shipment',
      segmentsSolution: (orderTrackingTab) =>
        `Solved with ${orderTrackingTab.segmentsNo} ` + (orderTrackingTab.segmentsNo === 1 ? 'segment' : 'segments'),
      pickUpDate: 'Pick up date',
      in_transit: 'In transit',
      complaints: 'Complaints',
    },
    orderTab: {
      viewVehicle: 'View vechicle',
      viewResume: 'View shipments resume',
      price: (param) =>
        param.value && param.currencyCode ? `Price: ${param.value} ${param.currencyCode}` : 'Price: -',
      orderReceived: 'Order received',
      currency: 'RON',
    },
    offerRequestTab: {
      receivedOfferRequest: 'Received offer request',
      offersSent: (offerRequestTab) =>
        `${offerRequestTab.offersSent} ` + (offerRequestTab.offersSent === '1' ? 'offer sent' : 'offers sent'),
      offerRefused: 'Offer refused',
      offerAccepted: 'Offer accepted',
    },
    'notification-monitoring-tooltip': 'Currently there are no notifications that can be monitored',
    'notification-monitoring': 'Notification monitoring',
    invoiceTab: {
      paymentTerm: (invoiceTab) =>
        `Payment term ${invoiceTab.paymentTerm} ` + (invoiceTab.paymentTerm === '1' ? 'day' : 'days'),
      invoice: 'Invoice',
      account: 'Account',
    },
    'delivery-monitoring': 'User actions monitoring',
    change: {
      segment_solution_created: 'New routing option created',
      order_status_updated: 'Status has changed',
      order_created: 'Order has been created',
      offer_received: 'New offer received',
      offer_added: 'New offer has been created',
      mrs_created: 'Completely new solution has been created',
      marked_mrs_preferred: 'A complete solution was marked as preferred',
      invoice_created: 'Invoice has been created',
    },
  },
  'shell-app': {
    termsAndConditions: {
      validFrom: 'Date of the action',
      title: 'Terms and conditions',
      needLogin: 'To be able to do actions or to visualize the status of your agreement, you must be authenticated',
      acceptedMessage: 'The terms and conditions were accepted successfully!',
      retryLater: 'The pdf is not yet generated, please try again later!',
      error: {
        user_agreement_exists: 'The terms and conditions have been accepted for this user. Reload the page to move on.',
        email_agreement_exists:
          'The terms and conditions have been accepted for this email address. Please reload the page to move on.',
        defaultValidationMessage: 'An error has occurred!',
      },
      accepted: 'You accepted the Terms and Conditions.',
      accept: 'Accept Terms and Conditions',
    },
    navigationMenu: {
      selectItems: 'Select items',
      myCompany: 'My company',
      logout: 'Logout',
      delivery: 'Delivery',
      crm: 'CRM',
      allCompanies: 'Companies',
      saftLabel: 'SAF-T',
    },
    dashboard: {
      delivery: 'Delivery',
      crm: 'CRM',
      companyAdministration: 'Company administration',
      saft: 'SAF-T',
    },
    companyValidation: {
      validateCompanyDetails: 'Validate company data',
      title: 'Company data validation',
      enableCompanyValidation: 'I confirm the authenticity of the company data',
      validatedMessage: 'Company details successfully validated!',
    },
  },
  sharedComponents: {
    timeInterval: {
      startTime: 'HH:mm ex: 08:00',
      endTime: 'HH:mm ex: 16:00',
    },
    search: 'Search ',
    numberInterval: {
      startNumber: 'Start...',
      endNumber: 'End...',
    },
    'language-dialog': {
      'select-language': 'Select language',
      language: 'Language',
    },
    errors: {
      minLengthWaypoints: 'Add at least 2 locations',
    },
    dateRange: {
      start: 'Start Date...',
      end: 'End Date...',
    },
    dateTimeRange: {
      start: 'Start Time',
      end: 'End Time',
    },
    attachments: {
      invalidTotalFileSizeMessageSummary: 'Total limit reached!',
      invalidTotalFileSizeMessageDetail: 'The size of all files cannot exceed 10MB.',
      invalidFileSizeMessageSummary: 'Limit reached! ',
      invalidFileSizeMessageDetail: 'A file cannot exceed 2MB in size.',
      fileRemoved: 'The file was successfully deleted!',
      confirmed: 'Confirm',
      confirmDeletionMessage: 'Are you sure you want to delete this file?',
      confirmationHeader: 'Confirm',
    },
  },
  'shared-providers': {
    'deactivate-message': 'You have unsaved changes! If you leave, your changes will be lost.',
  },
  'select-items': {
    all: 'All',
  },
  'select-account': 'Select account',
  'scheduled-utils': {
    stopRecurrenceMessage: 'Are you sure you want to stop the recurrence?',
    stopRecurrenceConfirmation: 'Confirm recurrence stop',
    stopRecurrence: 'Stop recurrence',
    recurrentShipmentTooltip: 'Recurrent shipment until',
    open: 'Open',
    newScheduledFromTemplate: 'Create scheduled shipment from template',
    edit: 'Edit',
    deleteTemplateMessage: 'Are you sure you want to delete the selected template?',
    deleteTemplate: 'Delete template',
    deleteConfirmation: 'Confirm deletion',
    delete: 'Delete',
    close: 'Close',
    add: 'Add',
  },
  'scheduled-shipments': {
    'filter-fields': {
      transportProject: 'Transport projects',
      shipmentFlowType: 'Flow type',
      pickupStart: 'Pickup date',
      pickupCompanyName: 'Pickup company',
      pickupCity: 'Pickup city',
      filterTags: 'Tags',
      externalReference: 'External reference',
      shipmentSeries: 'Shipment series',
      deliveryCompanyName: 'Delivery company',
      deliveryCity: 'Delivery city',
      createdAt: 'Created at',
      vendor: 'Vendor',
      type: 'Type',
      pickupLocation: 'Pickup location',
      deliveryLocation: 'Delivery location',
    },
    'empty-list': "The list is empty. Add a scheduled shipment using the 'Add' button above.",
    'edit-scheduled-shipment': 'Edit scheduled shipment',
    deleteConfirmation: 'Are you sure you want to delete the scheduled transport?',
    'delete-title': 'Delete confirmation ',
    assignToMe: 'Assign to me',
    assignedToMe: 'Assigned to me',
    'add-scheduled-shipment-from-template': 'Add scheduled shipment from template',
    'add-scheduled-shipment': 'Add scheduled shipment',
  },
  'scheduled-shipments-shared': {
    'invalid-order-button-tooltip': 'Select shipments with the same service provider and currency per tariff ',
    filter: 'Filter',
    'create-order-info-message':
      'In order to send an order, each tariff shipment must have the same service provider and currency.',
    'create-order-button-text': 'Create order',
    'create-supplier-order-button-text': 'Create supplier order',
    'create-offer-request-info':
      'Select at least one scheduled transport and/or a template, then press one of the buttons below.',
    'create-offer-request-button-text': 'Create request for offer',
    'change-layout': 'Change page size',
  },
  'route-share-location': {
    'view-route': 'View route',
    'total-package-weight': 'Total weight',
    'total-package-volume': 'Total volume',
    'total-package-count': 'Package number',
    title: 'Share route checkpoint',
    'shared-with': 'Shared with',
    'shared-by': 'Shared by',
    'share-checkpoint': 'Share',
    'sent-route-share-location': 'Sent shared checkpoints',
    'saved-succes': 'Route checkpoint saved successfully!',
    'received-route-share-location': 'Received shared checkpoints',
    'no-data-share-checkpoint': 'There are no shared checkpoints',
    list: 'Go to list',
    'future-checkpoints': 'Next checkpoints',
    form: {
      'task-checkpoint-required-error': 'Select a checkpoint',
      partners: 'Partners',
      checkpoint: 'Checkpoint',
    },
    'final-destination': 'Final destination',
    'driver-phone': 'Driver phone',
    'driver-name': 'Driver name',
    details: 'Details',
    back: 'Go back',
  },
  resourceSavedNavigationDialog: {
    title: 'Successfully saved!',
    closeButton: 'Stay on page',
    backButton: 'Back',
  },
  'resource-dropdown': {
    utils: {
      'empty-message': 'No results found.',
    },
  },
  'resource-availability': {
    selectRole: 'Select role',
    selectResType: 'Select resource type',
    search: 'Search',
    resType: 'Resource type',
    resRole: 'Resource role',
    partTimeDelegation: 'Partial delegation',
    name: 'Name',
    fullTimeDelegation: 'Full time delegation',
    department: 'Department',
    delegation: 'Delegation',
    availability: 'Availability',
  },
  'reporting-client-lib': {
    template: {
      xml: 'XML Template',
      xls: 'Excel Template',
      uploadXML: 'Upload XML Template',
      uploadXLS: 'Upload Excel Template',
      title: 'Reports - Template',
      parentFolder: 'Parent folder',
      new: 'New Template',
      edit: 'Edit Template',
      createdBy: 'Uploaded By',
      create: 'Create New Template',
    },
    showGeneratedReports: 'Show Generated Reports',
    search: 'Search',
    save: 'Save',
    report: {
      title: 'Reports',
      template: 'Template',
      filter: {
        values: 'Values',
        title: 'Filters',
        negated: 'Negated',
        filterTypes: {
          LT: 'Littel',
          LIKE: 'Like',
          LE: 'mLittle or Equal',
          IS_NULL: 'I Null',
          IN: 'In',
          GT: 'Greater',
          GE: 'Greater or Equal',
          EQUALS: 'Equal',
          BETWEEN: 'Between',
        },
        filterType: 'Operator',
        dataType: 'Type',
        columnName: 'Colum Name',
      },
      edit: 'Edit Report',
      cron: {
        weekDays: 'Select Week Days',
        title: 'Timetabe',
        time: 'Select Time ',
        schedule: 'Schedule',
        months: 'Select Month Days',
        monthDays: 'Select Month',
        cronExpression: 'Cronological Expression',
      },
      create: 'Create New Report',
    },
    refresh: 'refresh',
    private: 'Private',
    parametrized: 'Parametrized',
    parameters: 'Parameters',
    noRecords: 'No Records',
    newFolder: 'New folder',
    new: 'New',
    name: 'Name',
    hello: 'Hello!',
    generateReport: 'Generate Report',
    generatedReports: {
      title: 'Generated Reports',
      executionTime: 'Execution duration',
      dataLinesNumber: 'Result size',
    },
    generate: 'Generate',
    folder: 'Folder',
    error: {
      'xml-error': 'XML invalid!',
      'xls-error': 'EXCEL invalid!',
      'validation-error': 'Validation error!',
    },
    edit: 'Edit',
    download: 'Download',
    details: 'Details',
    delete: 'Delete',
    date: 'Date',
    createReport: 'Create Report',
    createFolder: 'Create new directory',
    createdBy: 'Created By',
    columns: 'Columns',
    cancel: 'Cancel',
    back: 'Back',
    authorization: 'Autorization',
  },
  pwl: {
    yes: 'Yes',
    search: 'Search',
    save: 'Save',
    reset: 'Reset',
    remove: 'Delete',
    person_edit: 'Edit person',
    person_delete: 'Delete this person?',
    person_create: 'Create person',
    no: 'No',
    name: 'Name',
    list_title: 'People',
    idSeries: 'ID Series',
    idNumber: 'ID Number',
    edit: 'Edit',
    detail_title: 'Person details',
    county: 'County',
    confirm_delete: 'Delete confirmation',
    cnp: 'Cnp',
    back: 'Back',
    address: 'Address',
  },
  priceManagement: {
    utils: {
      currency: 'Currency',
    },
    error: {
      requiredValue: 'Price is required!',
      requiredCurrencyCode: "The  'Currency' field is required!",
      currencyCoderequired: 'Currency is required!',
    },
  },
  price: {
    value: 'Price',
    currencyCode: 'Currency ',
  },
  'platform-company-contact-form': {
    send: 'Send',
    leaveUsAMessage: 'Leave us a message!',
    inputs: {
      subject: 'Subject',
      message: 'Message',
      email: 'E-mail',
      company: 'Company',
      category: 'Category',
      categoriesPlaceholder: 'Select a category',
      categories: {
        TECHNICAL_ISSUES: 'Technical problems',
        SERVICE_INFORMATION: 'Service information',
        QUESTION: 'Question',
        OFFER_REQUEST: 'Offer request',
        FEEDBACK: 'Feedback',
        COMPLAINTS: 'Complaints',
        ACCOUNT_ASSISTANCE: 'Account assistance',
      },
    },
    error: {
      requiredSubject: 'E-mail subject is required!',
      requiredMessage: 'The message is required!',
      requiredEmail: 'E-mail is required!',
      emailEmail: 'E-mail address is not valid!',
    },
  },
  'platform-administration': {
    utils: {
      search: 'Search',
      save: 'Save',
      platformCompany: 'Company platform',
      emptyMessage: 'No results were found',
      details: 'Company details',
      cancel: 'Cancel',
      billingDetails: 'Platform billing data administration',
      all: 'All',
    },
    subscriptionHistory: {
      validTo: 'Valid to',
      validFrom: 'Valid from',
      typeName: 'Subscription name',
      subscriptionPrice: 'Price',
      subscriptionCurrency: 'Currency',
      'list-title': 'Subscription history',
    },
    legalEntity: {
      validTo: 'Valid to',
      validFrom: 'Valid from',
      uniqueIdNumber: 'Unique identification number',
      subscriptionStatus: 'Subscription status',
      subscriptionPrice: 'Price',
      subscriptionCurrency: 'Currency ',
      paymentPeriods: {
        OVERDUE: 'Overdue',
        IN_TIME: 'In time',
      },
      activeStatuses: {
        true: 'Active',
        false: 'Inactive',
      },
      overduePaymentTerm: 'Payment due date',
      'list-title': 'Company subscriptions',
      invalidateSubscription: 'Delete subscription and company data',
      reactivateSubscription: 'Reactivate subscription and company data',
      invalidateMessage:
        'Your subscription and all details about the company will be deleted! Are you sure you want to continue?',
      reactivateMessage:
        'Your subscription and all details about the company will be restored! Are you sure you want to continue?',
      invalidateDialogHeader: 'Confirm company data deletion',
      reactivateDialogHeader: 'Confirm company data restoration',
      inactive: 'Inactive',
      dialogButtonMessages: {
        yes: 'Yes',
        no: 'No',
      },
      'detail-title': 'Company details',
      createdAt: 'Created at ',
      companyName: 'Company name',
      active: 'Active',
    },
    invoice: {
      totalPrice: 'Total price',
      priceCurrencyCode: 'Currency',
      paymentTimeLimit: 'Payment time limit',
      paymentStatuses: {
        UNPAID: 'Unpaid',
        PAID: 'Paid',
      },
      paymentStatus: 'Payment statut',
      paymentDueDate: 'Payment due date',
      payment: {
        paymentDate: 'Payment date',
      },
      markAsPaid: 'Mark as paid',
      'list-title': 'Invoice history',
      issueDate: 'Invoice issue date',
      invoiceSeries: 'Invoice series ',
      download: 'Download invoice',
    },
    company: {
      'legal-entity': {
        title: 'Platform Company',
        inputs: {
          uniqueIdentificationNumber: 'Unique Identification Number',
          registrationCode: 'Registration Code',
          preferredLanguage: 'Preferred Language',
          mainPhoneNumber: 'Main Phone Number',
          mainEmailAddress: 'Main Email Address',
          invoicingTerms: {
            paymentTimeLimit: 'Payment due date',
            invoiceSeriesPrefix: 'Invoice series prefix',
          },
          companyName: 'Company Name',
          bankAccount: {
            swiftCode: 'Swift code',
            iban: 'IBAN',
            currencyCode: 'Currency',
            bankName: 'Bank ',
          },
          address: {
            state: 'County',
            postalCode: 'Postal code',
            country: 'Country',
            city: 'City',
            addressLine: 'Address line',
          },
        },
        errors: {
          requiredUniqueIdentificationNumber: "'Unique Identification Number' is required",
          requiredRegistrationCode: "'Registration Code' is required",
          requiredPreferredLanguage: "'Preferred Language' is required",
          requiredCompanyName: "'Company Name' is required",
        },
      },
    },
  },
  place: {
    searchOnGoogle: 'Search on Google Maps',
  },
  personManagement: {
    input: {
      name: 'Name',
      idSeries: 'ID Series',
      idNumber: 'ID Number',
      error: {
        requiredName: "The  'Name' field is required",
        requiredCounty: "The  'County' field is required",
      },
      county: 'County',
      country: 'Country',
      address: 'Address',
    },
  },
  person: {
    idSeries: 'Series ID',
    idNumber: 'Number ID',
  },
  pdf: {
    yes: 'Yes',
    uploadFile: 'Upload file',
    template: 'Template',
    search: 'Search',
    save: 'Save',
    remove: 'Delete order',
    pdf_delete: 'Are you sure you want to delete this template?',
    no: 'No',
    name: 'Name',
    list_title: 'List of PDF templates',
    key: 'Key',
    error: {
      startDateAfterEndDate: 'The end date must be greater in calendar terms than the start date!',
      requiredresources: 'At least one resource must be chosen!',
      requireddates: 'Both a start and end date for the allocation must be chosen!',
      required: 'This field is required!',
      defaultValidationMessage: 'An error has occurred. Check the data entered and try again',
    },
    edit_title: 'PDF Template',
    edit: 'Edit template',
    date: 'Date',
    create: 'Add new template',
    confirm_selection: 'Confirm selection',
    confirm_delete: 'Confirm delete',
    children: 'Secondary templates',
    cancel: 'Cancel',
    back: 'Back',
    author: 'Author',
  },
  paymentTermBannerMessage: 'The payment deadline for the last invoice issued by the platform has expired',
  'payments-per-invoice': {
    utils: {
      search: 'Search',
      all: 'All',
    },
    list: {
      toBankAccount: 'To bank account',
      title: 'Payments on invoice',
      paymentStatusType: 'Payment status',
      paymentStatuses: {
        deallocated: 'Deallocated',
        canceled: 'Canceled',
        accepted: 'Accepted',
      },
      paymentDate: 'Payment date',
      paidAmount: 'Paid amount',
      invoiceSeries: 'Invoice series',
      fromBankAccount: 'From bank account',
      currencyCode: 'Currency',
    },
  },
  'payment-method': {
    retry: 'Retry Payment',
    refresh: 'Refresh',
    'pending-payment-method': 'Your card is under verification. Please try again later',
    'payment-order': 'Payment Order',
    'payment-method': 'Payment Method',
    'long-processing-warning': 'The payment processing is taking longer than usual',
    'failed-payment-method': 'Card authorization failed. Please retry',
    'change-payment-method': 'Change payment method',
  },
  order: {
    tariffs: 'Tariffs',
    price: 'Price',
    orderNumber: 'Order number',
    'navigation-suggestions': {
      back: 'Back',
    },
    invalidShipmentTariffs: 'Each shipment should have a tariff selected',
    invalidCurrencyShipments: 'Shipment tariffs must have the same currency',
    errors: {
      requiredVendor: 'This field is required',
    },
    details: 'Order details',
    specialConditions: 'Special conditions',
    orderExternalPackages: 'Ad-hoc scanned packages',
    customerName: 'Customer name',
    currencyCode: 'Currency',
    contract: 'Contract',
    contactsMissing: 'Each shipment should have contact fields completed',
    clientOrders: 'Customer orders',
    'add-page-title': 'Add new order',
    addOrderSubcontractingPageTitle: 'Subcontract with new order',
    'add-internal-page-title': 'Add new internal order',
    addPreOrderPageTitle: 'Add new pre-order',
    addPreOrderSubcontractingPageTitle: 'Subcontract with new pre-order',
  },
  'order-consolidation': {
    viewOrder: 'View order',
    order: 'Order',
    customerOrders: 'Customer orders',
  },
  'offer-request': {
    'sp-offer-request-reject': {
      title: 'Reject request offer',
      'reject-status': 'Refusal reason ',
    },
  },
  notification: {
    DELIVERY_ORDER_STATUS_CHANGED_FOR_CUSTOMER: 'Changed Order Status Mail',
    DELIVERY_ORDER_SENT: 'Order Sent Mail',
    DELIVERY_ORDER_RECEIVED: 'Order Received Mail',
    DELIVERY_ORDER_HANDOVER_SP_ALERT_MAIL: 'Handover Alert Mail',
    DELIVERY_ORDER_HANDOVER_ALERT_MAIL: 'Handover Alert Mail',
    DELIVERY_ORDER_CANCEL_REQUEST_REJECTED: 'Reject Cancellation Request Mail',
    DELIVERY_ORDER_CANCEL_REQUEST: 'Cancel Request Mail',
    DELIVERY_ORDER_CANCEL: 'Order Cancelled Mail',
    DELIVERY_OFFER_REQUEST_CREATED_FOR_EXTERNAL_VENDOR: 'New Offer Request Mail',
    DELIVERY_OFFER_REFUSED_FOR_VENDOR_MAIL: ' Refused Offer Mail',
    DELIVERY_OFFER_NEGOTIATION_MAIL: ' Negociation Offer Mail ',
    DELIVERY_OFFER_CREATED_FOR_EXTERNAL_CUSTOMER: 'New Offer Mail ',
    COMPANY_TERMS_AND_CONDITIONS_AGREEMENT_EMAIL: 'Terms & Conditions Agreement Mail',
    COMPANY_DETAILS_EMAIL: ' Invite to Platform Mail',
    AUTH_USER_PASSWORD_RECOVERY: 'Password Recovery Mail',
    AUTH_USER_EMAIL_CONFIRMATION: 'Confirmation E-mail',
    AUTH_SUPER_ADMIN_USER_EMAIL_CONFIRMATION: 'Super Admin Confirmation Mail',
  },
  'notification-ui': {
    title: 'Notifications',
    delete: 'Delete',
  },
  notif: {
    utils: {
      tableEmptyMessage: 'No results were found',
      search: 'Search',
      all: 'All',
    },
    username: 'Username',
    type_params: 'Type params',
    type: 'Type',
    subject: 'Subject',
    status: {
      SENT: 'Sent',
      SENDING: 'Sending',
      SEEN: 'Seen',
      PENDING: 'Pending',
      FAILED_TO_SEND: 'Failed to send',
    },
    sentList: {
      title: 'Sent notifications',
      subject: 'Subject',
      status: 'Notification status',
      senderType: 'Notification type',
      recipientAddress: 'Recipient',
      processingStatus: 'Processing status',
      eventType: 'Notification name',
      entityUuid: 'Entity ID',
      createdAt: 'Created at',
    },
    senderType: {
      PUSH: 'System notification',
      IN_APP: 'In app notification',
      EMAIL_WITH_ATCH: 'Email with attachment',
      EMAIL: 'Email',
      SES_EMAIL: 'SES Email',
      SES_EMAIL_WITH_ATTACH: 'SES Email with attachment',
    },
    senders: 'Senders',
    sender_type: 'Sender type',
    recipients: 'Recipients',
    protocol: 'Protocol',
    properties: 'Properties',
    processingStatus: {
      PROCESSING: 'Processing',
      PROCESSED: 'Processed',
      PENDING: 'Pending',
      FAILED_TO_PROCESS: 'Failed to process',
    },
    processing_status: 'Processing status',
    port: 'Port',
    password: 'Password',
    notifications_list: 'Notifications',
    notifiable_event: 'Event',
    notif_sender_config_list: 'Sender configurations',
    notif_config_list: 'Notification configurations',
    msg: {
      delete: 'Do you want to delete this record?',
    },
    mail_acc_list: 'Mail accounts',
    host: 'Host',
    group_content_template: 'Group content template',
    group_content: 'Group content',
    expected_type_params: 'Expected type params',
    event_type: 'Event type',
    edit_config: 'Edit config',
    description: 'Description',
    delete_confirmation: 'Delete confirmation',
    default_recipients: 'Default recipients',
    date: 'Date',
    content_template: 'Content template',
    content_params: 'Content params',
    config_params: 'Settings',
    body: 'Body',
    add_new_config: 'Add new config',
    add_new_acc: 'Add new account',
    _eventType: {
      MISSING_TIMEKEEPING_MANAGEMENT: 'Missing timekeepings - managers',
      MISSING_TIMEKEEPING_ENTRIES: 'Missing timekeepings',
      DELEGATION_ORDER_AWAITING_APPROVAL: 'Delegation orders awaiting approval',
      DELEGATION_ORDER_APPROVED_OR_REJECTED: 'Delegation order aproval/rejection',
    },
  },
  'not-found': {
    title: 'Page not found!',
    message: 'Unfortunately, the page you are looking for does not exist.',
    errorMessage: '404',
    back: 'Go back to Dashboard',
  },
  legalEntity: {
    selectCountry: 'Select a country ',
    noCompanyFound: "Didn't find the company? Add a company manually",
    inputs: {
      vatSplitStatus: 'VAT Split Status',
      vatRegistration: 'VAT Registration',
      vatInactiveStatus: 'VAT Inactive Status',
      vatInactivationDate: 'VAT Inactivation Date',
      uniqueIdNumber: 'Unique Identification Number',
      registrationCode: 'Registration Code',
      preferredLanguage: 'Language',
      officeAddress: 'Office address',
      mainPhone: 'Main Phone Number',
      mainEmailAddress: 'Main Email',
      mainAddress: 'Main Address',
      industryType: 'Industry Type',
      financialAddress: 'Financial address',
      emailImportSettings: 'Email Import Settings',
      country: 'Country',
      companyName: 'Company Name',
      city: 'City',
    },
    existentAnafCompanyLabel: 'Company data may exist in platform, those being imported from ANAF platform',
    error: {
      requiredUniqueIdNumber: "Field 'Unique Identification Number' is required",
      requiredPreferredLanguage: "Field 'Language' is required",
      requiredOfficeAddressDTO: "Field 'Office address' is required",
      requiredFinancialAddressDTO: "Field 'Financial address' is required",
      requiredCountry: "Field 'Country' is required",
      requiredCompanyName: "Field 'Company Name' is required",
      noLegalEntityCreated:
        "To save the company details, fill in the Company Name or Unique Identification Number and select one of the displayed options. If the searched company does not appear, press the 'Add manual company' button",
      invalidFinancialAddressDTO: 'Fill in all the required fields',
      invalidOfficeAddressDTO: 'Fill in all the required fields',
      patternUniqueIdNumber: 'This field must contain at least 2 digits and should not have any spaces',
    },
    country: 'Country',
    confirmationDialog: {
      dialogMessage: 'The selected information is official and taken from ANAF',
      dialogHeader: 'Modification of ANAF data',
      cancelLabel: 'Cancel',
      acceptLabel: 'I want to change the data',
    },
    closeInputs: 'Back to company search',
    autocompletePlaceholder: 'Search existing company in platform',
    autocomplete: 'Company name or Unique Identification Number',
    addManualCompany: 'Add manual company',
  },
  job: {
    utilizationHint: {
      UTILIZATION_MINOR: 'Minor',
      UTILIZATION_MAJOR: 'Major',
      UTILIZATION_DEFAULT: 'Default',
      UTILIZATION_CONSIDERABLE: 'Considerable',
    },
    utilization: 'Utilization Level',
    status: 'Status',
    search: 'Search...',
    retry: 'Retry',
    priority: 'Priority',
    prerequisistes: 'Retry after:',
    parameterType: {
      STRING: 'STRING',
      NUMERIC: 'NUMERIC',
      DATE: 'DATE',
      BOOLEAN: 'BOOLEAN',
    },
    options: 'Options',
    log_executions: {
      thread_name: 'Thread Exe Name',
      processing_started_at: 'Processingstrating at',
      processing_ended_at: 'Processing ended',
      originator_system: 'Originator System',
      logger_name: 'Logger Name',
      log_message: 'Log Message',
      log_level: 'Log Level',
      log_executions: 'Log Execution',
      execution_duration: 'Processing Duration',
    },
    lastTriggeredAt: 'Last Triggered At',
    job_name: 'Job Name',
    job_executions: {
      processing_started_at: 'Processing started at',
      processing_ended_at: 'Processing ended at',
      priority: {
        Medium: 'Medium',
        Lowest: 'Lowest',
        Lower: 'Lower',
        Low: 'Low',
        Highest: 'Highest',
        Higher: 'Higher',
        High: 'High',
        Default: 'Default',
      },
      originator_system: 'System originar',
      jobExecutionStatus: {
        WAITING: 'Waiting other jobs',
        SUCCESSWITHWARNING: 'Success with warning',
        SUCCESS_WITH_WARNING: 'Success with warning',
        SUCCESS: 'Success',
        STOPPING: 'Stopping',
        PROCESSING: 'Processing',
        PENDING: 'Pending',
        HALTED: 'Stopped',
        ERROR: 'Error',
      },
      job_executions: 'Job Execution',
      execution_duration: 'Execution Duration',
      cron_expression: 'Cronological expression ',
    },
    job_descr: 'Description',
    job_definitions: {
      status: {
        TRIGGERED: 'Triggered',
        SCHEDULED: 'Scheduled',
        NOT_TRIGGERED: 'Not Triggered',
        INTERRUPTED_TRIGGERED: 'Triggered',
        INTERRUPTED: 'Intrerupted',
        ARCHIVED: 'Archived',
      },
      job_parameters: 'Job Parameters',
      job_definitions: 'Programed Jobs',
    },
    job: 'Job',
    exception_details: 'Exception Details',
    details: 'Details',
    date: {
      start: 'Start...',
      end: 'ended...',
    },
    createdAt: 'Created At',
    _priority: {
      Medium: 'Medium',
      Lowest: 'Lowest',
      Lower: 'Lower',
      Low: 'Low',
      Highest: 'Highest',
      Higher: 'Higher',
      High: 'High',
      Default: 'Default',
    },
  },
  'issue-reporter': {
    user: 'User',
    type: 'Issue type',
    'text-notes-description': '(optional) position yourself on the faulty item, select it and add a description',
    'text-notes': 'Select elements with issues',
    summary: 'Summary',
    submit_feedback: 'Submit feedback',
    submit_comment: 'Submit comment',
    'paint-description': '(optional) you can highlight, try, draw arrows, etc.',
    paint: 'Paint',
    message: 'Message',
    'form-description': 'the main problem encountered is introduced',
    form: 'Form',
    description: 'Description',
    actions_description: 'Actions description',
  },
  'invoice-payment': {
    utils: {
      yes: 'Yes',
      search: 'Search',
      no: 'No',
      confirm: 'Confirm action ',
      all: 'All',
    },
    'reject-payment-form': {
      reason: 'Rejection reason',
    },
    'payment-form': {
      toBankAccount: 'To bank account',
      paymentReference: 'Payment reference',
      paymentDate: 'Payment date',
      paidAmount: 'Amount',
      fromBankAccount: 'From bank account',
      currency: 'Currency',
    },
    'new-per-invoice': {
      title: 'Add receipt to invoice',
      infoText: (params) => {
        const { invoiceSeries, remainingCost, currencyCode } = params;
        if (invoiceSeries && invoiceSeries.length > 1) {
          const formattedInvoiceSeries = invoiceSeries
            .map((series: any, index: any) => `${index + 1}.${series}`)
            .join(', ');
          return `Collect payment for invoices with the series ${formattedInvoiceSeries}. The remaining amount to be collected ${remainingCost} ${currencyCode}`;
        }
        return `Collect payment for invoices with the series ${invoiceSeries[0]}. The remaining amount to be collected ${remainingCost} ${currencyCode}`;
      },
    },
    'mark-as-paid': {
      title: 'Mark as cashed',
      customer: {
        title: 'Mark as paid',
      },
    },
    list: {
      toBankAccount: 'To bank account',
      sold: 'Balance',
      serviceProviderName: 'Provider name',
      sendPaymentDoneMail: 'Send payment on e-mail',
      'receipts-title': 'Receipts',
      paymentStatuses: {
        deallocated: 'Deallocated',
        canceled: 'Canceled',
        accepted: 'Accepted',
      },
      paymentStatus: 'Payment status',
      'payments-title': 'Payments',
      paymentReference: 'Payment reference',
      paymentDate: 'Payment date',
      paymentAgreementStatuses: {
        rejected: 'Rejected',
        pending: 'Pending',
        finalized: 'Finalized',
      },
      paymentAgreementStatus: 'Agreement status',
      paidAmount: 'Paid amount',
      openPartialPayments: 'Open intermediate payments',
      invoiceSeries: 'Invoice series',
      invoicePaymentStatus: {
        UNPAID: 'Unpaid',
        PARTIAL_PAID: 'Partially paid',
        PAID: 'Paid',
      },
      invoiceDetailsTooltip: 'Click for invoice details',
      fromBankAccount: 'From bank account',
      deallocatePayment: 'Deallocate',
      customerName: 'Customer name',
      currencyCode: 'Currency',
      createdBy: 'Created by',
      cancelPayment: 'Cancel',
      canceledBy: 'Canceled by',
      acceptPaymentMessage: 'Are you sure you want to accept payment? This action is irreversible!',
    },
    filters: {
      paymentAgreementStatusPending: 'Cash receipts pending',
    },
    errors: {
      requiredToBankAccountUuid: 'The To bank account field is required',
      requiredPaymentDate: 'The Payment date field is required',
      requiredPaidAmount: 'The Amount field is required',
      requiredFromBankAccountUuid: 'The From bank account field is required',
      requiredCurrencyCode: 'The Currency field is required',
      maxValueExceeded: 'The amount must not exceed the total remaining',
    },
    'deallocate-payment-form': {
      errors: {
        requiredDeallocateReason: 'The Reason for deallocation field is required',
      },
      deallocateReason: 'Deallocate reason',
    },
    customer: {
      title: 'Add payment to your invoice',
      infoText: (params) => {
        const { invoiceSeries, remainingCost, currencyCode } = params;
        if (invoiceSeries && invoiceSeries.length > 1) {
          const formattedInvoiceSeries = invoiceSeries
            .map((series: any, index: any) => `${index + 1}.${series}`)
            .join(', ');
          return `Make payment for the invoices with the series ${formattedInvoiceSeries}. The remaining amount to be paid ${remainingCost} ${currencyCode}`;
        }
        return `Make payment for the invoices with the series ${invoiceSeries[0]}. The remaining amount to be paid ${remainingCost} ${currencyCode}`;
      },
    },
    'cancel-payment-form': {
      errors: {
        requiredCancelReason: 'The Cancel reason field is required',
      },
      cancelReason: 'Cancel reason',
    },
    actions: {
      reject: 'Reject',
      accept: 'Accept',
    },
  },
  'invoice-payment-reject': {
    title: 'Reject payment',
  },
  'invoice-payment-deallocate': {
    title: 'Deallocate payment',
  },
  'invoice-partial-payments': {
    list: {
      title: 'Partial payments on invoices',
    },
  },
  'invoice-cancel': {
    title: 'Cancel payment',
    description: 'Cancel payment',
  },
  integ: {
    upload: 'Upload',
    msg: {
      q_delete_import_def:
        'Are you sure you want to delete this import definition? All associated execution information will be deleted from the execution log.',
    },
    label: 'Label',
    import_parameters: 'Parameters',
    import_label: 'Import label',
    import_execution_list: 'Executed imports',
    import_definition_list: 'Defined imports',
    execution_status: 'Execution status',
    execution_details: 'Execution details',
    edit_import_def: 'Edit import definition',
    duration: 'Duration',
    description: 'Description',
    owner: 'Company',
    delete: 'Delete',
    date: 'Date',
    create_import_def: 'Define new import ',
    cancel: 'Cancel',
    all_values: 'All',
    _executionStatuses: {
      SUCCESS: 'Success',
      FAILURE: 'Failure',
      FAILED: 'Failure',
    },
  },
  'http-error-interceptor': {
    ETransportNotificationInvalidStateException: 'The state of the eTransport has changed. Refresh the page.',
    SingleCompanyContactsSelectedException: 'You have not selected contacts for both companies',
    sent: 'Sent',
    MissingAppropriateAddressException: 'There is no main or mailing address for this company',
    InvalidOrderStatusTransitionException: (params) =>
      `The order cannot switch from status ${params.param0} to status ${params.param1}`,
    in_transit: 'Picked up',
    in_progress: 'In progress',
    GENERAL: 'GENERAL',
    documents_received: 'Sent documents',
    CostCenterDuplicateLabelException: 'There is already a cost center with this name',
    EmployeeUserPhoneNotFoundException:
      'The user associated to the selected employee does not have a validated user phone',
    completed: 'Completed',
    cancelled: 'Cancelled',
    archived: 'Archived',
    OperationalTerritoryPartnerNamedLocationDuplicateException:
      'Some partner and location associations are already present on another active territory',
  },
  greeting: 'hello!',
  'gps-tracking': {
    tooltip: 'Tracking vehicle routes',
    title: (param) => `Tracking vehicle: ${param.licensePlate}`,
    monitoringInterval: 'Vehicle monitoring interval: ',
    interval: {
      startDate: 'Start interval',
      endDate: 'End interval',
    },
  },
  globalFilter: {
    minimizeFilters: '<<',
    expandFilters: '<<',
  },
  globalAccount: 'Global acount',
  generalErrors: {
    isNotServiceProvider:
      'Your company is not a Service Provider. To activate this option please go to your company profile',
  },
  fwl: {
    yes: 'Yes',
    search: 'Search',
    save: 'Save',
    reset: 'Reset',
    remove: 'Delete',
    phone: 'Phone',
    nrComReg: 'Commercial Registration Number',
    no: 'No',
    name: 'Name',
    list_title: 'Firms',
    firm_edit: 'Edit firm',
    firm_delete: 'Delete this firm?',
    firm_create: 'Create firm',
    fax: 'Fax',
    edit: 'Edit',
    detail_title: 'Firm details',
    createBankAccount: 'Create bank account',
    county: 'County',
    confirm_delete: 'Delete confirmation',
    cif: 'Cif',
    capital: 'Capital',
    bankAccounts: 'Bank Accounts',
    bank: 'Bank',
    back: 'Back',
    address: 'Address',
    account: 'Account',
  },
  footer: {
    usefulLinks: {
      termsAndConditions: 'Terms and conditions',
      privacyPolicy: 'Privacy policy',
      links: 'Useful links',
      cookiePolicy: 'Cookie policy',
      ANPC: 'ANPC',
    },
    contactUs: 'Contact us!',
    companyDetails: 'Company details',
  },
  fileStorage: {
    dragAndDrop: 'Drag and Drop',
  },
  'exception-web-lib': {
    system_name: 'System name',
    stack_trace: 'Stack trace',
    search: 'Search... ',
    message: 'Message',
    list_of_exceptions: 'List of exceptions',
    exception_list: 'Exceptions',
    date: 'Date',
    author: 'Author',
  },
  etransport: {
    declarant: {
      messages: 'ANAF messages',
      list: {
        type: 'Type',
        status: 'Status',
        uit: 'UIT',
        declarationCode: 'Declaration code',
        declarationReference: 'Declaration reference',
        postDamage: 'Post-System Outage Status',
        source: 'Source',
        loadId: 'Load id',
        creationDate: 'Creation date',
        modificationDate: 'Modification date',
        operationType: 'Operation type',
        transportDate: 'Transport date',
        pickupCountry: 'Pickup country',
        pickupCode: 'Pickup code',
        pickupName: 'Pickup name',
        deliveryCountry: 'Delivery country',
        deliveryCode: 'Delivery code',
        deliveryName: 'Delivery name',
        vehicleModificationDate: 'Vehicle modification date',
        vehicleNumber: 'Vehicle number',
        trailer1Number: 'Trailer 1 number',
        trailer2Number: 'Trailer 2 number',
        vehicleModifications: 'Vehicle modifications',
        lineCount: 'Line count',
        totalNetWeight: 'Total net weight',
        totalGrossWeight: 'Total gross weight',
        totalValue: 'Total value',
        confirmation: 'Confirmation',
        expiresIn: 'Expires in',
        expired: 'Expired',
        messages: 'Messages',
        actions: {
          seeVehicleModificationsAndAnafMessages: 'See messages details',
        },
      },
      modifiedVehicleMessagesAndMessages: {
        title: 'Details',
      },
      vehicleModifMessages: {
        title: 'Vehicle modifications messages',
        dataModifVeh: 'Date',
        nrVeh: 'Vehicle number',
        nrRem1: 'First trailer number',
        nrRem2: 'Second trailer number',
        codDecl: 'Declaration code',
        refDecl: 'Declaration reference',
        postAvarie: 'Post-System Outage Status',
        sursa: 'Source',
        dataDecl: 'Declaration date',
        idIncarcare: 'Loading ID',
        obs: 'Observations',
      },
      anafMessages: {
        title: 'Messages',
        tip: 'Type',
        mesaj: 'Message',
      },
    },
    uploadStatuses: {
      UPLOAD_SUCCESS: 'Success',
      UNSENT: 'Unsent',
      ERROR: 'Error',
      CONVERSION_ERROR: 'Conversion error',
      COMMUNICATION_ERROR: 'Communication error',
      AUTHORIZATION_ERROR: 'Authorization error',
      CANCEL_SUCCESS: 'Cancelled',
    },
    integration: {
      uploadStatus: 'Upload status',
      cancelConfirmationMessage: 'Are you sure you want the cancel this notification?',
      uit: 'UIT code',
      title: 'eTransport',
      resendButton: 'Resend notification',
      notificationButton: 'eTransport notification',
      uploadButton: 'Send notification',
      uploadButtonTooltip: "The notification isn't complete to be sent",
      modifVehicleButton: 'Modify vehicle',
      checkStatus: 'Check status',
      checkButton: 'Check status',
      duplicateButton: 'Duplicate eTransport',
      moreDetailsMessage: 'For more details, use the button below.',
      cancelButton: 'Cancel',
      deleteButton: 'Delete',
      commercialDataInvitationEmail: 'Commercial data collaboration',
      shipmentDataInvitationEmail: 'Shipment data collaboration',
      anafMessage: 'Message',
      notificationDetails: 'Notification details',
      uits: 'UITs',
      defaultStatusLabel: 'Unsent/Unchecked',
      emailCommercialPartner: 'Send details to commercial partner',
      disabledEmailCommercialPartner:
        'The UIT must be valid, within the validity period and contacts must be selected for the commercial partner',
      disabledEmailShipmentOrganizer:
        'The UIT must be valid, within the validity period and contacts must be selected for the shipment organizer',
      emailShipmentOrganizer: 'Send details to shipment organizer',
      downloadPdf: 'Download PDF',
      anafSearch: 'Search on ANAF server',
    },
    nullUitMessage: 'Unobtained',
    modifVehicle: {
      title: 'Modify eTransport vehicle',
      modifyDateSuggestion: 'The date cannot exceed the validity period of the UIT and cannot be in the past',
      notificationVehicle: 'eTransport notification vehicle',
      form: {
        modificationDate: 'Modification date',
        secondTrailerLicensePlate: 'Second trailer license plate',
        licensePlate: 'License plate',
        firstTrailerLicensePlate: 'First trailer license plate',
        observations: 'Observations',
        errors: {
          requiredModificationDate: "The field 'Modification date' is required",
          requiredLicensePlate: "The field 'License plate' is required",
          patternLicensePlate:
            'The field must be 2 to 20 characters long and contain only uppercase letters and digits.',
          patternFirstTrailerLicensePlate:
            'The field must be 2 to 20 characters long and contain only uppercase letters and digits.',
          patternSecondTrailerLicensePlate:
            'The field must be 2 to 20 characters long and contain only uppercase letters and digits.',
        },
      },
    },
    details: 'eTransport details',
    form: {
      title: 'Add eTransport',
      editTitle: 'Edit eTransport',
      legendRequiredForSending: 'Fields are required for SENDING an eTransport.',
      legendRequiredForSaving: 'Fields are required for SAVING an eTransport (ex: Operation type).',
      shipmentDocument: {
        title: 'Shipment documents',
        observations: 'Observations',
        documentTypes: {
          10: 'CMR (10)',
          20: 'Invoice (20)',
          30: 'Delivery note (30)',
          9999: 'Others (9999)',
        },
        errors: {
          requiredObservations: "The field 'Observations' is required",
          requiredDocumentType: "The field 'Document type' is required",
          requiredDocumentDate: "The field 'Document date' is required",
          maxLength50: 'Campul nu poate depasi 50 de caractere',
          maxLength200: 'Campul nu poate depasi 200 de caractere',
        },
        documentType: 'Document type',
        documentTitle: 'Document',
        documentNumber: 'Document number',
        documentDate: 'Document date',
        add: 'Add shipment document',
      },
      shipmentData: {
        transporterCountry: 'Transporter country',
        title: 'Shipment data',
        shipmentOrganizerName: 'Shipment organizer name',
        shipmentOrganizerCode: 'CUI',
        shipmentOrganizerAsIndividual: 'Physical person',
        shipmentDateTooltip:
          'The shipment date should be the date at which the shipment starts if it starts in Romania, or the date at which the shipments cross the Romanian borders',
        shipmentDate: 'Shipment date',
        secondTrailerLicensePlate: 'Second trailer license plate',
        licensePlate: 'License plate',
        firstTrailerLicensePlate: 'First trailer license plate',
        contacts: "Shipment organizer's contacts",
        errors: {
          requiredTransporterCountry: "The field 'Transporter country' is required",
          requiredShipmentOrganizerName: "The field 'Shipment organizer name' is required",
          requiredShipmentOrganizerCountryCode: "The field 'Shipment organizer country' is required",
          requiredShipmentDate: "The field 'Shipment date' is required",
          requiredLicensePlate: "The field 'License plate' is required",
          patternLicensePlate:
            'The field must be 2 to 20 characters long and contain only uppercase letters and digits.',
          patternFirstTrailerLicensePlate:
            'The field must be 2 to 20 characters long and contain only uppercase letters and digits.',
          patternSecondTrailerLicensePlate:
            'The field must be 2 to 20 characters long and contain only uppercase letters and digits.',
          maxLength20: 'Campul nu poate depasi 20 de caractere',
          maxLength30: 'Campul nu poate depasi 30 de caractere',
          maxLength200: 'Campul nu poate depasi 200 de caractere',
          patternShipmentOrganizerCode: 'This field must contain at least 2 digits and should not have any spaces',
        },
      },
      packages: {
        valueWithoutVAT: 'Value without VAT',
        unitMeasurement: 'Unit of measurement',
        title: 'Products',
        addProduct: 'Add product',
        changeLayout: 'Change the product layout',
        copyValueToAll: 'Apply this value to all products',
        refDeclarant: 'Declarant reference',
        operationPurpose: 'Operation purpose',
        netWeight: 'Net weight (kg)',
        grossWeight: 'Gross weight (kg)',
        unitPrice: 'Unit price',
        productsResume: 'Products resume',
        exchangeRate: 'Exchange rate',
        getBnrExchangeRate: 'Get BNR exchange rate',
        successfulExchangeRateMessage: 'Exchange rate updated! Verify the data.',
        convertToLeiMessage: 'Convert from alternative currency to Lei',
        operationPurposes: {
          1001: 'Ongoing Investment (1001)',
          101: 'Commercialization (101)',
          1101: 'Donations, Aid (1101)',
          201: 'Production (201)',
          301: 'Free Goods (301)',
          401: 'Commercial Equipment (401)',
          501: 'Fixed Assets (501)',
          601: 'Own Consumption (601)',
          703: 'Delivery with Installation Operations (703)',
          704: 'Transfer between Managements (704)',
          705: 'Goods Made Available to the Client (705)',
          801: 'Financial/Operational Leasing (801)',
          802: 'Goods under Warranty (802)',
          901: 'Exempt Operations (901)',
          9901: 'Others (9901)',
          9999: 'Same as the Operation (9999)',
        },
        measurementUnitTranslation: '',
        measurementUnit: {
          null: '-',
          '10': 'Grup (10)',
          '11': 'Ţinută (11)',
          '13': 'Ratia (13)',
          '14': 'Doză (14)',
          '15': 'Stick, militar (15)',
          '20': 'Container (20ft) (20)',
          '21': 'Container (40ft) (21)',
          '22': 'Decilitru pe gram (22)',
          '23': 'Gram pe centimetru cub (23)',
          '24': 'Livră teoretică (24)',
          '25': 'Gram pe centimetru pătrat (25)',
          '27': 'Tonă teoretică (27)',
          '28': 'Kilogram pe metru pătrat (28)',
          '33': 'Kilopascal pătrat metru pe gram (33)',
          '34': 'Kilopascal pe milimetru (34)',
          '35': 'Mililitru pe centimetru pătrat secundă (35)',
          '37': 'Uncie pe metru pătrat (37)',
          '38': 'Uncie pe metru pătrat la 0,01 inci (38)',
          '40': 'Mililitru pe secundă (40)',
          '41': 'Mililitru pe minut (41)',
          '56': 'Sitas (56)',
          '57': 'Plasă (57)',
          '58': 'Kilogram net (58)',
          '59': 'Parte la milion (59)',
          '60': 'Greutate procentuală (60)',
          '61': 'Parte pe miliard (SUA) (61)',
          '74': 'Milipascal (74)',
          '77': 'Milli (77)',
          '80': 'Kilogram pe centimetru pătrat absolut (80)',
          '81': 'Henry (81)',
          '85': 'Livră picior (lucru mecanic) (85)',
          '87': 'Livră pe picior cub (densitate) (87)',
          '89': 'Vâscozitate dinamică (pascal/sec) (89)',
          '91': 'Stokes (91)',
          '1I': 'Rată fixă (1I)',
          '2A': 'Radian pe secundă (2A)',
          '2B': 'Radian pe secundă la pătrat (2B)',
          '2C': 'Roentgen (2C)',
          '2G': 'Volt AC (2G)',
          '2H': 'Volt DC (2H)',
          '2I': 'BTU (tabel internațional) pe oră (2I)',
          '2J': 'Centimetru cub pe secundă (2J)',
          '2K': 'Picior cubic pe oră (2K)',
          '2L': 'Picior cubic pe minut (2L)',
          '2M': 'Centimetru pe secundă (2M)',
          '2N': 'Decibel (2N)',
          '2P': 'Kilobyte (2P)',
          '2Q': 'Kilobecquerel (2Q)',
          '2R': 'Kilocurie (2R)',
          '2U': 'Megagram (2U)',
          '2X': 'Metru pe minut (2X)',
          '2Y': 'Miliroentgen (2Y)',
          '2Z': 'Milivolt (2Z)',
          '3B': 'Megajoule (3B)',
          '3C': 'Lună om (3C)',
          '4C': 'Centistokes (4C)',
          '4G': 'Microlitru (4G)',
          '4H': 'Micrometru (micron) (4H)',
          '4K': 'Milliamper (4K)',
          '4L': 'Megabyte (4L)',
          '4M': 'Miligram pe oră (4M)',
          '4N': 'Megabecquerel (4N)',
          '4O': 'Microfarad (4O)',
          '4P': 'Newton pe metru (4P)',
          '4Q': 'Uncie pe inch (4Q)',
          '4R': 'Uncie pe picior (4R)',
          '4T': 'Picofarad (4T)',
          '4U': 'Livră pe oră (4U)',
          '4W': 'Tonă (SUA) pe oră (4W)',
          '4X': 'Kilolitru pe oră (4X)',
          '5A': 'Baril (SUA) pe minut (5A)',
          '5B': 'Lot (5B)',
          '5E': 'MMSCF/zi (5E)',
          '5J': 'Cal putere hidraulic (5J)',
          A10: 'Amper pe metru pătrat pe joule secundă (A10)',
          A11: 'Angstrom (A11)',
          A12: 'Unitate astronomică (A12)',
          A13: 'Joule atomic (A13)',
          A14: 'Barn (A14)',
          A15: 'Barn per electronvolt (A15)',
          A16: 'Barn per electronvolt steradian (A16)',
          A17: 'Barn pe steradian (A17)',
          A18: 'Becquerel pe kilogram (A18)',
          A19: 'Becquerel pe metru cub (A19)',
          A2: 'Amperi pe centimetru (A2)',
          A20: 'BTU pe secundă grad de metru pătrat Rankine (A20)',
          A21: 'BTU pe grad de lira Rankine (A21)',
          A22: 'BTU pe grad secund Rankine (A22)',
          A23: 'BTU pe oră grad de metru pătrat Rankine (A23)',
          A24: 'Candelă pe metru pătrat/Lux (A24)',
          A26: 'Coulomb metru (A26)',
          A27: 'Coulomb metru pătrat per volt (A27)',
          A28: 'Coulomb pe centimetru cub (A28)',
          A29: 'Coulomb pe metru cub (A29)',
          A3: 'Amper pe milimetru (A3)',
          A30: 'Coulomb pe milimetru cub (A30)',
          A31: 'Coulomb pe kilogram pe secundă (A31)',
          A32: 'Coulomb pe mol (A32)',
          A33: 'Coulomb pe centimetru pătrat (A33)',
          A34: 'Coulomb pe metru pătrat (A34)',
          A35: 'Coulomb pe milimetru pătrat (A35)',
          A36: 'Centimetru cub pe mol (A36)',
          A37: 'Decimetru cub pe mol (A37)',
          A38: 'Metru cub pe coulomb (A38)',
          A39: 'Metru cub pe kilogram (A39)',
          A4: 'Amper pe centimetru pătrat (A4)',
          A40: 'Metru cub pe mol (A40)',
          A41: 'Amperi pe metru pătrat (A41)',
          A42: 'Curie pe kilogram (A42)',
          A43: 'Tonă TWD (A43)',
          A44: 'Decalitru (A44)',
          A45: 'Decametru (A45)',
          A47: 'Decitex (A47)',
          A48: 'Grad Rankine (A48)',
          A49: 'Denier (A49)',
          A5: 'Amper metru pătrat (A5)',
          A53: 'Electronvolt (A53)',
          A54: 'Electronvolt pe metru (A54)',
          A55: 'Metru pătrat de electronvolt (A55)',
          A56: 'Electronvolt metru pătrat pe kilogram (A56)',
          A59: 'Okta (A59)',
          A6: 'Amper pe metru pătrat Kelvin pătrat (A6)',
          A68: 'Exajoule (A68)',
          A69: 'Farad pe metru (A69)',
          A7: 'Amper pe milimetru pătrat (A7)',
          A70: 'Femtojoule (A70)',
          A71: 'Femtometri (A71)',
          A73: 'Picior pe secundă la pătrat (A73)',
          A74: 'Livră picior forță pe secundă (A74)',
          A75: 'Tonă de marfă (A75)',
          A76: 'Gal (A76)',
          A8: 'Amper secundă (A8)',
          A84: 'Gigacoulomb pe metru cub (A84)',
          A85: 'Gigaelectronvolt (A85)',
          A86: 'Gigahertz (A86)',
          A87: 'Gigaohm (A87)',
          A88: 'Gigaohm metru (A88)',
          A89: 'Gigapascal (A89)',
          A9: 'Rata (A9)',
          A90: 'Gigawatt (A90)',
          A91: 'Gon (A91)',
          A93: 'Gram pe metru cub (A93)',
          A94: 'Moleculă (A94)',
          A95: 'Gray (A95)',
          A96: 'Gray pe secundă (A96)',
          A97: 'Hectopascal (A97)',
          A98: 'Henry pe metru (A98)',
          A99: 'Bit (A99)',
          AA: 'Spera solida (AA)',
          AB: 'Ambalaj în vrac (AB)',
          ACR: 'Ar (ACR)',
          ACT: 'Activitate (ACT)',
          AD: 'Byte (AD)',
          AE: 'Amper pe metru (AE)',
          AH: 'Minut suplimentar (AH)',
          AI: 'Minut mediu pe apel (AI)',
          AK: 'stânjen (AK)',
          AL: 'Linie de acces (AL)',
          AMH: 'Amper (AMH)',
          AMP: 'Amper (AMP)',
          ANN: 'An (ANN)',
          APZ: 'Uncie troy sau uncie farmaceutică (APZ)',
          AQ: 'Unitate de factor antihemofilic (AHF) (AQ)',
          AS: 'Sortiment (AS)',
          ASM: 'Grad alcool (masic) (ASM)',
          ASU: 'Grad alcool (volumic) (ASU)',
          ATM: 'Atmosferă standard (ATM)',
          AWG: 'Ecartament cale ferată (AWG)',
          AY: 'Mulțime (AY)',
          AZ: 'BTU (tabel internațional) per kilogram (AZ)',
          B1: 'Baril (SUA) pe zi (B1)',
          B10: 'Bit pe secundă (B10)',
          B11: 'Joule pe kilogram de Kelvin (B11)',
          B12: 'Joule pe metru (B12)',
          B13: 'Joule pe metru pătrat (B13)',
          B14: 'Joule pe metru la puterea a patra (B14)',
          B15: 'Joule pe mol (B15)',
          B16: 'Joule pe mol Kelvin (B16)',
          B17: 'Credit (B17)',
          B18: 'Joule pe secundă (B18)',
          B19: 'Cifră (B19)',
          B20: 'Joule metru pătrat pe kilogram (B20)',
          B21: 'Kelvin pe watt (B21)',
          B22: 'Kiloamper (B22)',
          B23: 'Kiloamper pe metru pătrat (B23)',
          B24: 'Kiloamper pe metru (B24)',
          B25: 'Kilobecquerel pe kilogram (B25)',
          B26: 'Kilocoulomb (B26)',
          B27: 'Kilocoulomb pe metru cub (B27)',
          B28: 'Kilocoulomb pe metru pătrat (B28)',
          B29: 'Kiloelectronvolt (B29)',
          B3: 'Livra putere (B3)',
          B30: 'Gibit (B30)',
          B31: 'Kilogram metru pe secundă (B31)',
          B32: 'Kilogram metru pătrat (B32)',
          B33: 'Kilogram metru pătrat pe secundă (B33)',
          B34: 'Kilogram pe decimetru cub (B34)',
          B35: 'Kilogram pe litru (B35)',
          B4: 'Baril, imperial (B4)',
          B41: 'Kilojoul pe Kelvin (B41)',
          B42: 'Kilojoul pe kilogram (B42)',
          B43: 'Kilojoul pe kilogram Kelvin (B43)',
          B44: 'Kilojoul pe mol (B44)',
          B45: 'Kilomol (B45)',
          B46: 'Kilomol pe metru cub (B46)',
          B47: 'Kilonewton (B47)',
          B48: 'Kilonewton pe metru (B48)',
          B49: 'Kiloohm (B49)',
          B50: 'Kiloohm pe metru (B50)',
          B52: 'Kilosecunde (B52)',
          B53: 'Kilosiemens (B53)',
          B54: 'Kilosiemens pe metru (B54)',
          B55: 'Kilovolt pe metru (B55)',
          B56: 'Kiloweber pe metru (B56)',
          B57: 'An (B57)',
          B58: 'Litru per mol (B58)',
          B59: 'Lumen pe oră (B59)',
          B60: 'Lumen pe metru pătrat (B60)',
          B61: 'Lumen pe watt (B61)',
          B62: 'Lumen pe secundă (B62)',
          B63: 'lux pe oră (B63)',
          B64: 'lux pe secundă (B64)',
          B66: 'Megaamper pe metru pătrat (B66)',
          B67: 'Megabecquerel pe kilogram (B67)',
          B68: 'Gigabit (B68)',
          B69: 'Megacoulomb pe metru cub (B69)',
          B7: 'Ciclu (B7)',
          B70: 'Megacoulomb pe metru pătrat (B70)',
          B71: 'Megaelectronvolt (B71)',
          B72: 'Megagram pe metru cub (B72)',
          B73: 'Meganewton (B73)',
          B74: 'meganewton pe metru (B74)',
          B75: 'Megaohm (B75)',
          B76: 'Megaohm pe metru (B76)',
          B77: 'Megasiemens pe metru (B77)',
          B78: 'Megavolt (B78)',
          B79: 'Megavolt pe metru (B79)',
          B8: 'Joule pe metru cub (B8)',
          B80: 'Gigabit pe secundă (B80)',
          B81: 'Metru pătrat reciproc (B81)',
          B82: 'inch pe metru liniar (B82)',
          B83: 'Metru la puterea a patra (B83)',
          B84: 'Microamper (B84)',
          B85: 'Microbar (B85)',
          B86: 'Microcoulomb (B86)',
          B87: 'Microcoulomb pe metru cub (B87)',
          B88: 'Microcoulomb pe metru pătrat (B88)',
          B89: 'Microfarad pe metru (B89)',
          B90: 'Microhenry (B90)',
          B91: 'Microhenry pe metru (B91)',
          B92: 'Micronewton (B92)',
          B93: 'micronewton pe metru (B93)',
          B94: 'Microohm (B94)',
          B95: 'microohm pe metru (B95)',
          B96: 'Micropascal (B96)',
          B97: 'Microradian (B97)',
          B98: 'Microsecundă (B98)',
          B99: 'Microsiemens (B99)',
          BAR: 'Bar [unitate de presiune] (BAR)',
          BB: 'Casetă (BB)',
          BFT: 'Picior cubic (cherestea) (BFT)',
          BHP: 'Cal putere la frânare (BHP)',
          BIL: 'Miliard (EUR) (BIL)',
          BLD: 'Baril uscat (SUA) (BLD)',
          BLL: 'Baril (SUA) (BLL)',
          BP: 'Kilo pasi (cherestea) (BP)',
          BPM: 'Bătăi pe minut (BPM)',
          BQL: 'Becquerel (BQL)',
          BTU: 'BTU (tabel internațional) (BTU)',
          BUA: 'Baniță (SUA) (BUA)',
          BUI: 'Baniță (UK) (BUI)',
          C0: 'Apel (C0)',
          C10: 'Millifarad (C10)',
          C11: 'Miligal (C11)',
          C12: 'Miligram pe metru (C12)',
          C13: 'Milligray (C13)',
          C14: 'Milihenry (C14)',
          C15: 'Milijoul (C15)',
          C16: 'Milimetru pe secundă (C16)',
          C17: 'Milimetru pătrat pe secundă (C17)',
          C18: 'Millimol (C18)',
          C19: 'Mol pe kilogram (C19)',
          C20: 'Millinewton (C20)',
          C21: 'Kibibit (C21)',
          C22: 'Milinewton pe metru (C22)',
          C23: 'Miliohm pe metru (C23)',
          C24: 'Milipascal pe secundă (C24)',
          C25: 'Milliradian (C25)',
          C26: 'Milisecundă (C26)',
          C27: 'Milisiemens (C27)',
          C28: 'Milisievert (C28)',
          C29: 'Millitesla (C29)',
          C3: 'Microvolt pe metru (C3)',
          C30: 'Milivolt pe metru (C30)',
          C31: 'Miliwatt (C31)',
          C32: 'Miliwatt pe metru pătrat (C32)',
          C33: 'Miliweber (C33)',
          C34: 'Mol (C34)',
          C35: 'Mol pe decimetru cub (C35)',
          C36: 'Mol pe metru cub (C36)',
          C37: 'Kilobit (C37)',
          C38: 'Mol pe litru (C38)',
          C39: 'Nanoamper (C39)',
          C40: 'Nanocoulomb (C40)',
          C41: 'Nanofarad (C41)',
          C42: 'Nanofarad pe metru (C42)',
          C43: 'Nanohenry (C43)',
          C44: 'Nanohenry pe metru (C44)',
          C45: 'Nanometri (C45)',
          C46: 'Nanoohm metru (C46)',
          C47: 'Nanosecundă (C47)',
          C48: 'Nanotesla (C48)',
          C49: 'Nanowatt (C49)',
          C50: 'Neper (C50)',
          C51: 'Neper pe secundă (C51)',
          C52: 'Picometru (C52)',
          C53: 'Newton metru pe secundă (C53)',
          C54: 'Newton metru pătrat pe kilogram la pătrat (C54)',
          C55: 'Newton pe metru pătrat (C55)',
          C56: 'Newton pe milimetru pătrat (C56)',
          C57: 'Newton secundă (C57)',
          C58: 'Newton secundă pe metru (C58)',
          C59: 'Octavă (C59)',
          C60: 'Ohm pe centimetru (C60)',
          C61: 'Ohm metru (C61)',
          C63: 'Parsec (C63)',
          C64: 'Pascal pe Kelvin (C64)',
          C65: 'Pascal secundă (C65)',
          C66: 'Pascal secundă pe metru cub (C66)',
          C67: 'Pascal secundă pe metru (C67)',
          C68: 'Petajoule (C68)',
          C69: 'Fon (C69)',
          C7: 'centipoise (C7)',
          C70: 'Picoamper (C70)',
          C71: 'Picocoulomb (C71)',
          C72: 'Picofarad pe metru (C72)',
          C73: 'Picohenry (C73)',
          C74: 'Kilobit pe secundă (C74)',
          C75: 'Picowatt (C75)',
          C76: 'Picowatt pe metru pătrat (C76)',
          C78: 'Livra (C78)',
          C79: 'Kilovolt amper oră (C79)',
          C8: 'Miliicoulomb pe kilogram (C8)',
          C80: 'Rad (C80)',
          C81: 'Radian (C81)',
          C82: 'Radian metru pătrat pe mol (C82)',
          C83: 'Radian metru pătrat pe kilogram (C83)',
          C84: 'Radian pe metru (C84)',
          C85: 'Angstrom reciproc (C85)',
          C86: 'Metru cub reciproc (C86)',
          C87: 'Metru cub reciproc pe secundă (C87)',
          C88: 'Electron volt reciproc per metru cub (C88)',
          C89: 'Henry reciproc (C89)',
          C9: 'Grup de bobine (C9)',
          C90: 'Joule reciproce pe metru cub (C90)',
          C91: 'Reciproc Kelvin sau Kelvin la puterea minus unu (C91)',
          C92: 'Metru reciproc (C92)',
          C93: 'Metru pătrat reciproc (C93)',
          C94: 'Minut reciproc (C94)',
          C95: 'Mol reciproc (C95)',
          C96: 'Pascal reciproc sau pascal la puterea minus unu (C96)',
          C97: 'Secundă la puterea minus unu (C97)',
          C99: 'Secundă la puterea minus unu pe metru pătrat (C99)',
          CCT: 'Capacitate de transport în tone metrice (CCT)',
          CDL: 'Candelă (CDL)',
          CEL: 'Grad Celsius (CEL)',
          CEN: 'Suta (CEN)',
          CG: 'Card (CG)',
          CGM: 'Centigram (CGM)',
          CKG: 'Coulomb pe kilogram (CKG)',
          CLF: 'Sac (ciment) (CLF)',
          CLT: 'Centilitru (CLT)',
          CMK: 'Centimetru pătrat (CMK)',
          CMQ: 'Centimetru cub (CMQ)',
          CNP: 'Pachet de o suta (CNP)',
          CNT: 'Cental (UK) (CNT)',
          COU: 'Coulomb (COU)',
          CTG: 'Conținut gram (CTG)',
          CTM: 'Carat metric (CTM)',
          CTN: 'Tonă de conţinut (metric) (CTN)',
          CUR: 'Curie (CUR)',
          CWA: 'Sute de livre (cwt)/sute de kilograme (SUA) (CWA)',
          CWI: 'Chintal (CWI)',
          D03: 'Kilowatt oră pe oră (D03)',
          D04: 'Lot [unitate de greutate] (D04)',
          D1: 'Secundă la puterea minus unu per steradian (D1)',
          D10: 'Siemens pe metru (D10)',
          D11: 'Mebibit (D11)',
          D12: 'Siemens metru pătrat per mol (D12)',
          D13: 'Sievert (D13)',
          D15: 'Son (D15)',
          D16: 'Centimetru pătrat pe erg (D16)',
          D17: 'Centimetru pătrat pe erg steradian (D17)',
          D18: 'Metru Kelvin (D18)',
          D19: 'Metru pătrat Kelvin pe watt (D19)',
          D2: 'Secundă la puterea minus unu pe metru steradian pătrat (D2)',
          D20: 'Metru pătrat pe joule (D20)',
          D21: 'Metru pătrat pe kilogram (D21)',
          D22: 'Metru pătrat pe mol (D22)',
          D23: '10 cmc per gram (D23)',
          D24: 'Metru pătrat pe steradian (D24)',
          D25: 'Metru pătrat pe joule steradian (D25)',
          D26: 'Metru pătrat pe secundă volt (D26)',
          D27: 'Steradian (D27)',
          D29: 'Terahertz (D29)',
          D30: 'Terajoule (D30)',
          D31: 'Terawatt (D31)',
          D32: 'Terawatt oră (D32)',
          D33: 'Tesla (D33)',
          D34: 'Tex (D34)',
          D36: 'Megabit (D36)',
          D41: 'Tonă pe metru cub (D41)',
          D42: 'An tropic (D42)',
          D43: 'Unitate de masă atomică unificată (D43)',
          D44: 'Var (D44)',
          D45: 'Volt pătrat pe Kelvin pătrat (D45)',
          D46: 'Volt (D46)',
          D47: 'Volt pe centimetru (D47)',
          D48: 'Volt per Kelvin (D48)',
          D49: 'Milivolt per Kelvin (D49)',
          D5: 'Kilogram pe centimetru pătrat (D5)',
          D50: 'Volt pe metru (D50)',
          D51: 'Volt pe milimetru (D51)',
          D52: 'Watt per Kelvin (D52)',
          D53: 'Watt pe metru Kelvin (D53)',
          D54: 'Watt pe metru pătrat (D54)',
          D55: 'Watt pe metru pătrat Kelvin (D55)',
          D56: 'Watt pe metru pătrat Kelvin la a patra putere (D56)',
          D57: 'Watt per steradian (D57)',
          D58: 'Watt per metru pătrat steradian (D58)',
          D59: 'Weber pe metru (D59)',
          D6: 'Roentgen pe secundă (D6)',
          D60: 'Weber pe milimetru (D60)',
          D61: 'Minut [unghi] (D61)',
          D62: 'Secunda [unitate de unghi] (D62)',
          D63: 'Carte (D63)',
          D65: 'Buștean (D65)',
          D68: 'Număr de cuvinte (D68)',
          D69: 'Inch la puterea a patra (D69)',
          D73: 'Joule metru pătrat (D73)',
          D74: 'Kilogram pe mol (D74)',
          D77: 'Megacoulomb (D77)',
          D78: 'Megajoule pe secundă (D78)',
          D80: 'Microwatt (D80)',
          D81: 'Microtesla (D81)',
          D82: 'Microvolt (D82)',
          D83: 'Milinewton metru (D83)',
          D85: 'Microwatt pe metru pătrat (D85)',
          D86: 'Miliicoulomb (D86)',
          D87: 'Millimol pe kilogram (D87)',
          D88: 'Miliicoulomb pe metru cub (D88)',
          D89: 'Miliicoulomb pe metru pătrat (D89)',
          D91: 'REM (D91)',
          D93: 'Secundă pe metru cub (D93)',
          D94: 'Secundă pe metru cub radian (D94)',
          D95: 'Joule pe gram (D95)',
          DAA: 'Decare (DAA)',
          DAD: 'Decadă (DAD)',
          DAY: 'Zi (DAY)',
          DB: 'Livra uscata (DB)',
          DD: 'Grad [unitate de unghi] (DD)',
          DEC: 'Deceniu (DEC)',
          DG: 'Decigramă (DG)',
          DJ: 'Decagramă (DJ)',
          DLT: 'Decilitru (DLT)',
          DMA: 'Decametru cub (DMA)',
          DMK: 'Decimetru pătrat (DMK)',
          DMO: 'Kilolitru standard (la 15 grd C) (DMO)',
          DMQ: 'Decimetru cub (DMQ)',
          DMT: 'Decimetru (DMT)',
          DN: 'Decinewton metru (DN)',
          DPC: 'Duzină (DPC)',
          DPR: 'Duzină de perechi (DPR)',
          DPT: 'Deplasament metric (tone) (DPT)',
          DRA: 'DRAM (SUA) (DRA)',
          DRI: 'DRAM (UK) (DRI)',
          DRL: 'Duzina de rolă (DRL)',
          DT: 'Tonă uscată (DT)',
          DTN: 'Decitonă (DTN)',
          DWT: 'Pennyweight (DWT)',
          DZP: 'Duzină de pachete (DZP)',
          E01: 'Newton pe centimetru pătrat (E01)',
          E07: 'Megawatt oră pe oră (E07)',
          E08: 'Megawatt per hertz (E08)',
          E09: 'Miliamper ora (E09)',
          E10: 'Grad pe zi (E10)',
          E12: 'Mille (E12)',
          E14: 'Kilocalorie (tabel internațional) (E14)',
          E15: 'Kilocalorie (termochimică) pe oră (E15)',
          E16: 'Milioane Btu(IT) pe oră (E16)',
          E17: 'Picior cubic pe secundă (E17)',
          E18: 'Tonă pe oră (E18)',
          E19: 'Ping (E19)',
          E20: 'Megabit pe secundă (E20)',
          E21: 'Acțiuni (E21)',
          E22: 'TEU (E22)',
          E23: 'Pneu (E23)',
          E25: 'Unitate activa (E25)',
          E27: 'Doză (E27)',
          E28: 'Tonă uscată de aer (E28)',
          E30: 'Componentă (E30)',
          E31: 'Metru pătrat pe litru (E31)',
          E32: 'Litru pe oră (E32)',
          E33: 'Picior la mie (E33)',
          E34: 'Gigabyte (E34)',
          E35: 'Terabyte (E35)',
          E36: 'Petabyte (E36)',
          E37: 'Pixel (E37)',
          E38: 'Megapixel (E38)',
          E39: 'Puncte pe inch (E39)',
          E4: 'Kilogram brut (E4)',
          E40: 'Partea la o suta de mii (E40)',
          E41: 'Kilogram (E41)',
          E42: 'Kilogram (E42)',
          E43: 'Joule pe centimetru pătrat (E43)',
          E44: 'Kilogram (E44)',
          E45: 'Miliohm (E45)',
          E46: 'Kilowatt oră pe metru cub (E46)',
          E47: 'Kilowatt oră per Kelvin (E47)',
          E48: 'Unitate de service (E48)',
          E49: 'Zi lucrătoare (E49)',
          E50: 'Unitate de contabilitate (E50)',
          E51: 'Loc de muncă (E51)',
          E52: 'Pasi deplasare (E52)',
          E53: 'Test (E53)',
          E54: 'Deplasare (E54)',
          E55: 'Utilizare (E55)',
          E56: 'Unitate de foraj (E56)',
          E57: 'Zonă (E57)',
          E58: 'Exabit pe secundă (E58)',
          E59: 'Exbibyte (E59)',
          E60: 'Pebibyte (E60)',
          E61: 'Tebibyte (E61)',
          E62: 'Gibibyte (E62)',
          E63: 'Mebibyte (E63)',
          E64: 'Kibibyte (E64)',
          E65: 'Exbibit pe metru (E65)',
          E66: 'Exbibit pe metru pătrat (E66)',
          E67: 'Exbibit pe metru cub (E67)',
          E68: 'Gigabyte pe secundă (E68)',
          E69: 'Gibibit pe metru (E69)',
          E70: 'Gibibit pe metru pătrat (E70)',
          E71: 'Gibibit pe metru cub (E71)',
          E72: 'Kibibit pe metru (E72)',
          E73: 'Kibibit pe metru pătrat (E73)',
          E74: 'Kibibit pe metru cub (E74)',
          E75: 'Mebibit pe metru (E75)',
          E76: 'Mebibit pe metru pătrat (E76)',
          E77: 'Mebibit pe metru cub (E77)',
          E78: 'Petabit (E78)',
          E79: 'Petabit pe secundă (E79)',
          E80: 'Pebibit pe metru (E80)',
          E81: 'Pebibit pe metru pătrat (E81)',
          E82: 'Pebibit pe metru cub (E82)',
          E83: 'Terabit (E83)',
          E84: 'Terabit pe secundă (E84)',
          E85: 'Tebibit pe metru (E85)',
          E86: 'Tebibit pe metru cub (E86)',
          E87: 'Tebibit pe metru pătrat (E87)',
          E88: 'Bit pe metru (E88)',
          E89: 'Bit pe metru pătrat (E89)',
          E90: 'Centimetru la puterea minus unu (E90)',
          E91: 'Zi la puterea minus unu (E91)',
          E92: 'Decimetru cub pe oră (E92)',
          E93: 'Kilogram pe oră (E93)',
          E94: 'Kilomol pe secundă (E94)',
          E95: 'Mol pe secundă (E95)',
          E96: 'Grad pe secundă (E96)',
          E97: 'Milimetri pe grad celcius metru (E97)',
          E98: 'Grad Celsius pe Kelvin (E98)',
          E99: 'Hectopascal per bar (E99)',
          EB: 'Căsută poștală electronică (EB)',
          EQ: 'Galon echivalent (EQ)',
          F01: 'Bit pe metru cub (F01)',
          F02: 'Kelvin per Kelvin (F02)',
          F03: 'Kilopascal pe bar (F03)',
          F04: 'Milibar pe bar (F04)',
          F05: 'Megapascal pe bar (F05)',
          F06: 'Poise pe bar (F06)',
          F07: 'Pascal pe bar (F07)',
          F08: 'Milliampere pe inch (F08)',
          F10: 'Kelvin pe oră (F10)',
          F11: 'Kelvin pe minut (F11)',
          F12: 'Kelvin pe secundă (F12)',
          F13: 'Slug (F13)',
          F14: 'Gram pe Kelvin (F14)',
          F15: 'Kilogram pe Kelvin (F15)',
          F16: 'Miligram per Kelvin (F16)',
          F17: 'Livră (F17)',
          F18: 'Kilogram de centimetru pătrat (F18)',
          F19: 'Kilogram milimetru pătrat (F19)',
          F20: 'Livra inch pătrat (F20)',
          F21: 'Livra (F21)',
          F22: 'Livra (F22)',
          F23: 'Gram pe decimetru cub (F23)',
          F24: 'Kilogram pe kilomol (F24)',
          F25: 'Gram per hertz (F25)',
          F26: 'Gram pe zi (F26)',
          F27: 'Gram pe oră (F27)',
          F28: 'Gram pe minut (F28)',
          F29: 'Gram pe secundă (F29)',
          F30: 'Kilogram pe zi (F30)',
          F31: 'Kilogram pe minut (F31)',
          F32: 'Miligram pe zi (F32)',
          F33: 'Miligram pe minut (F33)',
          F34: 'Miligram pe secundă (F34)',
          F35: 'Gram pe zi Kelvin (F35)',
          F36: 'Gram pe oră Kelvin (F36)',
          F37: 'Gram pe minut Kelvin (F37)',
          F38: 'Gram pe secundă Kelvin (F38)',
          F39: 'Kg pe zi Kelvin (F39)',
          F40: 'Kilogram pe oră Kelvin (F40)',
          F41: 'Kilogram pe minut Kelvin (F41)',
          F42: 'Kilogram pe secundă Kelvin (F42)',
          F43: 'Miligram pe zi Kelvin (F43)',
          F44: 'Miligram pe oră Kelvin (F44)',
          F45: 'Miligram pe minut Kelvin (F45)',
          F46: 'Miligram pe secundă Kelvin (F46)',
          F47: 'Newton pe milimetru (F47)',
          F48: 'Livră (F48)',
          F49: 'Tijă [unitate de distanță] (F49)',
          F50: 'Micrometru per Kelvin (F50)',
          F51: 'Centimetru pe Kelvin (F51)',
          F52: 'Metru pe Kelvin (F52)',
          F53: 'Milimetru pe Kelvin (F53)',
          F54: 'Miliohm pe metru (F54)',
          F55: 'Ohm pe milă (statute mile) (F55)',
          F56: 'Ohm pe kilometru (F56)',
          F57: 'Miliamper per kilogram (F57)',
          F58: 'Bar la puterea minus unu (F58)',
          F59: 'Milliamper pe bar (F59)',
          F60: 'Grad Celsius pe bar (F60)',
          F61: 'Kelvin pe bar (F61)',
          F62: 'Gram pe zi bar (F62)',
          F63: 'Gram pe oră bar (F63)',
          F64: 'Gram pe bar pe minut (F64)',
          F65: 'Gram pe secundă bar (F65)',
          F66: 'Kilogram pe bar pe zi (F66)',
          F67: 'Kilogram pe oră bar (F67)',
          F68: 'Kilogram pe minut bar (F68)',
          F69: 'Kilogram pe secundă bar (F69)',
          F70: 'Miligram pe zi bar (F70)',
          F71: 'Miligram pe oră bar (F71)',
          F72: 'Miligram pe bar de minut (F72)',
          F73: 'Miligram pe secundă bar (F73)',
          F74: 'Gram pe bar (F74)',
          F75: 'Miligram pe bar (F75)',
          F76: 'Miliamper pe milimetru (F76)',
          F77: 'Pascal pe secundă pe Kelvin (F77)',
          F78: 'Inch coloană de apă (F78)',
          F79: 'Centimetru coloană de mercur (F79)',
          F80: 'Cal putere hidraulic (F80)',
          F81: 'Bar pe Kelvin (F81)',
          F82: 'Hectopascal per Kelvin (F82)',
          F83: 'Kilopascal pe Kelvin (F83)',
          F84: 'Milibar pe Kelvin (F84)',
          F85: 'Megapascal pe Kelvin (F85)',
          F86: 'Poise per Kelvin (F86)',
          F87: 'Volt pe litru minut (F87)',
          F88: 'Centimetru Newton (F88)',
          F89: 'Newton metru pe grad (F89)',
          F90: 'Newton metru pe amper (F90)',
          F91: 'Bar litru pe secundă (F91)',
          F92: 'Bar cub metru pe secundă (F92)',
          F93: 'Hectopascal litru pe secundă (F93)',
          F94: 'Metru cub hectopascal pe secundă (F94)',
          F95: 'Milibar litru pe secundă (F95)',
          F96: 'Milibar metru cub pe secundă (F96)',
          F97: 'Megapascal litru pe secundă (F97)',
          F98: 'Metru cub megapascal pe secundă (F98)',
          F99: 'Litru Pascal pe secundă (F99)',
          FAH: 'Grad Fahrenheit (FAH)',
          FAR: 'Farad (FAR)',
          FBM: 'Metru de fibră (FBM)',
          FC: 'Kilo pași cub (FC)',
          FF: 'Sută metri cubi (FF)',
          FH: 'Micromol (FH)',
          FIT: 'Defect în timp (FIT)',
          FL: 'Tonă fulgi (FL)',
          FP: 'Livră pe metru pătrat (FP)',
          FR: 'Picior pe minut (FR)',
          FS: 'Picior pe secundă (FS)',
          FTK: 'Picior pătrat (FTK)',
          FTQ: 'Picior cubic (FTQ)',
          G01: 'Metru cub pascal pe secundă (G01)',
          G04: 'Centimetru pe bar (G04)',
          G05: 'Metru pe bar (G05)',
          G06: 'Milimetri per bar (G06)',
          G08: 'Pătrat inch pe secundă (G08)',
          G09: 'Metru pătrat pe secundă Kelvin (G09)',
          G10: 'Stokes per Kelvin (G10)',
          G11: 'Gram pe bar centimetru cub (G11)',
          G12: 'Gram pe bar de decimetru cub (G12)',
          G13: 'Gram pe litru bar (G13)',
          G14: 'Gram pe metru cub bar (G14)',
          G15: 'Gram pe bar mililitru (G15)',
          G16: 'Kilogram pe bar centimetru cub (G16)',
          G17: 'Kilogram pe litru bar (G17)',
          G18: 'Kilogram pe metru cub bar (G18)',
          G19: 'Newton metru pe kilogram (G19)',
          G2: 'Galon (SUA) pe minut (G2)',
          G20: 'Livră (G20)',
          G21: 'Cupă [unitate de volum] (G21)',
          G23: 'Peck (G23)',
          G24: 'Lingură (SUA) (G24)',
          G25: 'Linguriță (SUA) (G25)',
          G26: 'Ster (G26)',
          G27: 'Centimetru cub pe Kelvin (G27)',
          G28: 'Litru pe Kelvin (G28)',
          G29: 'Metru cub per Kelvin (G29)',
          G3: 'Galon imperial pe minut (G3)',
          G30: 'Mililitru pe Kelvin (G30)',
          G31: 'Kilogram pe centimetru cub (G31)',
          G32: 'Uncie (avoirdupois) per picior cubic (G32)',
          G33: 'Gram pe centimetru cub Kelvin (G33)',
          G34: 'Gram pe decimetru cub Kelvin (G34)',
          G35: 'Gram pe litru Kelvin (G35)',
          G36: 'Gram pe metru cub Kelvin (G36)',
          G37: 'Gram pe mililitru Kelvin (G37)',
          G38: 'Kilogram pe centimetru cub Kelvin (G38)',
          G39: 'Kilogram pe litru Kelvin (G39)',
          G40: 'Kilogram pe metru cub Kelvin (G40)',
          G41: 'Metru pătrat pe bar secundă (G41)',
          G42: 'Microsiemens pe centimetru (G42)',
          G43: 'Microsiemens pe metru (G43)',
          G44: 'Nanosiemens pe centimetru (G44)',
          G45: 'Nanosiemens pe metru (G45)',
          G46: 'Stokes pe bar (G46)',
          G47: 'Centimetru cub pe zi (G47)',
          G48: 'Centimetru cub pe oră (G48)',
          G49: 'Centimetru cub pe minut (G49)',
          G50: 'Galon (SUA) pe oră (G50)',
          G51: 'Litru pe secundă (G51)',
          G52: 'Metru cub pe zi (G52)',
          G53: 'Metru cub pe minut (G53)',
          G54: 'Mililitru pe zi (G54)',
          G55: 'Mililitru pe oră (G55)',
          G56: 'Centimetru cub pe oră (G56)',
          G57: 'Centimetru cub pe minut (G57)',
          G58: 'Centimetru cub pe secundă (G58)',
          G59: 'Miliamper pe litru minut (G59)',
          G60: 'Volt pe bar (G60)',
          G61: 'Centimetru cub pe zi Kelvin (G61)',
          G62: 'Centimetru cub pe oră Kelvin (G62)',
          G63: 'Centimetru cub pe minut Kelvin (G63)',
          G64: 'Centimetru cub pe secundă Kelvin (G64)',
          G65: 'Litru pe zi Kelvin (G65)',
          G66: 'Litru pe oră Kelvin (G66)',
          G67: 'Litru pe minut Kelvin (G67)',
          G68: 'Litru pe secundă Kelvin (G68)',
          G69: 'Metru cub pe zi Kelvin (G69)',
          G70: 'Metru cub pe oră Kelvin (G70)',
          G71: 'Metru cub pe minut Kelvin (G71)',
          G72: 'Metru cub pe secundă Kelvin (G72)',
          G73: 'Mililitru pe zi Kelvin (G73)',
          G74: 'Mililitru pe oră Kelvin (G74)',
          G75: 'Mililitru pe minut Kelvin (G75)',
          G76: 'Mililitru pe secundă Kelvin (G76)',
          G77: 'Milimetri la puterea a patra (G77)',
          G78: 'Centimetru cub pe bar zi (G78)',
          G79: 'Centimetru cub pe bar oră (G79)',
          G80: 'Centimetru cub pe bar minut (G80)',
          G81: 'Centimetru cub pe bar secundă (G81)',
          G82: 'Litru pe zi bar (G82)',
          G83: 'Litru pe oră bar (G83)',
          G84: 'Litru pe minut bar (G84)',
          G85: 'Litru pe secundă bar (G85)',
          G86: 'Metru cub pe zi bar (G86)',
          G87: 'Metru cub pe oră bar (G87)',
          G88: 'Metru cub pe minut bar (G88)',
          G89: 'Metru cub pe secundă bar (G89)',
          G90: 'Mililitru pe zi bar (G90)',
          G91: 'Mililitru pe oră bar (G91)',
          G92: 'Mililitru pe minut bar (G92)',
          G93: 'Mililitru pe secundă bar (G93)',
          G94: 'Centimetru cub pe bar (G94)',
          G95: 'Litru pe bar (G95)',
          G96: 'Metru cub pe bar (G96)',
          G97: 'Mililitru pe bar (G97)',
          G98: 'Microhenry pe kiloohm (G98)',
          G99: 'Microhenry pe ohm (G99)',
          GB: 'Galon (SUA) pe zi (GB)',
          GBQ: 'Gigabecquerel (GBQ)',
          GDW: 'Gram, greutate uscată (GDW)',
          GE: 'Livră pe galon (SUA) (GE)',
          GF: 'Gram pe metru (GF)',
          GFI: 'Gram de izotop fisionabil (GFI)',
          GGR: 'Unitate brută (GGR)',
          GIA: 'Gill (SUA) (GIA)',
          GIC: 'Gram, inclusiv recipientul (GIC)',
          GII: 'Gill (UK) (GII)',
          GIP: 'Gram, inclusiv ambalajul interior (GIP)',
          GJ: 'Gram pe mililitru (GJ)',
          GL: 'Gram pe litru (GL)',
          GLD: 'Galon uscat (SUA) (GLD)',
          GLI: 'Galon (UK) (GLI)',
          GLL: 'Galon (SUA) (GLL)',
          GM: 'Gram pe metru pătrat (GM)',
          GO: 'Miligram pe metru pătrat (GO)',
          GP: 'Miligram pe metru cub (GP)',
          GQ: 'Microgram pe metru cub (GQ)',
          GRN: 'Bob [unitate farmaceutică] (GRN)',
          GRO: 'Brut (GRO)',
          GV: 'Gigajoule (GV)',
          GWH: 'Gigawatt oră (GWH)',
          H03: 'Henry pe kiloohm (H03)',
          H04: 'Henry pe ohm (H04)',
          H05: 'Milihenry pe kiloohm (H05)',
          H06: 'Milihenry per ohm (H06)',
          H07: 'Pascal secundă pe bar (H07)',
          H08: 'Microbecquerel (H08)',
          H09: 'An la puterea minus unu (H09)',
          H10: 'Oră la puterea minus unu (H10)',
          H11: 'Lună la puterea minus unu (H11)',
          H12: 'Grad Celsius pe oră (H12)',
          H13: 'Grad Celsius pe minut (H13)',
          H14: 'Grad Celsius pe secundă (H14)',
          H15: 'Centimetru pătrat pe gram (H15)',
          H16: 'Decametru pătrat (H16)',
          H18: 'Hectometri pătrați (H18)',
          H19: 'Hectometri cubi (H19)',
          H20: 'Kilometru cub (H20)',
          H21: 'Blanchetă (H21)',
          H22: 'Volt pe inch pătrat pe kilogram (H22)',
          H23: 'Volt pe inch (H23)',
          H24: 'Volt pe microsecundă (H24)',
          H25: 'Procent per Kelvin (H25)',
          H26: 'Ohm pe metru (H26)',
          H27: 'Grad pe metru (H27)',
          H28: 'Microfarad pe kilometru (H28)',
          H29: 'Microgram per litru (H29)',
          H30: 'Micrometru pătrat (micron pătrat) (H30)',
          H31: 'Amper pe kilogram (H31)',
          H32: 'Amper pătrat pe secundă (H32)',
          H33: 'Farad pe kilometru (H33)',
          H34: 'Hertz metru (H34)',
          H35: 'Kelvin metru pe watt (H35)',
          H36: 'Megaohm pe kilometru (H36)',
          H37: 'Megaohm pe metru (H37)',
          H38: 'Megaamper (H38)',
          H39: 'Megahertz kilometru (H39)',
          H40: 'Newton pe amper (H40)',
          H41: 'Newton metru watt la puterea minus 0,5 (H41)',
          H42: 'Pascal pe metru (H42)',
          H43: 'Siemens pe centimetru (H43)',
          H44: 'Teraohm (H44)',
          H45: 'Volt secundă pe metru (H45)',
          H46: 'Volt pe secundă (H46)',
          H47: 'Watt pe metru cub (H47)',
          H48: 'Attofarad (H48)',
          H49: 'Centimetru pe oră (H49)',
          H50: 'Centimetru cub reciproc (H50)',
          H51: 'Decibel pe kilometru (H51)',
          H52: 'Decibel pe metru (H52)',
          H53: 'Kilogram per bar (H53)',
          H54: 'Kilogram pe decimetru cub Kelvin (H54)',
          H55: 'Kilogram pe bara de decimetru cub (H55)',
          H56: 'Kilogram pe metru pătrat secundă (H56)',
          H57: 'Inch per doi pi radiant (H57)',
          H58: 'Metru pe secundă volt (H58)',
          H59: 'Metru pătrat pe newton (H59)',
          H60: 'Metru cub pe metru cub (H60)',
          H61: 'Milisiemens pe centimetru (H61)',
          H62: 'Milivolt pe minut (H62)',
          H63: 'Miligram pe centimetru pătrat (H63)',
          H64: 'Miligram pe gram (H64)',
          H65: 'Mililitru pe metru cub (H65)',
          H66: 'Milimetri pe an (H66)',
          H67: 'Milimetri pe oră (H67)',
          H68: 'Millimol pe gram (H68)',
          H69: 'Picopascal pe kilometru (H69)',
          H70: 'Picosecundă (H70)',
          H71: 'Procente pe lună (H71)',
          H72: 'Procent pe hectobar (H72)',
          H73: 'Procente pe decaKelvin (H73)',
          H74: 'Watt pe metru (H74)',
          H75: 'Decapascal (H75)',
          H76: 'Gram pe milimetru (H76)',
          H77: 'Lățime modulară (H77)',
          H79: 'Ecartament francez (H79)',
          H80: 'Unitate de rack (H80)',
          H81: 'Milimetri pe minut (H81)',
          H82: 'Punct tipografic (H82)',
          H83: 'Litru pe kilogram (H83)',
          H84: 'Gram milimetru (H84)',
          H85: 'Săptămână la puterea minus unu (H85)',
          H88: 'Megaohm kilometru (H88)',
          H89: 'Procent pe ohm (H89)',
          H90: 'Procent pe grad (H90)',
          H91: 'Procent la zece mii (H91)',
          H92: 'Procent la suta de mii (H92)',
          H93: 'Procent la sută (H93)',
          H94: 'Procent la mie (H94)',
          H95: 'Procent per volt (H95)',
          H96: 'Procent per bar (H96)',
          H98: 'Procent pe inch (H98)',
          H99: 'Procent pe metru (H99)',
          HA: 'Hank (HA)',
          HBA: 'Hectobar (HBA)',
          HBX: 'Sute de cutii (HBX)',
          HC: 'Set de o suta (HC)',
          HDW: 'Chintal, greutate uscată (HDW)',
          HEA: 'Capete (HEA)',
          HGM: 'Hectogram (HGM)',
          HH: 'O sută de metri cubi (HH)',
          HIU: 'O sută de unități internaționale (HIU)',
          HKM: 'Chintal, masă netă (HKM)',
          HLT: 'Hectolitru (HLT)',
          HM: 'Milă pe oră (milometru statuat) (HM)',
          HMQ: 'Milioane de metri cubi (HMQ)',
          HMT: 'Hectometri (HMT)',
          HPA: 'Hectolitru de alcool pur (HPA)',
          HTZ: 'Hertz (HTZ)',
          HUR: 'Oră (HUR)',
          IA: 'Inch pe livră (IA)',
          IE: 'Persoană (IE)',
          INK: 'Centimetru pătrat (INK)',
          INQ: 'Inch cub (INQ)',
          ISD: 'Grad internațional de zahăr (ISD)',
          IU: 'Inch pe secundă (IU)',
          IUG: 'Unitate internațională pe gram (IUG)',
          IV: 'Centimetru pe secundă la pătrat (IV)',
          J10: 'Procent pe milimetru (J10)',
          J12: 'Per mille pe psi (J12)',
          J13: 'Grad API (J13)',
          J14: 'Grad Baume (scară de origine) (J14)',
          J15: 'Grad Baume (SUA, mai dens decât apa) (J15)',
          J16: 'Grad Baume (SUA, mai ușor decât apa) (J16)',
          J17: 'Grad Balling (J17)',
          J18: 'Grad Brix (J18)',
          J19: 'Grad Fahrenheit oră metru pătrat pe BTU (termochimic) (J19)',
          J2: 'Joule pe kilogram (J2)',
          J20: 'Grad Fahrenheit per Kelvin (J20)',
          J21: 'Grad Fahrenheit per bar (J21)',
          J22: 'Grad Fahrenheit oră pătrată pe BTU (masă internațională) (J22)',
          J23: 'Grad Fahrenheit pe orp (J23)',
          J24: 'Grad Fahrenheit pe minut (J24)',
          J25: 'Grad Fahrenheit pe secundă (J25)',
          J26: 'Grad reciproc Fahrenheit (J26)',
          J27: 'Grad Oechsle (J27)',
          J28: 'Grad Rankine pe oră (J28)',
          J29: 'Grad Rankine pe minut (J29)',
          J30: 'Grad Rankine pe secundă (J30)',
          J31: 'Grad Twaddell (J31)',
          J32: 'MicroPoise (J32)',
          J33: 'Microgram per kilogram (J33)',
          J34: 'Microgram pe metru cub Kelvin (J34)',
          J35: 'Microgram pe metru cub bar (J35)',
          J36: 'Microlitru pe litru (J36)',
          J38: 'Baud (J38)',
          J39: 'BTU (medie) (J39)',
          J40: 'BTU (măsură internațională) picior pe oră picior pătrat grad Fahrenheit (J40)',
          J41: 'BTU (măsură internațională) inch pe oră picior pătrat grad Fahrenheit (J41)',
          J42: 'BTU (măsură internațională) inch pe secundă picior pătrat grad Fahrenheit (J42)',
          J43: 'BTU (tabel internațional) pe grad pe livra Fahrenheit (J43)',
          J44: 'BTU (tabel internațional) pe minut (J44)',
          J45: 'BTU (tabel internațional) pe secundă (J45)',
          J46: 'BTU (termochimică) picior pe oră picior pătrat grad Fahrenheit (J46)',
          J47: 'BTU (termochimică) pe oră (J47)',
          J48: 'BTU (termochimică) inch pe oră picior pătrat grad Fahrenheit (J48)',
          J49: 'BTU (termochimică) inch pe secundă picior pătrat grad Fahrenheit (J49)',
          J50: 'BTU (termochimică) pe grad de lira Fahrenheit (J50)',
          J51: 'BTU (termochimică) pe minut (J51)',
          J52: 'BTU (termochimică) pe secundă (J52)',
          J53: 'Coulomb metru pătrat per kilogram (J53)',
          J54: 'Megabaud (J54)',
          J55: 'Watt pe secundă (J55)',
          J56: 'Bar pe bar (J56)',
          J58: 'Baril (UK Oil) pe minut (J58)',
          J59: 'Baril (UK Oil) pe zi (J59)',
          J60: 'Baril (UK petrol) pe oră (J60)',
          J61: 'Baril (UK Oil) pe secundă (J61)',
          J62: 'Baril (U.A. petrol) pe oră (J62)',
          J63: 'Baril (U.A. petrol) pe secundă (J63)',
          J64: 'Baniță (UK) pe zi (J64)',
          J65: 'Baniță (UK) pe oră (J65)',
          J66: 'Baniță (UK) pe minut (J66)',
          J67: 'Baniță (UK) pe secundă (J67)',
          J68: 'Baniță (SUA uscată) pe zi (J68)',
          J69: 'Baniță (SUA uscată) pe oră (J69)',
          J70: 'Bushel (US uscat) pe minut (J70)',
          J71: 'Bushel (US uscat) pe secundă (J71)',
          J72: 'Centinewton metru (J72)',
          J73: 'Centipoise pe Kelvin (J73)',
          J74: 'Centipoise pe bar (J74)',
          J75: 'Calorie (medie) (J75)',
          J76: 'Calorie (tabel internațional) pe gram grad Celsius (J76)',
          J78: 'Calorie (termochimic) pe centimetru secundă grad Celsius (J78)',
          J79: 'Calorie (termochimic) pe gram grad Celsius (J79)',
          J81: 'Calorii (termochimice) pe minut (J81)',
          J82: 'Calorii (termochimice) pe secundă (J82)',
          J83: 'Clo (J83)',
          J84: 'Centimetru pe secundă Kelvin (J84)',
          J85: 'Centimetru pe bar secundă (J85)',
          J87: 'Centimetru cub pe metru cub (J87)',
          J90: 'Decimetru cub pe zi (J90)',
          J91: 'Decimetru cub pe metru cub (J91)',
          J92: 'Decimetru cub pe minut (J92)',
          J93: 'Decimetru cub pe secundă (J93)',
          J95: 'Uncie (lichid Marea Britanie) pe zi (J95)',
          J96: 'Uncie (lichid Marea Britanie) pe oră (J96)',
          J97: 'Uncie (lichid Marea Britanie) pe minut (J97)',
          J98: 'Uncie (lichid Marea Britanie) pe secundă (J98)',
          J99: 'Uncie (lichid american) pe zi (J99)',
          JE: 'Joule per Kelvin (JE)',
          JK: 'Megajoul pe kilogram (JK)',
          JM: 'Megajoul pe metru cub (JM)',
          JNT: 'Bucăți îmbinare conductă (JNT)',
          JOU: 'Joule (JOU)',
          JPS: 'O suta de metri (JPS)',
          JWL: 'Carat (JWL)',
          K1: 'Kilowatt oră (K1)',
          K10: 'Uncie (lichid american) pe oră (K10)',
          K11: 'Uncie (lichid american) pe minut (K11)',
          K12: 'Uncie (lichid american) pe secundă (K12)',
          K13: 'Picior pe grad Fahrenheit (K13)',
          K14: 'Picior pe oră (K14)',
          K15: 'Livra pas (K15)',
          K16: 'Livra pas (K16)',
          K17: 'Picior pe psi (K17)',
          K18: 'Picior pe secundă grad Fahrenheit (K18)',
          K19: 'Picior pe secundă psi (K19)',
          K2: 'Amper kilovolt (K2)',
          K20: 'Picior cubic la puterea minus unu (K20)',
          K21: 'Picior cubic pe grad Fahrenheit (K21)',
          K22: 'Picior cubic pe zi (K22)',
          K23: 'Picior cubic pe psi (K23)',
          K26: 'Galon (UK) pe zi (K26)',
          K27: 'Galon (UK) pe oră (K27)',
          K28: 'Galon (UK) pe secundă (K28)',
          K3: 'Kilovolt ampere reactiv ora (K3)',
          K30: 'Galon (lichid SUA) pe secundă (K30)',
          K31: 'Gram (K31)',
          K32: 'Gill (UK) pe zi (K32)',
          K33: 'Gill (UK) pe oră (K33)',
          K34: 'Gill (UK) pe minut (K34)',
          K35: 'Gill (UK) pe secundă (K35)',
          K36: 'Gill (SUA) pe zi (K36)',
          K37: 'Gill (SUA) pe oră (K37)',
          K38: 'Gill (SUA) pe minut (K38)',
          K39: 'Gill (SUA) pe secundă (K39)',
          K40: 'Accelerația standard în cădere liberă (g) (K40)',
          K41: 'Cereale pe galon (SUA) (K41)',
          K42: 'Cal putere (boiler) (K42)',
          K43: 'Cal putere (electric) (K43)',
          K45: 'Inch pe grad Fahrenheit (K45)',
          K46: 'Inch pe psi (K46)',
          K47: 'Inch pe secundă grad Fahrenheit (K47)',
          K48: 'Inch pe secundă psi (K48)',
          K49: 'Centimetru cub reciproc (K49)',
          K50: 'Kilobaud (K50)',
          K51: 'Kilocalorie (medie) (K51)',
          K52: 'Kilocalorie (tabel internațional) pe oră grad Celsius (K52)',
          K53: 'Kilocalorie (termochimic) (K53)',
          K54: 'Kilocalorie (termochimică) pe minut (K54)',
          K55: 'Kilocalorie (termochimică) pe secundă (K55)',
          K58: 'Kilomol pe oră (K58)',
          K59: 'Kilomol pe metru cub Kelvin (K59)',
          K6: 'Kilolitrul (K6)',
          K60: 'Kilomol pe metru cub bar (K60)',
          K61: 'Kilomol pe minut (K61)',
          K62: 'Litru pe litru (K62)',
          K63: 'Litru reciproc (K63)',
          K64: 'Livra (avoirdupois) pe grad Fahrenheit (K64)',
          K65: 'Livra (avoirdupois) picior pătrat (K65)',
          K66: 'Livra (avoirdupois) pe zi (K66)',
          K67: 'Livra pe metru ora (K67)',
          K68: 'Livra pe secundă picior (K68)',
          K69: 'Livra (avoirdupois) per grad de picior cubic Fahrenheit (K69)',
          K70: 'Livra (avoirdupois) per psi picior cub (K70)',
          K71: 'Livra (avoirdupois) pe galon (UK) (K71)',
          K73: 'Livra (avoirdupois) pe oră grad Fahrenheit (K73)',
          K74: 'Livra (avoirdupois) pe oră psi (K74)',
          K75: 'Livra (avoirdupois) per grad cub inch Fahrenheit (K75)',
          K76: 'Livra (avoirdupois) per centimetru cub psi (K76)',
          K77: 'Livra (avoirdupois) per psi (K77)',
          K78: 'Livra (avoirdupois) pe minut (K78)',
          K79: 'Livra (avoirdupois) pe minut grad Fahrenheit (K79)',
          K80: 'Livra (avoirdupois) pe minut psi (K80)',
          K81: 'Livra (avoirdupois) pe secundă (K81)',
          K82: 'Livră (avoirdupois) pe gradul doi Fahrenheit (K82)',
          K83: 'Livra (avoirdupois) pe secundă psi (K83)',
          K84: 'Livra pe curte cubica (K84)',
          K85: 'Livra (K85)',
          K86: 'Livra (K86)',
          K87: 'PSI cubic inch pe secundă (K87)',
          K88: 'Litru PSI pe secundă (K88)',
          K89: 'PSI metru cub pe secundă (K89)',
          K90: 'Picior cubic psi pe secundă (K90)',
          K91: 'Livra (K91)',
          K92: 'Livra (K92)',
          K93: 'Psi la puterea minus unu (K93)',
          K94: 'Quart (lichid UK) pe zi (K94)',
          K95: 'Quart (lichid UK) pe oră (K95)',
          K96: 'Quart (lichid UK) pe minut (K96)',
          K97: 'Quart (lichid UK) pe secundă (K97)',
          K98: 'Quart (lichid US) pe zi (K98)',
          K99: 'Quart (lichid US) pe oră (K99)',
          KA: 'Disc (KA)',
          KAT: 'Katal (KAT)',
          KB: 'Kilocaracter (KB)',
          KBA: 'Kilobar (KBA)',
          KCC: 'Kilogram de clorură de colină (KCC)',
          KDW: 'Kg greutate netă scursă (KDW)',
          KEL: 'Kelvin (KEL)',
          KGS: 'Kilogram pe secundă (KGS)',
          KHY: 'Kilogram de peroxid de hidrogen (KHY)',
          KHZ: 'Kilohertz (KHZ)',
          KI: 'Kilogram pe milimetru lățime (KI)',
          KIC: 'Kilogram, inclusiv recipient (KIC)',
          KIP: 'Kilogram, inclusiv ambalajul interior (KIP)',
          KJ: 'Kilosegment (KJ)',
          KJO: 'Kilojoule (KJO)',
          KL: 'Kilogram pe metru (KL)',
          KLK: 'Procentul de substanta uscata lactica (KLK)',
          KLX: 'Kilolux (KLX)',
          KMA: 'Kilogram de metilamină (KMA)',
          KMH: 'Kilometru pe oră (KMH)',
          KMK: 'Kilometru pătrat (KMK)',
          KMQ: 'Kilogram pe metru cub (KMQ)',
          KNI: 'Kilogram de azot (KNI)',
          KNM: 'Kilonewton pe metru pătrat (KNM)',
          KNS: 'Kilogram de substanță numită (KNS)',
          KNT: 'Nod (KNT)',
          KO: 'Potasa caustica de miliechivalenta per gram de produs (KO)',
          KPA: 'Kilopascal (KPA)',
          KPH: 'Kilogram de hidroxid de potasiu (potasă caustică) (KPH)',
          KPO: 'Kilogram de oxid de potasiu (KPO)',
          KPP: 'Kilogram de pentoxid de fosfor (anhidridă fosforică) (KPP)',
          KR: 'Kiloroentgen (KR)',
          KSD: 'Kilogram de substanță 90 % uscată (KSD)',
          KSH: 'Kilogram de hidroxid de sodiu (sodă caustică) (KSH)',
          KT: 'Kit (KT)',
          KTN: 'Kilotonă (KTN)',
          KUR: 'Kilogram de uraniu (KUR)',
          KVA: 'Kilovolt (KVA)',
          KVR: 'Kilovar (KVR)',
          KVT: 'Kilovolt (KVT)',
          KW: 'Kilogram pe milimetru (KW)',
          KWH: 'Kilowatt oră (KWH)',
          KWN: 'Kilowatt oră per metru cub normalizat (KWN)',
          KWO: 'Kilogram de trioxid de tungsten (KWO)',
          KWS: 'Kilowatt oră pe metru cub standard (KWS)',
          KWT: 'Kilowatt (KWT)',
          KX: 'Mililitru pe kilogram (KX)',
          L10: 'Litru (lichid american) pe minut (L10)',
          L11: 'Litru (lichid american) pe secundă (L11)',
          L12: 'Metru pe secundă Kelvin (L12)',
          L13: 'Metru pe secundă bar (L13)',
          L14: 'Metru pătrat grad Celsius pe kilocalorie (tabel internațional) (L14)',
          L15: 'Milipascal secundă pe Kelvin (L15)',
          L16: 'Milipascal secundă pe bar (L16)',
          L17: 'Miligram pe metru cub Kelvin (L17)',
          L18: 'Miligram pe metru cub bar (L18)',
          L19: 'Mililitru pe litru (L19)',
          L2: 'Litru pe minut (L2)',
          L20: 'Milimetri cubi reciproci (L20)',
          L21: 'Milimetri cubi pe metru cub (L21)',
          L23: 'Mol pe oră (L23)',
          L24: 'Mol pe kilogram Kelvin (L24)',
          L25: 'Mol pe kilogram bar (L25)',
          L26: 'Mol pe litru Kelvin (L26)',
          L27: 'Mol pe litru bara (L27)',
          L28: 'Mol pe metru cub Kelvin (L28)',
          L29: 'Mol pe metru cub bara (L29)',
          L30: 'Mol pe minut (L30)',
          L31: 'Miliroentgen echivalent kilocorp (L31)',
          L32: 'Nanograme per kilogram (L32)',
          L33: 'Uncie (avoirdupois) pe zi (L33)',
          L34: 'Uncie (avoirdupois) pe oră (L34)',
          L35: 'Uncie (avoirdupois) pe minut (L35)',
          L36: 'Uncie (avoirdupois) pe secundă (L36)',
          L37: 'Uncie (avoirdupois) per galon (UK) (L37)',
          L38: 'Uncie (avoirdupois) pe galon (SUA) (L38)',
          L39: 'Uncie (avoirdupois) per centimetru cub (L39)',
          L40: 'Uncie (avoirdupois) (L40)',
          L41: 'Uncie (avoirdupois) (L41)',
          L42: 'Picosiemens pe metru (L42)',
          L43: 'Peck (UK) (L43)',
          L44: 'Peck (UK) pe zi (L44)',
          L45: 'Peck (UK) pe oră (L45)',
          L46: 'Peck (UK) pe minut (L46)',
          L47: 'Peck (UK) pe secundă (L47)',
          L48: 'Peck (SUA uscat) pe zi (L48)',
          L49: 'Peck (SUA uscat) pe oră (L49)',
          L50: 'Peck (US uscat) pe minut (L50)',
          L51: 'Peck (US uscat) pe secundă (L51)',
          L52: 'PSI pe psi (L52)',
          L53: 'Halba (UK) pe zi (L53)',
          L54: 'Halba (UK) pe oră (L54)',
          L55: 'Halba (UK) pe minut (L55)',
          L56: 'Halba (UK) pe secundă (L56)',
          L57: 'Halba lichidă (SUA) pe zi (L57)',
          L58: 'Halba lichidă (SUA) pe orĂ (L58)',
          L59: 'Halba lichidă (SUA) pe minut (L59)',
          L60: 'Halba lichidă (SUA) pe secundă (L60)',
          L63: 'Slug pe zi (L63)',
          L64: 'Slug pe secundă picior (L64)',
          L65: 'Slug pe picior cub (L65)',
          L66: 'Slug pe oră (L66)',
          L67: 'Slug pe minut (L67)',
          L68: 'Slug pe secundă (L68)',
          L69: 'Tonă per Kelvin (L69)',
          L70: 'Tonă per bar (L70)',
          L71: 'Tonă pe zi (L71)',
          L72: 'Tonă pe zi Kelvin (L72)',
          L73: 'Tonă pe zi bar (L73)',
          L74: 'Tonă pe oră Kelvin (L74)',
          L75: 'Tonă pe oră bar (L75)',
          L76: 'Tonă pe metru cub Kelvin (L76)',
          L77: 'Tonă pe metru cub bar (L77)',
          L78: 'Tonă pe minut (L78)',
          L79: 'Tonă pe minut Kelvin (L79)',
          L80: 'Tonă pe minut bar (L80)',
          L81: 'Tonă pe secundă (L81)',
          L82: 'Tonă pe secundă Kelvin (L82)',
          L83: 'Tonă pe secundă bar (L83)',
          L84: 'Ton (transport maritim în Marea Britanie) (L84)',
          L85: 'O tona lunga pe zi (L85)',
          L86: 'Ton (transport maritim american) (L86)',
          L87: 'Ton scurt pe grad Fahrenheit (L87)',
          L88: 'O tona scurta pe zi (L88)',
          L89: 'Ton scurt pe oră grad Fahrenheit (L89)',
          L90: 'O tona scurta pe oră psi (L90)',
          L91: 'O tona scurta per psi (L91)',
          L92: 'Tonă (Marea Britanie lunga) per yard cubic (L92)',
          L93: 'Tonă (SUA) pe yard cubic (L93)',
          L94: 'Forta tona (Scurta în SUA) (L94)',
          L95: 'An comun (L95)',
          L96: 'An sideral (L96)',
          L98: 'Yard pe grad Fahrenheit (L98)',
          L99: 'Yard per psi (L99)',
          LA: 'Livră pe centimetru cub (LA)',
          LAC: 'Procentajul excesului de lactoză (LAC)',
          LBR: 'Livră (LBR)',
          LBT: 'Troy pound (SUA) (LBT)',
          LD: 'Litru pe zi (LD)',
          LEF: 'Frunză (LEF)',
          LF: 'Picior liniar (LF)',
          LH: 'Ora travaliului (LH)',
          LK: 'Link (LK)',
          LN: 'Lungime (LN)',
          LO: 'Lot [unitatea de achiziții] (LO)',
          LP: 'Livră lichidă (LP)',
          LPA: 'Litru de alcool pur (LPA)',
          LR: 'Strat (LR)',
          LS: 'Sumă forfetară (LS)',
          LTN: 'Tonă (Marea Britanie) sau tonă lungă (SUA) (LTN)',
          LUB: 'Tonă metrică, ulei lubrifiant (LUB)',
          LUM: 'Lumen (LUM)',
          LUX: 'Lux (LUX)',
          LY: 'Yard liniar (LY)',
          M1: 'Miligram pe litru (M1)',
          M10: 'Yard cubic reciproc (M10)',
          M11: 'Yard cubic pe grad Fahrenheit (M11)',
          M12: 'Yard cubic pe zi (M12)',
          M13: 'Yard cubic pe oră (M13)',
          M14: 'Yard cubic per psi (M14)',
          M15: 'Yard cubic pe minut (M15)',
          M16: 'Yard cubic pe secundă (M16)',
          M17: 'Kilohertz metru (M17)',
          M18: 'Gigahertz metru (M18)',
          M19: 'Beaufort (M19)',
          M20: 'Reciproc megaKelvin sau megaKelvin la puterea minus unu (M20)',
          M21: 'Kilovolt reciproc (M21)',
          M22: 'Mililitru pe minut de centimetru pătrat (M22)',
          M23: 'Newton pe centimetru (M23)',
          M24: 'Ohm kilometru (M24)',
          M25: 'Procent pe grad Celsius (M25)',
          M26: 'Gigaohm pe metru (M26)',
          M27: 'Metru megahertz (M27)',
          M29: 'Kilogram pe kilogram (M29)',
          M30: 'Volt reciproc secundă amper reciproc (M30)',
          M31: 'Kilogram pe kilometru (M31)',
          M32: 'Pascal secundă pe litru (M32)',
          M33: 'Millimol per litru (M33)',
          M34: 'Newton metru pe metru pătrat (M34)',
          M35: 'Milivolt (M35)',
          M36: 'Lună de 30 zile (M36)',
          M37: 'Actual/360 (M37)',
          M38: 'Kilometru pe secundă la pătrat (M38)',
          M39: 'Centimetru pe secundă la pătrat (M39)',
          M4: 'Valoare monetară (M4)',
          M40: 'Yard pe secundă la pătrat (M40)',
          M41: 'Milimetri pe secundă la pătrat (M41)',
          M42: 'Milă (milometru statuat) pe secundă la pătrat (M42)',
          M43: 'Mil (M43)',
          M44: 'Rotație (M44)',
          M45: 'Grad [unitate de unghi] pe secundă la pătrat (M45)',
          M46: 'Rotație pe minut (M46)',
          M47: 'Mil circulară (M47)',
          M48: 'Milă pătrată (bazată pe piciorul studiului american) (M48)',
          M49: 'Lanț (bazat pe picior releveu SUA) (M49)',
          M5: 'Microcurie (M5)',
          M50: 'Furlong (M50)',
          M51: 'Picior (releveu SUA) (M51)',
          M52: 'Mile (bazat pe piciorul de sondaj american) (M52)',
          M53: 'Metru pe pascal (M53)',
          M55: 'Metru pe radiant (M55)',
          M56: 'Se agita (M56)',
          M57: 'Milă pe minut (M57)',
          M58: 'Milă pe secundă (M58)',
          M59: 'Metru pe secundă pascal (M59)',
          M60: 'Metru pe oră (M60)',
          M61: 'Inch pe an (M61)',
          M62: 'Kilometru pe secundă (M62)',
          M63: 'Inch pe minut (M63)',
          M64: 'Yard pe secundă (M64)',
          M65: 'Yard pe minut (M65)',
          M66: 'Yard pe oră (M66)',
          M67: 'Acre (M67)',
          M68: 'Cordonul (128 ft3) (M68)',
          M69: 'Mile cub (statutul Marii Britanii) (M69)',
          M7: 'Micro (M7)',
          M70: 'Ton, înregistrare (M70)',
          M71: 'Metru cub per pascal (M71)',
          M72: 'Bel (M72)',
          M73: 'Kilogram pe metru cub pascal (M73)',
          M74: 'Kilogram per pascal (M74)',
          M75: 'Kilometru (M75)',
          M76: 'Poundal (M76)',
          M77: 'Kilogram metru pe secundă la pătrat (M77)',
          M78: 'Iaz (M78)',
          M79: 'Picior pătrat pe oră (M79)',
          M80: 'Stokes per pascal (M80)',
          M81: 'Centimetru pătrat pe secundă (M81)',
          M82: 'Metru pătrat pe secundă pascal (M82)',
          M83: 'Denier (M83)',
          M84: 'Livră pe metru (M84)',
          M85: 'Ton, test de (M85)',
          M86: 'Pfund (M86)',
          M87: 'Kilogram pe secundă pascal (M87)',
          M88: 'Tonă pe lună (M88)',
          M89: 'Tonă pe an (M89)',
          M9: 'Milioane Btu per 1000 picior cub (M9)',
          M90: 'Kilometru pe oră (M90)',
          M91: 'Livră pe kilogram (M91)',
          M92: 'Livră (M92)',
          M93: 'Newton metru pe radian (M93)',
          M94: 'Kilogram de metru (M94)',
          M95: 'Piciorul poundal (M95)',
          M96: 'Livră inch (M96)',
          M97: 'Dyne metru (M97)',
          M98: 'Kilogram centimetru pe secundă (M98)',
          M99: 'Gram centimetru pe secundă (M99)',
          MAH: 'Megavolt amper reactiv oră (MAH)',
          MAL: 'Megalitre (MAL)',
          MAM: 'Megametre (MAM)',
          MAR: 'Megavar (MAR)',
          MAW: 'Megawatt (MAW)',
          MBE: 'O mie echivalent caramida standard (MBE)',
          MBF: 'O mie de picioare la bord (MBF)',
          MBR: 'Milibar (MBR)',
          MC: 'Microgram (MC)',
          MCU: 'Milicurie (MCU)',
          MD: 'Tonă metrică uscată de aer (MD)',
          MGM: 'Miligram (MGM)',
          MHZ: 'Megahertz (MHZ)',
          MIK: 'Milă pătrată (milometru statuat) (MIK)',
          MIL: 'Mii de persoane (MIL)',
          MIN: 'Minut [timp] (MIN)',
          MIO: 'Un milion (MIO)',
          MIU: 'Milioane de unitati internaționale (MIU)',
          MLD: 'Biliard (MLD)',
          MLT: 'Mililitru (MLT)',
          MMK: 'Milimetru pătrat (MMK)',
          MMQ: 'Milimetri cubi (MMQ)',
          MMT: 'Milimetri (MMT)',
          MND: 'Kilogram, greutate uscată (MND)',
          MON: 'Lună (MON)',
          MPA: 'Megapascal (MPA)',
          MQH: 'Metru cub pe oră (MQH)',
          MQS: 'Metru cub pe secundă (MQS)',
          MSK: 'Metru pe secundă la pătrat (MSK)',
          MTS: 'Metru pe secundă (MTS)',
          MVA: 'Megavolt amper (MVA)',
          MWH: 'Megawatt oră (1000 kW.h) (MWH)',
          N1: 'Caloria stiloului injector (pen) (N1)',
          N10: 'Livră picior pe secundă (N10)',
          N11: 'Livră inch pe secundă (N11)',
          N12: 'Pferdestaerke (N12)',
          N13: 'Centimetru de mercur (0 grd C) (N13)',
          N14: 'Centimetru de apa (4 grd C) (N14)',
          N15: 'Picior de apa (39,2 ›F) (N15)',
          N16: 'Centimetru de mercur (32 grd F) (N16)',
          N17: 'Centimetru de mercur (60 grd F) (N17)',
          N18: 'Inci de apă (39,2 ›F) (N18)',
          N19: 'Inci de apă (60 ›F) (N19)',
          N20: 'Kip pe inch pătrat (N20)',
          N21: 'Poundal pe metru pătrat (N21)',
          N22: 'Uncie (avoirdupois) pe centimetru pătrat (N22)',
          N23: 'Metru convențional de apă (N23)',
          N24: 'Gram pe milimetru pătrat (N24)',
          N25: 'Livră pe metru pătrat (N25)',
          N26: 'Poundal pe centimetru pătrat (N26)',
          N27: 'Picior la a patra putere (N27)',
          N28: 'Decimetru cub per kilogram (N28)',
          N29: 'Picior cub pe kilogram (N29)',
          N3: 'Punct de imprimare (N3)',
          N30: 'Centimetru cub per kilogram (N30)',
          N31: 'Kilonewton pe metru (N31)',
          N32: 'Poundal pe inch (N32)',
          N33: 'Livră (N33)',
          N34: 'Poundal (N34)',
          N35: 'Poise per pascal (N35)',
          N36: 'Newton secundă pe metru pătrat (N36)',
          N37: 'Kilogram pe metru de secundă (N37)',
          N38: 'Kilogram pe metru minut (N38)',
          N39: 'Kilogram pe metru de zi (N39)',
          N40: 'Kilogram pe metru oră (N40)',
          N41: 'Gram pe centimetru secundă (N41)',
          N42: 'Poundal (N42)',
          N43: 'Livră pe minut picior (N43)',
          N44: 'Livră pe zi picior (N44)',
          N45: 'Metru cub pe secundă pascal (N45)',
          N46: 'Livră picior (N46)',
          N47: 'Inch poundal (N47)',
          N48: 'Watt pe centimetru pătrat (N48)',
          N49: 'Watt pe inch pătrat (N49)',
          N50: 'BTU (masură internațională) pe metru pătrat ora (N50)',
          N51: 'BTU (termochimică) pe metru pătrat ora (N51)',
          N52: 'BTU (termochimică) pe minut de metru pătrat (N52)',
          N53: 'BTU (masură internațională) pe secundă metru pătrat (N53)',
          N54: 'BTU (termochimică) pe secundă metru pătrat (N54)',
          N55: 'BTU (masa internaționala) pe secundă pătrată (N55)',
          N56: 'Calorie (termochimic) pe centimetru pătrat minut (N56)',
          N57: 'Calorie (termochimic) pe centimetru pătrat secundă (N57)',
          N58: 'BTU (masură internațională) pe picior cub (N58)',
          N59: 'BTU (termochimică) pe picior cub (N59)',
          N60: 'BTU (tabel internațional) pe grad Fahrenheit (N60)',
          N61: 'BTU (termochimică) pe grad Fahrenheit (N61)',
          N62: 'BTU (tabel internațional) pe grad Rankine (N62)',
          N63: 'BTU (termochimică) pe grad Rankine (N63)',
          N64: 'BTU (termochimică) pe lira Rankine grad (N64)',
          N65: 'Kilocalorie (tabel internațional) pe gram Kelvin (N65)',
          N66: 'BTU (39 grd F) (N66)',
          N67: 'BTU (59 grd F) (N67)',
          N68: 'BTU (60 grd F) (N68)',
          N69: 'Calorii (20 grdC) (N69)',
          N70: 'Quad (1015 BtuIT) (N70)',
          N71: 'Term (CE) (N71)',
          N72: 'Therm (SUA) (N72)',
          N73: 'BTU (termochimică) per kilogram (N73)',
          N74: 'BTU (masură internațională) pe oră grad de metru pătrat Fahrenheit (N74)',
          N75: 'BTU (termochimică) pe oră grad de picior pătrat Fahrenheit (N75)',
          N76: 'BTU (masură internațională) pe secundă grad de picior pătrat Fahrenheit (N76)',
          N77: 'BTU (termochimică) pe secundă grad de picior pătrat Fahrenheit (N77)',
          N78: 'Kilowatt pe metru pătrat Kelvin (N78)',
          N79: 'Kelvin per pascal (N79)',
          N80: 'Watt pe metru grad Celsius (N80)',
          N81: 'Kilowatt pe metru Kelvin (N81)',
          N82: 'Kilowatt pe metru grad Celsius (N82)',
          N83: 'Metru pe grad celcius metru (N83)',
          N84: 'Grad Fahrenheit oră per unitate termică britanică (tabel internațional) (N84)',
          N85: 'Grad Fahrenheit oră per unitate termică britanică (termochimic) (N85)',
          N86: 'Grad Fahrenheit secundă pe unitate termică britanică (tabel internațional) (N86)',
          N87: 'Grad Fahrenheit secundă pe unitate termică britanică (termochimic) (N87)',
          N88: 'Grad Fahrenheit oră metru pătrat per unitate termică britanică (masa internaționala) inch (N88)',
          N89: 'Grad Fahrenheit oră metru pătrat per unitate termică britanică (termochimic) inch (N89)',
          N90: 'Kilofarad (N90)',
          N91: 'Joule reciproce (N91)',
          N92: 'Picosiemens (N92)',
          N93: 'Amperi per pascal (N93)',
          N94: 'Franklin (N94)',
          N95: 'Amper minut (N95)',
          N96: 'Biot (N96)',
          N97: 'Gilbert (N97)',
          N98: 'Volt per pascal (N98)',
          N99: 'Picovolt (N99)',
          NA: 'Miligram pe kilogram (NA)',
          NCL: 'Număr de celule (NCL)',
          NEW: 'Newton (NEW)',
          NF: 'Mesaj (NF)',
          NIL: 'Nul (NIL)',
          NIU: 'Număr de unități internaționale (NIU)',
          NL: 'Sarcina (NL)',
          NM3: 'Metru cub normalizat (NM3)',
          NMI: 'Milă marină (NMI)',
          NMP: 'Număr de ambalaje (NMP)',
          NPT: 'Număr de părți (NPT)',
          NT: 'Tonă netă (NT)',
          NU: 'Newton metru (NU)',
          NX: 'Parte la o mie (NX)',
          OA: 'Panou (OA)',
          ODE: 'Echivalent ODS (ODE)',
          ODG: 'Gram ODS (ODG)',
          ODK: 'Kilogram ODS (ODK)',
          ODM: 'Miligram ODS (ODM)',
          OHM: 'Ohm (OHM)',
          ON: 'Uncie pe metru pătrat (ON)',
          ONZ: 'Uncie (avoirdupois) (ONZ)',
          OPM: 'Oscilatii pe minut (OPM)',
          OT: 'Ore suplimentare ora (OT)',
          OZA: 'Uncie de lichid (SUA) (OZA)',
          OZI: 'Uncie de lichid (UK) (OZI)',
          P1: 'Procent (P1)',
          P10: 'Coulomb pe metru (P10)',
          P11: 'Kiloweber (P11)',
          P12: 'Gama (P12)',
          P13: 'Kilotesla (P13)',
          P14: 'Joule pe secundă (P14)',
          P15: 'Joule pe minut (P15)',
          P16: 'Joule pe oră (P16)',
          P17: 'Joule pe zi (P17)',
          P18: 'Kilojoul pe secundă (P18)',
          P19: 'Kilojoul pe minut (P19)',
          P2: 'Livră pe picior (P2)',
          P20: 'Kilojoul pe oră (P20)',
          P21: 'Kilojoul pe zi (P21)',
          P22: 'Nanoohm (P22)',
          P23: 'Ohm circular (P23)',
          P24: 'Kilohenry (P24)',
          P25: 'Lumen pe metru pătrat (P25)',
          P26: '?Phot? ? ?Phot? (P26)',
          P27: 'Licoare pentru picioare (P27)',
          P28: 'Candelă pe centimetru pătrat (P28)',
          P29: 'Footlambert (P29)',
          P30: 'Lambert (P30)',
          P31: 'Stilb (P31)',
          P32: 'Candelă pe metru pătrat (P32)',
          P33: 'Kilocandela (P33)',
          P34: 'Millicandela (P34)',
          P35: 'Hefner (P35)',
          P36: 'Candelă internațională (P36)',
          P37: 'BTU (masură internațională) pe metru pătrat (P37)',
          P38: 'BTU (termochimică) pe metru pătrat (P38)',
          P39: 'Calorii (termochimice) pe centimetru pătrat (P39)',
          P40: 'Langley (P40)',
          P41: 'Decadă (logaritmică) (P41)',
          P42: 'Pascal la pătrat secundă (P42)',
          P43: 'Bel pe metru (P43)',
          P44: 'Livră mol (P44)',
          P45: 'Livră mol pe secundă (P45)',
          P46: 'Livră mol pe minut (P46)',
          P47: 'Kilomol pe kilogram (P47)',
          P48: 'Livră mol pe kilogram (P48)',
          P49: 'Newton metru pătrat pe amperi (P49)',
          P5: 'Cinci pachete (P5)',
          P50: 'Weber metru (P50)',
          P51: 'Mol pe kilogram pascal (P51)',
          P52: 'Mol pe metru cub pascal (P52)',
          P53: 'Pol unitate de unitate (P53)',
          P54: 'Milligray pe secundă (P54)',
          P55: 'Micrograie pe secundă (P55)',
          P56: 'Nanogray pe secundă (P56)',
          P57: 'Gri pe minut (P57)',
          P58: 'Milligray pe minut (P58)',
          P59: 'Micrograie pe minut (P59)',
          P60: 'Nanogray pe minut (P60)',
          P61: 'Gri pe oră (P61)',
          P62: 'Milligray pe oră (P62)',
          P63: 'Micrograie pe oră (P63)',
          P64: 'Nanogray pe oră (P64)',
          P65: 'Sievert pe secundă (P65)',
          P66: 'Milisievert pe secundă (P66)',
          P67: 'Microsievert pe secundă (P67)',
          P68: 'Nanosievert pe secundă (P68)',
          P69: 'REM pe secundă (P69)',
          P70: 'Sievert pe oră (P70)',
          P71: 'Milisievert pe oră (P71)',
          P72: 'Microsievert pe oră (P72)',
          P73: 'Nanosievert pe oră (P73)',
          P74: 'Sievert pe minut (P74)',
          P75: 'Milisievert pe minut (P75)',
          P76: 'Microsievert pe minut (P76)',
          P77: 'Nanosievert pe minut (P77)',
          P78: 'Centimetru pătrat reciproc (P78)',
          P79: 'Patrat Pascal metru per kilogram (P79)',
          P80: 'Milipascal pe metru (P80)',
          P81: 'Kilopascal pe metru (P81)',
          P82: 'Hectopascal per metru (P82)',
          P83: 'Atmosferă standard pe metru (P83)',
          P84: 'Atmosferă tehnică pe metru (P84)',
          P85: 'Torr pe metru (P85)',
          P86: 'PSI pe inch (P86)',
          P87: 'Metru cub pe secundă metru pătrat (P87)',
          P88: 'Rhe (P88)',
          P89: 'Livră (P89)',
          P90: 'Livră (P90)',
          P91: 'Perm (0 ›C) (P91)',
          P92: 'Perm (23 ›C) (P92)',
          P93: 'Byte pe secundă (P93)',
          P94: 'Kilobyte pe secundă (P94)',
          P95: 'Megabyte pe secundă (P95)',
          P96: 'Volt reciproc (P96)',
          P97: 'Radian reciproc (P97)',
          P98: 'Pascal la suma de putere a numerelor stoichiometrice (P98)',
          P99: 'Mol pe metru de cubiv la suma de putere a numerelor stoechiometrice (P99)',
          PAL: 'Pascal (PAL)',
          PD: 'Pad (PD)',
          PFL: 'Litru de proba (PFL)',
          PGL: 'Galon de probă (PGL)',
          PI: 'Pas (PI)',
          PLA: 'Grad Plato (PLA)',
          PO: 'Livră pe centimetru de lungime (PO)',
          PQ: 'Pagina pe inch (PQ)',
          PR: 'Pereche (PR)',
          PS: 'Livră (PS)',
          PTD: 'Halba uscată (SUA) (PTD)',
          PTI: 'Halba (UK) (PTI)',
          PTL: 'Halba lichidă (SUA) (PTL)',
          PTN: 'Porțiune (PTN)',
          Q10: 'Joule per tesla (Q10)',
          Q11: 'Erlang (Q11)',
          Q12: 'Octet (Q12)',
          Q13: 'Octet pe secundă (Q13)',
          Q14: 'Shannon (Q14)',
          Q15: 'Hartley (Q15)',
          Q16: 'Unitate naturală de informații (Q16)',
          Q17: 'Shannon pe secundă (Q17)',
          Q18: 'Hartley pe secundă (Q18)',
          Q19: 'Unitate naturala de informatii pe secundă (Q19)',
          Q20: 'Secundă pe kilogram (Q20)',
          Q21: 'Metru pătrat Watt (Q21)',
          Q22: 'Secundă pe radian metru cub (Q22)',
          Q23: 'Weber la puterea minus unu (Q23)',
          Q24: 'Centimetru reciproc (Q24)',
          Q25: 'Dioptru (Q25)',
          Q26: 'Una pe una (Q26)',
          Q27: 'Newton metru pe metru (Q27)',
          Q28: 'Kilogram pe metru pătrat pascal secundă (Q28)',
          Q29: 'Microgram per hectograma (Q29)',
          Q30: 'PH (potential de hidrogen) (Q30)',
          Q31: 'Kilojoul pe gram (Q31)',
          Q32: 'Femtolitre (Q32)',
          Q33: 'Picolitre (Q33)',
          Q34: 'Nanolitrul (Q34)',
          Q35: 'Megawati pe minut (Q35)',
          Q36: 'Metru pătrat pe metru cub (Q36)',
          Q37: 'Metru cub standard pe zi (Q37)',
          Q38: 'Metru cub standard pe oră (Q38)',
          Q39: 'Metru cub normalizat pe zi (Q39)',
          Q40: 'Metru cub normalizat pe oră (Q40)',
          Q41: 'Joule per metru cub normalizat (Q41)',
          Q42: 'Joule pe metru cub standard (Q42)',
          Q3: 'Masă (Q3)',
          QA: 'Pagina (QA)',
          QAN: 'Trimestru (de un an) (QAN)',
          QB: 'Pagina (QB)',
          QR: 'Quire (QR)',
          QTD: 'Litru uscat (SUA) (QTD)',
          QTI: 'Quart (UK) (QTI)',
          QTL: 'Litru lichid (SUA) (QTL)',
          QTR: 'Trimestru (Regatul Unit) (QTR)',
          R1: 'Pica (R1)',
          R9: 'Mii de metri cubi (R9)',
          RH: 'Ora de functionare sau de functionare (RH)',
          RM: 'Ream (RM)',
          ROM: 'Cameră (ROM)',
          RP: 'Livră pe ream (RP)',
          RPM: 'Rotații pe minut (RPM)',
          RPS: 'Rotații pe secundă (RPS)',
          RT: 'Venituri de o mila (RT)',
          S3: 'Picior pătrat pe secundă (S3)',
          S4: 'Metru pătrat pe secundă (S4)',
          SAN: 'Jumatate de an (6 luni) (SAN)',
          SCO: 'Punctaj (SCO)',
          SCR: 'Scrupula (SCR)',
          SEC: 'Secundă [unitate de timp] (SEC)',
          SG: 'Segment (SG)',
          SIE: 'Siemens (SIE)',
          SM3: 'Metru cub standard (SM3)',
          SMI: 'Mile (milometru statuat) (SMI)',
          SQ: 'Patrat (SQ)',
          SQR: 'Patrat, acoperisuri (SQR)',
          SR: 'Benzi (SR)',
          STC: 'Stick (STC)',
          STI: 'Stone (UK) (STI)',
          STK: 'Stick, tigara (STK)',
          STL: 'Litru standard (la 15 grd C) (STL)',
          STN: 'Tonă (SUA) sau tona scurtă (UK/SUA) (STN)',
          STW: 'Paie (STW)',
          SW: 'Skein (SW)',
          SX: 'Transport (SX)',
          SYR: 'Seringa (SYR)',
          T0: 'Linie de telecomunicații în exploatare (T0)',
          T3: 'O mie de bucăți (T3)',
          TAH: 'Kiloampere oră (mii de amper ora) (TAH)',
          TAN: 'Număr total de acid (TAN)',
          TI: 'O mie de centimetri pătrați (TI)',
          TIC: 'Tonă metrică, inclusiv recipient (TIC)',
          TIP: 'Tonă metrică, inclusiv ambalajul interior (TIP)',
          TKM: 'Tonă kilometru (TKM)',
          TMS: 'Kilogram de carne importată, mai puțin organe comestibile (TMS)',
          TP: 'Zece pachete (TP)',
          TPI: 'Dinți pe centimetru (TPI)',
          TPR: 'Zece perechi (TPR)',
          TQD: 'Mii de metri cubi pe zi (TQD)',
          TRL: 'Trilion (EUR) (TRL)',
          TST: 'Zece set (TST)',
          TTS: 'Zece mii de bete (TTS)',
          U1: 'Tratament (U1)',
          U2: 'Comprimat (U2)',
          UB: 'Media liniei de telecomunicații în exploatare (UB)',
          UC: 'Port de telecomunicații (UC)',
          VA: 'Volt ? amper pe kilogram (VA)',
          VLT: 'Volt (VLT)',
          VP: 'Volumul procentual (VP)',
          W2: 'Kg umed (W2)',
          WA: 'Watt pe kilogram (WA)',
          WB: 'Livră umedă (WB)',
          WCD: 'Cordonul (WCD)',
          WE: 'Tonă umedă (WE)',
          WEB: 'Weber (WEB)',
          WEE: 'Săptămână (WEE)',
          WG: 'Galon de vin (WG)',
          WHR: 'Ora Watt (WHR)',
          WM: 'Lună de lucru (WM)',
          WSD: 'Standard (WSD)',
          WTT: 'Watt (WTT)',
          X1: 'Lantul lui Gunter (X1)',
          YDK: 'Yard pătrat (YDK)',
          YDQ: 'Yard cubic (YDQ)',
          YRD: 'Yard (YRD)',
          Z11: 'Container suspendat (Z11)',
          ZP: 'Pagina (ZP)',
          ZZ: 'Unitate definită de comun acord (ZZ)',
          X1A: 'Tambur, oțel (X1A)',
          X1B: 'Tambur, aluminiu (X1B)',
          X1D: 'Tambur, placaj (X1D)',
          X1F: 'Container, flexibil (X1F)',
          X1G: 'Tambur, fibre (X1G)',
          X1W: 'Tambur, din lemn (X1W)',
          X2C: 'Butoi, din lemn (X2C)',
          X3A: 'Jerrican, oțel (X3A)',
          X3H: 'Jerrican, plastic (X3H)',
          X43: 'Sac, super vrac (X43)',
          X44: 'Pungă, pungă de poligam (X44)',
          X4A: 'Cutie, oțel (X4A)',
          X4B: 'Cutie, aluminiu (X4B)',
          X4C: 'Cutie, lemn natural (X4C)',
          X4D: 'Cutie, placaj (X4D)',
          X4F: 'Cutie, lemn reconstituit (X4F)',
          X4G: 'Cutie, panouri fibrolemnoase (X4G)',
          X4H: 'Cutie, plastic (X4H)',
          X5H: 'Pungă, țesută din plastic (X5H)',
          X5L: 'Sac, textil (X5L)',
          X5M: 'Sac, hârtie (X5M)',
          X6H: 'Ambalaj compozit, recipient din plastic (X6H)',
          X6P: 'Ambalaj compozit, recipient din sticlă (X6P)',
          X7A: 'Case, masina (X7A)',
          X7B: 'Carcasă, din lemn (X7B)',
          X8A: 'Palet, din lemn (X8A)',
          X8B: 'Ladă, din lemn (X8B)',
          X8C: 'Pachet, din lemn (X8C)',
          XAA: 'Recipient mare pentru vrac, din plastic rigid (XAA)',
          XAB: 'Recipient, fibră (XAB)',
          XAC: 'Recipient, hârtie (XAC)',
          XAD: 'Recipient din lemn (XAD)',
          XAE: 'Aerosoli (XAE)',
          XAF: 'Palet, modular, manșon 80x60 cm (XAF)',
          XAG: 'Palet, înfășurat în vrac (XAG)',
          XAH: 'Palet, 100cm x 110cm (XAH)',
          XAI: 'Scoica de scoica (XAI)',
          XAJ: 'Con de con (XAJ)',
          XAL: 'Bilă (XAL)',
          XAM: 'Fiola, neprotejată (XAM)',
          XAP: 'Fiola, protejată (XAP)',
          XAT: 'Atomizor (XAT)',
          XAV: 'Capsulă (XAV)',
          XB4: 'Centură (XB4)',
          XBA: 'Baril (XBA)',
          XBB: 'Bobină (XBB)',
          XBC: 'Bottlecrate/bottlerack (XBC)',
          XBD: 'Board (XBD)',
          XBE: 'Pachet (XBE)',
          XBF: 'Balon, neprotejat (XBF)',
          XBG: 'Sac (XBG)',
          XBH: 'Buchet (XBH)',
          XBI: 'Coș de gunoi (XBI)',
          XBJ: 'Găleată (XBJ)',
          XBK: 'Coș (XBK)',
          XBL: 'Balot, comprimat (XBL)',
          XBM: 'Bazin (XBM)',
          XBN: 'Balot, necomprimat (XBN)',
          XBO: 'Sticlă, neprotejată, cilindrică (XBO)',
          XBP: 'Balon, protejat (XBP)',
          XBQ: 'Flacon, protejat cilindric (XBQ)',
          XBR: 'Bar (XBR)',
          XBS: 'Sticlă, neprotejată, cu bulbi (XBS)',
          XBT: 'Șurub (XBT)',
          XBU: 'Cap la cap (XBU)',
          XBV: 'Sticlă, protejată, cu bulbi (XBV)',
          XBW: 'Cutie, pentru lichide (XBW)',
          XBX: 'Cutie (XBX)',
          XBY: 'Masă, în pachet/bucata/truss (XBY)',
          XBZ: 'Bare, în pachet/bucată/truss (XBZ)',
          XCA: 'Cutie, dreptunghiulară (XCA)',
          XCB: 'Ladă, bere (XCB)',
          XCC: 'Churn (XCC)',
          XCD: 'Poate, cu mâner și gura de scurgere (XCD)',
          XCE: 'Creel (XCE)',
          XCF: 'Cufăr (XCF)',
          XCG: 'Cușcă (XCG)',
          XCH: 'Piept (XCH)',
          XCI: 'Canistră (XCI)',
          XCJ: 'Coșciug (XCJ)',
          XCK: 'Butoiaș (XCK)',
          XCL: 'Bobină (XCL)',
          XCM: 'Card (XCM)',
          XCN: 'Container, nespecificat altfel ca echipament de transport (XCN)',
          XCO: 'Carboy, neprotejat (XCO)',
          XCP: 'Carboy, protejat (XCP)',
          XCQ: 'Cartuș (XCQ)',
          XCR: 'Ladă (XCR)',
          XCS: 'Cutie (case) (XCS)',
          XCT: 'Cutie de carton (XCT)',
          XCU: 'Cupă (XCU)',
          XCV: 'Copertă (XCV)',
          XCW: 'Cușcă, rolă (XCW)',
          XCX: 'Can, cilindric (XCX)',
          XCZ: 'Canvas (XCZ)',
          XDA: 'Cutie, strat multiplu, plastic (XDA)',
          XDB: 'Ladă, strat multiplu, din lemn (XDB)',
          XDC: 'Cutie, strat multiplu, carton (XDC)',
          XDG: 'Cușcă (CHEP) (XDG)',
          XDH: 'Box, CHEP, Eurobox (XDH)',
          XDI: 'Tambur, fier (XDI)',
          XDJ: 'Demijohn, neprotejat (XDJ)',
          XDK: 'Cutie, vrac, carton (XDK)',
          XDL: 'Cutie, vrac, din plastic (XDL)',
          XDM: 'Ladă, vrac, din lemn (XDM)',
          XDN: 'Seringa dozatoare (XDN)',
          XDP: 'Demijohn, protejat (XDP)',
          XDR: 'Tambur (XDR)',
          XDS: 'Tavă, un strat fără capac, plastic (XDS)',
          XDT: 'Tavă, un strat fără capac, din lemn (XDT)',
          XDU: 'Tavă, un strat fără capac, polistiren (XDU)',
          XDV: 'Tavă, un strat fără capac, carton (XDV)',
          XDW: 'Tavă, două straturi fără capac, plastic (XDW)',
          XDX: 'Tavă, două straturi fără capac, din lemn (XDX)',
          XDY: 'Tavă, două straturi fără capac, carton (XDY)',
          XEC: 'Pungă, plastic (XEC)',
          XED: 'Caz, cu baza de paleti (XED)',
          XEE: 'Carcasă, cu suport palet, din lemn (XEE)',
          XEF: 'Carcasă, cu suport palet, carton (XEF)',
          XEG: 'Carcasă, cu suport palet, plastic (XEG)',
          XEH: 'Carcasă, cu suport palet, metal (XEH)',
          XEI: 'Caz, izotermie (XEI)',
          XEN: 'Plic (XEN)',
          XFB: 'FlexiBag (XFB)',
          XFC: 'Ladă, fructe (XFC)',
          XFD: 'Ladă, înrămată (XFD)',
          XFE: 'Flexitank (XFE)',
          XFI: 'Bradkin (XFI)',
          XFL: 'Balon (XFL)',
          XFO: 'Cufăr de picior (XFO)',
          XFP: 'Pachet de filme (XFP)',
          XFR: 'Cadru (XFR)',
          XFT: 'Furnizor de alimente (XFT)',
          XFW: 'Cărucior, cu platformă (XFW)',
          XFX: 'Sac, recipient flexibil (XFX)',
          XGB: 'Sticla, gaz (XGB)',
          XGI: 'Grinzi (XGI)',
          XGL: 'Recipient, galon (XGL)',
          XGR: 'Recipient, sticlă (XGR)',
          XGU: 'Tavă, cu elemente plane stivuite orizontal (XGU)',
          XGY: 'Sac, gunny (XGY)',
          XGZ: 'Grinzi, în pachet/bucata/truss (XGZ)',
          XHA: 'Coș, cu mâner, plastic (XHA)',
          XHB: 'Coș, cu mâner, din lemn (XHB)',
          XHC: 'Coș, cu mâner, carton (XHC)',
          XHG: 'Butoi hogshead (XHG)',
          XHN: 'Umeraş (XHN)',
          XHR: 'Coș nuiele (XHR)',
          XIA: 'Pachet, afisaj, lemn (XIA)',
          XIB: 'Pachet, afisaj, carton (XIB)',
          XIC: 'Pachet, afisaj, plastic (XIC)',
          XID: 'Pachet, afisaj, metal (XID)',
          XIE: 'Pachet, arata (XIE)',
          XIF: 'Pachet, flux (XIF)',
          XIG: 'Pachet, hârtie învelită (XIG)',
          XIH: 'Tambur, plastic (XIH)',
          XIK: 'Pachet, carton, cu capace de prindere (XIK)',
          XIL: 'Tavă rigidă, cu capac stivuit (CEN TS 14482:2002) (XIL)',
          XIN: 'Lingou (XIN)',
          XIZ: 'Lingouri, în pachet/bucata/truss (XIZ)',
          XJB: 'Sac, jumbo (XJB)',
          XJC: 'Jerrican, dreptunghiular (XJC)',
          XJG: 'Ulcior (XJG)',
          XJR: 'Borcan (XJR)',
          XJT: 'Jutebag (XJT)',
          XJY: 'Jerrican, cilindric (XJY)',
          XKG: 'Butoi de bere (XKG)',
          XKI: 'Kit (XKI)',
          XLE: 'Bagaj (XLE)',
          XLG: 'Jurnal (XLG)',
          XLT: 'Lot (XLT)',
          XLU: 'Lug (XLU)',
          XLV: 'Liftvan (XLV)',
          XLZ: 'Bușteni, în pachet/truss (XLZ)',
          XMA: 'Ladă, metal (XMA)',
          XMB: 'Sac, se înmulteste? (XMB)',
          XMC: 'Ladă, lapte (XMC)',
          XMR: 'Recipient, din metal (XMR)',
          XMS: 'Sack, cu mai multe pereti (XMS)',
          XMT: 'Mat (XMT)',
          XMW: 'Recipient, înfășurat din plastic (XMW)',
          XMX: 'Cutie de chibrituri (XMX)',
          XNA: 'Nedisponibil (XNA)',
          XNE: 'Despachetat sau neambalat (XNE)',
          XNF: 'Despachetat sau neambalat, o singură unitate (XNF)',
          XNG: 'Despachetate sau neambalate, mai multe unități (XNG)',
          XNS: 'Cuib (XNS)',
          XNT: 'Plasă (XNT)',
          XNU: 'Plasă, tub, plastic (XNU)',
          XNV: 'Net, tub, textile (XNV)',
          XOA: 'Palet, CHEP 40 cm x 60 cm (XOA)',
          XOB: 'Palet, CHEP 80 cm x 120 cm (XOB)',
          XOC: 'Palet, CHEP 100 cm x 120 cm (XOC)',
          XOD: 'Palet, AS 4068 (XOD)',
          XOE: 'Palet, ISO T11 (XOE)',
          XOF: 'Platformă, greutate sau dimensiune nespecificată (XOF)',
          XOK: 'Bloc (XOK)',
          XOT: 'Octabina (XOT)',
          XOU: 'Recipient, exterior (XOU)',
          XP2: 'Pan (XP2)',
          XPA: 'Pachet (XPA)',
          XPC: 'Parcela (XPC)',
          XPD: 'Palet, modular, manșon 80x100 cm (XPD)',
          XPE: 'Palet, modular, manșon 80x120 cm (XPE)',
          XPF: 'Stilou injector (pen) (XPF)',
          XPG: 'Placă (XPG)',
          XPH: 'Ulcior (XPH)',
          XPI: 'Țeavă (XPI)',
          XPJ: 'Punnet (XPJ)',
          XPK: 'Pachet (XPK)',
          XPL: 'Găleată (XPL)',
          XPN: 'Scândură (XPN)',
          XPO: 'Husă (XPO)',
          XPR: 'Recipient, din plastic (XPR)',
          XPT: 'Oala (XPT)',
          XPU: 'Tavă (XPU)',
          XPV: 'Țevi, în pachet/bucata/truss (XPV)',
          XPX: 'Palet (XPX)',
          XPY: 'Plăci, în pachet/bucata/truss (XPY)',
          XPZ: 'Scânduri, în pachet/bucată/truss (XPZ)',
          XQA: 'Tambur, otel, cap nedetașabil (XQA)',
          XQB: 'Tambur, oțel, cap detașabil (XQB)',
          XQC: 'Tambur, din aluminiu, cap nedetașabil (XQC)',
          XQD: 'Tambur, aluminiu, cap detașabil (XQD)',
          XQF: 'Tambur, din plastic, cap nedetașabil (XQF)',
          XQG: 'Tambur, plastic, cap detașabil (XQG)',
          XQH: 'Butoi lemn, tip cep (XQH)',
          XQJ: 'Butoi lemn, cap detașabil (XQJ)',
          XQK: 'Jerican, otel, cap nedetașabil (XQK)',
          XQL: 'Jerrican, otel, cap detasabil (XQL)',
          XQM: 'Cap de plastic, nedetașabil (XQM)',
          XQN: 'Jerrican, plastic, cap detasabil (XQN)',
          XQP: 'Cutie, lemn, lemn natural, obișnuit (XQP)',
          XQQ: 'Cutie, lemn, lemn natural, cu pereți rezistenti la cernere (XQQ)',
          XQR: 'Cutie, plastic, extins (XQR)',
          XQS: 'Cutie, plastic, solid (XQS)',
          XRD: 'Tijă (XRD)',
          XRG: 'Inel (XRG)',
          XRJ: 'Rack, umeras de îmbrăcăminte (XRJ)',
          XRK: 'Rack (XRK)',
          XRL: 'Rolă (XRL)',
          XRO: 'Rolă (XRO)',
          XRT: 'ReDNet (XRT)',
          XRZ: 'Tije, în pachet/bucata/truss (XRZ)',
          XSA: 'Sack (XSA)',
          XSB: 'Lespede (XSB)',
          XSC: 'Ladă, superficială (XSC)',
          XSD: 'Ax (XSD)',
          XSE: 'Pieptul marii (XSE)',
          XSH: 'Plic (XSH)',
          XSI: 'Derapeaza (XSI)',
          XSK: 'Carcasă, cutie, cadru (XSK)',
          XSL: 'Foaia de alunecare (XSL)',
          XSM: 'Tablă de metal (XSM)',
          XSO: 'Bobină (XSO)',
          XSP: 'Folie de plastic (XSP)',
          XSS: 'Caz, din otel (XSS)',
          XST: 'Foaia de hartie (XST)',
          XSU: 'Valiză (XSU)',
          XSV: 'Plic, otel (XSV)',
          XSW: 'Infoliată (XSW)',
          XSY: 'Mânecă (XSY)',
          XSZ: 'Foi, în pachet/bucată/truss (XSZ)',
          XT1: 'Comprimat (XT1)',
          XTB: 'Cadă (XTB)',
          XTC: 'Piept de ceai (XTC)',
          XTD: 'Tub, pliabil (XTD)',
          XTE: 'Pneu (XTE)',
          XTG: 'Recipient pentru cisterna, generic (XTG)',
          XTI: 'Cravata (XTI)',
          XTK: 'Rezervor, dreptunghiular (XTK)',
          XTL: 'Cadă, cu capac (XTL)',
          XTN: 'Staniu (XTN)',
          XTO: 'Tun (XTO)',
          XTR: 'Trunchi (XTR)',
          XTS: 'Truss (XTS)',
          XTT: 'Sac, tote (XTT)',
          XTU: 'Tub (XTU)',
          XTV: 'Tub, cu duză (XTV)',
          XTW: 'Palet, triwall (XTW)',
          XTZ: 'Tuburi, în pachet/bucată/truss (XTZ)',
          XUC: 'Neascutita (XUC)',
          XUN: 'Unitate (XUN)',
          XVA: 'VAT (XVA)',
          XVG: 'Vrac, gaz (la 1031 mbar și 15 grdC) (XVG)',
          XVI: 'Flacon (XVI)',
          XVK: 'Vanpack (XVK)',
          XVL: 'Vrac, lichid (XVL)',
          XVO: 'Vrac, solide, particule mari (XVO)',
          XVP: 'Ambalaj vidat (XVP)',
          XVQ: 'Vrac, gaz lichefiat (la temp./presiune anormală) (XVQ)',
          XVN: 'Vehicul (XVN)',
          XVR: 'Particule groase, solide, granulare (XVR)',
          XVS: 'Vrac, deșeuri metalice (XVS)',
          XVY: 'Vrac, solide, particule fine (pulberi) (XVY)',
          XWA: 'Recipient vrac (XWA)',
          XWB: 'Biberonul de Wickerbottle (XWB)',
          XWC: 'Recipient vrac, oțel (XWC)',
          XWD: 'Recipient vrac, aluminiu (XWD)',
          XWF: 'Recipient vrac, din metal (XWF)',
          XWG: 'Recipient vrac, din oțel, presurizat > 10 kpa (XWG)',
          XWH: 'Recipient vrac, din aluminiu, presurizat > 10 kpa (XWH)',
          XWJ: 'Recipient vrac, metal, presurizat 10 kpa (XWJ)',
          XWK: 'Recipient vrac, din oțel, lichide (XWK)',
          XWL: 'Recipient vrac, aluminiu, lichide (XWL)',
          XWM: 'Recipient vrac, metalic, lichide (XWM)',
          XWN: 'Recipient vrac, plastic țesut, fără acoperire/căptușeală (XWN)',
          XWP: 'Recipient vrac, plastic țesut, acoperit (XWP)',
          XWQ: 'Recipient vrac, plastic țesut, căptușit (XWQ)',
          XWR: 'Recipient vrac, plastic țesut, acoperit/căptușit (XWR)',
          XWS: 'Recipient vrac, pelicula din plastic (XWS)',
          XWT: 'Recipient vrac, textil, acoperit/căptușit (XWT)',
          XWU: 'Recipient vrac, din lemn natural, cu sigiliu interior (XWU)',
          XWV: 'Recipient vrac, textil, acoperit (XWV)',
          XWW: 'Recipient vrac, textil, căptușit (XWW)',
          XWX: 'Recipient vrac, textil, acoperite și căptușit (XWX)',
          XWY: 'Recipient vrac, placaj, căptușit (XWY)',
          XWZ: 'Recipient vrac, lemn reconstituit, căptușit (XWZ)',
          XXA: 'Pungă, plastic țesut, fără strat interior/căptușeală (XXA)',
          XXB: 'Sac, plastic țesut, dovada cernerii (XXB)',
          XXC: 'Pungă, plastic țesut, rezistentă la apă (XXC)',
          XXD: 'Pungă, folie de plastic (XXD)',
          XXF: 'Sac, textil, fără strat interior (XXF)',
          XXG: 'Sac, textil, probă de cernere (XXG)',
          XXH: 'Sac, textil, rezistent la apă (XXH)',
          XXJ: 'Pungă, hârtie, multi (XXJ)',
          XXK: 'Pungă, hârtie, multi (XXK)',
          XYA: 'Ambalaj compozit, recipient din plastic în tambur de oțel (XYA)',
          XYB: 'Ambalaj compozit, recipient din plastic în cutie de oțel (XYB)',
          XYC: 'Ambalaj compozit, recipient din plastic în tambur de aluminiu (XYC)',
          XYD: 'Ambalaj compozit, recipient din plastic în ladă de aluminiu (XYD)',
          XYF: 'Ambalaj compozit, recipient din plastic în cutie de lemn (XYF)',
          XYG: 'Ambalaj compozit, recipient din plastic în tambur din placaj (XYG)',
          XYH: 'Ambalaj compozit, recipient din plastic în cutie din placaj (XYH)',
          XYJ: 'Ambalaj compozit, recipient din plastic în tambur din fibre (XYJ)',
          XYK: 'Ambalaj compozit, recipient din plastic în cutie pentru panouri fibrolemn (XYK)',
          XYL: 'Ambalaj compozit, recipient din plastic în tambur de plastic (XYL)',
          XYM: 'Ambalaj compozit, recipient din plastic în cutie din plastic solid (XYM)',
          XYN: 'Ambalaj compozit, recipient din sticlă în tambur de oțel (XYN)',
          XYP: 'Ambalaj compozit, recipient din sticlă în cutie de otel (XYP)',
          XYQ: 'Ambalaj compozit, recipient din sticlă în tambur de aluminiu (XYQ)',
          XYR: 'Ambalaj compozit, recipient din sticlă în ladă de aluminiu (XYR)',
          XYS: 'Ambalaj compozit, recipient din sticlă în cutie de lemn (XYS)',
          XYT: 'Ambalaj compozit, recipient din sticlă în tambur din placaj (XYT)',
          XYV: 'Ambalaj compozit, recipient din sticlă în coș de răchită (XYV)',
          XYW: 'Ambalaj compozit, recipient din sticlă în tambur din fibră (XYW)',
          XYX: 'Ambalaj compozit, recipient din sticlă în cutie pentru panouri fibrolemn (XYX)',
          XYY: 'Ambalaj compozit, recipient din sticlă în ambalaj din plastic expandabil (XYY)',
          XYZ: 'Ambalaj compozit, recipient din sticlă în ambalaj din plastic solid (XYZ)',
          XZA: 'Recipient vrac, hârtie, multi (XZA)',
          XZB: 'Sac mare (XZB)',
          XZC: 'Recipient vrac, hârtie, multi (XZC)',
          XZD: 'Recipient vrac, plastic rigid, cu echipamente structurale, solide (XZD)',
          XZF: 'Recipient vrac, plastic rigid, de sine statator, solide (XZF)',
          XZG: 'Recipient vrac, plastic rigid, cu echipament structural, presurizat (XZG)',
          XZH: 'Recipient vrac, plastic rigid, de sine statator, presurizat (XZH)',
          XZJ: 'Recipient vrac, plastic rigid, cu echipamente structurale, lichide (XZJ)',
          XZK: 'Recipient vrac, plastic rigid, de sine statator, lichide (XZK)',
          XZL: 'Recipient vrac, compozit, plastic rigid, solide (XZL)',
          XZM: 'Recipient vrac, compozit, plastic flexibil, solide (XZM)',
          XZN: 'Recipient vrac, compozit, plastic rigid, presurizat (XZN)',
          XZP: 'Recipient vrac, compozit, plastic flexibil, presurizat (XZP)',
          XZQ: 'Recipient vrac, compozit, plastic rigid, lichide (XZQ)',
          XZR: 'Recipient vrac, compozit, plastic flexibil, lichide (XZR)',
          XZS: 'Recipient vrac, compozit (XZS)',
          XZT: 'Recipient vrac, panouri fibrolemnoase (XZT)',
          XZU: 'Recipient vrac, flexibil (XZU)',
          XZV: 'Recipient vrac, din metal, altele decât oțelul (XZV)',
          XZW: 'Recipient vrac, lemn natural (XZW)',
          XZX: 'Recipient vrac, placaj (XZX)',
          XZY: 'Recipient vrac, lemn reconstituit (XZY)',
          XZZ: 'Unitate definită de comun acord (XZZ)',
          DBM: 'Decibel (DBM)',
          DBW: 'Decibel Watt (DBW)',
          FNU: 'Unitate nefelometrică de formazină (FNU)',
          HAD: 'Bucată zi (HAD)',
          HMO: 'Bucată lună (HMO)',
          HWE: 'Bucată săptămână (HWE)',
          KWY: 'kilowați an (KWY)',
          MKD: 'Zi metru pătrat (MKD)',
          MKM: 'Lună metru pătrat (MKM)',
          MKW: 'Săptămâna metru pătrat (MKW)',
          MNJ: 'Mega Joule pe metru cub normalizat (MNJ)',
          MQD: 'Zi metru cub (MQD)',
          MQM: 'Luna metru cub (MQM)',
          MQW: 'Săptămâna metru cub (MQW)',
          MRD: 'Zi metru (MRD)',
          MRM: 'Lună metru (MRM)',
          MRW: 'Săptămână metru (MRW)',
          MTZ: 'milihertz (MTZ)',
          NTU: 'Unitatea de turbiditate nefelometrică (NTU)',
          Z9: 'nanomol (Z9)',
          XO1: 'Cușcă pe două fețe pe roți cu curea de fixare (XO1)',
          XO2: 'Cărucior (XO2)',
          XO3: 'Palet unic ISO 0 (XO3)',
          XO4: 'Palet unic ISO 1 (XO4)',
          XO5: 'Palet unic ISO 2 (XO5)',
          XO6: 'Palet cu dimensiuni exceptionale (XO6)',
          XO7: 'Palet din lemn 40 cm x 80 cm (XO7)',
          XO8: 'Palet plastic SRS 60 cm x 80 cm (XO8)',
          XO9: 'Palet plastic SRS 80 cm x 120 cm (XO9)',
          XOG: 'Palet ISO 0 (XOG)',
          XOH: 'Palet ISO 1 (XOH)',
          XOI: 'Palet ISO 2 – 2/1 EURO Palet (XOI)',
          XOJ: 'Palet 1/4 EURO (XOJ)',
          XOL: 'Palet 1/8 EURO (XOL)',
          XOM: 'Palet sintetic ISO 1 (XOM)',
          XON: 'Palet sintetic ISO 2 (XON)',
          XOP: 'Palet angro (XOP)',
          XOQ: 'Palet 80 X 100 cm (XOQ)',
          XOR: 'XOR (XOR)',
          XOS: 'Palet unic (XOS)',
          XOV: 'Palet returnabil (XOV)',
          XOW: 'Geanta mare, dimensiunea paletului (XOW)',
          XOX: 'Un palet pe roți cu margine ridicată (81 x 67 x 135) (XOX)',
          XOY: 'Palet pe roți cu margine ridicată (81 x 72 x 135) (XOY)',
          XOZ: 'Palet cu roți cu jantă ridicată ( 81 x 60 x 16) (XOZ)',
          XP1: 'Palet CHEP 60 cm x 80 cm (XP1)',
          XP3: 'Palet LPR 60 cm x 80 cm (XP3)',
          XP4: 'Palet LPR 80 cm x 120 cm (XP4)',
          XSX: 'Set (XSX)',
          XME: 'metal container (XME)',
          XPB: 'pallet, box combined with open box and pallet (XPB)',
          XTY: 'cistern, cylindrical (XTY)',
          XCY: 'cylinder (XCY)',
          C62: 'unit (C62)',
          EA: 'units (EA)',
          CMT: 'centimetre (CMT)',
          H87: 'pieces (H87)',
          INH: 'inch (INH)',
          KGM: 'kilogram (KGM)',
          KMT: 'kilometre (KMT)',
          LTR: 'litre (LTR)',
          MTK: 'square metre (MTK)',
          MTQ: 'cubic metre (MTQ)',
          MTR: 'metre (MTR)',
          TNE: 'tonne (metric ton TNE)',
          GRM: 'gram (GRM)',
          LM: 'linear metre (LM)',
          DZN: 'dozen (DZN)',
          SET: 'set (SET)',
          FOT: 'foot (FOT)',
          J57: 'barrel (UK petroleum) (J57)',
          PF: 'pallet (lift) (PF)',
          NAR: 'number of articles (NAR)',
          XPP: 'piece (XPP)',
        },
        errors: {
          requiredUnitMeasurement: "The field 'Unit of measurement' is required",
          requiredOperationPurpose: "The field 'Operation purpose' is required",
          requiredGrossWeight: "The field 'Gross weight' is required",
          requiredCargoName: "The field 'Product name' is required",
          requiredQuantity: "The field 'Quantity' is required",
          maxLength8: 'The field cannot exceed 8 characters',
          maxLength200: 'The field cannot exceed 200 characters',
          requiredNetWeight: "The 'Net Weight' field is required",
          requiredUnitPrice: "The 'Unit Price' field is required",
          requiredCombinedNomenclature: "The 'Tariff Code' field is required",
          maxlengthCombinedNomenclature: "The 'Tariff Code' field cannot exceed 8 characters",
        },
        secondaryCurrencyCode: 'Secondary currency',
        combinedNomenclature: 'Tariff Code (HS code)',
        cargoName: 'Product name',
        quantity: 'Quantity',
      },
      operationType: 'Operation type',
      operationTypes: {
        10: 'Intra-Community Acquisition (10)',
        12: 'Contract Work Operations (EU) - Entry (12)',
        14: "Client's Call-off Stock - Entry (14)",
        20: 'Intra-Community Delivery (20)',
        22: 'Contract Work Operations (EU) - Exit (22)',
        24: "Client's Call-off Stock - Exit (24)",
        30: 'Transport within National Territory (30)',
        40: 'Import (40)',
        50: 'Export (50)',
        60: 'Intra-Community Transaction - Entry for Storage/Preparation for New Transport (60)',
        70: 'Intra-Community Transaction - Exit after Storage/Preparation for New Transport (70)',
      },
      declaringCompanyReference: 'Declarant reference',
      selectContactWarning: 'Select minimum one contact',
      notificationContacts: 'My contacts for notification',
      confirmation: {
        confirmationType: 'Confirmation type',
        observations: 'Observations',
        confirmationTypes: {
          10: 'Confirmed (10)',
          20: 'Partially confirmed (20)',
          30: 'Infirmed (30)',
        },
        errors: {
          requiredConfirmationTypeUuid: "The field 'Confirmation type' is required",
        },
      },
      location: {
        stateType: {
          ptf: 'Border crossing point',
          customsOffice: 'Customs office',
          address: 'Address',
        },
        startTitle: 'Start location',
        ptf: 'Border crossing point',
        errors: {
          requiredPtf: "The field 'Border crossing point' is required",
          requiredCustomsOffice: "The field 'Customs office' is required",
          requiredAddress: "The field 'Address' is required",
        },
        endTitle: 'End location',
        customsOffice: 'Customs office',
        noLocation: 'No location selected',
      },
      errors: {
        requiredOperationType: "The field 'Operation type' is required",
        maxLength50: 'This field must not be longer than 50 characters',
        requiredShipment: "The field 'Shipment' is required",
      },
      commercialPartner: {
        title: 'Commercial partner',
        name: 'Name',
        errors: {
          requiredName: "The field 'Name' is required",
          requiredCountry: "The field 'Country' is required",
          maxLength30: 'This field must not be longer than 30 characters',
          maxLength300: 'This field must not be longer than 300 characters',
          patternCode: 'This field must contain at least 2 digits and should not have any spaces',
        },
        country: 'Country',
        code: 'Code',
        asIndividual: 'Physical person',
        contacts: "Commercial partner's contacts",
      },
      legalEntityInfoMessage: 'Choose from existing companies, from ANAF or manually fill the fields',
      legalEntityErrorMessage: 'Country, CIF and name are required',
    },
    vehicleHistory: {
      licensePlates: 'License plates',
      modificationDate: 'Modification date',
      observation: 'Observations',
      declaringCompanyCode: 'CUI',
      declaringCompanyReference: 'Declarant ref.',
      activeVehicle: 'Active vehicle',
      title: 'Vehicle modification history',
    },
    checkStatuses: {
      UNCHECKED: 'Unchecked',
      COMMUNICATION_ERROR: 'Communication error, try again later',
      AUTHORIZATION_ERROR: 'Authorization error',
      PENDING: 'Pending',
      OK: 'Notification valid',
      NOT_OK: 'Notification invalid',
      ERROR: 'Error',
    },
    authorization: {
      validTo: 'Valid to',
      token: 'Token',
      title: 'ANAF authorizations (eFactura + eTransport)',
      processAuthorization: 'Processing authorization',
      authorizedBy: 'Authorized by',
      authorizedAt: 'Authorized at',
      addAuthorizationTooltip: 'Add new ANAF authorization',
      addAuthorization: 'New authorization',
      authorizationSuccess: 'Authorization successful',
      authorizationError: 'Authorization error',
    },
    list: {
      title: 'eTransport notifications',
      createdBy: 'Added by',
      externalReference: 'Declarant ref.',
      uit: 'UIT code',
      uploadIndex: 'Index',
      shipmentDate: 'Shipment date',
      validUntil: 'Valid until',
      operationType: 'Operation type',
      commercialPartner: 'Commercial partner',
      shipmentOrganizerName: 'Shipment organizer',
      address: 'Address',
      licensePlate: 'License plate',
      startLocation: 'Start location',
      endLocation: 'End location',
      orderNumber: 'Order number',
      order: 'Order',
      status: 'Status',
      confirmationType: 'Confirmation type',
      latestActionType: 'Latest action type',
      collaborationStatus: 'Collaboration',
      uploadStatus: 'Upload status',
      checkStatus: 'Check status',
      actionStatus: 'Last action',
      anafMessage: 'Anaf message',
      resetFilters: 'Reset filters',
      uitUnchecked: 'UIT code unchecked',
      uitValid: 'UIT code valid',
      uitInvalid: 'UIT code invalid',
      import: 'Import',
      personalizedImport: 'Custom import',
      downloadTemplate: 'Download template',
      modifiedVehicleTooltip: 'Vehicle was modified at: ',
      totalNetWeight: 'Total net weight (kg)',
      totalGrossWeight: 'Total gross weight (kg)',
      totalValue: 'Total value in lei',
      bulkSendSuccessfulMessage: 'eTransporturile au fost trimise cu succes!',
      bulkCheckSuccessfulMessage: 'eTransporturile au fost verificate cu succes!',
      verifyData: 'Verify data...',
      selectedETransports: 'Selected eTransports',
      selectMessage: 'Select unsent or unchecked eTransports',
      sendETransports: 'Send eTransports',
      checkETransports: 'Check eTransports',
      predefinedNotices: {
        UNSEND: 'Unsend notices',
        UNVERIFIED: 'Unverified notices',
      },
      actionCheckStatuses: {
        UNCHECKED: 'Unchecked action',
        PENDING: 'Pending check',
        COMMUNICATION_ERROR: 'Communication error, try again later',
        ERROR: 'Error',
        NOT_OK: 'Invalid action',
        OK: 'Valid action',
      },
      checkStatuses: {
        UNCHECKED: 'Unchecked',
        PENDING: 'Pending check',
        COMMUNICATION_ERROR: 'Communication error',
        AUTHORIZATION_ERROR: 'Authorization error',
        ERROR: 'Error',
        NOT_OK: 'Invalid',
        OK: 'Valid',
      },
      uploadStatuses: {
        UNSENT: 'Unsent',
        CONVERSION_ERROR: 'Conversion error',
        COMMUNICATION_ERROR: 'Communication error',
        ERROR: 'Upload error',
        UPLOAD_SUCCESS: 'Upload success',
        AUTHORIZATION_ERROR: 'Authorization error',
        CANCEL_SUCCESS: 'Canceled',
        null: '',
      },
      actionTypes: {
        CANCEL: 'Cancel',
        MODIF_VEHICLE: 'Vehicle modification',
        CONFIRMATION: 'Confirmation',
      },
      checkActionStatus: 'Check action status',
      uploadAction: 'Upload action',
      collaborationSent: 'Collaboration invitation was sent',
      collaborationPartiallyCompleted: 'The data was partially completed by the collaborators',
      collaborationCompleted: 'The data was completed by the collaborators',
    },
    confirmETransportTitle: 'eTransport confirmation',
    commercialDataTitle: 'Commercial data',
    shipmentDataTitle: 'Shipment data',
    dataUpdateSuccess: 'Data updated successfully!',
    contactSuggestion: 'In order to update the contacts you need to edit the eTransport',
    shipmentOrganizer: {
      list: {
        title: 'eTransport Organizer',
        uit: 'UIT',
        declaringCompanyCode: 'Declarant code',
        declaringCompanyName: 'Declarant name',
        declaringCompanyReference: 'Declarant ref.',
        shipmentDate: 'Shipment date',
        validUntil: 'UIT expiration date',
        shipmentOrganizerCode: 'Transporter code',
        shipmentOrganizerName: 'Transporter name',
        licensePlates: 'License plates',
        startLocation: 'Start location',
        endLocation: 'End location',
        documents: 'Documents',
      },
      anafCommunicationError: 'Communication error with ANAF. Try again later',
    },
    errors: {
      ETransportNotificationNotUploadReadyException: 'The eTransport is not fully completed in order to be uploaded!',
    },
  },
  error: {
    '403': 'You are not authorized to access the page.',
    'warehouse-times-minimum-one-interval-error': 'The end time is the same as the start time.',
    'warehouse-end-time-before-start-time-error': 'The end time should be after the start time.',
    UserNotFoundException: 'User not found',
    userexists: 'Login name already used!',
    PackageContractTariffNotUnique:
      'There is already a contract with this provider for the selected package and territories in the chosen time frame',
    OrderAuditPdfGenerationException: 'The PDF cannot be generated because there are no saved transactions.',
    TaskDeletedException: 'The task is deleted!',
    TaskCheckpointDeletedException: 'The task checkpoint is deleted!',
    TaskCheckpointUpdateStatusException: 'The task checkpoint status is invalid!',
    EmployeeAlreadyIsDriver: 'The selected employee is already a driver',
    userAlreadyHasOwner:
      'You have already been assigned to another company. Select the company from the existing ones in the platform',
    UserAlreadyAssignedException: 'You have already been assigned to another company.',
    InvalidGeneratedAndSignedPdfException:
      'The PDF cannot be generated and signed at the moment. Please try again later!',
    url: {
      not: {
        found: 'Not found',
      },
    },
    unauthorized: 'Unauthorized action ',
    title: 'Error page!',
    'terminal-reservation-end-time-same-with-start-time-error':
      'The end time is equal to the start time, a reservation should have minimum one interval.',
    'terminal-reservation-end-time-before-start-time-error': 'The end time cannot be before the start time.',
    'invalid-status-for-offer-request': 'The offer request is not available anymore.',
    validExternalReferenceAlreadyExistForTheReferenceType: 'There is already a valid external reference of this type',
    'error-cannot-add-ownership-request-phone-null': 'You cannot claim a location without having a valid phone number.',
    'error-cannot-add-ownership-request-phone-not-validated':
      'You cannot claim without entering and validating your phone number.',
    Size: 'Field {{ field }} does not meet min/max size requirements!',
    NotNull: 'Field {{ field }} cannot be empty!',
    server: {
      not: {
        reachable: 'Server not reachable',
      },
    },
    requiredGlobalAccountTypeValue: 'The Global Account Type field is required',
    requiredGlobalAccountCode: 'The Global Account Code field is required',
    'overlapping-terminal-reservation-error': 'Reservations are overlapping, choose free time slots.',
    'invoice-external-error-single-company-contacts-selected': 'Choose contacts from both companies ',
    internalServerError: 'Internal server error',
    idexists: 'A new {{ entityName }} cannot already have an ID',
    'external-invoice-orders-different-payment-time-limit-error': 'Choose orders with the same payment term',
    'external-invoice-orders-invoiced-by-other-invoices-error': 'At least one order already belongs to another invoice',
    'external-invoice-orders-invoiced-error': 'At least one order is already invoiced',
    error: {
      validation: 'Validation error',
      '429': 'Too many requests',
    },
    EmailImportSettingsWrongFormatException: 'Invalid email import!',
    emailexists: 'Email is already in use!',
    'email-already-sent-in-the-last-five-minutes-error': 'You have already sent a message in the last 5 minutes!',
    EFacturaAuthorizationException: 'No valid ANAF authorization!',
    defaultError: 'An error has occured',
    currentUserNotFound: 'The current user was not found. Please try again.',
    companyAlreadyHasSuperUser: 'The company already has another user assigned. Contact an administrator.',
    'bad-credentials': 'Wrong username or password',
    AssignedUserAlreadyExistsException: 'The company already has another user assigned.',
    activityMustHaveAtLeastOneContact: 'The activity must have at least one contact!',
    AbstractNotifiableEntityEmptyContactListException: 'No contact selected!',
    ShipmentGroupDefaultSolutionException: 'The necessary information is too old. Please reload the page!',
    'external-invoice-orders-invalid-currency-codes-error':
      'You can select orders in at most one other currency besides the one of the invoice',
    'no-rights-selected': 'You cannot save a role with no rights',
    InvalidCompanyAddressException: 'The company address is invalid, verify the fields and try again.',
    invalidPasswordFormat:
      'Password must contain at least one lowercase, at least one uppercase, at least one numeric, at least one special character, it must have minimum 9 characters and maximum 32 characters!',
    '429': 'Rate limit exceeded for this request! Try later.',
    ActiveTariffOnOperationalTerritoryInvalidateException: 'An active tariff on this territory exists',
    MaxAttemptsExceededException: 'Ati depasit numarul maxim admis de solicitari!',
    AttemptsExceededExceptionPT1M: 'Too many requests! Try again in 1 minute',
    AttemptsExceededExceptionPT1H: 'Too many requests! Try again in 1 hour',
    AttemptsExceededExceptionPT24H: 'Too many requests! Try again in 1 day',
    AttemptsExceededExceptionPT240H: 'Too many requests! Try again in 10 days',
    AttemptsLeft4: 'You have 4 more attempts!',
    AttemptsLeft3: 'You have 3 more attempts!',
    AttemptsLeft2: 'You have 2 more attempts!',
    AttemptsLeft1: 'You have 1 more attempt!',
    'blocked-user': 'User is temporarily blocked due to too many failed login attempts.',
    'remaining-time-until-unblocked-beggining-message': 'Remaining time until unblocking: ',
    'remaining-days-until-unblocked': ' days, ',
    'remaining-hours-until-unblocked': ' hours, ',
    'remaining-minutes-until-unblocked': ' minutes, ',
    'remaining-seconds-until-unblocked': ' seconds.',
    usernameAlreadyExists: 'Username already exists',
    missingPhoneNumber: 'The phone number is mandatory',
    invalidPhoneNumber: 'Invalid phone number',
    invalidEmail: 'Invalid e-mail',
    externalVendorRequestCredentialDTOMap: 'Credentials have not been introduced for each request',
    'order-shipper-party': "Shipper's account number is missing.",
    'order-payment-party': 'Payment details are missing.',
    'order-with-already-allocated-shipment-drafts': 'The shipments for this order are already allocated.',
    'task-with-already-allocated-shipment-drafts': 'The shipments for this task are already allocated.',
    'original-sp-pre-order-not-updatable': 'The subcontracted order is no longer in the pre-order phase.',
    'shipment-group-solution-not-locked-in': 'The shipment group solution is not locked in.',
    'terminal-reservation-vendor-and-external-service-provider-error':
      'The reservation must be made either with a single vendor or with a single courier.',
    ShipmentCanNotBeCancelledException: 'The shipment can not be cancelled!',
    PickupAndShipmentCanNotBeCancelledException: 'The pickup request and shipment can not be cancelled!',
    OrderTariffCancelledException: 'The order cannot be created/accepted because the tariff has been cancelled!',
    InvalidOrderForAuditException: "The order audit couldn't be generated because the order is in an invalid state!",
    'invalid-shipment-status-change-invoice-generated':
      'The shipment status cannot be changed because the invoice has been already been generated!',
    'invalid-shipment-status-change': 'The shipment status transition is invalid!',
    'duplicate-routed-order-template-label': 'A route template with this name already exists!',
  },
  emptyListPlaceholder: {
    description: 'No matching items found',
    changeFilters: 'Check the filter settings!!',
  },
  efactura: {
    seeInvoiceDetails: 'See invoice details',
    officeAddressStateCountryMessage:
      'For the registered office address of companies in Romania, <strong>the county and country must be completed.</strong>',
    officeAddressBucharestMessage:
      'For companies from <strong>București</strong> in the state, enter București, and the sector will be written in the field City in the <strong>format SECTOR1-6</strong> (ex: SECTOR3)',
    messages: {
      type: 'Invoice status',
      title: 'Title',
      serial: 'Serial',
      searchDaysMessage: 'Select the number of days for displaying messages (max. 60 days in the past)',
      pageTitle: 'ANAF Messages',
      idRequest: 'Request ID',
      id: 'Message ID',
      emptyMessage: 'No results found.',
      details: 'Details',
      cui: 'CUI',
      createdAt: 'Created at',
      cif: 'CIF',
    },

    assignedToInvoice: 'Assigned to an invoice',
    assignedToCost: 'Assigned to a cost',
    assignInvoiceNotAvailable: 'Invoice already assigned',
    invoiceSent: 'Invoice already sent',
    assignToCost: 'Assign to a cost',
    assignToOrder: 'Assign to an order',
    title: 'eFacturi',
    supplierName: 'Supplier Name',
    partnerName: 'Partner Name',
    partnerCif: 'Partner CIF',
    supplierCif: 'Supplier CIF',
    uploadedAt: 'Uploaded At',
    uploadId: 'Upload ID',
    downloadId: 'Download ID',
    invoiceSeriesNumber: 'Invoice Series Number',
    invoiceDate: 'Invoice Date',
    maturityDate: 'Maturity Date',
    amount: 'Amount',
    amountInclTax: 'Amount Including Tax',
    currency: 'Currency',
    details: 'Details',
    type: 'Type',
    errorMessage: 'efactura.errorMessage',
    zipFileUuid: 'efactura.zipFileUuid',
    pdfFileUuid: 'efactura.pdfFileUuid',
    invoiceNotSystemGenerated: 'Invoice was not generated by the system!',
    downloadZip: 'Download ZIP',
    downloadPdf: 'Download PDF',
    import: {
      selectAnafInvoice: 'Select eFactura',
      dialogTitle: 'Import eFactura data',
      importButton: 'Import data',
      selectAnafInvoiceSeries: 'Select invoice series',
      externalInvoice: {
        selectCustomer: 'Customer must be selected',
        selectSp: 'Service Provider must be selected',
      },
    },
  },
  dispatcher: {
    tasks: {
      taskStatusChange: {
        title: 'Change status',
        submit: 'Save',
        rejectReason: 'Reject reason',
        reject: 'Reject',
        pickup: 'Pickup',
        delivery: 'Delivery',
        return: 'Return',
        handshakePersonName: 'Warehouse contact name ',
        error: {
          requiredRejectReason: 'This field is required',
          requiredHandshakePersonName: 'This field is required',
          requiredAchievedAt: 'This field is required',
        },
        description: 'Description',
        comment: 'Comment',
        chooseAction: 'Choose status',
        achievedAt: 'At',
      },
      summary: {
        vehicles: 'Assigned / Available vehicles',
        tasks: 'Assigned / Available tasks',
        drivers: 'Assigned / Available drivers',
        cardTitle: 'Overview',
        'available-tasks': 'Available vehicles',
        addNewRoute: 'Add new route',
      },
      listTitle: 'Tasks',
      updatedAt: 'Last update',
      updatedByDriver: 'Updated by driver',
      updatedByDispatcher: 'Updated by dispatcher',
      showTasks: 'Tasks',
      showMap: 'Map',
      showAvailableResources: 'Available Resources',
      online: 'online',
      offline: 'offline',
      noDataFoundDescription: 'No unassigned tasks',
      lastSeen: 'Last seen',
      estimatedDirection: 'Estimated date from google maps',
      edit: 'Edit',
      cancel: 'Cancel',
      details: 'Task details',
      viewDetails: 'View details',
      delete: 'Delete',
      completedDirection: 'Date concrete bazate pe interactiunea cu aplicatia',
      changeStatus: 'Change status',
      availableTasks: 'Available tasks',
      assignToDriver: 'Assign to other vehicle',
      changeVehicle: 'Change vehicle',
      unavailableDelivery: 'Unavailable delivery',
      changeMainDriver: 'Change main driver',
      changeSecondDriver: 'Change second driver',
      warehouseEmployee: 'Warehouse contact person',
      warehouseEmployeeManuallyAddedTooltip: 'Warehouse contact person was added manually',
      warehouseEmployeeScannedTooltip: 'Warehouse contact person was scanned through the mobile app',
      driverEmployee: 'Driver contact person',
      driverEmployeeManuallyAddedTooltip: 'Driver contact person was added manually',
      driverEmployeeScannedTooltip: 'Driver contact person was scanned through the mobile app',
      latestStatusAchieved: 'Latest status achieved at',
      comments: 'Comments',
      checkpoints: {
        status: {
          not_started: 'Not started',
          completed: 'Completed',
          completed_delayed: 'Completed with delay',
          unavailable: 'Unavailable',
          refused: 'Refused',
          cancelled: 'Cancelled',
          closed: 'Closed',
        },
      },
      takenPackages: 'Taken packages',
      takenPackagesSummary: (params) => {
        const { actualPackagesLength, totalPackagesLength } = params;
        return `${actualPackagesLength} out of a total of ${totalPackagesLength} packages were taken up`;
      },
      proofOfHandover: {
        signature: 'Signature',
        signatures: 'Signatures',
        achievedAt: 'Achieved at',
        responsibleName: 'Responsible',
        executedBy: 'Executed by',
        comment: 'Comment',
        unavailableMessage: 'Delivery was unavailable, package is being returned',
        executedByType: {
          DRIVER: 'Executed from the mobile application by the driver',
          WAREHOUSE: 'Executed from the mobile application by warehouse staff',
          PREORDER_LINK: 'Executed via preorder link',
          OFFICE: 'Executed from the web application',
        },
        responsibleType: {
          CARRIER: 'Driver',
          SENDER: 'Sender',
          CONSIGNEE: 'Consignee',
        },
      },
    },
  },
  'delivery-outbox': {
    vendorName: 'Vendor',
    utils: {
      shipments: 'Shipments',
      open: 'Open',
      'empty-message': 'Add offer request',
      'empty-list': 'The list is empty ',
    },
    type: 'Type ',
    totalWeight: 'Total weight',
    title: 'Outbox',
    'timeline-phase': {
      transport: 'Shipment',
      order: 'Order',
      offer_request: 'Offer request',
      invoice: 'Invoice',
    },
    sort: 'Sort',
    shipmentFlowType: 'Flow type',
    receivedOffers: 'Received Offers',
    pickupCompany: 'Pickup company',
    pickupCity: 'Pick up city',
    pickupLocation: 'Pickup location',
    deliveryLocation: 'Delivery location',
    orderStatus: 'Order status',
    offerRequestStatusEnum: {
      sent: 'Sent',
      rejected: 'Rejected',
      received: 'Received',
      offers_received: 'Available offers',
      offer_accepted: 'Accepted',
      in_progress: 'In progress',
      completed: 'Completed',
      cancelled: 'Cancelled',
      archived: 'Archived',
    },
    offerRequestStatus: 'Offer requests status',
    more: {
      resendInvoiceUploadInvitationEmail: 'Resend invoice upload email',
      orderCancelRequestDisabledTooltip: 'There is a cancellation request or the order is not in an appropriate status',
      orderCancelRequest: 'Cancel order',
      orderCancelForced: 'Forced cancel order',
    },
    invoiceStatusEnum: {
      UNPAID: 'Unpaid',
      STORNO: 'Storno',
      PARTIAL_PAID: 'Partially paid',
      PAID: 'Paid',
      NOT_INVOICED: 'Not invoiced',
      CANCELLED: 'Cancelled',
    },
    invoiceStatus: 'Invoice status',
    filter: 'Filter',
    pickupStart: 'Pickup date',
    deliveryEnd: 'Delivery date',
    employeeName: 'Employee name',
    documentNumber: 'Document number',
    shipmentSeries: 'Shipment series',
    deliveryCompany: 'Delivery company',
    deliveryCity: 'Delivery city',
    deadline: 'Deadline',
    createdAt: 'Created at',
    costCenters: 'Cost centers',
    assignedToUser: 'Assigned to me',
    addOfferRequest: '+ Add offer request',
    addInternalOrder: '+ Add internal order',
    addContractOrder: '+ Add order',
    addSupplierOrder: '+ Add supplier order',
    addPreOrder: '+ Add pre-order',
    requestedBy: 'Requested by',
    moreShipments: 'more...',
    lessShipments: 'see less',
    units: {
      kg: 'kg',
      pcs: 'pcs',
    },
  },
  'delivery-shared': {
    shipmentList: {
      pcs: 'pcs',
      moreShipments: 'more...',
      lessShipments: 'see less',
    },
  },
  'delivery-inbox': {
    urgent: 'Urgent',
    type: 'Type',
    'try-again': 'Try again',
    title: 'Inbox',
    'timeline-phase': {
      transport: 'Transport',
      order: 'Order',
      offer_request: 'Offer request',
      invoice: 'Invoice',
      finished: 'Finalized',
    },
    'sort-labels': {
      deadline: 'Deadline',
      createdAt: 'Received at',
    },
    sort: 'Sort',
    solve: 'Solve',
    viewInvoice: 'Invoice',
    shipments: 'Shipments',
    pickupCity: 'Pick up city',
    phases: {
      transport: 'Shipment',
      order: 'Order',
      'offer-request': 'Offer request',
      invoice: 'Completed',
    },
    orderStatus: 'Order status',
    offerRequestStatusEnum: {
      sent: 'Sent',
      rejected: 'Rejected',
      received: 'Received',
      offers_received: 'Available offers',
      offer_accepted: 'Accepted',
      in_progress: 'In progress',
      completed: 'Completed',
      cancelled: 'Cancelled',
      archived: 'Archived',
    },
    offerRequestStatus: 'Offer request status',
    'no-results-found': 'No results found for your search.',
    more: {
      refuseOfferRequest: 'Reject offer request',
      orderCancelRequestDisabledTooltip: 'There is a cancellation request or the order is not in an appropriate status',
      orderCancelRequest: 'Cancel order',
      orderCancelForced: 'Forced cancel order',
    },
    filter: 'Filter',
    expiringOffersMessage: 'There are expiring offers !',
    employeeName: 'Employee name',
    documentNumber: 'Document number',
    shipmentSeries: 'Shipment series',
    deliveryCity: 'Delivery city',
    pickupStart: 'Pickup date',
    deliveryEnd: 'Delivery date',
    customerName: 'Customer name',
    'choose-account': 'Select account',
    assignedToUser: 'Assigned to me',
    addOfferRequest: '+ Add offer request',
    accountName: 'Account',
    bulkActions: {
      title: 'Bulk actions',
      submit: 'Submit',
      selectedItems: 'selected items',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      toggleSelection: {
        order: {
          accept: 'Accept',
          reject: 'Reject',
          archive: 'Archive',
          selectEmployee: 'Select employee',
        },
      },
      clearSelection: 'Clear selection',
    },
  },
  'delivery-app': {
    vendorTag: {
      wizardTabTitle: 'Vendor partner',
      wizardTabHeader: 'Vendor partner tags',
      vendorSort: 'Sort partner vendors by tags',
      vendorFilter: 'Or select tags',
      value: 'Tag name',
      search: 'Search tags',
      newTitle: 'Add tag',
      error: {
        requiredValue: " The  'Label Name' field is required",
      },
    },
    vendor: {
      wizardTabTitle: 'Company',
      wizardTabHeader: 'Company details',
      viewCompany: 'View Company',
      uniqueIdNumber: 'Unique identification number',
      unblockCompany: 'Unblock Company',
      to: 'To',
      title: 'Vendor partners',
      tags: 'Tags',
      singular: 'Vendor partner',
      searchOne: 'Search vendor partner',
      searchMultiple: 'Search vendor partners',
      refresh: "This vendor's data has not yet been processed. Click here to retry. ",
      plural: 'Vendor partners',
      platformMemberLegend:
        'The vendor is not registered on the platform. He will receive an email with the created offer request.',
      paymentTimeLimit: 'Payment due date',
      name: 'Name',
      mainPhoneNumber: 'Phone number',
      mainEmailAddress: 'E-mail',
      industryType: 'Industry type',
      country: 'Country',
      contactsWarning: 'This vendor has no contacts. Add using the next button.',
      blockCompany: 'Block Company',
      blockCommentPlaceholder: 'Reason',
      blockForm: {
        error: {
          requiredComment: 'Reason is required',
        },
      },
      'amendment-title': 'Introduce amendment',
      amendment: 'Amendment',
      addNew: 'Add vendor partner',
      courier: 'Courier',
    },
    'shipment-tracking': {
      title: 'Shipment tracking',
      filter: 'Filter',
      costCenter: 'Cost center',
      deliveryDate: 'Delivery date',
      pickupDate: 'Pickup date',
      deliveryCity: 'Delivery city',
      pickupCity: 'Pickup city',
      deliveryCompany: 'Delivery company',
      pickupCompany: 'Pickup company',
      documentNumber: 'Order number',
      shipmentSeries: 'Shipment series',
      setAsFavorite: 'Set as favorite',
      removeFavorite: 'Remove favorite',
      externalReference: 'External ref.',
      timelineView: 'Timeline',
      listView: 'List',
      packageId: 'Package ID',
      status: 'Status',
      noPackages: 'No packages found for this shipment',
    },
    vehicle: {
      width: 'Width (m)',
      weight: 'Vehicle weight (kg)',
      volume: 'Volume (m3)',
      vehicleTypeValue: 'Vehicle type',
      user: 'User',
      type: 'Type',
      tonnage: 'Tonnage',
      title: 'Vehicle',
      tabs: {
        success: 'Success',
        saved: 'Saved vehicle',
        financial: 'Financial',
        fuelCards: 'Fuel cards',
        equipment: 'Equipment',
        documents: 'Documents',
        details: 'Details',
      },
      subtitle: 'Routes',
      requiredField: 'This field is required',
      registrationDate: 'Registration date',
      pricePerKm: 'Price per km (RON)',
      power: 'Power',
      owner: 'Owner',
      name: 'Name',
      model: 'Model',
      maximumAllowedMass: 'Maximum allowed mass (kg)',
      manufacturingYear: 'Manufacturing year',
      make: 'Brand',
      licensePlateLabel: 'License plate label',
      licensePlate: 'License plate',
      length: 'Lenght (m)',
      legalCharge: 'Legal charge',
      inventoryNumber: 'Inventory number',
      height: 'Height (m)',
      general: {
        wheelbase: 'Loading meters (mm)',
        volume: 'Volume (m3)',
        vin: 'VIN',
        vehicle: 'Vehicle',
        usableWeight: 'Usable weight (kg)',
        urbanConsumption: 'Urban fuel consumption (Liters/100km)',
        traction: 'Traction',
        technical: 'Technical informations',
        region: 'Region',
        photos: 'Vehicle Photos',
        nrSeats: 'Seats number',
        nrDoors: 'Doors number',
        model: 'Model',
        mixedConsumption: 'Mixed fuel consumption (Liters/100km)',
        loadingType: 'Loading type',
        loadingMeters: 'Loading meters (m)',
        lateralLoading: 'Lateral',
        lateralDoorWidth: 'Lateral door width (m)',
        lateralDoorHeight: 'Lateral door height (m)',
        gpsMonitorisation: 'GPS Monitorisation',
        GPSDisabled: 'Inactive',
        GPSActive: 'Active',
        general: 'General informations',
        gearBox: 'Gear box',
        fuelType: 'Fuel',
        fuelTankCapacity: 'Fuel tank capacity (Liters)',
        extraUrbanConsumption: 'Extra urban fuel consumption (Liters/100km)',
        engineType: 'Engine type',
        engineMaxPower: 'Engine maximum power (Kw/hp)',
        engineCMC: 'CMC',
        emissionsStandard: 'Emissions standard',
        doorHeight: 'Door height (m)',
        division: 'Division',
        dateOfFabrication: 'Date of fabrication',
        costCenter: 'Cost center',
        condition: 'Condition',
        company: 'Company',
        color: 'Color',
        co2Emissions: 'CO2 Emissions (g/km)',
        cargoWidth: 'Width (m)',
        cargoLength: 'Length (m)',
        cargoHeight: 'Height (m)',
        cargo: 'Cargo Compartment',
        brand: 'Brand',
        backLoading: 'Back',
        backDoorWidth: 'Back door width (m)',
        backDoorHeight: 'Back door height (m)',
      },
      fuel: 'Fuel',
      financial: {
        valVehicle: 'Vehicle value (EUR)',
        value: 'Costs',
        valResidual: 'Residual value (EUR)',
        valOperations: 'Operations value (EUR)',
        valAccesories: 'Accesories cost (EUR)',
        taxCategoryPlaceholder: 'Select a tax category',
        taxCategory: 'Tax category',
        startDate: 'Start date',
        returnDate: 'Return date',
        policyNr: 'Policy number',
        ownerPlaceholder: 'Select an Owner',
        owner: 'Owner',
        operatorPlaceholder: 'Select an operator',
        operator: 'Operator',
        nrKmCtr: 'Total contract kilometers',
        nrInventory: 'Inventory number',
        nrCtr: 'Contract number',
        monitoringStartDate: 'Monitoring start date',
        kmAtRendition: 'Kilometers at rendition',
        insuranceStartDate: 'Start date',
        insuranceEndDate: 'End date',
        insurance: 'Insurance',
        general: 'General Info',
        financingType: 'Financing type',
        financingPeriod: 'Financing period (months)',
        endDate: 'End date',
        deliveryDate: 'Delivery date',
        costKmNotDriven: 'Kilometers not driven cost (EUR)',
        costKm: 'Extra kilometers cost (EUR)',
        casco: 'CASCO',
        addOwner: 'Add owner',
        addOperator: 'Add operator',
        additionalInfo: 'Extra Informations',
      },
      fuelCards: {
        title: 'Fuel cards',
        series: 'Series',
        provider: 'Provider name',
        add: 'Add fuel card',
        edit: 'Edit fuel card',
        details: 'Fuel card details',
        delete: 'Delete fuel card',
        errors: {
          requiredSeries: "The 'Series' field is required",
          requiredProvider: "The 'Provider name' field is required",
        },
      },
      ewp: 'EWP',
      error: {
        requiredUninstallationDate: "The  'Installation date' field is required",
        requiredTransferDate: "The  'Date document received' field is required",
        requiredOperator: "The  'Operator' field is required",
        requiredNewDocumentHolder: "The  'New Owner' field is required!",
        requiredLicensePlate: "The  'License plate' field is required",
        requiredInstallationDate: "The  'Installation date' field is required",
        requiredField: 'Required field',
        requiredEquipmentVO: "The  'Equipment type' field is required",
        requiredEquipmentType: "The  'Equipment type' field is required",
        requiredDocumentVO: "The  'Document type' field is required",
        requiredDocumentType: "The  'Document type' field is required",
        requiredDocument: "The  'Document type' field is required",
        requiredCompanyOwner: "The  'Owner' field is required",
      },
      equipment: {
        validTo: 'Valid to',
        validPeriod: 'Validity period',
        validFrom: 'Valid from',
        uninstallEquipment: 'Uninstall equipment',
        uninstallationDate: 'Uninstallation date',
        installEquipment: 'Install equipment',
        installationDate: 'Installation date',
        equipmentTypePlaceholder: 'Select an equipment',
        equipmentType: 'Equipment type',
        equipments: 'Equipments',
        editEquipment: 'Edit equipment',
        addEquipmentType: 'Add equipment type',
        addEquipment: 'Add equipment',
      },
      engine: 'Engine',
      'edit-vehicle-title': 'Edit vehicle',
      documents: {
        validTo: 'Valid to',
        validFrom: 'Valid from',
        transferDoc: 'Transfer document',
        transferDate: 'Document transfer date',
        title: 'Documents',
        status: 'Status',
        photos: 'Document photos',
        obs: 'Observations',
        newDocumentHolder: 'New document holder',
        markInactive: 'Mark as inactive',
        markActive: 'Mark as active',
        issueDate: 'Issue date',
        inactive: 'Inactive',
        expirationDate: 'Expiration date',
        editDocument: 'Edit document',
        documentTypePlaceholder: 'Select a document type',
        documentType: 'Document type',
        documentHolder: 'Document holder',
        document: 'Document',
        details: 'Document details',
        currentDocumentHolder: 'Current document holder',
        addDocumentType: 'Add document type',
        addDocument: 'Add document',
        active: 'Active',
      },
      description: 'Description',
      configuration: 'Configuration',
      color: 'Color',
      chassisSeries: 'Chassis series',
      category: 'Category',
      addNew: 'Add vehicle',
      'add-vehicle-title': 'Add vechile',
    },
    utils: {
      loadMore: 'More',
      loadLess: 'Less',
      others: 'others',
      yes: 'Yes',
      width: 'Width',
      weight: 'Weight',
      volume: 'Volume',
      upload: 'Upload',
      update: 'Update',
      unselected: 'Unselected',
      type: 'type',
      termsAndConditions: 'Terms and conditions',
      tableEmptyMessage: 'No results found',
      sumWeight: 'kg',
      sumVolume: 'm',
      'statuses-selected': 'Selected statuses',
      'select-statuses': 'Select statuses',
      sort: 'Sort',
      showLess: 'Show less packages',
      showAllPackages: 'Show all packages',
      id: 'ID',
      movePieceLeft: 'Move piece left',
      movePieceRight: 'Move piece right',
      shipmentId: 'ID',
      settings: 'Preferences',
      sentOffer: 'I agree to contract',
      sent: 'Send',
      send: 'Send',
      search: 'Search',
      saveAndSend: 'Save and Send',
      save: 'Save',
      reset: 'x',
      requiredLegend: 'The field marked with * are required!',
      refuse: 'Refuse',
      preview: 'Control Panel',
      pickUpDate: 'Pick up date',
      pickup: 'Pickup',
      return: 'Return',
      packages: 'Packages',
      ok: 'Ok',
      nrPcs: 'pcs',
      no: 'No',
      nextStep: 'Next step',
      next: 'Next',
      negotiationHistory: 'Negotiation history',
      negotiate: 'Negociate',
      'needs-invoice-select-item': {
        null: 'All',
        needsInvoiceLabel: 'Yes',
        hasInvoiceLabel: 'No',
      },
      myContacts: 'My contacts',
      moreDetails: 'More details',
      maxDimension: 'cm',
      manualAdd: 'Add manually',
      length: 'Leght',
      language: 'Language',
      labels: 'Tag',
      invoicePreview: 'Preview',
      height: 'Height',
      group: 'Group',
      findSolution: 'Find solutions',
      filter: 'Filter',
      error: 'Error',
      emptyMessage: 'No results found',
      'empty-list': 'There is no item for the search. Change filters for a new search!',
      edit: 'Edit invoice',
      download: 'Download',
      details: 'Details',
      deliveryDate: 'Delivery date',
      delivery: 'Delivery',
      deleteConfirmation: 'Delete confirmation',
      delete: 'Delete',
      days: 'Days',
      day: 'Day',
      create: 'Create',
      continue: 'Continue',
      confirmation: 'Confirmation',
      'columns-selected': 'Columns selected',
      closePanel: 'Close panel',
      close: 'Close',
      clear: 'Reset',
      chooseFile: 'Choose files',
      'choose-columns': 'Add columns',
      choose: 'Choose',
      change: 'Change',
      cancel: 'Close',
      'boolean-select-item': {
        true: 'Yes',
        null: 'All',
        false: 'No',
      },
      bindingBody:
        'The continuation represents your express agreement to enter into contractual relations and is equivalent to signing the contract of shipment under the conditions detailed in the Deliwell Terms and Conditions of Use and the Contract of Carriage. After this confirmation any modification, rescission or cancellation can only be made by agreement of the parties.',
      backToSearch: (param) => (param.context ? `Back to search ${param.context}` : `Back to search`),
      selectFromExistentVehicles: 'Select from existent vehicles',
      selectFromExistentDrivers: 'Select from existent drivers',
      attachments: 'Attachements',
      signatures: 'Signatures',
      all: 'All',
      'advanced-filters': 'Advanced filters',
      addService: 'Add service',
      addFile: 'Add files',
      add: 'Add',
      accept: 'Accept',
    },
    util: {
      showDetails: 'Details',
      save: 'Save',
      isEmailAuthTooltipMessage: 'You need to be registered on the platform to access this feature',
      defaultError: 'An error has occured',
    },
    territoryAssignment: {
      deleteTerritoryConfirm: 'Confirm teritory delete',
      deleteConfirm: 'Confirm deletion ',
    },
    tariff: {
      template: 'Add from template',
      'start-zone': 'Start zone',
      'service-name': 'Service name',
      service: 'Service',
      'price-interval': {
        to: 'To',
        title: 'Pricing ranges',
        from: 'From',
        'base-quantity': 'Base quantity',
        'base-price': 'Base price',
        'add-quantity-step': 'Price increase step',
        'add-price-per-step': 'Price variation per step',
      },
      'new-title': 'New tariff',
      'list-title': 'Tariff',
      'from-template-title': 'New tariff from template',
      error: {
        requiredto: 'Mandatory to complete!',
        requiredtariffCalculationMethod: 'The calculation method is required!',
        requiredstartZone: 'The start area is required!',
        requiredfrom: 'Mandatory to complete!',
        requiredendZone: 'The end zone is required!',
        requireddeliveryServiceVO: 'Service name is required!',
        requiredcurrency: 'Currency is required!',
        requiredcontractVO: 'The contract is mandatory to choose!',
        requiredbaseQuantity: 'Mandatory to complete!',
        requiredbasePrice: 'Mandatory to complete!',
        requiredaddQuantityStep: 'Mandatory to complete!',
        requiredaddPricePerStep: 'Mandatory to complete!',
        requiredaccountVO: 'The account is mandatory to choose!',
        invalidIntervals: 'The inserted intervals must not intersect!',
        invalidInterval: 'The range entered is invalid!',
      },
      'end-zone': 'End zone',
      'detail-title': 'Edit tariff',
      'customer-name': 'Customer name',
      currency: 'Currency ',
      contract: 'Contract',
      'calculation-method-value': {
        WEIGHT: 'Weight',
        PIECES: 'Pieces',
      },
      'calculation-method': 'Calculation method',
      addNew: 'Add tariff',
      account: 'Account',
    },
    suggestions: {
      selectDispatcher: 'Click to select an employee',
      unassignEmployee: 'Unassign',
      orderListPage:
        'Orders cannot be sent directly. Orders are only created based on an offer. Click on the button on the right to send an offer request.',
      addVendorTag: 'To add a tag, click the following button',
      addVendor: 'To add a vendor, click the following button',
      addExternalVendor: 'To add a courier, click the following button',
      addCustomer: 'To add a client, click the following button',
      addBankAccountForPartnerPopup:
        "Bank accounts must be in Active status and type Normal. To check the existence of bank accounts go to 'My Company/Partner Profile'.",
      addBankAccount:
        "Bank accounts must be in Active status and type Normal. If you don't have one, add one using this icon",
      addAccount: 'To add an account, click the following button',
      employeeList: 'To add an employee, click the following button',
      transportProjectList: 'To add a transport project, click the following button',
    },
    shipment: {
      filters: {
        pickupCity: 'Pick up city',
        deliveryCity: 'Delivery city',
        pickupLocation: 'Pickup location',
        deliveryLocation: 'Delivery location',
      },
      routing: {
        assignToAll: 'The information was assign to all shipments!',
        error: {
          requiredDriverName: 'Driver name is required',
          requiredDriverPhone: 'Driver phone number is required',
          requiredLicensePlate: 'License plate is required',
          requiredVehicleType: 'Vehicle type is required',
          requiredVehicle: 'Vehicle is required',
          requiredDriver: 'Driver is required',
        },
      },
      util: {
        requested: 'requested',
        overlap: 'overlap',
        given: 'given',
      },
      unstackable: 'Unstackable',
      type: 'Type',
      tariff: 'Shipment tariff',
      createAutomaticTask: 'Create task for this shipment',
      tags: 'Tags',
      stackable: 'Stackable',
      savedAttachments: 'Existing attachments',
      saveCmr: 'Upload selected CMR',
      saveAttachments: 'Upload selected attachments',
      request: {
        title: 'Request shipment',
        modalTitle: 'Complete the following data:',
        error: {
          defaultValidationMessage: 'An error has occured',
        },
      },
      reference: 'Reference',
      packagesDetails: '{{packagesNumber}} packages | {{weight}} kg | {{volume}} cbm',
      otherDocuments: 'Other documents',
      series: 'Shipment series',
      number: 'Shipment number',
      locked: 'Exclusive shipment',
      updateVehicle: 'Update vehicle',
      updateDriver: 'Update driver and contact',
      updateDriverSuccessMessage: 'Driver successfully updated!',
      updateVehicleSuccessMessage: 'Vehicle successfully updated!',
      emptyVehicleWarningMessage: 'Please fill in at least one field to update the vehicle',
      emptyDriverWarningMessage: 'Please fill in at least one field to update the driver.',
      removeVehicle: 'Remove vehicle',
      removeDriver: 'Remove driver',
      removeDriverSuccessMessage: 'Driver successfully removed!',
      removeVehicleSuccessMessage: 'Vehicle successfully removed!',
      hasAssociatedTerminalReservations:
        'Updating this information will overwrite the data you previously entered for the warehouse order scheduling.',
      summaryTitle: 'Shipments summary',
      assignToShipments: 'Assign to all shipments',
      assignToShipmentsTooltip: 'Prefill data on other shipments',
      assignVehicleToShipments: 'Assign vehicle to shipments',
      assignDriverToShipments: 'Assign driver and contact to shipments',
      list: {
        title: 'Shipment task',
        modalTitle: 'Save task',
      },
      flowTypeEnum: {
        THIRD_COUNTRY: '3rd Country',
        OUT: 'Outbound',
        IN: 'Inbound',
      },
      flowType: 'Flow type',
      externalReference: 'External reference',
      error: {
        pickupRequired: 'Pickup information is required',
        isEmptyshipment: 'There must be at least one shipment',
        isEmptypackages: 'There must be at least one package',
        isEmptyProductCustomsClearanceDTOS: 'There must be at least one product',
        packageCountExceeded: 'The number of packages exceeds the maximum allowed: 200',
        deliveryServicerequired: 'Delivery service is required',
        deliveryRequired: 'Delivery information is required',
        addressOrLocationRequired: 'Selecti o adresa sau o locatie',
      },
      downloadTemplateCMR: 'Download CMR with shipment details',
      downloadPackageLabels: 'Download package tags',
      downloadCMR: 'Download CMR',
      downloadAWB: 'Download AWB',
      displayPackageLabels: 'Show package tags',
      displayCMR: 'Display CMR',
      displayAWB: 'Display AWB',
      deliveryService: 'Delivery service',
      delete: 'Delete shipment',
      customsRegime: 'Customs procedure',
      customsDuty: 'Customs',
      contactPerson: 'Contact person',
      companyName: 'Company name',
      common: {
        shipment: 'Shipment',
        weight: 'Weight',
        volume: 'Volume',
        tags: 'Tags',
        stackable: 'Stackable',
        size: 'Size',
        shipmentTags: 'Shipment tags',
        services: 'Services',
        searchClient: 'Search customer',
        save: 'Save',
        pieces: 'Package number',
        pickup: 'Pickup location',
        perPackage: 'Package',
        package: 'Package',
        onChangeCurrencyNote: 'Currency will be changed for all shipments!',
        next: 'Next',
        dropHere: 'Drop item here',
        delivery: 'Delivery location',
        customerName: 'Customer',
        currency: 'Currency ',
        close: 'Close',
        cargoValue: 'Cargo value',
        budget: 'Budget',
        'boolean-select-item': {
          true: 'Yes',
          null: 'All',
          false: 'No',
        },
        vendor: 'Vendor',
      },
      CMR: 'CMR',
      chooseCMR: 'Choose new CMR',
      chooseAttachments: 'Choose new attachments',
      cargoValue: 'Cargo value',
      budget: 'Budget',
      booleanAffirmationValues: {
        true: 'Yes',
        false: 'No',
      },
      awb: 'AWB',
      attachedCMR: 'Existing CMR',
      assignedDispatcher: 'Assigned dispatcher',
      add: 'Add shipment',
      status: {
        requested: 'Requested',
        request_rejected: 'Rejected',
        cancelled: 'Cancelled',
        before_pickup: 'Not picked up',
        in_progress: 'Planned',
        partially_in_progress: 'Partially planned',
        unavailable_cargo: 'Unavailable cargo',
        returned_to_origin: 'Returned to origin',
        partially_returned_to_origin: 'Partially returned to origin',
        in_transit: 'Transit',
        partially_in_transit: 'Partially in transit',
        transit_end: 'Transit end',
        partially_transit_end: 'Partially transit end',
        return_to_origin: 'Return to origin',
        partially_return_to_origin: 'Partially return to origin',
        lost: 'Lost',
        partially_completed: 'Partially completed',
        mixed: 'Mixed',
        mixed_with_failure: 'Mixed with failure',
        completed: 'Delivered',
        completed_with_failure: 'Incomplete delivery',
        undelivered: 'Undelivered',
        documents_received: 'Documents received',
      },
    },
    'shipment-templates': {
      vendor: {
        dashboard: {
          title: 'Scheduled shipments',
        },
        'add-shipment-template': {
          errors: {
            isEmptyvendors: 'At least one vendor should be selected',
          },
        },
      },
      recurrentShipment: 'Recurrent shipment',
      recurrenceEndDate: 'Recurring end time',
      recurrence: 'Recurrence',
      errors: {
        requiredCronExpression: "The 'Recurrence' field is required",
      },
      defaultRecurrenceEndDate: 'By default, the end date of the recurrence is one year from now.',
      customer: {
        dashboard: {
          title: 'Customers',
        },
      },
      common: {
        dashboard: {
          subtitle: 'Shipment templates',
          createOffReqTooltip: 'To create a request, select at least one shipment',
          createOffReq: 'Create offer request',
          'add-button': 'Add',
        },
        chips: {
          placedOnOfferReq: 'On offer request',
        },
        'add-shipment-template': {
          title: 'Add template',
        },
        'edit-shipment-template': {
          title: 'Edit template',
        },
        'action-menu': {
          newTemplateFromTemplate: 'Create template from template',
          newScheduledShipmentFromTemplate: 'Create scheduled shipment from template',
        },
      },
      chooseRecurrence: 'Choose recurrence',
    },
    'shipment-split': {
      allSegmentsMustHaveAtLeastOneShipmentMessage: 'All segments must have at least one shipment',
      yes: 'Yes',
      updateSegment: 'Save changes to current solution',
      unsavedChangesWarning: 'Daca aveti modificari nesalvate, aceste se vor pierde',
      unsavedChanges: 'You have unsaved changes. Click Save to not lose these changes',
      title: 'Shipment Split',
      success: 'Success',
      emptySegment: 'There are no shipments on this segment.',
      'split-wizard': {
        splitMethodTitle: 'Split method',
        splitConditionTitle: 'Split conditions',
        secondCardFooter: 'Splitting shipments at an intermediate location point',
        packagesSplitTitle: 'Packages',
        packages: 'Packages',
        packagesDisabledTooltip: "This splitting method isn't available for this shipment due to missing packages",
        enablePackagesGrouping: 'Enable package grouping',
        disablePackagesGrouping: 'Disable package grouping',
        'next-step': 'Next step',
        locationSplitTitle: 'Breakpoint',
        locations: 'Locations',
        firstCardFooter: 'Splitting the packages into 2 shipments',
        addPoint: 'Add delivery location',
      },
      sort: 'Sort',
      solutions: 'Solutions',
      'show-on-map': 'View on map',
      'shipments-actions': {
        split: 'Shipment Split',
        'assign-to-new-shipment': 'Assign to a new route',
      },
      shipments: 'Shipments',
      'shipment-segment-solution': {
        title: 'Solutions',
        'selection-dialog-title': 'Change route?',
        'offer-requests': 'Offer requests sent',
        'offer-request': {
          status: 'Status',
          'empty-list': 'At the moment you have not sent any offer request!',
          details: 'Details',
          deadline: 'Deadline',
        },
        'create-solution': 'Create solution',
        'create-offer-request': 'Create offer request',
        back: 'Back',
      },
      'shipment-group-solutions': {
        vehicle: 'Vehicle',
        'transit-time': 'Transit time',
        'order-create': 'Create order',
        'pre-order-create': 'Create pre-order',
        'pre-offer-request-create': 'Create pre offer request',
        tooltips: {
          'task-details': 'Tasks details',
          'order-details': 'Order details',
          'not-preferred': 'You have to set the solution as preferred',
          disabled: 'There is a complete solution on which tasks / orders have been created',
          'add-task': 'Create tasks',
          'accept-offer-and-create-order': 'Accept offer and create order',
        },
        title: 'Solutions',
        'summaries-panel': {
          title: 'Solutions',
          seeAll: 'View all solutions',
          routingSolutions: 'Own solutions',
          offers: 'Offers',
          offerRequests: 'Offer requests',
        },
        sellAllSolutions: 'View all solutions',
        'segments-title': 'Route',
        'routing-solution': {
          title: 'Shipment solutions',
          'solution-created-message': 'Solution created successfully!',
          rsTitle: 'Shipment solution ',
          'rs-expired': 'Solution has expired',
          offerTitle: 'Offer',
          'offer-request-message': 'Offer request created successfully!',
          'offer-expired': 'The offer at the base of the solution has expired',
          'more-details': 'Click for more details',
          'list-title': 'Solutions',
          expired: 'Solution has expired!',
          'empty-list': 'You currently have no solution',
          'empty-create': 'Create own solution',
          'disabled-selection': 'You must have at least one solution!',
          details: 'Details',
          'create-vendor-solution-message': 'Create solution',
          'create-solution-message': 'Create solution using own fleet',
        },

        offer: {
          title: 'Offer',
          negotiate: 'Negotiate',
          'list-title': 'Offers',
          expired: 'Offer expired',
          'empty-list': 'You currently have no offer',
          'empty-create': 'Create offer request',
          'create-routing-solution': 'Create shipment solution',
        },
        'master-routing-solutions': {
          'unselected-routing-solution': 'No solution was selected',
          title: 'Complete solutions ',
          'save-solution': 'Save solution',
          'create-solution': 'Create solution',
          'context-menu': {
            'set-preferred': 'Change your preferred solution?',
            preferred: 'Preffered',
            'complete-offer': 'Complete offer',
          },
          'confirmation-dialog': {
            dialogMessage:
              'After completing the action, you will not be able to change your preferred complete solution!',
            dialogHeader: 'Are you sure?',
            cancelLabel: 'Close',
            acceptLabel: 'I want to continue',
          },
          'cancel-solution': 'Cancel',
          'additional-info': 'To set as preferred or to create offer, click right on the solution',
        },
        'graphic-legend': {
          warn: 'Subcontractor route',
          primary: 'Own route',
        },
        driver: 'Driver',
        dialog: {
          'order-details': 'Order details',
          'create-order': 'Create order',
        },
        defaultForSubco: 'Created by direct subcontracting',
        lockedInSolution: 'Locked in solution',
        inProgressSolution: 'In progress solution',
        createdAt: 'Created at:',
        'available-until': 'Available until',
      },
      'shipment-group-solution-tracking': {
        title: 'Shipment Group Solution Tracking',
        'empty-tracking': 'No tasks or orders have been created',
        delayed: 'Shipment delayed',
      },
      selectedSegment: 'Selected segment',
      'select-route': 'Select this route?',
      'select-existing-route': 'Select existing route',
      'select-existing-root-segment': 'Select segment',
      'segment-popup-form': {
        'vendor-route-tab': {
          vendor: 'Carrier',
          title: 'Subcontractor route',
          source: 'Origin',
          save: 'Save',
          errors: {
            isEmptySource: "The 'Origin' field is required",
            isEmptyDestination: "The 'Destination' field is required",
          },
          destination: 'Destination ',
        },
        'owned-route-tab': {
          waypoints: 'Intermediate locations',
          vehicleType: 'Vehicle type',
          title: 'Template route',
          source: 'Origin',
          save: 'Save',
          'map-placeholder': 'Select Origin and Destination in order to view the map!',
          error: {
            isEmptyWaypoint: 'The intemediare location cannot be empty!',
            isEmptySource: "The 'Origin' field is required",
            isEmptyDestination: "The 'Destination' field is required",
          },
          destination: 'Destination',
          'add-waypoint': 'Add intermediate location',
        },
      },
      'segment-definition': {
        waypointError: 'Select two points to define the segment',
        title: 'Define segment',
        selected: 'selected',
        'not-selected': 'not selected',
        info: 'Select segment ends',
      },
      saveWithUpdatedSegment: 'Save a new solutions',
      saveSuccessMessage: 'They were successfully saved. You can proceed to the next step',
      save: 'Save',
      routes: {
        tooltip: {
          'show-on-map': 'Show on map',
          details: 'Route details',
          'create-from-template': 'Create route from template',
        },
        'route-types': {
          vendor_route: 'Subcontractor route',
          route_template: 'Template route',
          route: 'Own route',
        },
      },
      'routes-list-title': 'Routes',
      'routes-filter-form': {
        'vendor-name': 'Subcontractor name',
        'vehicle-type': 'Vehicle type',
        'route-type': 'Route type',
        origin: 'Departure city',
        'license-plate': 'License plate',
        destination: 'Destination city',
      },
      route: {
        'show-on-map': 'View route on map',
      },
      'route-load': {
        weight: 'Weight',
        volume: 'Volume',
        title: 'Load route',
        nrPcs: 'Packages',
        empty: 'There is no load!',
      },
      'resolve-choice': {
        title: 'Solving method',
        subcontractingTitle: 'Offer request',
        subcontractingDescription: 'Request a offer from partner vendors for group shipments',
        splitTitle: 'Complete resolution',
        splitDescription: 'Resolve group of shipments using shipment split functionality',
      },
      'replace-segment': 'Change segment to a similar one',
      pickupAndDeliveryTitle: 'Update picking up / dropping off data for the route section',
      pickup: 'Pick up',
      packagesTitle: 'Assigned packages on the route section',
      packages: 'Packages',
      'no-shipment-info': 'Drag and drop a shipment here to load on route',
      'no-segment-error': 'No segments',
      no: 'No ',
      nextButtonSolutionNotCompleteTooltip:
        'The solution is not complete. Finalize the solution before proceeding to the next step',
      nextButtonHasChangesTooltip: 'You have unsaved changes. Click Save before proceeding to the next step',
      'more-waypoints': 'Inca {{waypointsLeft}} stop',
      missingRouteSelection: 'A segment must be selected',
      errorSummary: 'Error',
      childPackagesMismatch: 'Child shipments must match the parent package count. Adjust the splits before saving.',
      errorSuccessMessage: 'Check data and try again',
      error: {
        requiredPieces: 'Quantity of packages cannot be empty',
        notPositiveValue: 'Quantity of packages cannot be negative',
        maxValueExceeded: 'The quantity of packages introduced may not exceed the original value',
        maxDistanceExceeded: 'Address must be within 50km of the segment',
        allPiecesAreZero: 'You must include at least one package!',
        minTotalPieces: 'Total pieces must be at least 1',
      },
      delivery: 'Delivery',
      'delete-segment': 'Delete segment',
      'create-route-inline': 'Create new route',
      'create-new-route': 'Create new route',
      confirmation: 'Confirm',
      clearSolutionTooltip: 'Click to start new solution',
      choseSaveMode: 'Do you want to replace in the current solution or create a new solution',
      'choose-split-type': 'Choose split type',
      'choose-pickup-address': 'Choose pick up address',
      'choose-package-number': 'Enter the number of packages you want',
      'choose-delivery-address': 'Choose delivery address',
      canvas: {
        howToStartPartTwo: ', followed by the selection of a route to start the process of solving the shipment',
        howToStartPartOne: 'Click the button',
      },
      'are-you-sure-delete': 'Are you sure you want to delete this item',
      'add-segment': 'Add segment',
      activeSegment: 'Original segment',
      pickupIsFarAway: 'Pickup is far away from the original shipment',
      deliveryIsFarAway: 'Delivery is far away from the original shipment',
      dispatchOriginal: 'Continue with original',
      splitAndDispatch: 'Split',
      shipmentSplitRequired: 'A shipment split is required. Do you want to split or to dispatch the original shipment?',
      pickupSplitRequired:
        'Pickup point is too far from the Solution location. Do you want to continue or change the address',
      deliverySplitRequired:
        'Delivery point is too far from the Solution location. Do you want to continue or change the address',
      bothSplitRequired:
        'Both pickup and delivery points are too far from the Solution locations. Do you want to continue or change the addresses',
      makeChanges: 'Make changes',
      continue: 'Continue',
    },
    'shipment-groups-dashboard': {
      tooltips: {
        'shipment-group-solution-tracking': 'Shipment solution tracking',
      },
      title: 'Workspace',
      status: {
        workInProgress: 'In progress',
        sentOrdersNumber: 'Sent orders',
        receivedOffersNumberPerSentOfferRequestsNumber: 'Received offers / Sent requests',
        paymentTimeLimit: 'Payment time limit',
        orderStatus: 'Order status',
        orderAccepted: 'Order accepted',
        offerSent: 'Sent offer',
        noWorkInProgress: 'New',
        noOrderAccepted: 'Order not accepted',
        noOfferSent: 'No offer sent',
        masterRsNumber: 'Complete solutions',
        createdTasksNumber: 'Created tasks',
      },
      shipments: 'Shipments',
      routingSolution: 'Shipment solutions',
      resolve: 'Solve',
      pickupCity: 'Pick up city',
      order: 'Order',
      notificationTooltip: 'To see the new requests click the button. Attention! The filters will reset!',
      noRoutingSolution: 'At the moment there is no solution',
      newOfferRequestsNotification: 'You have new offer requests',
      goToOrderDetails: 'Details',
      goToOfferRequestDetails: 'Details',
      filter: 'Filter',
      expiredGroup: 'Expired',
      dueTime: 'Time left',
      dispatcher: 'Dispatcher',
      deliveryCity: 'Delivery city',
      customerName: 'Customer name',
      assignedToUser: 'Assigned to me',
      addOfferRequest: '+ Add request accepted',
      activeGroup: 'Active',
      'account-input-label': 'Select account',
      account: 'Account',
    },
    'shipment-group': {
      'vehicle-type': 'Vehicle type',
      'transit-time': 'Transit time',
      'subcontracting-title': 'Partner vendors offers',
      subcontract: 'Offer request',
      'routing-solution-title': 'Route solutions',
      'routing-solution': 'Route solutions',
      paymentTimeLimit: 'Payment time limit',
      'license-plate': 'License plate',
      'driver-name': 'Driver name',
    },
    'ship-transaction-terms-and-cond': {
      statuses: {
        rejected: 'Rejected',
        accepted: 'Accepted',
      },
      rejected: 'T&C rejected',
      reject: 'I refuse the terms and conditions',
      currentStatus: 'Terms and Conditions have been',
      comments: 'Comments',
      accepted: 'T&C accepted',
      accept: 'I agree to the terms and conditions',
    },
    services: {
      title: 'Services',
      newService: 'Add service',
      name: 'Service name',
      error: {
        requiredserviceName: "The  'Service name' field is required",
      },
      description: 'Description',
    },
    serviceProvider: {
      list: {
        vehicleTypes: 'Vehicle type',
        title: 'Service providers qualification',
        routes: 'Routes',
        name: 'Name',
        fleetSize: 'Fleet',
        deliveredInTimePercentage: 'Delivered in time (%)',
        countries: 'Countries',
        complaintPercentage: 'Complaint percentage (%)',
        averagePricePerKm: 'Average price per km',
      },
    },
    'scheduled-shipments': {
      title: 'Scheduled shipments',
      createOfferRequestTooltip: 'To create a request, select at least one shipment',
      createOfferRequest: 'Create offer request',
      'add-scheduled-shipment': 'Add scheduled shipment',
      add: 'Add',
    },
    driverExpenses: {
      title: 'Driver expenses',
      list: {
        expenseDate: 'Expense date',
        name: 'Driver',
        licensePlate: 'Vehicle',
        description: 'Description',
        expenseType: 'Expense type',
        currencyCode: 'Currency code',
        amount: 'Amount',
        localCurrencyAmount: 'Local currency amount',
        localCurrencyExchangeRate: 'Local currency exchange rate',
        documentNumber: 'Document number',
        status: 'Status',
      },
      options: {
        expenseType: {
          CLAIM: 'Claim',
          ADVANCE: 'Advance',
        },
        status: {
          REQUESTED: 'Requested',
          APPROVED: 'Approved',
          DECLINED: 'Declined',
        },
        currencyCode: {
          RON: 'RON',
          EUR: 'EUR',
          USD: 'USD',
        },
      },
      totalInRon: 'Total expenses',
      monthAndYear: 'Expenses from month and year: ',
      approve: 'Approve',
      decline: 'Decline',
    },
    courierManagement: {
      title: 'Couriers',
      list: {
        courierType: 'Courier company',
      },
      courierType: {
        FED_EX: 'FedEx',
        UPS: 'UPS',
        DHL: 'DHL',
      },
      new: 'Add',
      form: {
        apis: {
          RATES_AND_TRANSIT_TIMES: 'Rates and transit times',
          SHIPMENT: 'Shipment',
          PICKUP: 'Pickup',
          TRACKING: 'Tracking',
          UPLOAD_DOCUMENT: 'Trade Documents Upload',
          UPS_APIS: 'UPS APIs access',
          DHL_APIS: 'DHL APIs access',
        },
        apiKey: 'API key',
        secretKey: 'Secret key',
        accountNumber: 'Account number',
        courierType: 'Courier company',
        copy: 'Copy',
        paste: 'Paste',
      },
      accountNumber: {
        title: 'Account numbers',
        add: 'Add account number',
        saveMultipleForFedEx: 'I want to save this account number also for the following APIs: ',
        fedexApis: 'FedEx APIs',
        editLabel: 'Edit label',
        addLabel: 'Add label',
        noAccountNumbersWarningMessage: 'This courier has no account numbers. Add using the next button.',
        selectAnAccountNumberTooltip: 'You must select an account number!',
        list: {
          accountNumber: 'Account number',
          label: 'Label',
          countryCode: 'Associated country',
          postalCode: 'Associated postal code',
        },
        isPrimary: 'This will be the main account',
        primaryAccountInfo:
          'By setting this account as the primary, the account that is currently the primary will be automatically replaced.',
        markPrimary: 'Set this account as the primary one',
        unmarkPrimary: 'Remove primary status',
        error: {
          requiredAccountNumber: 'The account number is mandatory!',
        },
      },
      discount: {
        title: 'Discounts',
        add: 'Add discount',
        chargeTypes: {
          BASE_SERVICE: 'Base transportation charge',
          FUEL_SURCHARGE: 'Fuel surcharge',
          ADDITIONAL_SURCHARGE: 'Additional surcharges',
        },
        discountPercentage: 'Discount',
        chargeType: 'Charge type',
        serviceType: 'Service type',
        editPercentage: 'Edit percentage',
        allCourierChargeTypesHaveBeenAdded: 'All charge types have already been added!',
        useDiscounts: 'Apply discounts to courier-provided prices',
        deleteConfirmationMessage: 'Are you sure you want to delete the discount?',
        selectServiceTypes: 'Select service types',
        errors: {
          maxDiscountPercentage: 'The discount percentage cannot exceed 100!',
          minDiscountPercentage: 'The discount percentage cannot be less than 0!',
          requiredDiscountPercentage: 'The discount value is mandatory!',
        },
      },
      tag: 'Courier',
      latestStatusInfo: 'Last status from ',
      noLatestStatusInfo: 'No latest status from courier!',
      serviceTypes: {
        FEDEX_FIRST: 'FedEx® First',
        FEDEX_PRIORITY_EXPRESS: 'FedEx® Priority Express',
        FEDEX_PRIORITY: 'FedEx® Priority',
        FEDEX_PRIORITY_FREIGHT: 'FedEx® Priority Freight',
        FEDEX_10KG_BOX: 'FedEx® 10kg Box',
        FEDEX_25KG_BOX: 'FedEx® 25kg Box',
        FEDEX_INTERNATIONAL_CONNECT_PLUS: 'FedEx® International Connect Plus',
        FEDEX_REGIONAL_ECONOMY: 'FedEx® Regional Economy',
        FEDEX_REGIONAL_ECONOMY_FREIGHT: 'FedEx® Regional Economy Freight',
        EXPRESS_SAVER: 'FedEx® Express Saver',
        FEDEX_INTERNATIONAL_PRIORITY_EXPRESS: 'FedEx® International Priority Express',
        INTERNATIONAL_FIRST: 'FedEx® International First',
        FEDEX_INTERNATIONAL_PRIORITY: 'FedEx® International Priority',
        INTERNATIONAL_ECONOMY: 'FedEx® International Economy',
        FEDEX_GROUND: 'FedEx® Ground',
        FIRST_OVERNIGHT: 'FedEx® First Overnight',
        FEDEX_FIRST_FREIGHT: 'FedEx® First Overnight Freight',
        FEDEX_1_DAY_FREIGHT: 'FedEx® 1Day Freight',
        FEDEX_2_DAY_FREIGHT: 'FedEx® 2Day Freight',
        FEDEX_3_DAY_FREIGHT: 'FedEx® 3Day Freight',
        INTERNATIONAL_PRIORITY_FREIGHT: 'FedEx® International Priority Freight',
        INTERNATIONAL_ECONOMY_FREIGHT: 'FedEx® International Economy Freight',
        FEDEX_INTERNATIONAL_DEFERRED_FREIGHT: 'FedEx® International Deferred Freight',
        INTERNATIONAL_PRIORITY_DISTRIBUTION: 'FedEx® International Priority DirectDistribution',
        INTERNATIONAL_DISTRIBUTION_FREIGHT: 'FedEx® International Priority DirectDistribution Freight',
        INTL_GROUND_DISTRIBUTION: 'FedEx® International Ground Distribution',
        GROUND_HOME_DELIVERY: 'FedEx® Home Delivery',
        SMART_POST: 'FedEx® Ground Economy',
        PRIORITY_OVERNIGHT: 'FedEx® Priority Overnight',
        STANDARD_OVERNIGHT: 'FedEx® Standard Overnight',
        FEDEX_2_DAY: 'FedEx® 2Day',
        FEDEX_2_DAY_AM: 'FedEx® 2Day AM',
        FEDEX_EXPRESS_SAVER: 'FedEx® Express Saver',
        SAME_DAY: 'FedEx® SameDay',
        SAME_DAY_CITY: 'FedEx® SameDay City',

        UPS_STANDARD: 'UPS Standard',
        UPS_WORLDWIDE_EXPRESS_PLUS: 'UPS Worldwide Express Plus',
        UPS_WORLDWIDE_SAVER: 'UPS Worldwide Saver',
        UPS_2ND_DAY_AIR: 'UPS 2nd Day Air',
        UPS_2ND_DAY_AIR_AM: 'UPS 2nd Day Air AM',
        UPS_3_DAY_SELECT: 'UPS 3 Day Select',
        UPS_GROUND: 'UPS Ground',
        UPS_NEXT_DAY_AIR: 'UPS Next Day Air',
        UPS_NEXT_DAY_AIR_EARLY: 'UPS Next Day Air Early',
        UPS_NEXT_DAY_AIR_SAVER: 'UPS Next Day Air Saver',
        ROADIE_XD_AM: 'Roadie XD AM',
        ROADIE_XD_PM: 'Roadie XD PM',
        ROADIE_XD: 'Roadie XD',
        UPS_ACCESS_POINT_ECONOMY: 'UPS Access Point Economy',
        UPS_EXPEDITED: 'UPS Expedited',
        UPS_EXPRESS: 'UPS Express',
        UPS_EXPRESS_12_GERMANY: 'UPS Express 12 Germany',
        UPS_WORLDWIDE_EXPRESS_FREIGHT: 'UPS Worldwide Express Freight',
        UPS_WORLDWIDE_EXPRESS_FREIGHT_MIDDAY: 'UPS Worldwide Express Freight Midday',
        UPS_WORLDWIDE_ECONOMY_DDU: 'UPS Worldwide Economy DDU',
        UPS_WORLDWIDE_ECONOMY_DDP: 'UPS Worldwide Economy DDP',

        DHL_EXPRESS_WORLDWIDE_DOC: 'Express Worldwide',
        DHL_EXPRESS_WORLDWIDE_NON_DOC: 'Express Worldwide',
        DHL_EXPRESS_1200_DOC: 'Express 12:00',
        DHL_EXPRESS_1200_NON_DOC: 'Express 12:00',
        DHL_EXPRESS_EASY_NON_DECL: 'Express Easy',
        DHL_EXPRESS_EASY_NON_UE_DECL: 'Express Easy',

        DHL_MEDICAL_EXPRESS_UE_NON_DECL: 'Medical Express',
        DHL_EXPRESS_0900_DOC: 'Express 09:00',
        DHL_EXPRESS_0900_NON_DOC: 'Express 09:00',
        DHL_EXPRESS_WORLDWIDE_UE_NON_DECL: 'Express Worldwide',
        DHL_ECONOMY_SELECT_DOC: 'Economy Select',
        DHL_ECONOMY_SELECT_NON_DOC: 'Economy Select',
        DHL_EXPRESS_BREAKBULK: 'Express Breakbulk',
        DHL_ECONOMY_BREAKBULK: 'Economy Breakbulk',
        DHL_EXPRESS_1030_NON_DECL: 'Express 10:30',
        DHL_EXPRESS_1030_DECL: 'Express 10:30',
        DHL_EXPRESS_DOMESTIC: 'Express Domestic',
        DHL_MEDICAL_EXPRESS_NON_DECL: 'Medical Express',
        DHL_MEDICAL_EXPRESS_DECL: 'Medical Express',
      },
      fedex: {
        latestStatusDetailType: {
          AA: 'At Airport',
          AC: 'At Canada Post facility',
          AD: 'At Delivery',
          AF: 'At local FedEx Facility',
          AO: 'Shipment arriving On-time',
          AP: 'At Pickup',
          AR: 'Arrived at FedEx location',
          AX: 'At USPS facility',
          CA: 'Shipment Cancelled or Carrier',
          CH: 'Location Changed',
          DD: 'Delivery Delay',
          DE: 'Delivery Exception',
          DL: 'Delivered',
          DP: 'Departed',
          DR: 'Vehicle furnished but not used',
          DS: 'Vehicle Dispatched',
          DY: 'Delay',
          EA: 'Enroute to Airport or Export Approved',
          ED: 'Enroute to Delivery',
          EO: 'Enroute to Origin Airport',
          EP: 'Enroute to Pickup',
          FD: 'At FedEx Destination',
          HL: 'Hold at Location',
          HP: 'Ready for Recipient Pickup',
          IT: 'In Transit',
          IX: 'In transit (see Details)',
          LO: 'Left Origin',
          OC: 'Order Created',
          OD: 'Out for Delivery',
          OF: 'At FedEx origin facility',
          OX: 'Shipment information sent to USPS',
          PD: 'Pickup Delay',
          PF: 'Plane in Flight',
          PL: 'Plane Landed',
          PM: 'In Progress',
          PU: 'Picked Up',
          PX: 'Picked up (see Details)',
          RR: 'CDO requested',
          RM: 'CDO Modified',
          RC: 'CDO Cancelled or Recipient',
          RS: 'Return to Shipper',
          RP: 'Return label link emailed to return sender',
          LP: 'Return label link cancelled by shipment originator',
          RG: 'Return label link expiring soon',
          RD: 'Return label link expired',
          SE: 'Shipment Exception',
          SF: 'At Sort Facility',
          SP: 'Split Status',
          TR: 'Transfer',
          CC: 'Cleared Customs',
          CD: 'Clearance Delay',
          CP: 'Clearance in Progress',
          SH: 'Shipper',
          CU: 'Customs',
          BR: 'Broker',
          TP: 'Transfer Partner',
        },
      },
      errors: {
        requiredCourierType: "The field 'Courier company' is mandatory!",
        'requiredSecretKey-RATES_AND_TRANSIT_TIMES':
          "The field 'Secret key' is mandatory for the Rates and transit times API",
        'requiredApiKey-RATES_AND_TRANSIT_TIMES':
          "The field 'API key' is mandatory for the Rates and transit times API",
        'requiredAccountNumber-RATES_AND_TRANSIT_TIMES':
          "The field 'Account number' is mandatory for the Rates and transit times API",
        'requiredSecretKey-SHIPMENT': "The field 'Secret key' is mandatory for the Shipment API",
        'requiredApiKey-SHIPMENT': "The field 'API key' is mandatory for the Shipment API",
        'requiredAccountNumber-SHIPMENT': "The field 'Account number' is mandatory for the Shipment API",
        'requiredSecretKey-PICKUP': "The field 'Secret key' is mandatory for the Pickup API",
        'requiredApiKey-PICKUP': "The field 'API key' is mandatory for the Pickup API",
        'requiredAccountNumber-PICKUP': "The field 'Account number' is mandatory for the Pickup API",
        'requiredSecretKey-TRACKING': "The field 'Secret key' is mandatory for the Tracking API",
        'requiredApiKey-TRACKING': "The field 'API key' is mandatory for the Tracking API",
        'requiredAccountNumber-TRACKING': "The field 'Account number' is mandatory for the Tracking API",
        'requiredSecretKey-UPLOAD_DOCUMENT': "The field 'Secret key' is mandatory for the Upload Documents API",
        'requiredApiKey-UPLOAD_DOCUMENT': "The field 'API key' is mandatory for the Upload Documents API",
        'requiredAccountNumber-UPLOAD_DOCUMENT': "The field 'Account number' is mandatory for the Upload Documents API",
        'requiredApiKey-UPS_APIS': "The field 'API key' is mandatory for the UPS APIs",
        'requiredSecretKey-UPS_APIS': "The field 'Secret key' is mandatory for the UPS APIs",
        'requiredAccountNumber-UPS_APIS': "The field 'Account number' is mandatory for the UPS APIs",
        'requiredApiKey-DHL_APIS': "The field 'API key' is mandatory for the DHL APIs",
        'requiredSecretKey-DHL_APIS': "The field 'Secret key' is mandatory for the DHL APIs",
        'requiredAccountNumber-DHL_APIS': "The field 'Account number' is mandatory for the DHL APIs",
      },
    },
    packageTracking: {
      title: 'Package tracking',
      filter: 'Filter (Last 10 days)',
      packageIdFilter: 'Search all packages for those with exactly this id',
      destination: 'Destination',
      packageEventSource: {
        web: 'Status obtained from the web application',
        mobile: 'Status obtained from the mobile application',
        external: 'Status received from an external environment',
      },
      packageSelectionMethod: {
        SCANNED: 'Scanned',
        MANUALLY_SELECTED: 'Manually selected',
        MANUALLY_INSERTED: 'Manually inserted',
        AUTOMATICALLY_MATCHED: 'Automatically matched',
      },
      packageSelectionMethodShort: {
        SCANNED: 'Scanned',
        MANUALLY_SELECTED: 'Selected',
        MANUALLY_INSERTED: 'Inserted',
        AUTOMATICALLY_MATCHED: 'Automatically',
      },
      adHocPackage: 'Ad-hoc',
      statusEnum: {
        REQUESTED: 'The package has been requested',
        REQUEST_REJECTED: 'The package request was rejected',
        CANCELLED: 'The package has been cancelled',
        SCHEDULED: 'The package is scheduled for shipment',
        IN_PROGRESS: 'The package has been planned for pickup',
        TRANSIT_START: 'The package is in transit',
        TRANSIT_END: 'The package transit has ended',
        LOST: 'The package has been lost',
        UNAVAILABLE: 'The package is unavailable',
        RETURN_TO_ORIGIN: 'The package is returning to origin',
        RETURNED_TO_ORIGIN: 'The package was returned to origin',
        DELIVERED: 'The package has been successfully delivered',
      },
      shortStatusEnum: {
        REQUESTED: 'Requested',
        REQUEST_REJECTED: 'Rejected',
        CANCELLED: 'Cancelled',
        SCHEDULED: 'Scheduled',
        IN_PROGRESS: 'Planned',
        TRANSIT_START: 'In transit',
        TRANSIT_END: 'Transit ended',
        LOST: 'Lost',
        UNAVAILABLE: 'Unavailable',
        RETURN_TO_ORIGIN: 'Returning',
        RETURNED_TO_ORIGIN: 'Returned',
        DELIVERED: 'Delivered',
      },
      shipmentSeriesFilter: 'Filter by shipment series',
      markAsLost: 'Mark as lost',
      markAsLostConfirmHeader: 'Confirm mark as lost',
      markAsLostConfirmMessage: 'Are you sure you want to mark this package as lost?',
      markedAsLostSuccess: 'Package was marked as lost',
    },
    routingSolution: {
      vehicleType: 'Vehicle type',
      transitDays: 'Transit days',
      segmentSuggestionMessage:
        'On this segment, the pick-up and drop-off of the parcel must be within the following interval: ',
      minTimeAvailability: 'Minimum validity of the transport solution is',
      expired: 'Shipment solution has expired!',
      error: {
        requiredrouteUuid: 'An error occurred with the selection of route. Try again',
        requiredpackageGroupUuid: 'An error occurred with the selection of packages. Try again',
        requiredcurrency: 'The Currency field is required',
        requiredcost: 'Cost and currency are required!',
      },
      details: 'Details',
      currency: 'Currency',
      cost: 'Cost',
    },
    'routing-solution': {
      vehicleType: 'Vehicle type',
      licensePlate: 'License plate',
      driverName: 'Driver name',
    },
    routes: {
      withETAAfter: 'With ETA after',
      title: 'Routes',
      route: {
        vehicle: 'Vehicle',
        'update-title': 'Update route',
        templates: 'Templates',
        locations: 'Locations',
        label: 'Name',
        etd: 'ETD',
        eta: 'ETA',
        error: {
          waypointsInvalid: 'There must be a minimum of 2 locations',
          requiredStart: "The  'ETD' field is required",
          requiredName: "The  'Name' field is required",
          requiredFinish: "The  'ETA' field is required",
        },
        'edit-confirmation': 'Do you want to update this route?',
        driver: 'Driver',
        'details-title': 'Route details',
        'add-title': 'Add route',
        'add-location': 'Add locations',
      },
      'route-template': {
        'update-title': 'Update route template',
      },
      filters: {
        'vehicle-type': 'Vehicle type',
        'route-type': 'Route type',
        origin: 'Departure city',
        'license-plate': 'License plate',
        'driver-name': 'Driver name',
        destination: 'Destination city',
      },
      common: {
        source: 'Source',
        googleError: 'Google maps failed to create a route between Source and Destination',
        error: {
          isEmptyWaypoint: 'The intermediate point cannot be empty!',
          isEmptySource: "The  'Source' field is required",
          isEmptyDestination: "The  'Destination' field is required",
        },
        destination: 'Destination',
        addWaypoint: 'Add intermediate point',
      },
      addButtonLabel: 'Add route',
    },
    location: {
      autocomplete: 'Add location locatie',
    },
    planner: {
      order: {
        title: 'Order planner details',
        tasks: 'Tasks',
        task: 'Task',
        status: 'Status',
        deliveryCompanyNames: 'Delivery companies',
        pickupCompanyNames: 'Pickup companies',
        spName: 'Vendor partner',
        sales: 'Sales',
        pickups: 'Pickup point',
        pickup: 'Pickup point',
        paymentTimeLimit: 'Payment due date',
        orderNumber: 'Order number',
        invoiceGenerated: 'Invoiced',
        locked: 'Locked',
        listTitle: 'Orders',
        handover: {
          country: 'Country',
          city: 'City',
        },
        error: {
          defaultValidationMessage: 'An error has occurred. Check the data entered and try again',
          accountrequired: 'Account must be selected!',
        },
        'dispatcher-header': 'Dispatcher',
        dispatcher: 'Dispatcher name',
        delivery: 'Delivery point',
        deliveries: 'Delivery point',
        delete: 'Delete order planning',
        customerName: 'Customer',
        currencyCode: 'Currency ',
        totalWeight: 'Total weight',
        pieces: 'pcs',
        packageNumber: 'Package number',
        createdAt: 'Created at',
        contact: {
          phoneNumber: 'Phone number',
          name: 'Name',
        },
        billingCycle: 'Billing cycle',
        add: 'Add order',
        account: 'Account',
        requestingCompanyName: 'Requesting company',
      },
      name: 'Name',
    },
    package: {
      id: 'Package Id',
      width: 'Width',
      weight: 'Weight/Package',
      size: 'Size',
      type: 'Package type',
      totalWeight: 'Total weight',
      totalVolume: 'Total volume',
      totalCount: 'Number of packages',
      title: 'Packages',
      tags: 'Cargo description',
      pieces: 'Package number',
      status: {
        REQUESTED: 'Requested',
        REQUEST_REJECTED: 'Request rejected',
        CANCELLED: 'Cancelled',
        SCHEDULED: 'Scheduled',
        IN_PROGRESS: 'Planned',
        TRANSIT_START: 'Transit start',
        TRANSIT_END: 'Transit end',
        LOST: 'Lost',
        UNAVAILABLE: 'Unavailable',
        RETURN_TO_ORIGIN: 'Return to origin',
        RETURNED_TO_ORIGIN: 'Returned to origin',
        DELIVERED: 'Delivered',
      },
      packageEvent: {
        lastEventAchievedAtDate: 'Status achieved at date',
        lastEventAchievedAtAddress: 'Status achieved at address',
      },
      packages: 'packages',
      numberOfPackagesAssignedToShipment: 'For this shipment have been assigned',
      length: 'Length',
      height: 'Height',
      error: {
        widthrequired: 'Width is required',
        weightrequired: 'Weight is required',
        piecesrequired: 'The number of pieces is required',
        noPackages: ' At least one package must be added!',
        lengthrequired: 'Length is required',
        heightrequired: 'Height is required',
        descriptionrequired: 'Description is required',
      },
      tracking: {
        destination: 'Destination',
        pickup: 'Pickup',
        indicateAProblem: 'Indicate a problem',
        renewStatus: 'Renew status',
        moreActions: 'More actions',
      },
      delete: 'Delete package',
      add: 'Add package',
      select: 'Select a package',
      search: 'Search a package',
      custom: 'Custom package',
      packageStatusPopupTitle: 'Package statuses',
      packageStatusPopupButtonTooltip: 'See package statuses',
      downloadPdf: 'Download PDF',
    },
    productCustomsClearance: {
      title: 'Products details',
      add: 'Add commodity',
      commodityDescription: 'Commodity description',
      quantity: 'Quantity',
      quantityUnits: 'Units',
      unitPrice: 'Unit price',
      customsValue: 'Customs value',
      countryOfManufacture: 'Country of manufacture',
      amount: 'Amount',
      currency: 'Currency',
      totalWeight: 'Total weight (kg)',
      harmonizedCode: 'Harmonized code',
      customsCurrency: 'Prices are expressed in the currency: ',
      commodity: 'Commodity ',
      quantityUnitLabels: {
        AR: 'Carat',
        CM: 'Centimeter',
        CFT: 'Cubic Foot',
        M3: 'Cubic Meter',
        DOZ: 'Dozen',
        DPR: 'Dozen Pair',
        EA: 'Each',
        LFT: 'Foot',
        G: 'Gram',
        GR: 'Gross',
        KG: 'Kilogram',
        LNM: 'Linear Meter',
        LTR: 'Liter',
        M: 'Meter',
        MG: 'Milligram',
        ML: 'Milliliter',
        NO: 'Number',
        OZ: 'Ounce',
        PR: 'Pair',
        PCS: 'Pieces',
        LB: 'Pound',
        SFT: 'Square Foot',
        M2: 'Square Meter',
        SYD: 'Square Yard',
        YD: 'Yard',
      },
      error: {
        requiredCommodityDescription: "The field 'Commodity description' is mandatory!",
        requiredQuantity: "The field 'Quantity' is mandatory!",
        requiredQuantityUnits: "The field 'Units' is mandatory!",
        requiredCountryOfManufacture: "The field 'Country of manufacture' is mandatory!",
        requiredValue: 'The field is mandatory!',
        requiredCustomLabel: "The field 'Product code' is mandatory!",
        requiredCurrencyCode: 'The field is mandatory!',
        requiredTotalWeight: "The field 'Total weight (kg)' is mandatory!",
        minQuantity: "The quantity can't be smaller than 0",
        minValue: "The value can't be smaller than 0",
        greaterThanTotalWeight: 'The total weight must be greater than 0 kg',
        maxlengthHarmonizedCode: "The harmonized code can't have more than 8 characters!",
        requiredProductCustomsClearancesCurrencyCode: "The field 'Currency' is mandatory!",
        requiredEnglishLanguage: 'The description must be in english!',
        productsWeightIsBiggerThanPackagesWeight:
          'The total weight of the products must be smaller or equal to the total weight of the packages!',
      },
      nomenclature: {
        productName: 'Product name',
        customLabel: 'Product code',
        addEmptyProduct: 'Add empty product',
        searchProduct: 'Search product',
        selectProduct: 'Select a product',
        addProductToNomenclature: 'Add this product to nomenclature',
        saveInNomenclature: 'Save in nomenclature',
        saveSelectedProducts: 'Save selected products',
        enterCustomLabel: 'Product code',
        listTitle: 'Product nomenclature',
        formTitle: 'Add product',
        editTitle: 'Edit product',
        productSavedSuccessfully: 'Product saved successfully.',
        productDeletedSuccessfully: 'Product deleted successfully.',
        saveProductChangesHeader: 'Confirm save?',
        saveProductChangesMessage: 'If you save, the products with the following product codes will be updated',
        saveProductWithNoChangesMessage:
          "To continue without modifying the products, uncheck the 'Save in nomenclature' option.",
        unitMeasurementInvalidMessage: 'The unit of measure saved for this product is invalid. Select another one.',

        errors: {
          currencyNotTheSame: 'Product currency is invalid or does not match the selected one',
          productNomenclatureSaveException:
            'The products could not be saved to the nomenclature. To continue, please verify that all fields are completed correctly or uncheck the save option.',
        },
      },
    },
    order: {
      wizard: {
        stepTwo: 'Shipments',
        stepThree: 'Shipment documents',
        stepOne: 'Details',
        stepFour: 'Summary',
        contractStep: 'Contract',
      },
      pickupDate: 'Pickup date',
      deliveryDate: 'Delivery date',
      dispatcher: 'Dispatcher',
      viewOrder: 'View order',
      invoiceSerialNumber: 'Invoice series',
      invoiceList: {
        navigateToInvoiceTooltip: 'Click for details',
        navigateToInvoiceListTooltip: 'Navigate to all invoices',
        seeMore: 'See more',
        seeLess: 'See less',
      },
      viewComplaints: 'Complains',
      viewBlacklistHistory: 'Blacklist history',
      uninvoicedOrders: 'Previous uninvoiced orders',
      unarchiveOrderTooltip: 'The order can only be unarchived if it is archived',
      unarchiveOrder: 'Unarchive order',
      downloadOrderAuditPdf: 'Download order audit PDF',
      totalWeight: 'Total weight',
      packageNumber: 'Package number',
      pieces: 'pcs',
      deliveryCompanyNames: 'Delivery companies',
      pickupCompanyNames: 'Pickup companies',
      externalReferences: 'External references',
      uits: 'UIT code',
      tasks: 'Tasks',
      task: 'Task',
      statusTooltipForSp: 'The order can only be placed in this status by the customer',
      statusTooltipForCustomer: 'The order can only be placed in this status by the service provider',
      statusRequested: 'The customer has requested a status update for this order!',
      statusHistory: 'History satus',
      statusEnum: {
        sent: 'Sent',
        accepted: 'Accepted',
        rejected: 'Rejected',
        in_progress: 'Planned',
        partially_in_progress: 'Partially planned',
        returned_to_origin: 'Returned to origin',
        partially_returned_to_origin: 'Partially returned to origin',
        in_transit: 'In transit',
        partially_in_transit: 'Partially in transit',
        transit_end: 'Transit end',
        partially_transit_end: 'Partially transit end',
        return_to_origin: 'Return to origin',
        partially_return_to_origin: 'Partially return to origin',
        lost: 'Lost',
        partially_completed: 'Partially delivered',
        mixed: 'Mixed',
        mixed_with_failure: 'Mixed with failure',
        completed: 'Delivered',
        completed_with_failure: 'Incomplete delivery',
        undelivered: 'Undelivered',
        documents_partially_received: 'Documents partially available',
        documents_received: 'Documents available',
        archived: 'Archived',
        cancelled: 'Cancelled',
      },
      statusCommentTitle: 'Add comment (optional)',
      status: 'Status',
      'shipment-tracking': 'The solution on the basis of which the order was resolved',
      serviceProvider: 'Provider',
      sentListTitle: 'Sent orders',
      sendTitle: 'Order sent at',
      sendCustomerOrderEmailAccepted: 'Resend E-Mail Order Accepted',
      savedSuccess: (param) => `Order with number #${param.orderNumber} was successfully saved`,
      resendStatusUpdate: 'Resend status update e-mail',
      resendOrderEmailTooltip: 'Resending the order e-mail can only be done in status 1.',
      resendOrderEmail: 'Resend order e-mail ',
      resendInvoiceUploadInvitationEmail: 'Resend invoice upload email',
      requestStatus: 'Request status update',
      rejectTitle: 'Reject order',
      rejectOrderMessage: 'Are you sure you want to reject this order',
      refuseReason: 'Rejection reason',
      refuseOrder: {
        title: 'Reject order',
        refuseButton: 'Reject',
        mainButton: 'Reject order',
        comments: 'Reason',
      },
      refuse: 'Reject',
      receivedTitle: 'Order received from',
      receivedListTitle: 'Received orders',
      price: 'Price',
      pickups: 'Pickups',
      pickup: 'Pickup',
      orderTrackingTitle: 'Tracking order',
      ordersTrackingTitle: 'Tracking orders',
      ordersTrackingDescription: 'Filter orders in progress or in transit and view them on the map',
      orderStatus: {
        success: 'Success',
        sentSuccessMessage: 'The status update e-mail was sent successfully',
        requestMessage: 'Status update alert has been sent to the vendor',
        lastModifiedByEmployeeName: 'Modified by the employee',
        lastModifiedByEmail: 'Modified by the e-mail ',
        lastModifiedAt: 'Last modified at',
        historyTitle: 'History status',
        comment: 'Comments',
      },
      orderRefuseMessage: 'Order has been rejected',
      orderNumber: 'Order number',
      noOfferFound: 'The order was not created based on an offer',
      'no-preferred-solution': {
        title: 'No preferred solutions',
        body: 'Click on the following button to create a complete solution',
      },
      newTitle: 'New order',
      listTitle: 'Orders',
      invalidStatusTooltip: 'Order cannot be placed in this status',
      'go-to-mrs': 'More details',
      generateInvoices: {
        title: 'Invoice',
        languageWarning: 'Selected language is the one chosen by the customer',
        language: 'Language',
        description:
          'Select orders in the same currency, which do not have invoices issued, for which you want to generate invoices',
        currencyWarning:
          'Selected orders contain more than one currency. Select the currency you want to invoice the selected orders.',
        action: 'Generate invoice',
      },
      exclusiveOrder: 'Exclusive order',
      error: {
        serviceProviderrequired: 'Provider is required',
        noValidContractFound: 'There is no contract valid at the current date for this service!',
        notEqualCustomRegimes: 'The CUSTOMS FLAG must have the same value for all shipments!',
        notEqualCustomDuties: 'The CUSTOMS FLAG must have the same value for all shipments!',
        noProperPriceInterval: 'There is no defined price range for this quantity!',
        moreOrNoneTariffs: 'There are several or no defined tariffs for these areas!',
        isEmptyshipment: 'At least one transport must be added',
        differentTimeLimitError: 'Select orders with the same payment time limit',
        DelServiceProviderNotFoundException: 'There is no contract with a service provider!',
        DeliveryCustomerNotFoundException: 'There is no contract with a service provider!',
        defaultValidationMessage: 'An error has occured! ',
        customerrequired: 'Customer is required',
        requiredVehicleType: 'Vehicle type is required',
      },
      emptyDocuments: 'No documents uploaded',
      emptyCMR: 'No CMR uploaded',
      downloadPdf: 'Download order pdf',
      pdfSignedAndGenerated: 'Pdf generated and signed',
      pdfUnSignedOrNotGenerated: 'The pdf is unsigned or not generated',
      downloadInvoice: 'Download invoice',
      documents: 'Documents',
      details: 'Details',
      delivery: 'Delivery',
      deliveries: 'Deliveries',
      customer: 'Customer',
      createTask: 'Create task',
      createFromExistingOrder: 'Create order from the template',
      createSupplierOrderFromExisting: 'Create supplier order from template',
      create: 'Create order',
      costCenters: 'Cost centers',
      CMR: 'CMR',
      changeStatusInfo: 'To change the status choose a new one from the list above',
      changeShipmentStatus: {
        title: 'Transport status',
        status: 'Status',
        lastModifiedAt: 'At',
        dialog: {
          rejectLabel: 'No',
          message: "Are you sure you want to change your status? Once changed, you can't go back to previous statuses",
          header: 'Change status',
          acceptLabel: 'Yes',
        },
        comments: 'Details',
        actionedByUser: 'Set by',
        achievedAt: 'At',
        error: {
          requiredstatus: 'Status is required',
        },
      },
      cancelOrderForcedButton: 'Forced order cancellation',
      cancelOrderDisabledTooltip: 'There is a cancellation request or the order is not in an appropriate status',
      cancelOrderButton: 'Cancel order',
      cancelOrder: {
        rejectCancelOrder: 'Reject',
        orderCancelled: 'Order cancelled',
        hasCancelRequest: 'This order has a cancel request',
        cancelRequest: 'Cancel request',
        cancelOrderDialog: {
          title: 'Order Cancellation Request',
          forcedWarning:
            'The cancellation will be made without the agreement of the other parties involved. Cancellation will result in penalties according to the Terms and Conditions of Carriage.',
          forced: 'Forced cancellation ',
          details: 'Reason',
          attachments: 'Attachments',
        },
        acceptCancelOrder: 'Accept cancel order',
      },
      calculatePrice: 'Calculate price',
      billingCycleEnum: {
        Weekly: 'Weekly',
        Per_shipment: 'Per shipment',
        Monthly: 'Mothly',
        Manual: 'Manual',
        Bi_monthly: 'Bi-monthly',
      },
      attachments: {
        title: 'Attachments',
        shipments: 'Shipment documents',
        browse: 'Choose',
      },
      archiveOrderTooltip: 'The order can only be archived if it is delivered, canceled or has available documents',
      archiveOrder: 'Archive order',
      addStatusComment: 'Add comment',
      addOrderMessage: 'An order can be sent only if a valid contract exists in the platform.',
      addOrder: 'Add order',
      addPreOrder: 'Add pre-order',
      addSupplierOrder: 'Add supplier order',
      supplierOrderTitle: 'Supplier order',
      supplierOrderEmptyState: '',
      supplierOrderTimeline: {
        prepare: {
          title: 'Prepare request',
          description: 'Gather supplier contract details and confirm availability.',
        },
        submit: {
          title: 'Submit order',
          description: 'Fill in the supplier order form and send it for validation.',
        },
        review: {
          title: 'Track validation',
          description: 'Monitor order status while the supplier reviews the request.',
        },
      },
      supplierOrderTariffCheckboxLabel: 'I want tariff on order',
      supplierOrderTariffCheckboxTooltip: 'Remove shipment tariffs to enable order tariff selection.',
      supplierOrderTariffDescription: 'Tariffs will be negotiated and applied for the whole order.',
      fromParty: 'From (customer)',
      toParty: 'To (vendor)',
      uuid: 'UUID',
      supplierOrderPartiesTitle: 'Order parties',
      supplierOrderPartiesDescription: 'Confirm who places the order and who fulfills it.',
      validation: {
        minShipments: 'At least one shipment is required.',
        maxPackagePieces: 'Total package pieces ({{current}}) exceeds the maximum allowed ({{max}}).',
        shipmentsMinLengthShipmentsCount: 'At least one shipment is required.',
      },
      add: 'Add order',
      accountPaymentTimeLimitTooltip: 'Payment term set by the vendor',
      preorderTooltip: "This is a preorder, it's content will be updated.",
      preorder: {
        title: 'Preorder',
        description: "This is a preorder, it's content will be updated with data from the official order.",
      },
      acceptOrder: {
        title: 'Accept order',
        mainButton: 'Accept order',
        bodyMessage: 'Are you sure you want to accept the order?',
        acceptButton: 'Accept',
      },
      acceptAndCreate: 'Accept and send order',
      accept: 'Accept',
      courierDispatchDetails: 'Courier dispatch details',
      courierMasterTrackingNumber: 'Shipment Master Tracking Number',
      courierPackageTrackingNumbers: 'Tracking Numbers per package',
      courierCreateShipmentError: 'Shipment creation failed!',
      courierCreatePickupError: 'Pickup request failed!',
      courierPickupConfirmationCode: 'Pickup confirmation code',
      orderPaymentParty: {
        title: 'Payment details',
        paymentType: 'Responsible for payment',
        paymentTypes: {
          SENDER: 'Sender',
          RECIPIENT: 'Recipient',
          THIRD_PARTY: 'Third party',
        },
        accountNumber: 'Payer account number',
        countryCode: "Account's country",
        postalCode: "Account's postal code",
        sendOrder: 'Send order',
        saveAndSendOrder: 'Save and send order',
        seeAccountNumber: 'See account number',
        editAccountNumber: 'Edit account number',
        error: {
          requiredPaymentType: 'Responsible for payment is mandatory',
          requiredPayerAccountNumber: "Payer's ccount number is mandatory",
          requiredCountryCode: "Account's country is mandatory",
          requiredPostalCode: "Account's postal code is mandatory",
        },
      },
      tradeDocument: {
        documentNumber: 'Document number',
        issuedOn: 'Issued on',
        error: {
          requiredDocumentNumber: "The field 'Document number' is mandatory",
          requiredIssuedOn: "The field 'Issued on' is mandatory",
        },
      },
      incoterm: {
        label: 'Incoterm',
        values: {
          EXW: 'Ex Works (EXW)',
          DDP: 'Delivered Duty Paid (DDP)',
          DDU: 'Delivered Duty Unpaid (DDU)',
        },
        error: {
          requiredIncoterm: "The field 'Incoterm' is mandatory",
        },
      },
      commercialInvoice: 'Commercial Invoice',
      etdLabel: 'Attach commercial invoice electronically (recommended)',
      etdTooltip: 'A commercial invoice is required for shipments outside the European Union',
      commercialInvoiceRequired:
        'The upload of commercial invoice is required if you choose to attach it electronically',
      orderShipperParty: {
        title: 'Shipper details',
        accountNumber: 'Shipper account number',
        error: {
          requiredShipperAccountNumber: "Shipper's account number is mandatory",
        },
      },
      orderShipperAndPaymentPartiesPopup: {
        title: 'Additional Shipment Informations',
        accountNumber: {
          PAYMENT_PARTY: 'Numar cont platitor',
          SHIPPER_PARTY: 'Numar cont transportator',
        },
        shouldAddUploadTradeDocumentCredentials:
          'To upload documents electronically, it is necessary to enter the credentials for uploading documents intended for the FedEx courier.',
      },
      trackPackage: 'Track package with AWB ',
      downloadMergedLabel: 'Download labels',
      downloadLabel: 'Download label',
      verifyStatus: 'Verify status',
      latestScanLocation: 'Most recent location',
      latestStatus: 'Most recent status',
      noTrackingDetails: 'There are no tracking details right now!',
      latestAncillaryDetail: 'Ancillary Details',
      latestAncillaryDetailReason: 'Reason',
      latestAncillaryDetailAction: 'Action',
      latestServiceCommitMessage: 'Service Commit Message',
      previousActions: 'Previous actions',
      retryCreatingShipmentAndPickup: 'Retry creating shipment and pickup',
      successfullyCancelledCourierOrderShipment: 'Successfully cancelled dispatch!',
      successfullyCancelledCourierOrderPickup: 'Successfully cancelled pickup!',
      downloadProofOfDelivery: 'Download proof of delivery',
      seeStatus: 'See status',
      customerOrderTerminalReservations: 'Warehouse reservations',
    },
    offerSummary: {
      transitTime: 'Transit time',
      carType: 'Vehicle type',
    },
    offerRequest: {
      preOfferRequestTooltip:
        'This is a pre offer request, this will be hidden once the order created from this will be linked to a parent order.',
      preOfferRequest: {
        title: 'Pre offer request',
        description: 'This will be hidden once the order created from this will be linked to a parent order.',
      },
      wizard: {
        stepTwo: 'Shipments',
        stepThree: 'Summary ',
        stepOne: 'Details',
      },
      vendorContacts: (param) => `Vendor contacts (${param.companyName})`,
      externalVendorsQuestion: 'Do you want to ship with courier companies?',
      unavailableOfferRequest: 'The offer request is not in an appropriate status for this action',
      to: 'To',
      templates: 'Templates',
      suppliers: 'Service providers',
      statusReject: 'Reject status',
      status: 'Status',
      spOfferRequestTitle: 'Offer request received',
      shipments: 'Shipments',
      shipmentDetails: {
        value: 'Value',
        stackable: 'Stackable',
        singleCar: 'Exclusive shipment',
        type: 'Tip',
        service: 'Service',
        invalid: 'Missing dates! Click to add missing data!',
        budget: 'Budget',
      },
      shipment: 'Shipment',
      serviceType: 'Service',
      serviceProviders: 'Service providers',
      sentNotifications: 'See notifications sent for this request',
      saveAndSend: 'Save and Send',
      save: 'Save',
      resolve: 'Solve',
      resendOfferRequestEmail: 'Resend e-mail with offer request',
      resendOfferRequestCancelledEmail: 'Resend e-mail with cancellation of offer request',
      requestStatus: {
        sent: 'Sent',
        rejected: 'Rejected',
        received: 'Received ',
        offers_received: 'Available offers',
        offer_accepted: 'Accepted',
        in_progress: 'In progress',
        completed: 'Completed',
        cancelled: 'Canceled',
        archived: 'Archived',
      },
      rejectStatus: {
        rejected_terms_and_conditions: 'Terms & Conditions rejected',
        lost_price: 'Price',
        lost_offer_late: 'Late offer',
        lost_no_solution: 'No solution',
        lost_no_feedback: 'No feedback',
        lost_improper_sol: 'Improper solution ',
        lost_blocked: 'Blocked',
      },
      pickups: 'Pick up point',
      pickup: 'Pick up point',
      paymentTimeLimitWarning: 'There are vendors with different payment terms',
      paymentTimeLimit: 'Payment time limit',
      deliveryCompanyNames: 'Delivery companies',
      pickupCompanyNames: 'Pickup companies',
      offerStatus: {
        offer_sent: 'Sent',
        offer_received: 'Received',
        offer_not_sent: 'Not sent',
        offer_accepted: 'Accepted',
        no_offer: 'Missing request',
      },
      offers: 'Offers',
      courierErrorRates: 'Courier errors',
      correctOfferRequest: 'Correct offer request',
      seeOfferRequestCourierSuccessRateResponses:
        'See the successful response returned by the rates and transit times API',
      offerRequestCourierSuccessRateResponses: 'Successful response returned by the rates and transit times API',
      offerRequestTitle: 'Offer request sent',
      offerRequestSentTo: 'Offer request sent to',
      offerRequestNumber: 'Number',
      offerRequestDetailsTitle: 'Details of the offer request sent',
      offerNotAccepted: 'Not accepted',
      offerAccepted: 'Accepted',
      noOffers: 'No offers for current demand!',
      noContactsChosen: 'No contact chosen',
      newOffer: 'Add offer',
      negotiateTitle: 'Negociation',
      negotiateBody: 'This offer can be negotiated later by the customer, with the possibility to request a new offer.',
      moreDetails: 'More details',
      minimumOfferTimeAvailability: 'Minimum validity of offers',
      list: {
        title: 'Offer request',
        spOfferStatusType: {
          offer_sent: 'Sent offers',
          offer_not_sent: 'Not sent offers',
          offer_accepted: 'Offers accepted',
        },
        spOfferRequestStatusType: {
          received: 'Received',
          offer_accepted: 'Accepted',
          in_progress: 'In progress',
          cancelled: 'Cancelled',
        },
        spOfferRequestRejectStatusType: {
          rejected_terms_and_conditions: 'Terms & Conditions rejected',
          lost_price: 'Lost price',
          lost_offer_late: 'Offer late',
          lost_no_solution: 'No solution',
          lost_no_feedback: 'No feedback',
          lost_improper_sol: 'Improper solution',
          lost_blocked: 'Lost blocked',
        },
        serviceProviders: 'Service provicer',
        search: 'Search',
        requestStatus: 'Request status',
        requestedAt: 'Requested at ',
        requestBy: 'Customer',
        rejectStatus: 'Reject status',
        paymentTimeLimit: 'Payment time limit',
        offerStatusType: {
          offer_received: 'With offers',
          offer_accepted: 'Accepted',
          no_offer: 'Without offers',
        },
        offerStatus: 'Request status ',
        offerRequestStatusType: {
          sent: 'Sent',
          offer_accepted: 'Accepted',
          cancelled: 'Cancelled',
        },
      },
      hideDetails: 'Hide details',
      from: 'From',
      form: {
        invalidShipments: 'Missing valid transport data. Click on transports marked in red to update data!',
        handoverChangeWarning: 'Make sure that the pick-up, drop-off intervals are correct',
      },
      error: {
        requiredPieces: 'Number of packages is required',
        requiredHeight: 'Height is required',
        requiredWidth: 'Width is required',
        requiredLength: 'Length is required',
        requiredWeight: 'Weight is required',
        widthRequired: 'Width is required',
        weightRequired: 'Weight is required',
        selectedDateAfterCurrentDate: 'Deadline must be greater than the current date',
        requireddeadline: 'Deadline is required',
        requiredCustomerVO: 'Customer is required',
        requiredaddress: 'Address is required',
        piecesRequired: 'Number of packages is required',
        packageLimitExceeded: 'Number of packages per transaction cannot exceed 200',
        NullPointerException: 'An error has occured. ',
        lengthRequired: 'Length is required',
        isEmptyvendors: 'You must select at least one vendor',
        isEmptypackage: 'At least one package must exist',
        heightRequired: 'Height is required',
        minLength: 'The length must be at least 1 cm',
        minWeight: 'The weight must be at least 1 kg',
        greaterThanWeight: 'The weight must be greater than 0 kg',
        minPieces: 'The package number must be at least 1',
        maxPieces: (value: { max: number; actual: number }) => 'The package number should not exceed ' + value.max,
        minWidth: 'The width must be at least 1 cm',
        minHeight: 'The height must be at least 1 cm',
        arrayItemsFieldhasContactsNotEqualTo:
          'Vendors who had no contacts to whom they could e-mail the offer request, were selected. Their contacts must have a valid e-mail address, receive requests, their contact method must be e-mail and their visibility must be one of the following values - Customer, Public or Both.',
      },
      dispatcher: 'Dispatcher',
      disabledAddCompleteOfferTooltip: (isEmailAuth) => {
        if (isEmailAuth) {
          return '';
        }
        return 'You need to have a preferred complete solution!';
      },
      details: 'Details',
      detail: {
        width: 'Width',
        weight: 'Weight',
        vehicleType: 'Vehicle type',
        type: 'Type',
        transitPeriod: 'Transit time',
        tags: 'Tags',
        status: 'Status',
        stackable: 'Stackable',
        spName: 'Name',
        serviceProvidersTitle: 'Service providers ',
        sendAt: 'Send at',
        search: 'Search',
        reject: 'Cancel',
        priceValue: 'Price',
        postalCode: 'Postal code',
        pieces: 'Pieces',
        pickupLocations: 'Pick up location',
        pickup: 'Pick up location',
        paymentTimeLimit: 'Payment time limit',
        pageTitle: 'Offer request detail ',
        packages: 'Packages',
        offerTitle: 'Offers',
        offersTitle: 'Offers',
        offerRequestTitle: 'Offer request',
        offerRequestStatus: {
          sent: 'Sent',
          offers_received: 'Received offers',
          offer_accepted: 'Accepted offer',
          completed: 'Completed',
          cancelled: 'Closed',
        },
        name: 'Name',
        locked: 'Locked',
        licensePlate: 'License plate',
        length: 'Length',
        height: 'Height',
        driverName: 'Driver name',
        deliveryLocations: 'Delivery location',
        delivery: 'Delivery location ',
        deadline: 'Deadline',
        customerOfferStatuses: {
          offer_received: 'Offer received',
          offer_accepted: 'Accepted offer',
          no_offer: 'No offer',
        },
        customerOfferStatus: 'Status of the offer received from the vendor',
        currency: 'Currency',
        createOrderTooltip: 'Create order',
        contactPhone: 'Phone number ',
        comments: 'Comments',
        cargoValue: 'Cargo value',
        budget: 'Budget',
        address: 'Address',
        acceptTooltip: 'Accept order',
      },
      description: 'Description',
      delivery: 'Delivery point',
      deliveries: 'Delivery point ',
      deadline: 'Deadline',
      customerContacts: (param) => `Customer contacts (${param.companyName})`,
      customer: 'Customer',
      createOfferRequestFromDraft: 'Create offer request from template',
      createFromExisting: 'Create offer request from template',
      confirmationDialog: {
        header: 'Confirmation',
        body: 'After confirmation, the entered data cannot be edited!',
      },
      cancelRequest: 'Cancel request',
      cancelReason: 'Cancellation reason ',
      cancelOfferRequest: 'Cancel offer request',
      cancelledOfferRequest: 'Offer request cancelled',
      bindingTitle: 'irrevocable',
      binding: 'Binding',
      addCompleteOfferTooltip: 'Create a complete offer from a complete solution',
      addCompleteOffer: 'Complete offer',
      add: 'Add offer request',
    },
    offerCreation: {
      totalCost: 'Total cost',
      shipments: 'Vendors',
      serviceProviders: 'Partner vendors',
      sendOffer: 'Send offer',
      routingSolutions: 'Transport solutions',
      requiredRoutingSolution: 'At least one routing solution must be chosen!',
      requestDate: 'Request date',
      offersPreview: 'Offers preview',
      groups: 'Groups',
      deadline: 'Deadline',
      createOffer: 'Create offer',
    },
    offerChat: {
      textInput: 'Type a message...',
      systemMessage: {
        username: 'System',
        content: {
          sp_closed: 'A new offer has been created',
          customer_closed: 'The client agrees to the negotiated terms',
          closed: 'Negotiation is over',
        },
      },
      offerLoading: 'Offer is loading...',
      navigateToOfferRequestTooltip: 'Navigate to the offer request',
      confirmationDialog: {
        confirmHeader: 'Confirmation',
        acceptConfirm: 'Do you agree to the terms discussed?',
      },
      chatThreadTitle: 'Negociation ',
      basedOnOffer: 'Based on the offer of ',
      actionBar: {
        createOffer: 'Offer',
      },
    },
    offer: {
      vehicleType: 'Vehicle type',
      vehicle: 'Vehicle',
      updateVehicle: 'Update vehicle',
      transitDays: 'Transit days',
      totalCostWarning: 'The total cost of the offer is',
      timeAvailability: 'Available',
      text: 'Offer',
      termsAndConditionsTooltip: 'Terms and Conditions',
      termsAndConditionsStep: {
        offerRequestTermsAndConditions: 'Terms and conditions received on request for offer',
      },
      termsAndConditionsDisabledTooltip: 'No Terms & Conditions',
      steps: {
        termsAndConditions: 'Terms & Conditions',
        offer: 'Offer',
        masterRoutingSolutions: 'Solutions',
        completeOffer: 'Complete offer',
      },
      shipmentList: 'Shipment requested ',
      selectRoutingSolutionsHeader: 'Select one or more shipment solutions',
      selectMasterRoutingSolution: 'Select a solution ',
      masterRoutingSolutions: {
        disabledMasterRoutingSolution: 'The solution is not available due to its split solution is not locked in.',
      },
      savedSuccess: (param) =>
        `Offer worth ${param.offerPrice.value} ${param.offerPrice.currencyCode} with series ${param.offerSeries} sent in the application  #${param.offerRequestNumber} for the customer ${param.offerCustomer} was successfully saved`,
      save: 'Add offer',
      resendOfferEmail: 'Resend email with offer created',
      resendOffer: 'Resend offer',
      refuseReason: 'Refusal reason',
      refuseOffer: 'Reject offer',
      price: 'Price',
      pickupTimeWindowStart: 'Pickup from',
      pickupTimeWindowEnd: 'Pickup until',
      paymentTimeLimit: 'Payment time limit',
      offerRefused: 'The offer was refused!',
      offerPopupTitle: 'New offer',
      offerContacts: 'Offer contacts',
      offerAccepted: 'Offer accepted',
      noOffers: 'There are currently no offers',
      newSolution: {
        title: 'Create new solution',
        description:
          'You are not happy with the existing solutions. Click on the button below to create a new solution, and start the process from the beginning.',
      },
      minPaymentTimeLimit: 'Minimum payment term from solution segments',
      minOfferTimeAvailability: 'Minimum validity of the offer is',
      masterRoutingSolution: 'Solution',
      licensePlate: 'License plate',
      vehicleAndDriverData: 'Vehicle and driver',
      label: 'Tag',
      hasConflictsTooltip: 'The offer contains modified data compared to the request for offer',
      hasConflictsMessage:
        'The offer contains modified data compared to the request for offer. Are you sure you want to continue?',
      expired: 'Offer has expired!',
      error: {
        requiredRefuseReason: 'The reason for refusal is required',
        requiredPrice: 'The Price is required',
        detailsrequired: 'Details are required!',
      },
      driverName: 'Drive name',
      driver: 'Driver',
      directOffer: {
        title: 'Direct Offer',
        description: 'Add offer without solution',
      },
      details: 'Details',
      deliveryTimeWindowStart: 'Delivery from ',
      deliveryTimeWindowEnd: 'Delivery until',
      customer: 'Customer',
      currency: 'Currency',
      createdBy: 'Created by',
      createCompleteOffer: (param) =>
        param.offerRequestNumber ? `Respond to the offer request no. ${param.offerRequestNumber}` : 'Respond',
      contactPhone: 'Phone number',
      completeOffer: {
        'form-title': 'Complete new offer',
        'enable-complete-solution-details': 'View Full Solution Details',
        'complete-solution-details': {
          title: 'Full Solution Details',
        },
        'close-complete-solution-details': 'Close Full Solution Details',
      },
      changesFromOfferRequest: 'Changes in relation to the request for offer',
      binding: 'Binding',
      baseOffer: 'Base offer',
      basedOn: 'Offer',
      amendmentStep: {
        termsAndConditionsNotFound: 'No Terms & Conditions',
        offerTermsAndConditions: 'Terms and conditions to be sent with the offer',
        offerRequestTermsAndConditions: 'Terms and conditions received on request for offer',
      },
      amendment: 'Amendment',
      alreadyAcceptedAnotherOffer: 'Another offer has already been accepted!',
      acceptOfferAndCreateOrder: 'Accept and send order',
      acceptedOffer: 'Offer accepted! ',
      deliveredBy: 'Delivery by ',
      deliveredBetween: 'Delivery between ',
    },
    'offer-request': {
      savedSuccess: (param) => {
        return `Offer request with number #${param.offerRequestNumber} was successfully saved`;
      },
      new: {
        titleServiceProvider: 'Add offer request received from customer',
        titleCustomer: 'Send offer request to vendor',
        titleCustomerSubcontracting: 'Subcontract with a offer request',
        titleCustomerPre: 'Send pre-offer request to vendor',
        titleCustomerPreSubcontracting: 'Subcontract with a pre-offer request',
      },
      list: {
        sentTitle: 'Offer requests sent',
        receivedTitle: 'Offer requests received',
        addNew: 'Add',
      },
    },
    'navigation-suggestions': {
      shipmentGroupSolution: 'Solution details',
      orderDetails: 'Order details',
      offerRequestDetails: 'Offer request details',
      back: {
        workspace: 'Back to Workspace',
        undefined: 'Back ',
        subcontracting: 'Back ',
        'sp-order-list': 'Back to Received Orders',
        'sp-offer-request-list': 'Back to received Offer Request ',
        outbox: 'Back to Outbox',
        'offer-request-details': 'Back to Offer Request details',
        inbox: 'Back to Inbox',
        'customer-shipment-template': 'Back to Shipment',
        'customer-order-list': 'Back to Sent Orders',
        'customer-offer-request-list': 'Back to sent Offer Request ',
      },
    },
    menu: {
      workspace: 'Workspace',
      warehouse: 'Warehouse',
      warehouseTerminals: 'Terminals',
      warehouseReservations: 'Appointments',
      vendorDrafts: 'Vendor partners',
      vendor: 'Vendor partners',
      courier: 'Couriers',
      vehicle: 'Vehicles',
      transportProject: 'Transport Projects',
      tariffs: 'Tariffs',
      standardPackageDimensions: 'Standard package',
      nomenclatureList: 'Product nomenclature',
      spInvoicePayments: 'Receipts',
      shipmentTracking: 'Shipment tracking',
      packageTracking: 'Package tracking',
      shipmentGroups: 'Shipment groups',
      services: 'Services',
      scheduledShipments: 'Scheduled shipments',
      routes: 'Routes',
      orderSent: 'Sent',
      orderReceived: 'Received',
      order: 'Orders',
      offerRequestSent: 'Sent',
      offerRequestReceived: 'Received',
      offerRequestEmails: 'E-mails',
      offerRequest: 'Offer requests',
      invoicesSent: 'Sent invoices',
      financial: 'Financial',
      invoices: 'Invoices',
      invoiceAssociation: 'Invoice Association',
      'invoice-payments': 'Invoice payments',
      employeeAssignment: 'Assign planner',
      driver: 'Drivers',
      drafts: 'Shipments templates',
      dispatcher: 'Dispatcher',
      taskList: 'Dispatcher Shipments',
      details: 'Details',
      'delivery-outbox': 'Outbox',
      'delivery-inbox': 'Inbox',
      customerList: 'Customer list',
      customerInvoices: 'Received invoices',
      eFacturi: 'eFacturi',
      anafMessages: 'ANAF Messages',
      customerInvoicePayments: 'Payments',
      customerDrafts: 'Customers',
      costs: 'Costs',
      costCenters: 'Cost centers',
      contractResponse: 'Contracts with clients',
      contractRequest: 'Contracts with vendors',
      contract: 'Contracts',
      contacts: 'Contacts',
      complaint: 'Complaints',
      cashFlow: 'Cash flow',
      budgetManagement: 'Budget',
      addresses: 'Addresses',
      'address-templates': 'Address templates',
      account: 'Accounts',
      collaboration: 'Collaboration',
      collaborationShipments: 'Shipments',
      eTransportDeclarant: 'Declarant',
      eTransportOrganizer: 'Organizer',
      eTransportAnafMessages: 'ANAF Messages',
      eTransportActions: 'Actions',
      namedLocation: 'Locations',
      ownershipRequest: 'Location requests',
      operationalTerritory: 'Territories',
      externalMappings: 'External references',
      shipmentManagement: 'Shipment management',
      fleet: 'Fleet',
      imports: 'Imports',
      ediImport: 'EDIFACT',
      driverExpense: 'Driver Expenses',
      driverTimesheet: 'Timesheet',
      supplierDelegation: 'Tariffs delegations',
    },
    invoicePreview: {
      vatDescriptions: {
        RO_XR: 'Transaction exempt from VAT cf. Art. 144 dir. European VAT',
        RO_ST: 'Standard VAT',
        RO_0R: 'Transaction exempt from VAT cf. cod. Fiscal',
        RO_AE: 'Reverse charge',
        RO_K: 'VAT exempt for EEA intra-community supply of goods and services',
        RO_G: 'Free export item, tax not charged',
        RO_O: 'Service outside scope of tax',
        RO_E: 'Exempt from tax',
      },
      vatCode: 'VAT Code',
      vat: 'VAT',
      exemptionReason: 'Exemption Reason',
      totalNet: 'Total net',
      total: 'Total',
      tooltips: {
        deleteService: 'Delete service',
      },
      swiftCode: 'Swift',
      storno: 'Storno Serious Invoice ',
      shipTo: 'Ship to',
      shipNumber: 'Shipment number',
      serviceProviderDetails: 'Service provider details',
      serviceProvider: 'Service provider',
      service: 'Service',
      series: 'Series and invoice number',
      senderAndReceiver: 'Sender / Receiver',
      registrationCode: 'Registration number',
      phone: 'Phone number',
      paymentTimeLimit: 'Payment time limit',
      paymentDueDate: 'Payment due date',
      orderNumber: 'order number',
      operationType: 'Operation type',
      net: 'Net',
      licensePlate: 'Vehicle number',
      issueDate: 'Invoice date',
      invoiceTitle: 'INVOICE',
      fromDate: 'from date',
      exchangeWarning: {
        title: 'Currency rate older than one day',
        description:
          'One or more currency courses are more than one day old. You can change any of these to the desired exchange rate.',
      },
      email: 'E-mail',
      date: 'Date',
      customerBankAccounts: 'Customer bank accounts',
      costCenter: 'Cost center',
      correspondenceAddress: 'Correspondence address',
      companyLocation: 'Headquarters',
      comment: 'Comments',
      billTo: 'Bill to',
      billingAddress: 'Billind address',
      bankNo: (param) => (param.currencyCode ? `Account (${param.currencyCode})` : 'Account'),
      bankName: 'Bank ',
      bankAccounts: 'Bank accounts',
      accounting: 'Accounting',
    },
    invoice: {
      vatRate: 'VAT code',
      exemptionReason: 'ExemptionReason',
      vat: 'VAT',
      updateAndPreview: 'Update and preview',
      unselectAll: 'Unselect all invoices',
      totalPrice: 'Total price',
      showInvoicePDF: 'Show invoice',
      serviceProviderName: 'Service provider name',
      sentOrdersDropdownDisabledMessage: 'You must select a service provider and a currency',
      selectedInvoices: 'Selected invoices',
      selectCancelable: 'Choose the invoice to be cancelled',
      selectEfactura: 'It is necessary to choose an eFactura because both companies are from Romania',
      report: {
        infoText: (params) => {
          const invoiceSeries = params.invoiceSeries;
          if (invoiceSeries && invoiceSeries.length > 1) {
            const formattedInvoiceSeries = invoiceSeries
              .map((series: any, index: any) => `${index + 1}.${series}`)
              .join(', ');
            return `Generate a report for the invoices with the series ${formattedInvoiceSeries}`;
          }
          return `Generate a report for the invoice with the serie ${invoiceSeries[0]}`;
        },
        generateReportSuggestion: 'Choose a currency, then select sent and unpaid invoices',
        generateReport: 'Generate report',
        fromBankAccount: 'Account from which payment is made',
        excel: {
          toBankAccountListSummary: 'Account Destination',
          serviceProviderName: 'Beneficiary',
          lineCount: 'Details 2',
          invoiceSeries: 'Details 1',
          fromBankAccount: 'Source account',
          currencyCode: 'Currency',
          amountToPay: 'Amount',
        },
        errors: {
          requiredFromBankAccountUuid: "The field  'Account from which payment' is made is required",
        },
      },
      refuseReasonPlaceholder: 'Reason',
      refuseInvoice: 'Reject invoice',
      receivedTitle: 'Invoices received',
      receivedOrdersDropdownDisabledMessage: 'You must select a client and a currency',
      paymentTimeLimit: 'Payment time limit',
      paymentStatuses: {
        UNPAID: 'Unpaid',
        PARTIAL_PAID: 'Partially paid',
        PAID: 'Paid',
      },
      externalInvoiceTypes: {
        ISSUED: 'Issued',
        STORNO: 'Storno',
      },
      invoiceTypes: {
        ISSUED: 'Issued',
        STORNO: 'Storno',
        CANCELLED: 'Cancelled',
      },
      invoiceType: 'Invoice type',
      paymentStatus: 'Payment status',
      paymentDueDate: 'Due date',
      payment: {
        title: 'Add payment',
        'service-provider-suggestion':
          'Choose a currency, then select invoices, sent, unpaid, with the same customer and currency',
        'selected-order-tooltip': 'Order number of the selected invoice',
        'customer-suggestion':
          'Choose a currency, then select invoices, received, unpaid, with the same supplier and currency',
        'add-receipt': 'Add receipt',
        'add-payment': 'Add payment',
      },
      ordersTotalCost: 'Orders total cost',
      association: {
        orderNumber: 'Order number',
        awb: 'AWB',
        orderDate: 'Order date',
        invoiceSeries: 'Invoice series',
        pickupNamedLocationLabel: 'Pickup location',
        pickupAddress: 'Pickup address',
        deliveryNamedLocationLabel: 'Delivery location',
        deliveryAddress: 'Delivery address',
        requestingCompanyName: 'Requesting company',
        courierName: 'Courier',
        orderPriceWithoutVat: 'Order value (net)',
        invoicePriceWithoutVat: 'Invoice value (net)',
        balance: 'Balance',
        issueDate: 'Issue date',
        createdAt: 'Created at',
        orderCurrencyCode: 'Order currency',
        invoiceCurrencyCode: 'Invoice currency',
        paymentTimeLimit: 'Payment term',
        paymentDueDate: 'Due date',
      },
      seeInvoices: 'View invoices',
      downloadInvoices: 'Download invoices',
      ordersPaymentTimeLimit: 'Order payment terms',
      orderContacts: 'Contacts from orders',
      numberLTFilter: 'Upper limit',
      numberGTFilter: 'Lower limit',
      newTitle: 'Invoice details',
      newService: 'Add extra service per order',
      newInvoiceStartDate: 'New start date of the due date',
      newDueDate: 'New payment deadline',
      netPrice: 'Net price',
      list: {
        tooltips: {
          warningTooltip: 'Prices and/or payment terms differ',
          systemInvoice: 'Invoice issued by platform',
          externalInvoice: 'Invoice issued external',
          download: 'Download invoice',
          downloadConfirmation: 'Download confirmation',
          disabledStorno: 'Disabled storno as long as the invoice is not finalised',
          disabledSendByEmail:
            'Sending e-mail is not possible as long as the invoice is not finalized or if it has not been generated by the system.',
          disabledEfacturaDownload:
            'The invoice must be synchronized with ANAF before it is possible to download the PDF.',
          disabledMarkAsPaid: 'Marking as paid is not possible as long as the invoice is not finalised',
        },
        storno: 'Storno invoice',
        split: 'Instalment',
        sendInvoiceToAnaf: 'Send invoice to ANAF',
        resendInvoiceToAnaf: 'Resend invoice to ANAF',
        paid: 'Mark as cashed',
        newReceipt: 'New cashing',
        newPaymentTooltip: 'This invoice is paid',
        newPayment: 'New payment',
        invoiceItemWarningLegend: 'Invoice data does not match the data on the orders',
        invoiceItemRejectLegend: 'Rejected invoice',
        invoiceItemAnafErrorsLegend: 'ANAF errors',
        invoiceItemStornoLegend: 'Storno invoice',
        anafErrorInvoices: 'Invoices with anaf errors in current month',
        waitingForTaxProcCompletionInvoices: 'Invoices with anaf process not finalized in current month',
        waitingForTaxSubmissionInvoices: 'Unsent to anaf invoices in current month',
        edit: 'Edit invoice',
        details: 'Invoice details',
        customerPaid: 'Mark as paid',
      },
      issuedTitle: 'Invoices issued',
      issueDate: 'Issue date',
      invoiceStatuses: {
        REJECTED: 'Rejected',
        PENDING: 'Pending',
        NOT_FINALIZED: 'Not sent',
        AWAITING_TAX_SUBMISSION: 'Awaiting tax submission',
        AWAITING_TAX_PROC_COMPLETION: 'Awaiting tax process completion',
        TAX_PROC_VALIDATION_FAILURE: 'Failed tax process validation',
        FINALIZED: 'Sent',
      },
      invoiceStatus: 'Invoice status',
      invoiceSeries: 'Series and invoice number',
      orderNumber: 'Order number',
      invoicedOrders: 'Invoiced orders',
      invoicedOrdersTooltip: 'Only invoiced orders are displayed',
      allOrders: 'Orders',
      allOrdersTooltip: 'All orders are displayed',
      invoiceDateHistory: 'History of due date changes',
      introducedAt: 'Introduced at',
      generate: 'Generate invoice',
      finalPaymentDueDate: 'Due date set',
      filters: {
        statusPending: 'Pending invoices',
        paymentDueDateExpired: 'Due date expired',
        awaitingTaxSubmission: 'Unsent to anaf in current month',
        anafInvoiceStatusErrors: 'Anaf errors in current month',
        awaitingTaxProcCompletion: 'Anaf process not finalized in current month',
        paymentDueDateAlmostExpired: 'Due date almost expired ',
      },
      errors: {
        totalShipmentPriceError: 'The sum of the net shipment prices does not agree with the net order total',
        SingleCompanyContactsSelectedException: 'You have not selected contacts for both companies',
        InvalidOrderCurrencyCodesException:
          'You can select orders in at most one other currency besides the one of the invoice ',
        invalidInvoiceTypeSelection:
          'The simultaneous selection of issued/cancelled invoices and storno ones is not allowed.',
        shipmentPriceError: 'Sum of net shipment prices exceeds net order total',
        requiredVendor: "The 'Service provider name' field is required!",
        requiredVatRate: "The 'VAT Code' field is required!",
        requiredExemptionReason: "The 'Exemption reason' field is required!",
        requiredTotalVATAmount: "The 'VAT' field is required!",
        requiredTotalNetAmount: "The 'Net price' field is required!",
        requiredTotalAmount: "The 'Total price' field is required!",
        requiredSecondaryTotalVATAmount: "The 'VAT' field is required!",
        requiredSecondaryTotalNetAmount: "The 'Net price' field is required!",
        requiredSecondaryTotalAmount: "The 'Total price' field is required!",
        requiredSecondaryCurrencyCode: "The 'Currency' field is required!",
        requiredPaymentTimeLimit: "The 'Payment Term' field is required!",
        requiredPaymentStatus: "The 'Payment status' field is required!",
        requiredInvoiceType: "The 'Invoice type' field is required!",
        requiredPaymentDueDate: "The 'Due date' field is required!",
        requiredLanguage: 'You must select language in order to send the invoice!',
        requiredIssueDate: "The 'Issue date' field is required!",
        requiredInvoiceStatus: "The 'Invoice Status' field is required!",
        requiredInvoiceSeries: "The 'Invoice series' field is required!",
        requiredInvoiceExternalSPOrderDTOs: "The 'Invoiced orders' field is required!",
        requiredCurrencyCode: "The 'Currency' field is required!",
        requiredInvoiceExchangeRate: 'Currency exchange is required!',
        requiredContactsFromBothCompanies: 'Contacts from both companies are required',
        requiredClient: "The 'Name' field is required! ",
        requiredCanceledInvoice: "The 'Canceled invoice' field is required!",
        requiredServiceName: "The 'Additional service description' field is required!",
        requiredTotalNetPrice: "The 'Service cost' field is required!",
        minTotalNetPrice: "The 'Service cost' field is required!",
        noOrders: 'You have not selected any order',
        multiplePaymentTimeLimitValidationError: 'Only orders with the same payment term should be selected',
        isEmptyAttachments: 'The Upload invoice field is required!',
        invoicesValidationError: 'You must select only unbilled orders',
        invalidPaymentTimeLimitValidationError: 'Payment term cannot be 0',
        differentTimeLimitErrorInvoiceExternalSPOrderDTOs: 'Select orders with the same payment time limit',
        customersValidationError: 'You must select only orders from the same customer',
        currenciesValidationError: 'Selected orders contain too many types of currencies',
        accountsValidationError: 'You only need to select orders with the same account',
        accountsLengthValidationError: 'An account must be selected for each order',
      },
      error: {
        requiredNewInvoiceStartDate: "The 'New Start Date' field is required!",
      },
      EFacturaStatusTitle: 'ANAF eFactura status',
      editTitle: 'Edit invoice',
      editExternalInvoice: 'Edit invoice',
      downloadEFacturaZip: 'Download eFactura ZIP',
      downloadEFacturaPdf: 'Download eFactura PDF',
      download: 'Download',
      detailTitle: 'Invoice details',
      deleteSecondaryCurrencyValues: 'Delete secondary currency',
      dateOfChange: 'Date of change',
      dateLTFilter: 'End time',
      dateGTFilter: 'Start date',
      customPaymentDialog: {
        title: 'Select date of instalment',
        setCustomPaymentDate: 'Instalment',
        errors: {
          requiredAgreedPaymentDate: 'Select date of instalment',
        },
        customPaymentDate: 'Date of instalment',
      },
      customPaymentDate: 'Date of instalment',
      customPaymentAgreement: 'Installment payment',
      customerName: 'Customer name',
      customDutyTypes: {
        DUTIES_NOT_APPLICABLE: 'Duties not applicable',
        DUTIES_APPLICABLE: 'Duties applicable',
      },
      currencyCode: 'Currency',
      createdBy: 'Username',
      createdAt: 'Change date',
      contactsDropdownDisabledMessage: 'You must select at least one order',
      contacts: 'Contacts',
      confirmExternalCancel: 'Are you sure you want to cancel this invoice? This action is irreversible!',
      comment: 'Comments',
      clientContacts: 'Customer contacts',
      checkEFacturaStatus: 'Check eFactura status',
      changeInvoiceStartDate: 'Change the start date of the due date',
      cancelInvoice: 'Cancel invoice',
      balance: 'Balance',
      author: 'Author',
      attachments: 'Attachments',
      anafInvoiceStatusMessage: {
        UPLOAD_SUCCESS: 'The invoice was successfully sent to ANAF. Check the status of the invoice.',
        UNSENT: 'The invoice has not been sent to ANAF.',
        UNCHECKED:
          'The invoice status  has not been checked.Pleas verify the status through the button in the menu on the right.',
        TEMPORARY_ERROR: 'Recheck the invoice status',
        PENDING: 'The invoice is being processed by ANAF.',
        OK: 'The invoice has been successfully validated and processed by ANAF.',
        NOT_OK: 'The sent invoice is invalid. Please download the ZIP file.',
        ERROR: 'The sent invoice contains errors.',
        CONVERSION_ERROR: 'The sent invoice contains conversion errors.',
        COMMUNICATION_ERROR: 'Communication error with ANAF. Please try again later.',
      },
      anafInvoiceStatuses: {
        UPLOAD_SUCCESS: 'Success',
        UNSENT: 'Unsent',
        UNCHECKED: 'Unchecked',
        TEMPORARY_ERROR: 'Temporary error',
        PENDING: 'Pending',
        OK: 'The invoice is valid.',
        NOT_OK: 'The invoice is invalid.',
        ERROR: 'Error',
        CONVERSION_ERROR: 'Conversion error',
        COMMUNICATION_ERROR: 'Comunication error',
      },
      anafInvoiceStatus: 'ANAF status',
      addService: {
        label: 'Add service',
        inputs: {
          vat: 'VAT',
          type: 'Service type',
          total: 'Service cost',
          operationType: 'Operation type',
          description: 'Additional service description',
          currency: 'Currency',
          vatExemptionReason: 'Add the VAT exemption reason',
        },
        errors: {
          requiredVat: "The 'VAT' field is required!",
          requiredTotal: "The  'Service cost' field is required!",
          requiredDescription: "The  'Additional service description' field is required!",
          requiredCurrency: "The  'Currency' field is required!",
          requiredVatExemptionReason: 'For the selected code, the reason for the VAT exemption must be added',
          maxlengthVatExemptionReason: 'The maximum number of characters is 100',
          minTotal: "The 'Service cost' field cannot be negative!",
        },
      },
      addSecondaryCurrencyValues: 'Add secondary currency ',
      paymentTermsNote: 'Payment terms notes',
      addNewLine: 'Add line',
      addNewInvoice: 'Add invoice',
      addInvoice: 'Add invoice',
      actions: {
        updateAndPreview: 'Update and preview',
        sendByEmail: 'Send by e-mail',
        reject: 'Reject',
        finalizeTooltip: 'Once the invoice has been sent, its details can no longer be edited',
        finalize: 'Send',
        download: 'Download',
        accept: 'Accept',
      },
      acceptInvoice: {
        confirmMessage: 'Are you sure you want to accept the invoice? This action is irreversible!',
      },
    },
    handover: {
      postalCode: 'Postal code',
      Pickup: {
        title: 'Pickup',
        timeWindow: 'Pickup time',
        startTime: 'From',
        loadingReference: 'Loading reference',
        error: {
          timeWindowStartrequired: 'The beginning of the pick-up interval is required',
          pickupIsBeforeToday: 'Pick-up date must be currently!',
          pickupEndTimeIsBeforeNow: 'Final pickup time must be currently!',
        },
        endTime: 'To',
      },
      error: {
        noAddressSelected: 'Select a valid address',
        deliveryIsBeforePickup: 'The delivery date must be after the pick-up date!',
      },
      Delivery: {
        title: 'Delivery',
        timeWindow: 'Delivery range',
        startTime: 'From',
        loadingReference: 'Unloading reference',
        error: {
          timeWindowStartrequired: 'The beginning of the delivery interval is required',
          deliveryIsBeforePickup: 'The delivery date must be after the pick-up date',
        },
        endTime: 'To',
      },
      country: 'Country',
      companyName: 'Company',
      city: 'City',
      chooseAddress: 'Select an address',
      addNewAddress: 'Add a new address',
    },
    guide: {
      skipLabel: 'Finish',
      'shipment-split': {
        'vendor-routing-solutions': 'Routes taken from orders placed with vendor partners',
        solutions: 'List of shipment solutions already created',
        'shipment-panel': 'Shipments to be handled by loading cars and sections of routes',
        'segment-details': 'Details of loading route sections and specific actions',
        'own-routing-solutions': 'Route blocks and complete routes used to build the shipment solution',
        'new-segment': 'Add route section by selecting existing routes or creating a new route',
        'clear-solution': 'Start working on a new solution',
        canvas:
          'Workspace, with the ability to add track sections and link them together to get the transport solution. And loading them with drag & drop shipment',
      },
      'shipment-group-solutions': {
        solutions:
          'List of own solutions and solutions created from offers. From this panel you will select solutions for the appropriate route segment.',
        'segment-canvas': 'Route configuration created in the previous screen',
        offers: 'List of Offers received from sub-contracted Requests for Offers, in case of a subcontractor route.',
        'master-routing-solutions':
          'The aim of this page is to create complete solutions. A complete solution consists of solutions for each route segment.',
        'master-routing-solution':
          'This line is a complete solution. Use the right click on a complete solution to open the action menu!',
      },
      restartTour: 'Restart tour',
      prevLabel: 'Back',
      nextLabel: 'Next',
      doneLabel: 'Finish',
    },
    error: {
      vendorsRequired: 'At least one vendor partner must be selected!',
      shipmentTariffRequired: 'Tariff selection is required for the shipment',
      minLengthVendors: 'At least one vendor partner must be selected!',
      territoryNameExists: 'There is already a territory created with this name!',
      startTimeNotStandard: 'Start time is outside the standard range',
      startTimeAfterEndTime: 'Start time is after end time',
      startDateAfterEndDate: 'The end date must be greater in calendar terms than the start date!',
      requiredValue: 'The Reported value field is required!',
      requiredStartDate: 'The Stard date field is required!',
      requiredName: 'The Name field is required!',
      minLengthName: 'The Name must contain minimum 3 characters!',
      requiredPhoneNumber: 'The Phone number field is required!',
      minLengthPhoneNumber: 'The phone number is too short!',
      requiredCompanyName: 'The Company field is required!',
      requiredInterval: 'Range is required',
      requiredFinishDate: 'The Finish date field is required!',
      requiredCustomer: 'The Customer field is required',
      requiredComments: "Field 'Reason' is required",
      requiredCode: 'The Code field is required!',
      requiredAccountName: 'The Accound name field is required',
      required: 'The field is required!',
      pickupTimeWindowStartBeforeStandardInterval: 'Pick-up time must be in the present',
      packageLimitExceeded: 'Number of packages per transaction cannot exceed 200',
      deliveryIsBeforePickup: 'The delivery date must be after the pick-up date',
      noAddressSelected: 'Select a valid address',
      missingStartTime: 'Missing start time',
      missingEndTime: 'Missing end time',
      maxlengthType: 'Field must not exceed 255 characters',
      invalidStartTime: 'Start time invalid',
      invalidEndTime: 'End time invalid',
      endTimeNotStandard: 'End time is outside the standard range',
      maxLengthPhoneNumber: 'The Phone number should contain maximum 20 characters!',
      duplicateVendorTagValueForOwner: 'There is already a tag created with this value!',
      DuplicateUniqueID: 'There is another customer with this unique registration number!',
      DuplicateNumericPartOfUniqueID:
        'There is another company having the same numeric part of the unique registration number!',
      duplicateLegalEntityForVendor: 'The chosen company is already a vendor partner!',
      DuplicateCompanyName: 'There is already a customer with this name!',
      deliveryTimeWindowStartBeforeStandardInterval: 'Delivery time must be in the present',
      defaultValidationMessage: 'An error has occurred. Check the data entered and try again',
      customerVORequired: 'The Customer field is required!',
      nameRequired: 'The Name field is required!',
      phoneNumberRequired: 'The Phone number field is required!',
      phoneNumberLengthMessage: 'The Phone number should contain maximum 20 characters!',
      shipmentsRequired: 'At least one shipment must be selected!',
      packagesRequired: 'At least one package must be added',
      deadlineInFuture:
        "The selected date must be in the future.If today's date is selected, the time must be later than the current time.",
      selectAtLeastOneContactPerEntity: 'Select at least one contact for each company',
      selectAtLeastOneAccountNumberPerCourier: 'Select at least one account number for each courier',
      validationError: 'Validation error',
      dateTimeWithTimezoneInPastDeadline:
        "The selected date must be in the future. If today's date is selected, the time must be later than the current time.",
      orderContactRequired: 'Select or enter contact information for each location/address for pickup/delivery.',
      beforeOffsetTimeWindowDto: 'Date and time must be in the future',
      shipmentVehicleDTO: {
        vehicleType: {
          required: "The field 'Vehicle type' is required",
        },
      },
      productCustomsClearanceDTOS: 'The products are invalid',
      pickup: {
        name: {
          required: 'The Pickup Name field is required',
        },
        phoneNumber: {
          required: 'The Pickup Phone number field is required',
        },
        contact: {
          name: {
            required: "The pickup's contact name is mandatory!",
            minLength: {
              min: "The pickup's contact name must contain minimum 3 characters! ",
            },
          },
          phoneNumber: {
            required: "The pickup's contact phone number is mandatory!",
            minLength: {
              min: "The pickup's contact phone number is too short!",
            },
          },
        },
        address: {
          cityRequired: 'The city field is required',
          postalCodeRequired: 'The postal code field is required',
        },
        namedLocationVORequired: 'The pickup location is required',
        timeWindowDto: {
          startRequired: 'The start of the time window is required',
          invalidDateTime: 'The pickup date and time are invalid',
          beforeOffset: 'The pickup date and time must be in the future',
        },
      },
      delivery: {
        name: {
          required: 'The Delivery Name field is required',
        },
        phoneNumber: {
          required: 'The Delivery Phone number field is required',
        },
        contact: {
          name: {
            required: "The delivery's contact name is mandatory!",
            minLength: {
              min: "The delivery's contact name must contain minimum 3 characters! ",
            },
          },
          phoneNumber: {
            required: "The delivery's contact phone number is mandatory!",
            minLength: {
              min: "The delivery's contact phone number is too short!",
            },
          },
        },
        address: {
          cityRequired: 'The city field is required',
          postalCodeRequired: 'The postal code field is required',
        },
        namedLocationVORequired: 'The delivery location is required',
        timeWindowDto: {
          startRequired: 'The start of the delivery time window is required',
          invalidDateTime: 'The delivery date and time are invalid',
          beforeOffset: 'The delivery date and time must be in the future',
        },
      },
      packages: {
        heightRequired: 'The package height is required',
        widthRequired: 'The package width is required',
        lengthRequired: 'The package length is required',
        weightRequired: 'The package weight is required',
        piecesRequired: 'The number of pieces is required',
      },
      offerRequestWithCourierMustHaveOneShipment: 'Offer requests with couriers must have only one shipment!',
      $cross: {
        pickupTimeWindowStartInvalid: 'Invalid pickup time window start',
        packageRequired: 'The package is required',
        pickupLocationRequired: 'The pickup location is required',
        deliveryLocationRequired: 'The delivery location is required',
        productCustomsClearanceDTOSRequired: 'The products are required',
        isDateTimeEqualOrAfter: 'The delivery time window must be after or equal to the pickup time window',
        tagsPerPackageGroup: 'The merchandise description is missing for packages',
        packageCountExceeded: 'The number of packages per transaction cannot exceed 200',
        productsWeightIsBiggerThanPackagesWeight:
          'The total weight of the products must be smaller or equal to the total weight of the packages!',
        shipmentTariffRequired: 'Tariff selection is required for the shipment',
      },
    },
    employeeAssignment: {
      validTo: 'Valid to',
      validFrom: 'Valid from',
      title: 'Planner Assignment',
      territoryName: 'Teritory name',
      territory: 'Teritory',
      territories: 'Teritories',
      pid: 'PID',
      newTerritory: 'New teritory',
      markAsMainTooltip: 'Marks as Main Sales Agent',
      error: {
        requiredValidTo: "The  'Valid to' field is required",
        requiredValidFrom: "The  'Valid from' field is required",
        requiredName: "The  'Teritory' name field is required",
      },
      employees: 'Employees',
      employeeName: 'Employee name',
      employeeAssignment: 'Employee assignment',
      employee: 'Employee',
      deleteTooltip: 'Delete',
      activeStatuses: {
        true: 'Active',
        false: 'Inactive',
      },
      active: 'Active',
    },
    email: {
      to: 'To',
      title: 'E-mails',
      subject: 'Subject',
      'receive-date': 'Receive date',
      'plain-text-content': 'Plain text content',
      from: 'From',
      'create-offer-request': 'Create offer request',
      cc: 'CC',
    },
    driver: {
      workSchedule: 'Work schedule',
      validTo: 'Valid to',
      validFrom: 'Valid from',
      title: 'Drivers',
      tabs: {
        success: 'Success',
        saved: 'Driver saved',
        license: 'Driver license',
        'identity-card': 'ID card',
        documents: 'Documents',
        details: 'General',
        vehicle: 'Vehicle',
      },
      subtitle: 'Routes',
      pricePerKm: 'Price per KM',
      licensePlate: 'Associated vehicle',
      pid: 'PID',
      phoneNumber: 'Phone number',
      name: 'Name',
      licenseExpirationDate: 'License expiration date',
      licenseCategory: 'License category ',
      license: {
        title: 'Driver license',
        licenseCategory: {
          issueDate: 'Issue date',
          expirationDate: 'Expiration date',
          addCategory: 'Add category ',
        },
        issueAuthority: 'Issuing authority',
        editLicense: 'Edit driver license',
        driverLicenseNumber: 'Driver license number',
        driverLicenseCategories: 'Driver license categories',
        details: 'Driver license details',
        addLicense: 'Add driver license',
      },
      idSeries: 'ID Series',
      idNumber: 'ID Number',
      'identity-document': {
        title: 'ID card',
        series: 'Series',
        number: 'Number',
        issueDate: 'Issue date',
        issueAuthority: 'Issue authority',
        expirationDate: 'Expiration date',
        editIdentityDocument: 'Edit ID card',
        details: 'ID card details',
        addIdentityDocument: 'Add ID card',
      },
      vehicle: {
        title: 'Vehicle',
        subtitle: 'Associate/Disassociate vehicle',
        vehiclePlaceholder: 'Vehicle',
        unassign: 'Unassign',
        assign: 'Assign',
        errors: {
          requiredVehicleVO: "The field 'Vehicle' is mandatory!",
        },
      },
      fridCode: 'FRID code',
      error: {
        requiredSeries: 'ID series is required!',
        requiredPricePerKm: 'The Price per km field is required',
        requiredNumber: 'ID number is required!',
        requiredLicenseCategory: 'The Category field is required',
        requiredIssueDate: 'The date of issue of the identity card is required!',
        requiredIssueAuthority: 'The issuing authority of the ID card is mandatory!',
        requiredExpirationDate: 'The date of issue of the ID card is required!',
        requiredEmployee: 'The Employee field is required',
        requiredDriverLicenseNumber: "Driver's license number is required!",
        requiredDescription: 'The Description field is required',
        minlengthSeries: 'Series must contain 2 characters!',
        minlengthNumber: 'Number must contain 6 digits!',
        maxlengthSeries: 'Series must contain 2 characters!',
        maxlengthNumber: 'Number must contain 6 digits!',
        EmployeeRequired: 'The employee is required to choose!',
        EmployeeAlreadyIsDriver: 'The chosen employee has already been marked as a driver!',
      },
      erpId: 'ID ERP',
      employee: 'Employee',
      'edit-driver-title': 'Driver details ',
      documents: {
        validTo: 'Valid to',
        validFrom: 'Valid from ',
        title: 'Documents',
        status: 'Status',
        photos: 'Document photos',
        obs: 'Observations',
        markInactive: 'Mark as inactive',
        markActive: 'Mark as active',
        issueDate: 'Issue date',
        inactive: 'Inactive',
        expirationDate: 'Expiration date',
        editDocument: 'Edit document',
        documentTypePlaceholder: 'Select a document type',
        documentType: 'Document type',
        document: 'Document',
        details: 'Document details',
        addDocumentType: 'Add document type',
        addDocument: 'Add document',
        active: 'Active',
      },
      description: 'Description',
      dangerousGoodsCertification: 'Dangerous goods certification',
      county: 'County',
      contactPersonPhoneNumber: 'Contact person phone number',
      common: {
        employee: 'Employee',
      },
      cnp: 'CNP',
      cityOfResidence: 'City of residence',
      bankAccount: 'Bank account',
      address: 'Address',
      addNew: 'Add driver',
      'add-driver-title': 'Add driver',
      activityType: 'Activity type',
      activeTo: 'Active to',
      activeFrom: 'Active from',
    },
    'delivery-inbox': {
      statusChange: 'Status has been changed',
      phaseChange: 'Status has been changed',
      isNew: 'New entry',
      assigmentChange: 'The employee assigned has been changed',
    },
    title: 'Delivery module',
    customer: {
      title: 'Customer',
      searchClient: 'Search customer',
      order: {
        listTitle: 'Customer order list',
      },
      list: {
        walletCurrencyCode: 'Wallet currency ',
        walletBalance: 'Wallet balance',
        uniqueIdentificationNumber: 'Unique identification number',
        unblockCompany: 'Unblock company',
        title: 'Customer list',
        territoryVo: 'Territory',
        name: 'Customer name',
        mainPhoneNumber: 'Phone number',
        mainEmailAddress: 'E-mail',
        globalAccType: 'Global account type',
        globalAccCode: 'Global account code',
        favourite: 'Favorite',
        country: 'Country',
        blockCompany: 'Block company',
      },
      detail: {
        uniqueIdNumber: 'Unique identification number',
        title: 'Company',
        territory: 'Teritory',
        mainEmail: 'Main e-mail',
        mainAddress: 'Main address',
        industryType: 'Industry type',
        header: 'Company details',
        generalInfo: 'General information',
        favouriteCustomer: 'Favorite customer',
        customerName: 'Customer name ',
      },
      contactsWarning: 'This client has no contacts. Add using the next button.',
      addressList: {
        type: 'Address type',
        title: 'Addresses',
        state: 'State',
        postalCode: 'Postal code',
        location: 'Location',
        label: 'Tag',
        country: 'Country',
        companyAddress: 'Company address',
        city: 'City ',
        address: 'Address',
        add: 'Add address',
      },
      address: {
        pickup: 'Address for loading',
        editTitle: 'Edit address',
        delivery: 'Address for unloading',
        addTitle: 'Add new address for loading / unloading',
      },
    },
    currencyValue: {
      value: 'Value',
      currencyCode: 'Currency',
    },
    contract: {
      'valid-to': 'Valid to',
      'valid-from': 'Valid from',
      'service-provider': 'Service provider',
      'new-title': 'New contract',
      'list-title': 'Contracts with clients',
      label: 'Registration number / Data',
      error: {
        requiredvalidTo: 'End date is required! ',
        requiredvalidFrom: 'Start date is required! ',
        requiredstatus: 'Status is required!',
        requiredlabel: 'Registration number is required!',
        requiredcustomerVO: 'Customer is required!',
        requiredaccountVO: 'Account is required!',
      },
      'edit-title': 'Edit contract',
      customer: 'Customer',
      'contract-status-value': {
        requested: 'Requested',
        accepted: 'Accepted',
      },
      'contract-status': 'Contract status',
      'company-name': 'Customer name',
      comments: 'Comments',
      'attachments-title': 'Attachments',
      addNew: 'Add contract',
      account: 'Account',
    },
    contactList: {
      visibilityTypes: {
        SERVICE_PROVIDER: 'Service provider',
        PUBLIC: 'Public',
        null: 'All',
        NONE: 'Private',
        CUSTOMER: 'Customer',
        BOTH: 'Both',
      },
      visibilityType: 'Visibility ',
      title: 'Contacts',
      receivesRequests: 'Receive requests',
      phoneNumber: 'Phone number',
      ownerCompanyName: 'Company owner',
      email: 'E-mail',
      contactName: 'Name',
      contactMethods: {
        VISIT: 'Visit',
        TEL: 'Phone number',
        null: 'All',
        EMAIL: 'E-mail',
      },
      contactMethod: 'Contact method',
      contactIsNotOwned: 'The contact cannot be deleted because it is not owned by you',
      contactCountry: 'Country',
      companyName: 'Company name',
      add: 'Add contact',
    },
    contact: {
      title: 'Contact',
      selectContacts: 'Select contacts',
      phoneNumber: 'Contact phone number',
      name: 'Contact name',
      error: {
        requiredPhoneNumber: 'Phone number is required',
        requiredName: 'Name is required',
        requiredDeliveryPhoneNumber: 'Phone number is required',
        requiredDeliveryName: 'Name is required',
        requiredDeliveryContactName: 'Name is required',
        requiredDeliveryCompanyName: 'Company is required',
        requiredContactName: 'Name is required',
        requiredCompanyName: 'Company is required',
        maxlengthPhoneNumber: 'Phone number must not exceed 20 characters',
        maxlengthName: 'Name must not exceed 100 characters',
        requiredNamedLocationPartnerContactVO: 'The selection of a contact is required',
        maxlengthLoadingReference: 'Reference must not exceed 250 characters',
        maxlengthCompanyName: 'Company name must not exceed 100 characters',
        maxlength: 'Phone number must not exceed 20 characters',
      },
      email: 'E-mail',
      addContact: 'Add contact',
    },
    complaint: {
      title: 'Complaints',
      statuses: {
        resolved: 'Solved ',
        in_progress: 'In progress',
        created: 'Created',
      },
      status: 'Status',
      resolveComplaint: 'Mark as solved',
      replies: 'Complaint replies ',
      noParentComplaint: 'No complaints.',
      noComplaintHistory: 'No history for this complaint',
      noChildComplaints: 'No replies for this complaint',
      message: 'Message ',
      lastReplyBy: 'Last modification made by',
      initialComplaint: 'Initial complaint',
      history: 'History complaint ',
      error: {
        requiredMessage: 'The Message field is required',
      },
      createdAt: 'Created at',
      chooseFile: 'Choose file',
      addToExisting: 'New reply',
      addNew: 'New complaint ',
    },
    common: {
      map: 'Map',
    },
    billingCycle: {
      Weekly: 'Weekly',
      Per_shipment: 'Per shipment',
      Monthly: 'Monthly',
      Manual: 'Manual',
      Bi_monthly: 'Bi-monthly',
    },
    address: {
      state: 'County',
      selectedAddress: 'Selected address details',
      postalCode: 'Postal code',
      newAddress: 'New address details',
      error: {
        postalCoderequired: "The  'Postal code' field is required",
        noAddressSelected: 'The address must be selected or created',
        countryrequired: "The  'Country' field is required",
        cityrequired: "The  'City' field is required",
      },
      country: 'Country',
      city: 'City',
      addressTypes: {
        WorkPoint: 'Work point',
        Warehouse: 'Warehouse',
        Shipping: 'Shipment',
        Registered: 'Registration ',
        Pickup: 'Loading',
        Main: 'Main',
        Invoicing: 'Invoicing',
        Delivery: 'Unloading',
        Decision: 'Decision',
        Correspondence: 'Correspondence',
        Billing: 'Billing',
      },
      addressType: 'Address type',
      addressLine: 'Address',
    },
    'address-template': {
      list: {
        title: 'Address templates',
        city: 'City',
        state: 'County',
        country: 'Country',
        addressLine: 'Address line',
        postalCode: 'Postal code',
        label: 'Tag',
        forCompany: 'For company',
        streetName: 'Street name',
        streetNumber: 'Street number',
        block: 'Block',
        building: 'Building',
        floor: 'Floor',
        apartment: 'Apartment',
        details: 'Details',
      },
    },
    account: {
      status: 'Status',
      serviceProviderName: 'Service provider name',
      'payment-time-limit': 'Payment due date (number of days)',
      'new-title': 'Add account',
      'list-title': 'Accounts',
      latestShipmentDate: 'Last shipment date',
      lastModifiedAt: 'Last modified at',
      firstShipmentDate: 'First shipment date',
      error: {
        defaultValidationMessage: 'An error has occurred. Check the data entered and try again',
      },
      'edit-title': 'Edit account',
      customerName: 'Customer name',
      customer: 'Customer',
      creditStopped: 'Credit stopped',
      contactPhoneNumber: 'Phone number ',
      contactName: 'Contact name',
      contactEmail: 'E-mail',
      contact: 'Contact',
      billingName: 'Billing name',
      billingCycle: 'Billing Method',
      billingAccountNumber: 'Billing account number',
      address: 'Address',
      addNew: 'Add account',
      accountStatus: 'Status',
      accountRequestedAt: 'Requested at',
      accountNumber: 'Account number',
      accountName: 'Account name',
      accountCreatedAt: 'Created at',
      accountClosedAt: 'Closed at',
      'account-status-value': {
        requested: 'Requested',
        created: 'Created',
        closed: 'Closed',
      },
    },
    localTimezoneInfoMessage: 'The selected times correspond to the local time of the chosen location.',
    supplierDelegationManagement: {
      title: 'Tariff Delegations to Business Partners',
      new: 'Add Delegations',
      form: {
        add: 'Delegate Tariffs to Business Partners',
        edit: 'Edit delegations for ',
        suppliers: 'Business Partners',
        tariffs: 'Tariffs',
        validFrom: 'Valid From',
        validTo: 'Valid To',
        availability: 'Validity Period',
        selectSuppliers: 'Select Business Partners',
        selectedTariffsBadge: ' selected tariffs',
        noAvailableTariffs: 'There are no available tariffs',
        contractsSuggestionMessage:
          'To delegate tariffs to suppliers, you must have at least one saved contract. You can add one using the button on the right.',
        contactSuggestionMessage:
          'To allow commercial partners to create orders with vendors based on delegated rates, you must have at least one public contact that receives offer requests. You can add one using the button on the right.',
        contactSuggestionMessageWithParam: (param) =>
          `To allow ${param.name} to create orders with vendors based on delegated rates, you must have at least one public contact that receives offer requests. You can add one using the button on the right.`,
        errors: {
          required: 'Selecting at least one business partner is mandatory.',
          requiredTariffs: 'Selecting at least one tariff is mandatory.',
          requiredValidFrom: 'The start date of validity is mandatory.',
          minLengthSuppliers: 'You must add at least one supplier!',
        },
      },
      list: {
        createdAt: 'Created at',
        supplierName: 'Supplier name',
        activeTariffDelegationsCount: 'Active tariff delegations count',
      },
      invalidate: 'Are you sure you want to delete this delegation?',
      invalidateAll: 'Delete delegations',
      invalidateAllConfirmationMessage: (param) =>
        `Are you sure you want to delete the delegations for <strong>${param.name}</strong> ?`,
    },
  },
  'saft-app': {
    downloadFile: 'Download the file generate at:',
    uploadFile: 'Upload',
    d406Declaration: 'd406 declaration',
    cnpValidation: 'Validate and replace CNP',
    cnpValidationUpload: 'Upload the excel file that contains the CNPs',
    cnpFileWarn: 'Upload a single excel file',
    accountingNote: 'Accounting note',
    title: 'Upload excel file and the xml file for the 3rd segment:',
    noRecentFiles: "You don't have any recently uploaded files.",
    segmentNumber: 'Segment number',
    filesWarn: 'Upload a single XML file and one Excel file together with the accounting note.',
  },
  'date-utils': {
    seconds: 'sec',
    minutes: 'min',
    hours: 'h',
    errors: {
      selectedDateAfterCurrentDatedateRange: 'Selected date is in the past',
      pickupIsBeforeToday: 'The pick-up date must be in the present',
      pickupEndTimeIsBeforeNow: 'Final pick-up time must be at present',
      deliveryIsBeforePickup: 'The delivery date must be after the pick-up date',
    },
    days: 'days',
  },
  dash: {
    users_prev_year: 'Average new users per day in a month',
    users_current_month: 'Average unique users per day per current month',
    users: 'Users',
    user: 'User',
    upload: 'Upload',
    total_orders_per_month_ytd: 'Orders received per month in the last year',
    total_orders_per_day_mtd: 'Average orders received per day in the last month',
    total_offer_requests_per_month_ytd: 'Monthly offer requests in the last year',
    total_offer_requests_per_day_mtd: ' Average daily offer requests in the last month',
    total_GP: 'Total GP',
    requests: 'Offer requests',
    registered_users_prev_year: 'Average registered users per month in the last year',
    registered_users_current_month: 'Average new users per working day in the current month',
    orders_by_status: 'Order statuses for the last 3 days',
    orders: 'Orders',
    order_status: {
      sent: 'Sent',
      accepted: 'Accepted',
      rejected: 'Rejected',
      in_progress: 'Planned',
      partially_in_progress: 'Partially planned',
      returned_to_origin: 'Returned to origin',
      partially_returned_to_origin: 'Partially returned to origin',
      in_transit: 'In transit',
      partially_in_transit: 'Partially in transit',
      transit_end: 'Transit end',
      partially_transit_end: 'Partially transit end',
      return_to_origin: 'Return to origin',
      partially_return_to_origin: 'Partially return to origin',
      lost: 'Lost',
      partially_completed: 'Partially delivered',
      mixed: 'Mixed',
      mixed_with_failure: 'Mixed with failure',
      completed: 'Delivered',
      completed_with_failure: 'Incomplete delivery',
      undelivered: 'Undelivered',
      documents_partially_received: 'Documents partially available',
      documents_received: 'Documents available',
      archived: 'Archived',
      cancelled: 'Cancelled',
    },
    new_temp_users_prev_year: 'Average users without new account per day in a month',
    new_temp_users_current_month: 'Average users without an account per working day in the current month',
    new_platform_customers: 'New users in one month in the last year',
    gross_profit_ytd: 'Profit per month in the last year',
    gross_profit_mtd: 'Average profit per day in the current month',
    edit: 'Edit',
    delete: 'Delete',
    dashboard_admin: 'Dashboard Admin',
    charts: 'Charts',
    cancel: 'Cancel',
    avg_transactions_prev_year: 'Average transactions for the previous year',
    avg_transactions_current_month: 'Average transactions per day per month',
    avg_gross_profit_ytd: 'Average profit per order per month in the last year',
    avg_GP: 'Medium GP',
    active_offers_req_offers_value: 'Total: {{total}} <br> Active: {{active}}',
    active_offers_req_offers: 'Last 3 days offers',
    abandoned_signups_to_date: 'Abandoned signups',
  },
  'crm-app': {
    utils: {
      yes: 'Yes',
      update: 'Update',
      total: 'Total',
      todayFilter: 'Today',
      'show-advanced-filters': 'Display advanced filtering',
      selectFilter: 'Predefined searches',
      search: 'Search',
      saveFilter: 'Save search',
      save: 'Save',
      resetTableFilters: 'Reset filters',
      reset: 'x',
      requiredLegend: '(*) mandatory fields',
      preview: 'Preview',
      no: 'No',
      nextStep: 'Next step',
      newRequest: 'New request',
      minimizeFilters: '<<',
      expandFilters: '>>',
      enable: 'Enable',
      edit: 'Edit',
      details: '- Details',
      deleteConfirmationMessage: 'Delete confirmation',
      currentWeekFilter: 'Current week',
      'columns-selected': 'columns selected',
      close: 'Close',
      clearTableFilters: 'Delete Filters From Table',
      'choose-columns': 'Choose columns',
      cancel: 'Cancel',
      'boolean-values': {
        true: 'Yes',
        null: 'All',
        false: 'No',
      },
      all: 'All',
      'advanced-filters': 'Advanced Filters',
      addFilterName: 'Add name to search',
      add: 'Add',
    },
    suggestions: {
      salesNotFound: 'In order to perform this action the current user needs an assigned and active "Sales".',
      missingServicesForOpportunity:
        'You can select only services defined on the customer profile. Click on the following arrow to navigate to the customer profile',
      missingEmployee: 'If the searched employee is not in the dropdown. Click on the next arrow',
      editOpportunitySuggestion:
        'To add services or edit other details of the service opportunity, click on the next arrow.',
      editActivitySuggestion: 'To change the status or other details of the activity, click on the next arrow.',
      companyNotServiceProvider:
        'To add a "Sales", your company must be a Service Provider. Click on the next arrow to change this.',
      addContact:
        "You don't have any contacts! In order to create an activity you need at least one contact. Click on the next arrow to create one",
    },
    service: {
      'weight-unit': 'Weight Unit',
      'weight-per-shipment': 'Weight per Shipment',
      'volume-unit': 'Volume Unit',
      'volume-per-shipment': 'Volume per Shipment',
      'transit-time': 'Transit Time',
      'traffic-channel-type': 'Traffic Channel Type',
      tags: 'Commodity type',
      'shipments-per-year': 'Shipments per Year',
      'shipment-type': 'Shipment Type',
      'service-type': 'Service Type',
      'revenue-per-shipment': 'Revenue per Shipment',
      origin: 'Origin',
      'new-title': 'New Service',
      'incoterm-value': 'Incoterm Value',
      'gross-profit-per-shipment': 'Gross Profit per Shipment',
      error: {
        requiredweightUnitValue: 'Weight field is mandatory',
        requiredweightPerShipment: 'Weight per Shipment field is mandatory!',
        requiredvolumeUnitValue: 'Volume Unit field is mandatory!',
        requiredvolumePerShipment: 'Volume per Shipment field is mandatory',
        requiredtransitTime: 'Transit Time field is mandatory!',
        requiredtrafficChannelTypeValue: 'Traffic Channel Type field is mandatory',
        requiredshipmentType: 'Shipment Type field is mandatory!',
        requiredshipmentsPerYear: 'Shipments per Year field is mandatory!',
        requiredserviceTypeValue: 'Service Type field is mandatory!',
        requiredrevenuePerShipment: 'Revenue per Shipment mandatory field!',
        requiredorigin: 'Origin mandatory field!',
        requiredincotermValue: 'Incoterm field is mandatory!',
        requiredgrossProfitPerShipment: 'Gross Profit per Shipment field is mandatory!',
        requireddestination: 'Destination field is mandatory!',
        originDestinationAddressValidationError: 'There cannot be more Origins and more Destinations',
      },
      'edit-title': 'Edit Service',
      destination: 'Destination',
      competitor: 'Competitor',
      comments: 'Comments',
      'add-service': 'Add service ',
    },
    selectItems: {
      weightUnitValue: 'Unit of weight measurement',
      volumeUnitValue: 'Unit of measurement volume',
      vehicleType: 'Vehicle type',
      trafficChannelTypeValue: 'Traffic channel type',
      shipmentType: 'Shipment type',
      serviceTypeValue: 'Services type',
      salesChannels: 'Sales channel',
      revenueBrands: 'Turnover range',
      reasonWonLostValues: 'Won lost values',
      offerRefuseReason: 'Reason for refusal offer',
      needs: 'Customer needs',
      jobTitleValue: 'Job title',
      invoiceOperationType: 'Operation type',
      industryTypeValue: 'Industry type',
      incotermValue: 'Incoterm value',
      gpBrands: 'Range of profitability',
      globalAccountTypes: 'Global account type',
      documentType: 'Document type',
      contactTypeValue: 'Contact type',
      callFrequency: 'Call frequency ',
      buyingRoleValue: 'Purchaser role',
      activityType: 'Activity type',
      activityPurpose: 'Activity purpose',
      activityOutcome: 'Activity outcome',
      activityObjective: 'Activity objective',
      activeUserType: 'User Type',
    },
    selectItem: {
      value: 'Value',
      title: 'Select Items management',
      label: 'Label',
      filterValue: 'Search value',
      filterLabel: 'Search label',
      filterFieldName: 'Search field name',
      fieldName: 'Field Name',
      edit: 'Edit',
      delete: 'Delete',
      all: '- all - ',
      addValue: 'Add value',
      addLabel: 'Add Label',
    },
    sales: {
      territory: {
        validTo: 'Valid to',
        validFrom: 'Valid from',
        title: 'Sales-territory asignment',
        territory: 'Teritory',
        territories: 'Territories',
        salesName: 'Name sales employee',
        salesAssignment: 'Employee assignment',
        sales: 'Sales Employees',
        sale: 'Sales Employee',
        pid: 'PID',
        name: 'Name',
        markAsMainTooltip: 'Mark as main sales',
        historyMenuLabel: 'Sales-territory asignment',
        error: {
          requiredName: "The  'Territory ' name field is required",
        },
        deleteTooltip: 'Delete',
        deleteTerritoryConfirm: 'Confirm territory removal',
        deleteConfirm: 'Are you sure you want to delete?',
        datePopUp: 'Select date interval',
        dateError: 'Date interval is invalid',
        addTitle: 'Add territory',
        activeStatuses: {
          true: 'Active',
          false: 'Inactive',
        },
        active: 'Active',
      },
      new: {
        title: 'Sales',
      },
      list: {
        validTo: 'Valid to',
        validFrom: 'Valid from',
        undefinedValidTo: 'Undefined',
        title: 'Sales',
        territories: 'Territories',
        salesChannelValue: 'Sales channel ',
        pid: 'PID',
        name: 'Name',
        manager: 'Manager',
        latestOpportunity: 'Opportunity',
        LatestActivity: 'Activity',
        filter: 'Search',
        expired: 'Inactive',
        assignSales: 'Assign Sales',
        assignedFrom: 'Assigned from',
        addSales: 'Add Sales',
        active: 'Active',
      },
      error: {
        requiredValidTo: "The 'Valid to' field is mandatory",
        requiredValidFrom: "The 'Valid from' field is mandatory",
        requiredSalesManager: "The 'Manager Sales' field is mandatory",
        requiredName: "The 'Name' field is mandatory",
        requiredEmployee: "The 'Employee' field is mandatory",
        DuplicateEmployeeForSales: 'There is already a Sales for this Employee',
        defaultValidationMessage: 'An error has occurred',
      },
      edit: {
        title: 'Edit sales',
      },
      common: {
        validTo: 'Valid to',
        validFrom: 'Valid from',
        selectSalesChannel: 'Select sales channel ',
        salesManager: 'Sales Manager',
        salesChannelValue: 'Sales channel ',
        employee: 'Employee',
      },
    },
    opportunity: {
      version: {
        title: 'History ',
        pipelineStage: 'Stage',
        name: 'Opportunity name',
        modifiedBy: 'Modified by ',
        modifiedAt: 'Modified at',
      },
      territory: 'Territory',
      teamOpportunities: 'Team opportunities ',
      'shipments-per-year': 'Shipments per year',
      service: 'Service',
      'sales-name': 'Sales name',
      'sales-channel': 'Sales channel ',
      sales: 'Sales',
      revenue: {
        totalRev: 'Total C.A. ',
        totalPercentGp: 'Estimated gross profit',
        totalGp: 'Total gross profit',
        potentialRev: 'C.A. potential ',
        potentialGp: 'Potential gross profit',
        percentGp: 'Agreed gross profit',
        committedRev: 'C.A. agreed',
        committedGp: 'Agreed gross profit',
      },
      'revenue-per-shipment': 'C.A. per shipment ',
      'reason-won-lost': 'Reason Won/Lost',
      'reason-for-lead': 'Reason For Lead',
      probability: 'Probability',
      'potential-revenue': 'Potential C.A. ',
      'potential-gp': 'Potential gross profit',
      'pipeline-stages': {
        UNABLE_TO_GAIN: 'Unable to Gain',
        SUBMIT_PROPOSAL: 'Submit Proposal',
        SHIPPING_TO_PROFILE: 'Shipments according to profile',
        SHIPPING: 'Shipping',
        RECEIVE_TENDER: 'Receive Tender',
        IMPLEMENTED: 'Implemented',
        IDENTIFY_BUSINESS: 'Identify Business',
        FUTURE_OPPORTUNITY: 'Future Opportunity',
      },
      'pipeline-stage': 'Pipeline Stage',
      'opportunity-types': {
        SPOT_SHIPMENT: 'Spot Shipment',
        PRICING: 'Pricing',
        CROSS_SELLING: 'Cross Selling',
        ACQUISITION: 'Acquisition',
      },
      'opportunity-type': 'Opportunity Type',
      'opportunity-title': 'Opportunity',
      'opportunity-name': 'Opportunity Name',
      'opportunity-info-header': 'Opportunity Info',
      'number-of-shipments': 'Number of Shipments',
      'new-title': 'New opportunity ',
      myOpportunities: 'My opportunities',
      'main-competitor-name': 'Main Competitor Name',
      'list-title': 'Opportunities',
      'lead-source': 'Lead Source',
      'gp-per-shipment': 'Gross profit per delivery',
      'first-shipment-expected-date': 'First Shipment Expected Date',
      'expected-close-date': 'Expected Close Date',
      'detail-title': 'Opportunity ',
      'customer-name': 'Customer Name',
      'contract-signed': 'Contract Signed',
      contact: {
        'new-title': 'Opportunity - New contact ',
        'list-title': 'Opportunity - Contacts ',
      },
      competitors: 'Competitors',
      'business-renewal-date': 'Business Renewal Date',
      allOpportunities: 'All opportunities',
      addServices: 'Add services ',
      addServiceDisabledTooltip: 'To add services, you must select a client',
      'add-opportunity': 'Add opportunity ',
      accountTitle: 'Account',
      accountDetails: 'Account details',
      account: 'Account',
    },
    menu: {
      title: 'Menu',
      sales: 'Sales',
      opportunityVersion: 'History',
      opportunityDetail: 'Details',
      opportunityContacts: 'Contacts',
      opportunityAddress: 'Addresses',
      opportunityActivity: 'Activities',
      opportunityAccount: 'Account',
      opportunity: 'Opportunities',
      language: 'Language',
      customerProfile: 'Profile',
      customerOpportunity: 'Opportunities',
      customerDetail: 'Details',
      customerCredit: 'Credit',
      customerContacts: 'Contacts',
      customerAttachments: 'Attachments',
      customerAddress: 'Addresses',
      customerActivity: 'Activities',
      customer: 'Customers',
      credit: 'Credits',
      address: 'Addresses',
      activityDetail: 'Details',
      activityContacts: 'Contacts',
      activityAddress: 'Addresses',
      activity: 'Activities ',
    },
    legalEntity: {
      title: 'Company ',
      error: {
        DuplicateUniqueID: 'A customer with this unique ID number already exists!',
        DuplicateCompanyName: 'A customer with this name already exists!',
      },
      add: 'Add a new company',
    },
    error: {
      timeIntervalError: 'The end time must be longer than the start time',
      territory_name_exists: 'This territory name already exists!',
      startDateAfterEndDate: 'The end date must be longer than the start date!',
      select_item_exists: 'The select item already exists.',
      requiredValue: 'The reported value is required!',
      requiredStartDate: 'The start date is required!',
      requiredStage: 'Status is required!',
      requiredOpportunityName: 'Opportunity Name is required!',
      requiredName: 'Name is required!',
      requiredFinishDate: 'The end date is required!',
      requiredCustomerName: 'The Customer field is required!',
      requiredCode: 'Code is required! ',
      requiredactualCompletionDate: 'Completion date is required!',
      required: 'This field is required!',
      opportunity_contact_exists: 'This contact is already saved on opportunity!',
      alreadyExistingAddressOfType: 'There is already an address of this type!',
      defaultValidationMessage: 'An error occured. Check the data you entered and try again.',
      activityMustHaveAtLeastOneContact: 'The activity must have at least one contact!',
      activity_contact_exists: 'This contact is already saved on activity!',
    },
    customer: {
      YTDRevenue: 'YTD: C.A.',
      YTDGP: 'YTD: Gross profit',
      vatSplitStatus: 'VAT breakdown payment',
      vatRegistration: 'VAT Payer',
      vatInactiveStatus: 'Inactive (VAT)',
      vatInactivationDate: 'Inactive (VAT) from',
      vat: 'VAT Value',
      'unique-id-number': 'Unique ID Number',
      totalOpportunityRev: 'C.A. total opp.',
      totalOpportunityGP: 'Total gross profit opp. ',
      totalCommittedRev: 'C.A. total committed',
      'territory-name': 'Territory Name',
      territory: 'Territory',
      teamCustomers: 'My team',
      'sales-name': 'Sales Name',
      'sales-channel': 'Sales Channel',
      'registration-code': 'Trade Register Registration Number',
      'profile-sales-channel': 'Profile Sales Channel',
      'profile-gp-brand': 'Profile GP Brand',
      profile: 'Profile',
      overview: {
        totalPotentialRevGP: 'Potential gross profit',
        'total-value': 'YTD: Revenue',
        'start-time': 'Start Time',
        'shipment-type': 'Shipment Type',
        'service-type': 'Service Type',
        'sales-team': 'Sales Team',
        routes: 'Routes',
        'route-source-location': 'Source ',
        'route-name': 'Route name',
        'route-destination-location': 'Destination ',
        profit: 'YTD: Profit',
        'planned-start-date': 'Planned Start Date',
        'pipeline-stage': 'Pipeline Stage',
        'phone-number': 'Phone Number',
        orders: 'Orders',
        'order-tasks': 'Tasks',
        'order-status': 'Status',
        'order-pickups': 'Pickups ',
        'order-deliveries': 'Deliveries',
        'opportunity-type': 'Opportunity Type',
        'opportunity-total-potential-gross-profit-per-year': 'Opportunity Total Potential Gross Profit Per Year',
        'opportunity-potential-gross-profit': 'Opportunity Potential Gross Profit',
        'opportunity-name': 'Opportunity Name',
        'opportunity-commited-gross-profit': 'Opportunity Commited Gross Profit',
        opportunities: 'Opportunities',
        noBillingData: 'No data on profits and turnover',
        'next-contact-date': 'Next Contact Date',
        'never-call': 'Never Call',
        'more-opportunities': 'More Opportunities',
        'more-contacts': 'More Contacts',
        'more-activities': 'More Activities',
        'job-title': 'Job Title',
        'first-shipment-expected-date': 'First Shipment Expected Date',
        'end-time': 'End Time',
        email: 'Email',
        dueAmount: 'Total payment',
        dso: 'DSO',
        createdBy: 'Created by ',
        contracts: 'Contracts',
        'contract-valid-to': 'Valid to ',
        'contract-valid-from': 'Valid from',
        'contract-status-value': {
          requested: 'Requested',
          accepted: 'Accepted',
        },
        'contract-status': 'Status',
        contacts: 'Contacts',
        'contact-type': 'Contact Type',
        'contact-name': 'Name',
        comments: 'Comments',
        'buying-role': 'Buying Role',
        'business-renewal-date': 'Business Renewal Date',
        actualPaymentTerm: 'Actual payment term ',
        'actual-completion-date': 'Actual Completion Date',
        'activity-status': 'Activity Status',
        activities: 'Activities',
      },
      nextContactDate: 'Next contact date',
      'new-customer': 'New customer',
      myCustomers: 'My customers ',
      'main-phone': 'Main Phone',
      'main-email': 'Main email address',
      'main-address': 'Main Address',
      loyaltyCode: 'Loyalty code ',
      'loyalty-options': {
        Uptrader: 'Uptrader',
        Stable: 'Stable',
        New: 'New',
        Lost: 'Lost',
        Inactive: 'Inactive',
        Downtrader: 'Downtrader',
      },
      listTitle: 'Customers',
      'legal-entity-search': 'Search existing legal entity (by Name or Unique ID Number)',
      'legal-entity-header': 'Legal Entity details',
      lastContactDate: 'Last contact date',
      globalAccount: {
        type: 'Global account type',
        code: 'Global account code',
        add: 'Add a new global account',
      },
      'global-account-type': 'Global Account Type',
      'global-account-code': 'Global Account Code',
      generalInfo: 'General information',
      financialInfo: 'Financial information ',
      favourite: 'Favorite',
      errors: {
        DuplicateUniqueID: 'There is another company with this unique registration number!',
        customer_exists: 'This company is already a customer!',
      },
      error: {
        uniqueIdNumberrequired: 'The unique identification number is required!',
        territoryrequired: 'Territory is required to choose!',
        alreadyExistingAddressOfType: 'There is already an address of this type!',
        customer_exists: 'There is already a customer established for this company!',
        countryrequired: 'Country is required!',
        companyNamerequired: 'Customer name is required!',
      },
      customerRating: 'Customer Fin. Rating',
      'customer-title': 'Customer',
      'customer-stages': {
        Track: 'Track',
        Suspect: 'Suspect',
        Prospect: 'Prospect',
        Maintain: 'Maintain',
        Lost: 'Lost',
        Action: 'Action',
      },
      'customer-stage': 'Customer Stage',
      'customer-search': 'Search customers',
      'customer-profile': {
        totalRevenue: 'Total revenue',
        totalGrossProfit: 'Total gross profit',
        'total-potential-revenue': 'Total Potential Revenue',
        'total-potential-gp': 'Total Potential GP',
        title: 'Customer Profile',
        services: 'Services',
        'sales-channel-options': {
          telesales: 'Telesales',
          majorAccount: 'Major Account',
          globalAccount: 'Global Account',
          fieldSales: 'Field Sales',
          directChannel: 'Direct Channel',
        },
        'sales-channel': 'Sales Channel',
        'revenue-brand': 'Revenue Brand',
        need: 'Need',
        mainCompetitor: 'Main competitor',
        'last-shipment-date': 'Last Shipment Date',
        'gp-brand': 'Profitability range',
        error: {
          requiredSalesChannelValue: 'The Sales Channel field is required',
          requiredCustomerNeedValue: 'The field ”Need” is required',
          requiredCommodity: 'The field ”Commodity type” is mandatory',
        },
        competitors: 'Competitors',
        commodity: 'Commodity',
      },
      'customer-new-warning': 'Customer is NEW!',
      'customer-name': 'Customer Name',
      'customer-loyalty-code': 'Customer Loyalty Code',
      'customer-last-contact-date': 'Last Contact Date',
      'customer-info-header': 'Customer Information ',
      'customer-industry-type': 'Industry Type',
      'customer-credit-status': 'Customer Credit Status',
      'customer-country': 'Customer Country',
      'customer-city': 'Customer City',
      'customer-call-frequency': 'Call Frequency (number of days)',
      credit: {
        validationDate: 'Validation date',
        title: 'Customer Credit Details',
        statusEnum: {
          Warning_exceeded: 'Warning Exceeded',
          Expired: 'Expired',
          Closed: 'Closed',
          Active: 'Active',
        },
        requestStatus: 'Request status',
        requestHistory: 'Credit request history',
        requestEnum: {
          Under_decision: 'Awaiting decision',
          Requested: 'Requested',
          Rejected: 'Rejected',
          Approved: 'Approved',
        },
        requestedBy: 'Requested by',
        requestDate: 'Request date',
        requestComment: 'Comments credit request',
        paymentTerms: 'Payment Term',
        paymentMethodEnum: {
          Credit_card: 'Credit Card',
          Credit: 'Credit',
          Cash: 'Cash',
        },
        paymentMethod: 'Payment Method',
        expectedYearlyRevenue: 'Expected Yearly Revenue',
        error: {
          requestDaterequired: 'The application date is required!',
          expectedYearlyRevenuerequired: 'Estimated annual income is required!',
          currencyValuerequired: 'Currency is required!',
          creditLimitrequired: 'The credit limit is required!',
        },
        currencyValue: 'Currency',
        creditStatus: 'Credit status',
        creditLimit: 'Credit Limit',
        creditChecked: 'Credit Approved',
        checkValidityDays: 'Credit Availability (days)',
        checkExpiryDate: 'Credit Expiration Date',
        checkedBy: 'Checked by',
        checkDate: 'Credit check Date',
        checkComment: 'Credit check comments',
        billingCycleEnum: {
          Weekly: 'Weekly',
          Per_shipment: 'Per Shipment',
          Monthly: 'Monthly',
          Manual: 'Manual',
          Bi_monthly: 'Bi-Monthly',
        },
        billingCycle: 'Billing Cycle',
        availableCredit: 'Available Credit',
        approvedAmount: 'Approved credit',
        approved: 'Approved',
        approvalTitle: 'Credit approval details',
      },
      'credit-status': {
        Warning_exceeded: 'Warning Exceeded',
        Expired: 'Expired',
        Closed: 'Closed',
        Active: 'Active',
      },
      contactedBy: 'Contacted by',
      contact: {
        list: {
          title: 'Contacts',
          add: 'New contact',
        },
        detail: {
          phoneNumber: 'Phone number ',
          'person-name': 'Name',
          'person-idSeries': 'ID Series',
          'person-idNumber': 'ID Number',
          'person-county': 'County ',
          'person-address': 'Address',
          new: {
            title: 'New Contact',
            save: 'Save',
            close: 'Close',
          },
          inputs: {
            addNewContact: 'New Contact',
          },
          errors: {
            defaultValidationMessage: 'Error',
          },
          email: 'E-mail',
          edit: {
            title: 'Contact Details',
          },
          common: {
            selectExistentContact: 'Select Existent Contact',
            neverCall: 'Never Call',
            jobTitleValue: 'Job Type',
            contactTypeValue: 'Contact Type',
            clearContactSelection: 'Delete Selected Contact ',
            buyingRoleValue: 'Role',
            autocompletePlaceholder: 'Search Contact',
          },
        },
        deleteConfirm: 'Are you sure you want to delete this contact?',
        customerContactTabTitle: 'Customer contact',
        customerContactTabHeader: 'Customer contact details',
        contactTabTitle: 'Contact',
        contactTabHeader: 'Contact details',
      },
      'contact-title': 'Contact',
      attachments: {
        'uploaded-list': 'Attachments list',
        'new-upload': 'Upload New File',
      },
      allCustomers: 'All customers ',
      'address-title': 'Address',
      'add-customer': 'Add customer',
    },
    credit: {
      status: 'Status',
      requestStatus: 'Request status',
      requestedBy: 'Requested by',
      requestDate: 'Requested at',
      listTitle: 'Credits',
      expiryDate: 'Expires on ',
      currencyValue: 'Currency ',
      creditAmount: 'Credit amount',
      approvalDate: 'Approved at',
    },
    contact: {
      list: {
        visibilityTypes: {
          SERVICE_PROVIDER: 'Service provider ',
          PUBLIC: 'Public',
          null: 'All',
          NONE: 'Private',
          CUSTOMER: 'Customer',
          BOTH: 'Both',
        },
        visibilityType: 'Visibility ',
        title: 'Contacts',
        search: 'Search',
        receivesRequests: 'Receives requests',
        phoneNumber: 'Phone number',
        neverCall: 'No sound',
        jobTitleValue: 'Title',
        email: 'E-mail',
        contactTypeValue: 'Contact type',
        contactName: 'Name',
        contactMethods: {
          VISIT: 'Visit',
          TEL: 'Phone number',
          null: 'All',
          EMAIL: 'E-mail',
        },
        contactMethod: 'Contact method ',
        contactCountry: 'Country ',
        buyingRoleValue: 'Role',
        add: 'New contact',
      },
    },
    billingCycle: {
      Weekly: 'Weekly',
      Per_shipment: 'Per shipment',
      Monthly: 'Monthly ',
      Manual: 'Manual',
      Bi_monthly: 'Bi-monthly',
    },
    address: {
      state: 'State',
      'postal-code': 'Postal Code',
      newTitle: 'New address ',
      list: {
        title: 'Adrese',
        add: 'Add',
      },
      error: {
        noAddressSelected: 'Select a valid address',
      },
      detailTitle: 'Address details',
      country: 'Country',
      city: 'City',
      'address-types': {
        Warehouse: 'Warehouse',
        Shipping: 'Shipping',
        Registered: 'Registered address',
        Pickup: 'Pickup',
        Main: 'Main',
        Invoicing: 'Invoicing',
        Delivery: 'Delivery',
        Decision: 'Decision making unit',
        Correspondence: 'Correspondence address',
        Billing: 'Billing',
      },
      'address-type': 'Address Type',
      'address-line': 'Address Line',
    },
    activity: {
      territory: 'Territory',
      teamActivities: 'My team ',
      startTime: 'From',
      'start-time': 'Start Time',
      saveAndCreateNew: 'Save and go to Activities Calendar',
      'sales-search': 'Assigned To Sales',
      sales: 'Sales',
      'planned-start-date': 'Planned Start Date',
      pipelineStage: 'Opportunity stage',
      'pipeline-stage': 'Pipeline Stage',
      overview: {
        title: 'Activity Details',
        startedAt: 'Started At',
        saveSuccess: 'Successfully saved',
        saveError: 'An error occurred',
        opportunity: 'Opportunity ',
        finishedAt: 'Finised At',
        customer: 'Customer',
        contact: 'Contact',
        assignedTo: 'Assigned to',
        actualCompletionDate: 'Completion date achieved',
        activityType: 'Activity Type',
        activityStatus: 'Activity Status',
        activityOutcome: 'Activity outcome',
        activityObjective: 'Activity Objective',
      },
      'opportunity-type': 'Opportunity Type',
      'opportunity-search': 'Opportunity',
      'opportunity-name': 'Opportunity Name',
      'opportunity-header': 'Opportunity Info',
      myActivities: 'My activities',
      list: {
        addNew: 'Add',
      },
      'list-title': 'Activitities',
      error: {
        requiredCustomerSummaryVO: 'The Customer field is required',
        requiredCustomerContactSummaryVO: 'The "Main Contact" field is required',
        requiredcontacts: 'The "Contacts field" is required',
        requiredAssignedToSalesSummaryVo: 'The "Assigned to" field is required',
        requiredActivityType: 'The "Activity Type" field is required',
        requiredActivityStatus: 'The "Activity Status" field is required',
        requiredActivityPurpose: 'The "Activity objective" field is required',
        requiredActivityOutcome: 'The "Activity result" field is required',
        requiredActivityObjective: 'The "Activity objective" field is required',
      },
      endTime: 'Until ',
      'end-time': 'End Time',
      'detail-title': 'Activity ',
      'customer-stage': 'Customer Stage',
      'customer-search': 'Customer',
      'customer-name': 'Customer Name',
      contact: {
        title: 'Contacts',
        'new-title': 'Contact new activity',
        new: 'New contact ',
        list: {
          phoneNumber: 'Phone number',
          contactTypeValue: 'Contact type',
          contactName: 'Name',
          buyingRoleValue: 'Role',
        },
        'add-contact': 'Add the contact',
      },
      'completion-date-time-stamp': 'Generated completion date',
      comments: 'Comments',
      allActivities: 'All activities ',
      'actual-completion-date': 'Actual Completion Date',
      activityCalendar: 'Activities calendar',
      'activity-type': 'Activity Type',
      'activity-title': 'Activity',
      'activity-statuses': {
        Scheduled: 'Scheduled',
        Requested: 'Requested',
        Rejected: 'Rejected',
        null: 'All',
        Done: 'Done',
        Cancelled: 'Cancelled',
      },
      'activity-status': 'Activity Status',
      'activity-purpose': 'Activity Purpose',
      'activity-planning': 'Planning information',
      'activity-outcome': 'Activity Outcome',
      'activity-objective': 'Activity Objective',
      'activity-name': 'Activity name',
      'activity-main-contact': 'Main contact ',
      'activity-header': 'Activity Info',
    },
  },
  costs: {
    totalCosts: 'Total costs',
    list: {
      value: 'Amount',
      validTo: 'To',
      validFrom: 'From',
      title: 'Costs',
      serviceProviderName: 'Service provider name',
      serviceProviderCUI: 'Service provider CUI',
      name: 'Name',
      documentType: 'Document type',
      documentInfo: 'Number / date of document',
      description: 'Desription',
      currencyCode: 'Currency',
      createdBy: 'Added by',
      createdAt: 'Added at',
      coveragePeriod: 'Coverage period',
      costAssociationTypes: {
        VEHICLE: 'Vehicle',
        SERVICE_PROVIDER_ORDER: 'Order',
        DRIVER: 'Driver',
        COST_CENTER: 'Cost center',
      },
      costAssociationType: 'Association type cost',
    },
    form: {
      vehicleAttachments: 'Vehicle attachments',
      vehicle: 'Vehicle',
      value: 'Amount',
      validTo: 'End date',
      validFrom: 'Start date',
      title: 'Title',
      serviceProviderName: 'Service provider name',
      serviceProviderCUI: 'Service provider CUI',
      recurrence: 'Recurrence',
      quantity: 'Quantity',
      orderNumber: 'Order number',
      order: 'Order',
      oneTimeCost: 'Total unique cost',
      measurementUnit: 'Measurement unit',
      errors: {
        requiredVehicle: "The 'Vehicle' field is required",
        requiredValue: "The 'Amount' field is required",
        requiredValidTo: "The 'End date' field is required",
        requiredValidFrom: "The 'Start date' field is required",
        requiredTitle: 'Title is required',
        requiredPrice: 'Amount is required',
        requiredDriver: "The 'Driver' field is required",
        requiredCurrencyCode: "The 'Currency' field is required",
        '0Price': 'Currency is required',
        requiredOneOfFour: 'One of the four fields needs to be completed',
        patternServiceProviderCUI: 'This field must contain at least 2 digits and should not have any spaces',
      },
      driver: 'Driver',
      documentType: 'Document type',
      documentInfo: 'Number / date of document',
      description: 'Description',
      customerName: 'Customer',
      currencyCode: 'Currency',
      cronExpressions: {
        yearly: 'Yearly, starting today',
        monthly: 'Monthly, starting today',
      },
      costCenter: 'Cost center',
      attachments: 'Attachments',
    },
    edit: 'Edit cost',
    'delete-confirmation-message': (param) =>
      `Are you sure you want to delete the cost <strong>${param.costTitle}</strong> ?`,
    delete: 'Delete cost',
    costs: 'costs',
    add: 'Add cost',
  },
  costCenter: {
    utils: {
      update: 'Update',
      search: 'Search',
      save: 'Save',
      requiredLegend: 'Fields marked with * are required!',
      close: 'Close',
      cancel: 'Cancel',
      add: 'Add',
      deleteConfirmationMessage: 'Are you sure you want to delete this cost center?',
    },
    selectDialog: {
      title: 'Cost center',
    },
    selectButton: 'Cost Center',
    manage: {
      title: 'Update Cost Center',
    },
    list: {
      validTo: 'Valid until',
      title: 'Cost Centers',
      parentLabel: 'Parent',
      label: 'Name',
      isPrivate: 'Private',
      isCustomerBehalf: 'Created by vendor',
      disabledDeleteTooltip: 'The cost center is already inactive',
      createdAt: 'Created at',
    },
    input: 'Cost Center',
    edit: {
      title: 'Edit Cost Center',
    },
    add: {
      title: 'Add Cost Center',
      parent: 'Parent',
      label: 'Label',
      isPrivate: 'Private',
      error: {
        requiredLabel: 'Name is required.',
      },
    },
  },
  contract: {
    tariff: 'Tariff',
    sp: {
      transitTime: 'Transit days',
      transitNamedLocation: 'Transit location',
      tooltip: {
        weight: 'Weight',
        vehicleType: 'Vehicle type',
        validTo: 'Valid to',
        validity: 'Validity',
        validFrom: 'Valid from',
        type: 'Type',
        transitTime: 'Transit time',
        transitNamedLocation: 'Transit location',
        transitPoint: 'Transit point',
        tags: 'Tags',
        size: 'Size',
        serviceProvider: 'Service provider',
        referenceNumber: 'Reference number',
        pieces: 'Pieces',
        paymentTimeLimit: 'Payment time limit',
        noticeTime: 'Notice time',
        label: 'Label',
        exclusive: 'Exclusive shipment',
        customerComments: 'Customer comments',
        customer: 'Customer',
        operationalTerritory: 'Territory',
        pickupNamedLocation: 'Pickup location',
        deliveryNamedLocation: 'Delivery location',
        centralNamedLocation: 'Central location',
      },
      title: 'Contract',
      tariffs: 'Tariffs',
      selectAccount: 'Select Account',
      save: 'Save',
      price: 'Price',
      from: 'from',
      exclusive: 'Exclusive shipment',
      dynamicTariffsInfoMessage:
        'The entered prices are per package and will be used to generate a dynamic price for the order.',
      disabledDynamicTariffsInfoMessage:
        'Contracts with automatically calculated prices cannot be used because there are transports that do not consist of standard locations and packages or there are no contracts for them',
      errors: {
        requiredTransitTime: 'The Price field is required',
        requiredPrice: 'The Price field is required',
        requiredAccount: 'The Account field is required',
        required: 'This field is required',
      },
      details: 'Details',
      'contract-answer': 'Respond to contract request',
      comments: 'Comments',
      cancel: 'Back',
      'answer-details': 'View details',
      account: 'Account',
    },
    'select-tariff': 'Select tariff',
    'remove-tariff': 'Remove tariff',
    selectedTariff: 'Selected tariff',
    request: {
      waypoint: 'Waypoint',
      'view-response-title': 'Contract request response',
      utils: {
        transport: 'Transport',
        to: 'To',
        save: 'Save',
        reject: 'Reject',
        edit: 'Edit',
        duplicate: 'Duplicate',
        delete: 'Delete',
        close: 'Close',
        cancel: 'Cancel',
        accept: 'Accept',
      },
      fixedPriceContract: 'Fixed price',
      useFixedPriceContract: 'Use contract with fixed price',
      dynamicPriceContract: 'Dynamic calculated price',
      selectedPackages: 'Selected packages',
      routes: 'Routes',
      routesAndTerritories: 'Routes and Territories',
      removeWaypoint: 'Delete location ',
      removeRoute: 'Delete route',
      rejectedRequest: 'Contract request was refused',
      rejectedReason: 'Rejected reason',
      quantity: 'Quantity',
      'page-title': 'Contract request',
      packages: 'Packages',
      form: {
        width: 'Width',
        weight: 'Weight',
        validTo: 'Valid to',
        validFrom: 'Valid from',
        'valid-to': 'Valid to',
        'valid-from': 'Valid from',
        type: 'Type',
        transitTime: 'Transit time (days)',
        tags: 'Tags',
        serviceProvider: 'Service provider name',
        'service-provider-name': 'Service provider name',
        referenceNumber: 'Reference Number',
        pieces: 'No. packages',
        paymentTimeLimit: 'Payment time limit (days)',
        notice: 'Notice time (days)',
        locked: 'Exclusive transport',
        'location-required': 'It is required to fill out minimum 2 locations for one route.',
        'location-or-territory-required':
          'It is required to fill out minimum 2 locations or territories for one route.',
        'list-title': 'Customer contracts',
        length: 'Length',
        label: 'Label',
        height: 'Height',
        details: 'Details',
        description: 'Name',
        currency: 'Currency',
        'contract-request-status': 'Status',
        carType: 'Vehicle type',
      },
      errors: {
        requiredWidth: 'This field is required',
        requiredWeight: 'This field is required',
        requiredValidTo: "The 'Valid until' field is required",
        requiredValidFrom: "The 'Valid from' field is required",
        requiredPieces: 'This field is required',
        requiredLength: 'This field is required',
        requiredHeight: 'This field is required',
        requiredCurrencyCode: "The 'Currency' field is required",
        requiredContacts: 'At least one contact is required',
        minPieces: 'Invalid quantity',
        invalidFormWithContacts:
          'It is required to select a vendor, a route with minimum two locations, minimum one contact and minimum one package dimensions',
        invalidForm:
          'It is required to select a vendor, a route with minimum two locations and minimum one package dimensions',
      },
      editUnavailable: 'Editing the request is no longer available',
      'edit-page-title': 'Edit contract request',
      comments: 'Remarks',
      addWaypoint: 'Add waypoint',
      addRoute: 'Add route',
      addRouteOrTerritory: 'Add route or territory',
      addTerritory: 'Add territory',
      addLocations: 'Locations',
      addTerritories: 'Territories',
      addCustomDimensions: 'Add other packages',
      acceptRequest: 'Are you sure you want to confirm the contract? This action cannot be reversed!',
    },
    order: {
      tariffType: 'Tariff type',
      tariffRequired: 'Tariff selection is required',
      shipmentTariff: 'Tariff per shipment',
      orderTariff: 'Tariff per order',
      changeTariffType: 'Change tariff type',
    },
    customer: {
      'valid-to': 'Valid to',
      'valid-from': 'Valid from',
      utils: {
        add: 'Add',
      },
      statuses: {
        REJECTED: 'Rejected',
        PENDING: 'Pending',
        null: 'No status',
        CONFIRMATION_PENDING: 'Waiting for confirmation',
        CANCELED: 'Canceled',
        ACCEPTED: 'Accepted',
      },
      status: 'Status',
      serviceProvider: 'Service provider',
      'list-title': 'Contracts with vendors',
      label: 'Label',
      'edit-contract-request': 'Edit contract request',
      contractRejectTitle: 'Reject Contract',
      contractRejectReason: 'Reason',
      'contract-request-details': 'See answer details',
    },
    cancellation: {
      rejectCancelContract: 'Reject',
      cancelRequest: 'Cancel request',
      cancelledContract: 'Contract cancelled',
      cancelContractForcedButton: 'Forced contract cancellation',
      cancelContractDialog: {
        title: 'Contract Cancellation Request',
        forcedWarning:
          'The cancellation will be made without the agreement of the other parties involved. Cancellation will result in penalties according to the Terms and Conditions of Carriage.',
        forced: 'Forced cancellation',
        details: 'Reason',
      },
      cancelContractButton: 'Cancel contract',
      acceptCancelContract: 'Accept cancel contract',
    },
  },
  contactManagement: {
    receivesRequestsRequiredTooltip: 'To select a contact method you must receive requests',
    inputs: {
      visibilityTypes: {
        SERVICE_PROVIDER: 'Service provider',
        PUBLIC: 'Public',
        NONE: 'Private',
        CUSTOMER: 'Customer',
        BOTH: 'Both',
      },
      visibilityType: 'Visibility',
      searchPerson: 'Search existing person',
      receivesRequests: 'Receive requests',
      phoneNumber: 'Phone number',
      person: 'Person',
      new: 'New person',
      email: 'E-mail',
      contactMethods: {
        VISIT: 'Visit',
        TEL: 'Phone number',
        EMAIL: 'E-mail',
      },
      contactMethod: 'Contact method',
      clearSelection: 'Delete selected person ',
      addPerson: 'Add new person',
      addContact: 'Add new contact',
    },
    error: {
      patternEmail: "The  'Email' is invalid",
      requiredVisibility: "The  'Visibility' field is required",
      requiredPhoneNumber: "The  'Phone number' field is required",
      requiredPerson: "The  'Person' field is required",
      requiredEmail: "The  'E-mail' field is required",
      requiredContactMethod: "The  'Contact method' field is required",
    },
    companyPartnerContact: {
      addTitle: 'Add contact for partner',
    },
  },
  constants: {
    cronExpressions: {
      yearly: 'Once a year',
      weekly: 'Once a week',
      monthly: 'Once a month',
      daily: 'Once a day',
    },
  },
  consolidation: {
    utils: {
      solve: 'Solve',
    },
    'shipment-group': {
      title: 'Consolidation',
      saveShipmentGroupDisabledTooltip: 'Select a group from the right to save a new shipment group',
      noDataDescription: 'No available shipment groups',
      list: {
        title: 'Shipment groups',
      },
      invalidShipmentGroupsMessage: 'Select shipment groups that are not already selected',
      addGroup: 'Add group',
    },
  },
  companyAsset: {
    unsupportedType: 'Asset type is not supported!',
  },
  company: {
    suggestions: {
      addLogoAsset: 'You do not have a company logo set up. Add it by clicking on the following button',
      addCompanyContact: 'Add a new contact to: ',
    },
    utils: {
      yes: 'Yes',
      upload: 'Upload ',
      singleUpload: 'Only one attachment of this type can be uploaded',
      select: 'Select',
      search: 'Search ',
      save: 'Save',
      requiredLegend: 'All fields marked with * are mandatory!',
      requiredLabel: 'All fields marked with * are mandatory!',
      no: 'No',
      next: 'Next page',
      invalidateEmployeeConfirmationMessage:
        'Once deleted, this user will become invalid and will no longer be able to login!',
      edit: 'Edit',
      deleteConfirmationTitle: 'Confirm delete',
      deleteConfirmationMessage: 'Would you like the employee, <b>{{employeeName}}</b>, to be deleted?',
      close: 'Close',
      cancel: 'Close',
      'boolean-select-item': {
        true: 'Yes',
        null: 'All',
        false: 'No',
      },
      all: 'All',
    },
    type: {
      service_provider: 'Vendor',
      forwarder: 'Forwarder',
      customer: 'Customer',
    },
    'subscription-type': {
      subscription: {
        list: {
          title: 'Subscriptions',
        },
        legalEntity: 'Company',
        detail: 'Details',
      },
      'select-company-type': 'Choose company type ',
      private: 'Private',
      'new-actions': 'Define Actions ',
      'list-title': 'Subscription Types',
      inputs: {
        typeName: 'Subscription name ',
        subscriptionPrice: 'Price',
        subscriptionDetails: 'Details',
        subscriptionCurrency: 'Currency',
        private: 'Private',
        pricePerExtraCredit: 'Cost per extra credit',
        legalEntity: 'Company ',
        creditStart: 'Credit start ',
        companyType: 'Company type',
      },
      errors: {
        requiredtypeName: 'The Name field is required',
        requiredsubscriptionPrice: 'The price field is required',
        requiredsubscriptionCurrency: 'The currency field is required',
        requiredPricePerExtraCredit: 'The "Cost per extra credit" field is required',
        requiredCreditStart: 'The "Credit start" field is required',
        requiredcompanyType: 'The company type field is required',
      },
      companyTypes: {
        service_provider: 'Vendor',
        forwarder: 'Forwarder',
        customer_with_fleet: 'Customer with fleet',
        customer: 'Customer',
      },
      companies: 'Companies',
      'add-title': 'Define Subscription Types',
      add: 'Add',
      actions: {
        SEND_ORDER: 'Send order',
        RECEIVE_ORDER: 'Receive order',
        pricePerExtraCredit: 'Cost per extra credit',
        'offer-request': 'Offer request ',
        monthlyIncludedAmount: 'Included actions',
        info: 'Access to all application features',
        creditStart: 'Credit start',
        credits: 'credits',
        CREATE_OFFER: 'Offer requests',
        actionCost: 'An additional action costs',
      },
      'actions-list': {
        list: {
          validTo: 'Valid to',
          validFrom: 'Valid from ',
          title: 'List actions',
          subscriptionTypeName: 'Subscription name',
          subscriptionTypeModule: 'Subscription mode',
          search: 'Search',
          name: 'Name',
          monthlyIncludedAmount: 'Monthly included',
          cost: 'Cost',
          adminTitle: 'Action administration ',
        },
        inputs: {
          validTo: 'Valid to',
          validFrom: 'Valid from',
          monthlyIncludedAmount: 'Included each month ',
          actionName: 'Action name',
          actionCost: 'Action cost',
        },
        errors: {
          requiredcost: 'The Action cost field is required',
          requiredactionName: 'The Action name field is required',
        },
        detailTitle: 'Action details',
        addTitle: 'Add action',
      },
    },
    myCompany: {
      title: 'Company profile',
      subscriptionValidFrom: 'Valid from',
      subscriptionRenewedAt: 'Renewed on',
      firstSubscriptionDate: 'Subscription created on',
      remainingCredit: 'Remaining credit',
      details: 'Company details',
    },
    menu: {
      userActionTracking: 'Action Tracking',
      termsAndConditions: 'Terms and Conditions',
      roleConfiguration: 'Role configuration ',
      partners: 'Partners',
      employees: 'Employees',
      details: 'Details',
      contacts: 'Contacts',
      companyProfile: 'Company Profile',
      companies: 'Companies',
      bankAccounts: 'Bank Accounts',
      bankAccountAudit: 'Bank Account Audit ',
      allCompanies: 'All Companies',
      addresses: 'Addresses',
    },
    'le-terms-and-conditions': {
      types: {
        SERVICE_PROVIDER_OFFER_REQ: 'Terms and Conditions with Vendors:',
        CUSTOMER_OFFER_REQ: 'Terms and Conditions with Customers:',
      },
      title: 'Terms and Conditions in language ',
      preview: 'Preview',
      'general-terms-and-conditions-title': {
        SERVICE_PROVIDER_OFFER_REQ: 'General Terms and Conditions with Vendors',
        CUSTOMER_OFFER_REQ: 'General Terms and Conditions with Clients',
      },
      dashboard: {
        vendors: 'Partner vendors ',
        customers: 'Customers',
      },
      add: {
        versions: 'Versions',
        version: 'Version in progress: ',
        'valid-to': 'Valid to ',
        'valid-from': 'Valid from ',
        tooltip: {
          SERVICE_PROVIDER_OFFER_REQ: 'Add general T&C with Vendors for accessing the button',
          CUSTOMER_OFFER_REQ: 'Add general T&C with Clients for accessing the button',
        },
        'time-undefined': 'Undefined',
        'new-major-version-button': 'Add new major version',
        'new-major-version': 'Add new version from scratch',
        'for-other': {
          SERVICE_PROVIDER_OFFER_REQ: 'Add T&C for other service providers',
          CUSTOMER_OFFER_REQ: 'Add T&C for other clients',
        },
        errors: {
          requiredValidFrom: 'The original validity cannot be empty',
          requiredTemplate: 'The field terms and conditions cannot be empty',
        },
        availability: 'Availability ',
        'active-version': 'Active version ',
      },
    },
    error: {
      noContactsWithEmail:
        'No contacts for this company were found to be marked as Receiving Requests or to use a valid email address!',
      alreadyExistingAddressOfType: 'There is already an address of this type!',
    },
    employee: {
      role: {
        roleSavedSuccess: 'Role configuration has been successfully saved!',
      },
      new: {
        title: 'Add Employee',
      },
      list: {
        validTo: 'Valid to',
        validFrom: 'Valid from',
        undefinedValidTo: 'Undefined ',
        search: 'Search',
        pid: 'PID',
        phoneNumber: 'Phone number',
        name: 'Name',
        hasUserStatus: {
          false: 'Absent',
        },
        hasUser: 'User',
        expired: 'Expired',
        county: 'County',
        country: 'Country',
        add: 'Add Employee',
        active: 'Active',
      },
      error: {
        requiredValidTo: 'The Valid to field is required',
        requiredValidFrom: 'The Valid from field is required',
        requireduserName: 'The Username field is required',
        patternEmail: 'The Username is invalid',
        requiredPerson: 'The Person field is required',
        requiredpassword: 'The Password field is required',
        requiredname: 'The Name field is required',
        requiredcounty: 'The county field is required',
      },
      edit: {
        title: 'Edit Employee',
      },
      common: {
        wizard: {
          userStep: 'User',
          employeeStep: 'Employee',
        },
        validTo: 'Valid to',
        validFrom: 'Valid from',
        userDTO: {
          userName: 'Username',
          password: 'Password',
        },
        selectDepartment: 'Select department ',
        phoneNumber: 'Phone number',
        personDTO: {
          selectUser: 'Select user or complete the fields below',
          person: 'Person',
          name: 'Name',
          idSeries: 'ID Series',
          idNumber: 'ID Number ',
          county: 'County',
          country: 'Country',
          cnp: 'Personal Identification Number',
          address: 'Address',
          addPerson: 'Add person',
        },
        newDepartment: 'New department ',
        email: 'Email address',
        departmentName: 'Department name',
      },
    },
    creditCard: {
      expirationDateFormat: 'MM/YY',
      expirationDate: 'Expiration date',
      error: {
        requiredName: "The field 'Card owner' is required",
        requiredExpirationDate: "The field 'Expiration date' is required",
        requiredCardNumber: "The field 'Card number' is required",
        invalidExpirationDate: 'Invalid expiration date',
        invalidCardNumber: 'Invalid card number',
      },
      cardOwner: 'Card owner',
      cardNumber: 'Card number',
      card: 'CARD',
    },
    contact: {
      unsubscribeSuccess: 'You have successfully unsubscribed',
      unsubscribe: 'Unsubscribe',
      save: 'Save',
      new: 'New contact',
      list: {
        visibilityTypes: {
          SERVICE_PROVIDER: 'Service provider',
          PUBLIC: 'Public',
          null: 'All',
          NONE: 'Private',
          CUSTOMER: 'Customer',
          BOTH: 'Both',
        },
        visibilityType: 'Visibility',
        search: 'Search',
        receivesRequests: 'Receives requests ',
        phoneNumber: 'Phone number',
        ownerCompanyName: 'Company owner',
        email: 'Email address',
        contactName: 'Name ',
        contactMethods: {
          VISIT: 'Visit',
          TEL: 'Phone number',
          null: 'All',
          EMAIL: 'Email address',
        },
        contactMethod: 'Contact method',
        contactIsNotOwned: 'The contact cannot be deleted because it is not owned by you',
        contactCountry: 'Country ',
        companyName: 'Company',
        companyIsSuperAdmin: 'The contact cannot be deleted because it belongs to the company owner',
        add: 'Add',
      },
      detail: 'Contact details',
      confirmEmailUnsubscribe: 'Are you sure you want to unsubscribe from receiving notifications via email?',
      close: 'Close',
    },
    companyType: {
      service_provider: 'Vendor',
      forwarder: 'Forwarder',
      customer_with_fleet: 'Client with fleet',
      customer: 'Customer',
    },
    companyDetails: {
      invoiceSeriesPrefix: 'Invoice Series Prefix',
      invoice: {
        logo: 'Logo',
      },
      existingCompanyError: 'The company you want to add is already registered in the platform',
      createServiceProvider: 'Service Provider',
      companyTabTitle: 'Company',
      companyTabHeader: 'Company details ',
      companyFormSubTitle: 'These are the official data from the Ministry of Finance',
    },
    businessProfile: {
      subscriptionTypeTabHeader: 'Subscription details ',
      publicTitle: 'Company ',
      partnerTitle: 'Partner companies',
      myProfileTitle: 'Company profile ',
      list: {
        vat: 'VAT',
        uniqueIdentificationNumber: 'Unique identification number ',
        typeValue: 'Type',
        sendInvitationEmail: 'Send invitation to collaborate',
        search: 'Search',
        PUBLIC: 'Not a partner',
        platformMember: 'Platform member',
        PARTNER: 'Partner ',
        mainPhoneNumber: 'Phone number',
        mainEmailAddress: 'Email address',
        industryTypesValue: 'Industry type ',
        delete: 'Delete',
        country: 'Country',
        contactList: 'Contact list',
        onCompanyAddress: 'Add company address',
        companyName: 'Company name',
        city: 'Locality',
        businessProfileType: 'Partner',
        addCompany: 'Add company ',
        account: 'Account',
      },
      companyTabHeader: 'Company details',
      cardTabHeader: 'Card details ',
      bankAccountTabHeader: 'Bank account details',
      partners: {
        selectPartner: 'Select a partner company',
      },
    },
    bankAccount: {
      updateExisting: 'Update the existing bank account ',
      typeEnum: {
        VAT: 'VAT ',
        Primary: 'Primary',
        Normal: 'Normal',
      },
      type: 'Account type',
      title: 'Bank Account',
      swiftCode: 'Swift Code',
      statusEnum: {
        Suspended: 'Suspended',
        Closed: 'Closed',
        Active: 'Active',
      },
      status: 'Account status',
      saveNew: 'Save bank account ',
      lastModifiedBy: 'Last modified by ',
      lastModifiedAt: 'Last modified at',
      iban: 'Iban ',
      error: {
        requiredType: 'The Type field is required',
        requiredStatus: 'The Status field is required',
        requiredIban: 'The Iban field is required',
        requiredCurrencyCode: 'The Currency field is required',
        requiredBankName: 'The Bank name field is required ',
        bankAccountOwnershipError: 'Cannot add or update data on other company bank accounts',
      },
      currencyCode: 'Currency ',
      bankName: 'Bank name',
      addNew: 'Add a new bank account',
    },
    address: {
      newTitle: 'New address',
      mainAddress: 'Primary address',
      list: {
        add: 'Add',
      },
      error: {
        noAddressSelected: 'Please select a valid address',
      },
      detailTitle: 'Address details',
    },
  },
  'company-user': {
    title: 'Users',
    list: {
      username: 'Username',
      phone: 'Phone',
      'last-login': 'Last login',
      indefinitely: 'Termen nedeterminat',
      email: 'Email',
      createdAt: 'Created at',
      company: 'Company',
      activeTo: 'Active to',
    },
  },
  'company-profile': {
    utils: {
      search: 'Search',
      save: 'Save',
      emptyMessage: ' No results were found',
      cancel: 'Cancel',
      all: 'All',
    },
    performedActions: {
      performedBy: 'Performed by',
      paymentDate: 'Payment date ',
      'list-title': 'Actions taken',
      creditPaymentSum: 'Number of Credits',
      actionName: 'Action name',
    },
  },
  'company-details': {
    'terms-and-conditions': 'Terms & Conditions',
    details: 'Details',
  },
  code: 'Global account code',
  close: 'Close',
  'cash-flow': {
    viewTransactions: 'View transactions',
    updateBalance: 'Update balance',
    transactions: {
      value: 'Value',
      type: {
        payment: 'Payment',
        invoice: 'Invoice',
        cashflow_item: 'Transaction',
      },
      title: 'Transactions',
      invoiceSeries: 'Invoice series',
      form: {
        errors: {
          requiredValue: 'This field is required',
          requiredDate: 'This field is required',
          requiredCurrencyCode: 'This field is required',
          requiredComments: 'This field is required',
        },
      },
      emptyTransactionsMessage: 'No transactions for this day',
      employee: 'Modified by employee',
      edit: 'Edit transaction',
      deleteMessage: 'Are you sure you want to delete this transaction?',
      deleteHeader: 'Confirm deletion',
      dateTransactionsTitle: 'Cash flow from date',
      date: 'Date',
      currencyCode: 'Currency',
      Correction: 'Correction',
      comments: 'Details / Tag',
      add: 'Add transaction',
    },
    transaction: 'Transaction',
    title: 'Cash Flow',
    selectStartDate: 'Select date',
    noCurrenciesSelected: 'Select a currency',
    currentDayBalance: 'Current day balance',
    correction: {
      title: 'Update balance',
      targetAmount: 'Updated balance',
      form: {
        errors: {
          requiredTargetAmount: 'This field is required',
          requiredDate: 'This field is required',
          requiredCurrencyCode: 'This field is required',
        },
      },
      date: 'Date',
      currencyCode: 'Currency',
    },
    addTransaction: 'Add transaction',
  },
  'budget-management': {
    totalCosts: 'Total costs',
    selectQuarter: 'Select quarter',
    quarterWeek: (params) => `Week ${params.weekNumber}`,
    'list-title': (params) => `Budget ${params.year}`,
    emptyCell: '-',
    budgetCosts: 'Budget costs',
    actualCosts: 'Actual costs',
  },
  'bp-selectable-contact-list': {
    selected: 'selected',
    noContactsSelected: 'No contacts selected',
    'contact-list-title': 'Contacts',
  },
  blacklist: {
    type: 'Type',
    lastModifiedByEmployeeName: 'Modified by',
    date: 'Date',
    comment: 'Comment',
    blacklistHistory: 'Blacklist history',
  },
  auth: {
    yes: 'Yes',
    warnings: {
      emailNullReference: 'To continue navigation to other pages, please set an email address!',
    },
    validationCode: 'Validation code',
    validatePhoneNumber: 'Phone number validation',
    validateCode: 'Validate code ',
    utils: {
      requiredLegend: 'All fields marked with * are mandatory!',
      cancel: 'Undo',
      back: 'Back ',
    },
    users: 'Users',
    username: 'Username',
    ipAddress: 'IP address',
    operatingSystem: 'Operating system',
    browser: 'Browser',
    user: {
      new: 'Create user',
      edit: 'Edit user ',
    },
    signupButton: 'Sign up Company',
    signup: 'Sign up',
    sendSmsValidation: 'Send text message for validation',
    selectAll: 'Select all roles ',
    search: 'Search',
    save: 'Save',
    role: {
      otherRights: 'Other Rights',
      newRole: 'New role title',
      isPlatform: 'Platform Role',
      editRole: 'Edit role',
      descriptionPlaceholder: 'Please enter the role description',
      confirmDeletion: 'Are you sure you want to delete the role?',
      cloneRole: 'Create a duplicate role',
      assigned: 'Assigned role',
      configuration: {
        errors: {
          requiredName: "'New role title' field is required",
        },
      },
    },
    rights: 'Rights',
    rightName: 'Name of the right',
    'resend-email-confirmation': {
      success: 'The confirmation email was successfully sent',
      error: 'Could not send confirmation email',
      button: 'Resend confirmation email',
    },
    registerQuestion: 'Your company is not registered on the platform?\n',
    profileInfoChanged: 'Profile details updated successfully! Please login in order for the changes to be visible.',
    phoneNumber: 'Phone number',
    passwordRecoveryRequest: {
      title: 'Password recovery assistance\n',
      recovery: 'Recover password\n',
      messages: {
        success: 'The password reset mail has been successfully sent\n',
        error: {
          '504': "We're sorry, but changing the password is not possible at the moment!\n",
          undefined: "We're sorry, but changing the password is not possible at the moment!\n",
        },
      },
      mainCredential: 'Username or email address\n',
      error: {
        requiredMainCredential: 'Please enter a username or email address',
      },
      description: 'Please enter your email address or username associated with your account\n',
    },
    passwordRecovery: {
      title: 'Recover password',
      newPasswordConfirmation: 'Confirm new password',
      newPassword: 'New Password',
      messages: {
        success: 'User password has been successfully changed\n',
        successfulIfValid: 'If the account exists, a password reset email has been sent',
      },
      error: {
        requiredNewPasswordConfirmation: 'New password confirmation field is required\n',
        passwordConfirmationMatchError: 'Password confirmation does not match with the password',
        minLength9: 'Your password must contain at least 9 characters\n',
        customPattern:
          'Password must contain at least one lowercase, at least one uppercase, at least one numeric, at least one special character, it must have minimum 9 characters and maximum 32 characters!\n',
      },
      changePassword: 'Change password',
    },
    passwordExample: 'E.g. parolagauss',
    passwordConfirmation: 'Password confirmation',
    'password-recovery-request-link': 'Forgot your password? ',
    password: 'Password',
    oldPassword: 'Old password',
    no: 'No',
    name: 'Name',
    menu: {
      workflows: 'Workflows',
      users: 'Users',
      sentNotifications: 'Sent notifications',
      reports: 'Reports',
      profile: 'Profile',
      platformManagementSubscriptions: 'Subscription types',
      platformManagementInvoices: 'Invoices',
      platformManagementCompanies: 'Companies',
      platformManagement: 'Platform',
      notificationSettings: 'Notification settings',
      notifications: 'Notifications',
      notificationEvents: 'Sent events',
      jobs: 'Jobs',
      importExecutions: 'Import Executions',
      importDefinitions: 'Import Definitions',
      feedbackManagement: 'Management feedback',
      exceptions: 'Exceptions',
      dashboard: 'Dashboard',
      authLogs: 'Login history',
      ownedAuthLogs: 'Login history',
    },
    loginDate: 'Login date',
    'login-details': 'Login details',
    login: 'Login',
    language: 'Language',
    itemsSelected: '{0} selected',
    invalidPhoneNumber: 'Invalid phone number',
    invalidCode: 'Incorrect validation code',
    indefinitely: 'Indefinitely',
    errors: {
      '504': "We're sorry, but authentication is not possible at the moment!",
      undefined: "We're sorry, but authentication is not possible at the moment!",
      requiredConfirmCheckbox: 'Checking the box is mandatory',
      requiredPhoneNumber: 'Phone Number required',
      requiredPasswordConfirmation: 'Please enter a new password',
      requiredPassword: 'Password is required ',
      requiredOldPassword: 'Please enter your old password',
      requiredNewPasswordConfirmation: 'Please re-enter your new password',
      requiredNewPassword: 'Please enter a new password',
      requiredName: 'Username field is required',
      requiredEmail: 'Email field is required',
      requiredConfirmEmail:
        'By checking the box, you agree that the confirmation email will be sent to the email address you have entered.',
      pattern: 'Please enter a valid email address',
      passwordConfirmationMatchError: 'Password confirmation does not match with the password',
      passwordConfirmation: {
        requiredPasswordConfirmation: 'The password confirmation is mandatory!',
        passwordConfirmationMatchError: 'Password confirmation does not match with the password',
      },
      password: {
        required: 'The field is required',
        requiredNewPassword: 'The password is mandatory.',
        requiredConfirmPassword: 'The password confirmation is mandatory.',
      },
      oldPassword: {
        'old-password-match': 'The old password is not correct!',
      },
      name: {
        required: 'The field is required',
        minlength: 'Username must be at least 5 characters long.',
      },
      minlengthPasswordConfirmation: 'Please enter at least 5 characters',
      minlengthPassword: 'Please enter at least 5 characters',
      minlengthOldPassword: 'Please enter at least 5 characters',
      minLength5: 'Please enter at least 5 characters',
      maxlengthPasswordConfirmation: 'Please enter a maximum of 50 characters',
      maxlengthPassword: 'Please enter a maximum of 50 characters',
      maxlengthOldPassword: 'Please enter a maximum of 50 characters',
      maxLength50: 'Please enter a maximum of 50 characters',
      invalid_token: 'Session expired. Please login again',
      hasWhitespacePassword: 'Password cannot contain any blank spaces',
      'expired-user': 'The user is no longer active',
      emailEmail: 'Email address not valid',
      email: {
        required: 'The field is mandatory to be filled in!',
        pattern: 'Email address not valid',
      },
      'disabled-user': 'The email address of the user has not been confirmed',
      customPatternUsername:
        "Username field must contain between 8-20 small characters. It cannot contain blank spaces or special characters, words must be linked by '.' or '_'",
      customPatternEmail: 'Email address not valid',
      'Bad credentials': 'Incorrect username or password!',
    },
    error: {
      'bad-credentials': 'Wrong username or password!',
    },
    emailConfirmation: {
      success: 'User has been successfully activated\n',
      error: 'User could not be activated\n',
    },
    email: 'E-mail',
    edit: 'Edit',
    description: 'Description',
    delete: 'Delete',
    confirmEmailCheck: 'I accept that the user confirmation link will be sent to the email address entered.\n',
    companyType: 'Company type',
    companySuperAdmin: 'Company Administrator ',
    changePassword: 'Change password',
    cancel: 'Cancel',
    authenticationLog: 'Login history',
    add: 'Add',
    activeTo: 'Active to',
    activeRight: 'Active right',
    activeOpts: {
      inactive: 'Inactive',
      all: 'All',
      active: 'Active',
    },
  },
  'auth-app': {
    greeting: 'Hello!',
  },
  attachmentUploader: {
    browse: 'Choose',
  },
  'alert-notification': {
    solve: 'Mark as solved',
    message: 'You have a pending alarm!',
  },
  address: {
    visibilityTypes: {
      SERVICE_PROVIDER: 'Service provider',
      PUBLIC: 'Public',
      null: 'All',
      NONE: 'Private',
      CUSTOMER: 'Customer',
      BOTH: 'Both',
    },
    visibility: 'Visibility',
    utils: {
      yes: 'Yes',
      save: 'Save',
      no: 'No',
      deleteConfirmation: 'Delete confirmation',
      apply: 'Apply',
      all: 'All ',
    },
    type: 'Address type',
    streetNumber: 'Street number',
    streetName: 'Street name',
    state: 'State',
    countyCode: 'County ode',
    block: 'Block',
    building: 'Building',
    floor: 'Floor',
    apartment: 'Apartment',
    selectAddress: 'Choose searched address',
    searchSavedAddress: 'Search saved address',
    'search-box': {
      'update-address': 'Update address',
      local: 'saved addressed',
      label: 'Search address',
      google: 'google',
    },
    'save-disabled': 'Saving the address can be done after entering a valid address',
    inaccurateAddressMessage:
      'A physical location could not be found for the entered address. Please check the correctness of the fields and try again or search for a new address.',
    savedAddressMessage: 'Address successfully saved !',
    'save-address-title': 'Add a new in order to save the address',
    'save-address-label': 'Save address',
    readonlyAddressType: 'Address type cannot be changed as long as the Main Address checkbox is enabled',
    postalCode: 'Postal code',
    mainAddress: 'Main address',
    locationChanged: 'Location was successfully changed',
    location: 'Location',
    list: {
      visibilityType: 'Visibility',
      type: 'Address type',
      state: 'State',
      search: 'Search',
      postalCode: 'Postal code',
      ownerCompanyName: 'Company owner',
      label: 'Tag',
      country: 'Country',
      companyName: 'Company ',
      city: 'City',
      addressLine: 'Line',
    },
    hideDialog: 'Close',
    google: {
      status: {
        ZERO_RESULTS: 'No results found for this search. Try again',
        UNKNOWN_ERROR: 'An error has occured',
        REQUEST_DENIED: 'Google does not allow the use of this service',
        OVER_QUERY_LIMIT: 'The number of searches has been exceeded. Contact the platform administrator for details',
        NOT_FOUND: 'Location was not found',
        INVALID_REQUEST: 'This search is not allowed',
      },
    },
    error: {
      ZERO_RESULTS: 'No results were found. Move the pin and try again',
      requiredVisibilityType: 'Visibility is required',
      requiredState: 'State is required',
      requiredPostalCode: 'Postal code is required',
      requiredCountry: 'Country is required',
      requiredCity: 'City is required',
      requiredStreetName: 'Street name is required',
      requiredStreetNumber: 'Street number is required',
      requiredAddressValueType: 'Address type is required',
      requiredAddressTypeValue: 'Address type is required',
      requiredAddressLabel: 'Tag is required',
      requiredaddress: 'Address is required',
      pinDistanceTooLong:
        'The distance between the selected address and the location of the pin on the map is more than 50km. Move the pin closer to the location of the selected address.',
      noAddressSelected: 'Address must be selected or created',
      maxDistanceExceeded: 'Address must be within 50km of the segment',
    },
    details: 'Details',
    country: 'Country',
    clearSelection: 'Delecte selection',
    city: 'City ',
    choose: 'Choose existing address',
    addressTypes: {
      Warehouse: 'Warehouse',
      Shipping: 'Delivery',
      Registered: 'Registration',
      Pickup: 'Loading',
      Office: 'Office',
      Main: 'Main',
      Invoicing: 'Invoicing',
      FiscalResidence: 'Fiscal Residence',
      Delivery: 'Unloading',
      Decision: 'Decision',
      Correspondence: 'Correspondence',
      Billing: 'Billing',
    },
    addressPickup: {
      saveAddress: 'Save address',
    },
    addressLine: 'Address line',
    addressLabel: 'Address tag',
    addressIsNotOwned: 'The address cannot be deleted because it is not owned by you',
    'address-title': 'Address',
    addNew: 'Add new address',
  },
  'add-form': {
    'warning-vehicle': 'Routing solution was successfully updated with vehicle details',
    'warning-driver': 'Routing solution was successfully updated with driver details',
    'vehicle-type': 'Vehicle Type',
    vehicle: 'Vehicle',
    title: 'Creat tasks',
    start: 'Start Date',
    secondDriver: 'Second Driver',
    save: 'Save',
    pickup: 'Pickup location',
    packages: 'Packages',
    mainDriver: 'Main Driver',
    finish: 'End Date',
    error: {
      selectedDateAfterCurrentDateStart: 'Pickup date should be Current date',
      selectedDateAfterCurrentDateFinish: 'Delivery date should be Current date',
      requiredVehicleVO: 'Vehicle field is mandatory',
      requiredDriverVO: 'Driver field is mandatory',
      endBeforeStartDateValidationError: 'Delivery date should be after pickup date',
      requiredPickupTimeWindowStart: 'Start Date is mandatory',
      requiredPickupTimeWindowEnd: 'End Date is mandatory',
    },
    delivery: 'Delivery Lloction',
  },
  add: 'Add new global account',
  account: {
    utils: {
      update: 'Save',
      showLess: 'Show less packages',
      showAllPackages: 'Show all packages',
      send: 'Send',
      search: 'Search',
      save: 'Save',
      reset: 'x',
      requiredLegend: 'Fields marked with * are required!',
      preview: 'Control Panel',
      delete: 'Delete',
      'columns-selected': 'Selected columns',
      close: 'Close',
      chooseFile: 'Choose files',
      'choose-columns': 'Choose columns',
      choose: 'Choose',
      cancel: 'Cancel',
      'boolean-select-item': {
        true: 'Yes',
        null: 'All',
        false: 'No',
      },
      'advanced-filters': 'Advanced filters',
      addFile: 'Add files',
      add: 'Add',
    },
    status: 'Status',
    serviceProviderName: 'Provider name',
    phoneNumber: 'Phone number',
    'payment-time-limit': 'Payment due date (number of days)',
    'new-title': 'New account',
    'list-title': 'Accounts',
    latestShipmentDate: 'Lastest shipment date',
    firstShipmentDate: 'First shipment date',
    error: {
      startDateAfterEndDate: 'The end date must be greater in calendar terms than the start date!',
      requiredValue: 'The reported value is required!',
      requiredStartDate: "The  'Start date' field is required!",
      requiredPaymentTimeLimit: "The  'Payment due date' field is required",
      requiredName: "The  'Name field' is required!",
      requiredFinishDate: "The 'Finish date' field is required!",
      requiredCustomer: 'The Customer field is required',
      requiredCode: 'The Code field is required!',
      requiredAccountName: 'The Account name field is required',
      required: 'The field is required!',
      defaultValidationMessage: 'An error has occurred. Check the data entered and try again',
    },
    email: 'E-mail',
    customerName: 'Customer name',
    customer: 'Customer',
    creditStoppedReason: 'Reason for stopping credit',
    creditStopped: 'Credit stopped',
    creditLimit: 'Credit limit',
    creditCloseDate: 'Credit stop date',
    creditAvailable: 'Available credit',
    contactPhoneNumber: 'Phone number',
    contactName: 'Contact name',
    contactEmail: 'Contact e-mail',
    contact: 'Contact',
    billingName: 'Billing name',
    billingCycleEnum: {
      Weekly: 'Weekly',
      Per_shipment: 'Per shipment',
      Monthly: 'Monthly',
      Manual: 'Manual',
      Bi_monthly: 'Bi-monthly',
    },
    billingCycle: 'Billing method',
    billingAccountNumber: 'Biiling account number',
    address: 'Address',
    accountStatus: 'Status',
    accountRequestedAt: 'Request sent at',
    accountNumber: 'Number account',
    accountName: 'Account name',
    accountCreatedAt: 'Created at',
    accountClosedAt: 'Closed at',
    'account-status-value': {
      requested: 'Requested',
      created: 'Created',
      closed: 'Closed',
    },
  },
  'access-denied': {
    title: 'This page is restricted!',
    message: "Unfortunately, you don't have the permissions required to access this page.",
    errorMessage: '403',
    back: 'Go back to Dashboard',
  },
  abstractNotifiableEntityContact: {
    editTooltip: 'Edit contact list',
    editDisabledTooltip: 'Currently it is not possible to edit the contact list',
  },
  'abstract-entity-contact-list-update-popup': {
    update: 'Update',
    title: 'Update contacts',
  },
  'self-signup-cards': {
    'authorization-token': {
      title: 'Authorize digital signature',
      done: 'Done',
      'not-done': 'Is missing',
      'go-to-authorize-token': 'See digital signature',
      'add-authorize-token': 'Add digital signature',
      expiringSoon: 'Expiring soon',
      expiringSoonMessage: 'The signature will expire soon, use the button below to renew it',
    },
    'terms-and-conditions': {
      title: 'Terms and Conditions',
      'general-terms-and-conditions-with': {
        service_provider: 'General T&C with Service Providers',
        customer: 'General T&C with Customers',
      },
      'terms-and-conditions-with': {
        service_provider: 'T&C with Service Providers',
        customer: 'T&C with Customers',
      },
      'go-to-terms-and-conditions': 'Add T&C',
      'platform-terms-and-conditions': 'See platform T&C',
    },
    'addresses-and-bank-accounts': {
      title: 'Addresses and Bank Accounts',
      'missing-office-address': 'Office Address is missing',
      'office-address': 'Registered Office',
      'fiscal-residence-address': 'Fiscal Residence',
      'missing-fiscal-residence-address': 'Fiscal Residence is missing',
      add: 'Add',
      edit: 'Edit',
      'active-bank-accounts': ' active bank accounts',
      'active-bank-account': ' active bank account',
      'go-to-bank-accounts': 'See Bank Accounts',
    },
    tariffs: {
      title: 'Contracts with Vendors',
      'tariff-contracts': ' contracts',
      'tariff-contract': ' contract',
      'add-tariff-contract': 'Add a Contract Request',
    },
    'employees-and-contacts': {
      title: 'Employees and Contacts',
      employee: ' valid employee',
      employees: ' valid employees',
      contact: ' contact',
      contacts: ' contacts',
      'add-employee': 'Add employee',
      'add-contact': 'Add contact',
    },
    customers: {
      title: 'Customers',
      customer: ' customer',
      customers: ' customers',
      'add-customer': 'Add customer',
    },
    'service-providers': {
      title: 'Service Providers',
      'service-provider': ' service provider',
      'service-providers': ' service providers',
      'add-service-provider': 'Add Service Provider',
    },
    fleet: {
      title: 'Drivers and Vehicles',
      driver: ' driver',
      drivers: ' drivers',
      vehicle: ' vehicle',
      vehicles: ' vehicles',
      'add-driver': 'Add driver',
      'add-vehicle': 'Add vehicle',
    },
    'util-links': {
      title: 'Util Links',
      'received-invoices': 'Received invoices',
      dashboard: 'Dashboard',
      reports: 'Reports',
      workflows: 'Workflows',
      'roles-configuration': 'Roles configuration',
    },
  },
  httpErrors: {
    connectionError: 'Connection error',
    connectionErrorMessage: 'A connection error occurred. Please reconnect!',
    timeoutError: 'Unstable connection',
    timeoutErrorDetail: 'Check submitted data',
  },
  eTransportActions: {
    title: 'eTransport Actions',
    list: {
      uit: 'UIT',
      uploadIndex: 'Upload index',
      createdAt: 'Created at',
      actionType: 'Action type',
      anafMessage: 'ANAF message',
      createdBy: 'Created by',
      checkStatus: 'Check status',
      uploadStatus: 'Upload status',
      licensePlates: 'License plates',
      observations: 'Observations',
      vehicleModificationDate: 'Vehicle modification date',
    },
  },
  timesheet: {
    title: 'Timesheet',
    driver: 'Driver',
    date: 'Date',
    type: 'Type',
    dailyAllownace: 'Daily allowance',
    weekendSupplement: 'Weekend supplement',
    dayOfTheWeek: 'Day',
    country: 'Country',
    monthAndYear: 'Timesheets for month and year:',
  },
  namedLocation: {
    addNamedLocation: 'Add location',
    namedLocation: 'Public location',
    location: 'Location',
    locationSolutions: 'Location solutions',
    lockFilters: 'Block filters',
    unlockFilters: 'Unblock filters',
    details: 'Details',
    name: 'Name',
    cost: 'Cost',
    packageStatus: 'Package status',
    filterTags: 'Tags',
    locations: 'Public Locations',
    territoryLocationOne: 'location',
    territoryLocationMultiple: 'locations',
    selectLocation: 'Select location',
    multipleSelectionSummary: '{{count}} locations selected',
    labelTitle: 'Location label',
    addLegalEntity: 'Add company into platform',
    duplicateCheckpoint: 'You have selected the same destination multiple times',
    label: 'Label',
    code: 'Code',
    orderNumber: 'Order number',
    shipmentSeries: 'Shipment series',
    deliveryTimeWindowEnd: 'Delivery date',
    statusMixed: 'Mixed',
    statusInTransit: 'In transit',
    statusInWarehouse: 'In warehouse',
    statusFailed: 'With errors',
    delete: 'Delete location',
    deleteConfirmationMessageTitle: 'After deletion, this location will no longer be usable',
    deleteConfirmationMessage: 'Are you sure you want the location to be deleted?',
    operatingCompanyName: 'Operating company',
    specialConditions: 'Special Conditions',
    schedule: 'Operating schedule',
    address: 'Address',
    companies: 'Companies',
    owner: 'Owner',
    operatingCompany: 'Operating company',
    operator: 'Operator',
    timeIntervalAndAddress: 'Operating hours and address',
    publicContacts: 'Public contacts',
    partnerContacts: 'Partner contacts',
    addNewContact: 'Add new contact',
    updateContacts: 'Update contacts',
    updateInfo: 'Update details',
    saveChanges: 'Save changes',
    manage: 'Manage',
    updateNamedLocationSpecialConditions: 'Update special conditions',
    emptyPublicContactsMessage: 'Currently there are no public contacts',
    emptyPartnerContactsMessage: 'Currently there are no partner contacts',
    emptySpecialConditionsMessage: 'Currently there are no special conditions',
    emptyScheduleMessage: 'Currently there is no schedule',
    selectDays: 'Select days',
    selectedDays: 'selected days',
    shipmentDays: 'Shipment days',
    start: 'Start',
    end: 'End',
    maxPackage: 'Vehicle capacity',
    startingLocation: 'Starting location',
    destination: 'Destination',
    destinations: 'Destinations',
    disabledDestinationsMessage: 'Select starting location in order to select destinations',
    timeWarning: "Info: The selected interval is before the selected location's schedule!",
    nextDayWarning:
      'Info: One or more checkpoints have start times earlier than the previous ones, indicating they may occur on the following day. Please verify the times for accuracy.',
    addDestination: 'Add destination',
    routesOrganisation: 'Route organisation',
    emptyLocationMessage: 'No location selected currently.',
    generalInfo: 'General info',
    sendOrder: 'Order',
    sendOrderTooltip: 'Send an order to a partner vendor',
    createTask: 'Task',
    createTaskTooltip: 'Create a task that will be solved with your fleet',
    deleteDraggedShipments: 'Delete added shipments',
    dragAndDropHere: 'Drag & Drop here',
    emptyShipmentsMessage: 'No shipment was found.',
    emptyRoutedOrderTemplatesMessage: 'No template was found',
    timezone: 'Timezone',
    scheduleTimezoneInfo: 'The schedule is based on the timezone',
    handoverPlaceholder: 'Code, name, company, city, street...',
    search: 'Code, name, company, city, street...',
    company: 'Company',
    searchAddressSuggestion: 'Or search address...',
    emptyNamedLocationContacts: 'No contact was found.',
    emptyLocationsSuggestion: 'The location does not exist? Add it!',
    isClaimedTooltip: 'This location is owned',
    operatedBy: 'Operated by',
    cannotEditAddress: 'This address is not editable because the location was used',
    employees: 'Employees',
    emptyEmployees: 'Currently there are no employees',
    updateEmployees: 'Update employees',
    notClaimedForUpdatingEmployees: 'To be able to add employees, it is necessary to claim the location',
    savedFilters: 'Saved filters',
    saveFilters: 'Save filters',
    routes: 'Templates',
    shipments: 'Shipments',
    preferencesSaveError: 'Please select at least one filter with available options before saving.',
    activeFilters: 'Active filters',
    labelRequired: 'The label is required!',
    adhocTemplateLabel: 'Ad-hoc template',
    dragAndDropForAdhocTemplate: '„Drag and drop shipments to create an ad-hoc template',
    goToDispatcherShipments: 'View tasks and shipments with this location',
    errors: {
      patternCode: 'Code must not contain spaces',
      requiredLabel: "The field 'Label' is required",
      requiredOperator: "The field 'Operator' is required",
      requiredCost: "The field 'Cost' is required",
      fillAllSpecialConditions: 'Complete all special conditions or remove the empty ones.',
      requiredIntervals: 'Start and End fields are required',
      operatorNotInPlatform: 'The operating company is not in platform',
      startBeforePrecedent: 'The start time must be after the start time of the previous location.',
      endAfterStart: 'End time must be after start time.',
    },
    utils: {
      filterActive: ' filter active',
      filtersActive: ' filters active',
    },
    ownershipRequest: {
      header: 'Named location ownership request',
      title: 'Named location ownership requests',
      createdAt: 'Created at',
      namedLocationLabel: 'Named location',
      message: 'Message',
      statusHeader: 'Status',
      phoneNumber: 'Phone number',
      email: 'Email',
      userName: 'User name',
      addRequest: 'Claim the location',
      phoneNotValidatedWarning: 'Validate the phone number to claim a location',
      delete: 'Delete request',
      deleteConfirmationMessage: 'Are you sure you want to delete this request',
      status: {
        ACCEPTED: 'ACCEPTED',
        PENDING: 'PENDING',
        CANCELED: 'CANCELED',
        REJECTED: 'REJECTED',
      },
      attachments: 'Attachments',
      errors: {
        requiredMessage: "The field 'Message' is required",
      },
    },
  },
  operationalTerritory: {
    territories: 'Territories',
    territory: 'Territory',
    addOperationalTerritory: 'Add territory',
    editOperationalTerritory: 'Edit territory',
    label: 'Name',
    validFrom: 'Valid from',
    validTo: 'Valid to',
    locationSelectionMessage: 'Choose desired locations from the drop-down list',
    centralNamedLocationLabel: 'Central location',
    centralNamedLocationSelectionMessage: 'Choose a central location by clicking on one of the selected ones.',
    centralNamedLocationHighlightMessage: 'The central location is highlighted with green.',
    partners: 'Partners',
    partnerSelectionMessage: 'Choose desired partners from the drop-down list',
    seeTerritoryLocations: 'See territory locations',
    selectTerritory: 'Select territory',
    invalidate: 'Invalidate territory',
    errors: {
      requiredLabel: "The field 'Label' is required",
      requiredPartners: "The field 'Partners' is required",
      requiredNamedLocations: "The field 'Named-locations' is required",
      requiredCentralNamedLocation: "The field 'Central named-location' is required",
      requiredValidFrom: "The field 'Valid from' is required",
      requiredValidTo: "The field 'Valid to' is mandatory!",
      validToValidTo: "The 'Valid to' date should be after 'Valid from'",
    },
    details: 'Details',
  },
  routedOrder: {
    addRoutedOrderTemplate: 'Add routes template',
    editRoutedOrderTemplate: 'Edit routes template',
    chronologicalTimeInfoMessage:
      'Info - The locations for this template will be saved in chronological order based on start times',
    deleteTemplateMessage: 'Are you sure you want to delete the selected template?',
    deleteTemplate: 'Delete template',
    shipmentRemoved: 'Shipment was removed from the template',
    shipmentMergeError: 'Unable to save shipment merge.',
    shipmentSplitError: 'Unable to save shipment split.',
  },
  externalMappings: {
    externalReferences: 'External references',
    locations: 'Locations',
    packages: 'Standard packages',
    standardPackage: 'Standard package',
    legalEntities: 'Companies',
    hubLocations: 'Hub locations',
    addReference: 'Add reference',
    addForLocation: 'Add reference for location',
    editForLocation: 'Edit reference for location',
    addForPackage: 'Add reference for package',
    editForPackage: 'Edit reference for package',
    addForLegalEntity: 'Add reference for company',
    editForLegalEntity: 'Edit reference for company',
    addForHubLocation: 'Add reference for hub location',
    editForHubLocation: 'Edit reference for hub location',
    showAll: 'See all',
    showOnlyValid: 'See only valid',
    list: {
      externalRefType: 'External system',
      externalRefId: 'Reference',
      namedLocationLabel: 'Location name',
      standardPackageDimensionName: 'Standard package',
      companyName: 'Company name',
      uniqueIdentificationNumber: 'Unique identification number',
      validFrom: 'Valid from',
      validTo: 'Valid to',
    },
    errors: {
      requiredExternalReferenceType: "The 'External system' field is required",
      requiredExternalReferenceId: "The 'Reference' field is required",
      requiredNamedLocation: 'Selecting a location is required',
      requiredStandardPackage: 'Selecting a package is required',
      requiredPartner: 'Selecting a partner is required',
      missingNamedLocation: 'Missing external reference for location.',
      missingStandardPackage: 'Missing external reference for standard package.',
      missingLegalEntity: 'Missing external reference for company.',
      missingNamedLocationHub: 'Missing external reference for hub location.',
      missingUnknown: `Missing entity mapping for code: {{code}}.`,
      NOMENCLATURE_UNKNOWN: 'Uninterpretable value from the EDI protocol for the code:: {{code}}.',
      NOMENCLATURE_MISSING_VALUE: 'Required value missing from the EDI protocol for the code: {{code}}.',
      ContractTariffItemNotMatchedConverterException: 'No contract with matched tariff was found.',
      ContractTariffItemWithDifferentCurrenciesConverterException: 'Contracts with multiple currencies were found.',
      NamedLocationWithoutContactConverterException: 'No contact found for the named location.',
      NamedLocationHubWithoutContactConverterException: 'The transporter has not added any contact for the hub.',
    },
  },
  unedifact: {
    edifactImports: 'EDIFACT imports',
    edifactImport: 'EDIFACT import',
    import: 'Import',
    createdAt: 'Created at',
    createdBy: 'Created by',
    fileName: 'File name',
    interchangeDate: 'External system creation date',
    controlRef: 'Ref. generated by external system',
    externalReferenceType: 'External system',
    orderNumber: 'Order number',
    fileUploadedSummary: 'File uploaded',
    fileUploadedDetails:
      "The uploaded file contains errors, but you don't have permission to access the details. Contact your supervisor.",
    fileUploadedContainsErrors:
      'The file has been uploaded successfully but contains errors. Resolve them in order to be able to send the order',
    importDetails: 'Import details',
    downloadFile: 'Download file',
    generalInformations: 'General informations',
    senderID: 'Sender ID',
    recipientID: 'Recipient ID',
    navigateToOrder: 'Navigate to order',
    importContains: 'Import contains',
    shipments: 'shipments',
    importProblems: 'Import problems',
    collapseAll: 'Collapse all',
    expandAll: 'Expand all',
    errors: 'errors',
    warnings: 'warnings',
    add: 'Add',
    licensePlate: 'License plate',
    externalReferenceNumber: 'External reference number',
    relinkTitle: 'Relink import',
    relinkConfirmationMessage: 'Are you sure you want to relink the import with the selected pre order?',
    relink: 'Link',
  },
  nomenclature: {
    unitMeasurementLabel: 'Measurement unit',
    unitMeasurementCode: 'Measurement unit code',
    customLabel: 'Product code',
    productName: 'Product name',
    productPrice: 'Price per unit',
    currencyCode: 'Currency',
    tariffCode: 'Tariff code',
    netWeight: 'Net weight (kg)',
    grossWeight: 'Gross weight (kg)',
    deleteMessage: 'Are you sure you would like to delete this product',
    errors: {
      requiredCustomLabel: "The field 'Product code' is required!",
      requiredProductName: "The field 'Product name' is required!",
      requiredProductPrice: "The field 'Price per unit' is required!",
      requiredTariffCode: "The field 'Tariff code' is required!",
      requiredNetWeight: "The field 'Net weight' is required!",
      requiredGrossWeight: "The field 'Gross weight' is required!",
      requiredUnitMeasurement: "The field 'Measurement Unit' is required!",
      requiredCurrencyCode: "The field 'Currency' is required!",
      existsCustomLabel: 'There already exists a product with this custom label!',
      maxlengthTariffCode: 'The tariff code cannot have more than 8 characters!',
      greaterThanGrossWeight: 'The gross weight must be greater than 0 kg',
      greaterThanNetWeight: 'The net weight must be greater than 0 kg',
    },
  },
  selectableEmployeeList: {
    employees: 'Employees',
    selected: 'selected',
    search: 'Search employees...',
  },
};
